var map = {
	".": [
		393,
		9
	],
	"./": [
		393,
		9
	],
	"./LDfeatureFlag": [
		45,
		9
	],
	"./LDfeatureFlag/": [
		45,
		9
	],
	"./LDfeatureFlag/constants": [
		37,
		9
	],
	"./LDfeatureFlag/constants.ts": [
		37,
		9
	],
	"./LDfeatureFlag/index": [
		45,
		9
	],
	"./LDfeatureFlag/index.tsx": [
		45,
		9
	],
	"./applications/apollo/apollo": [
		3534,
		9,
		1813
	],
	"./applications/apollo/apollo.tsx": [
		3534,
		9,
		1813
	],
	"./applications/app/ErrorBoundaryFallBack/ErrorBoundaryFallBack": [
		557,
		9
	],
	"./applications/app/ErrorBoundaryFallBack/ErrorBoundaryFallBack.tsx": [
		557,
		9
	],
	"./applications/app/ada-integration": [
		760,
		9,
		279
	],
	"./applications/app/ada-integration/": [
		760,
		9,
		279
	],
	"./applications/app/ada-integration/chatLoader": [
		2980,
		9,
		925
	],
	"./applications/app/ada-integration/chatLoader.tsx": [
		2980,
		9,
		925
	],
	"./applications/app/ada-integration/index": [
		760,
		9,
		279
	],
	"./applications/app/ada-integration/index.tsx": [
		760,
		9,
		279
	],
	"./applications/app/app": [
		3743,
		9,
		0,
		5,
		13,
		21,
		396
	],
	"./applications/app/app.scss": [
		4085,
		7,
		2934
	],
	"./applications/app/app.tsx": [
		3743,
		9,
		0,
		5,
		13,
		21,
		396
	],
	"./applications/app/appContainer": [
		3502,
		9,
		0,
		5,
		13,
		21,
		399
	],
	"./applications/app/appContainer.tsx": [
		3502,
		9,
		0,
		5,
		13,
		21,
		399
	],
	"./applications/app/appStyle": [
		3535,
		9,
		1814
	],
	"./applications/app/appStyle.ts": [
		3535,
		9,
		1814
	],
	"./applications/app/coBrowsing/hooks": [
		790,
		9,
		304
	],
	"./applications/app/coBrowsing/hooks/": [
		790,
		9,
		304
	],
	"./applications/app/coBrowsing/hooks/index": [
		790,
		9,
		304
	],
	"./applications/app/coBrowsing/hooks/index.tsx": [
		790,
		9,
		304
	],
	"./applications/app/coBrowsing/upscope": [
		836,
		9,
		280
	],
	"./applications/app/coBrowsing/upscope/": [
		836,
		9,
		280
	],
	"./applications/app/coBrowsing/upscope/index": [
		836,
		9,
		280
	],
	"./applications/app/coBrowsing/upscope/index.tsx": [
		836,
		9,
		280
	],
	"./applications/app/core-service-hooks/useGetConfigurationHook": [
		470,
		9
	],
	"./applications/app/core-service-hooks/useGetConfigurationHook.tsx": [
		470,
		9
	],
	"./applications/app/core-service-hooks/useGetInitialStateHook": [
		556,
		9
	],
	"./applications/app/core-service-hooks/useGetInitialStateHook.tsx": [
		556,
		9
	],
	"./applications/app/core-service-hooks/useGetPayrollDashboardInitialState": [
		1337,
		9,
		1446
	],
	"./applications/app/core-service-hooks/useGetPayrollDashboardInitialState.tsx": [
		1337,
		9,
		1446
	],
	"./applications/app/core-service-hooks/useGetPayrollDashboardPayGroupList": [
		1802,
		9,
		1245
	],
	"./applications/app/core-service-hooks/useGetPayrollDashboardPayGroupList.tsx": [
		1802,
		9,
		1245
	],
	"./applications/app/crowdin": [
		835,
		9,
		305
	],
	"./applications/app/crowdin/": [
		835,
		9,
		305
	],
	"./applications/app/crowdin/index": [
		835,
		9,
		305
	],
	"./applications/app/crowdin/index.tsx": [
		835,
		9,
		305
	],
	"./applications/app/heapAnalytics": [
		833,
		9,
		213
	],
	"./applications/app/heapAnalytics/": [
		833,
		9,
		213
	],
	"./applications/app/heapAnalytics/index": [
		833,
		9,
		213
	],
	"./applications/app/heapAnalytics/index.tsx": [
		833,
		9,
		213
	],
	"./applications/app/marker-io": [
		834,
		9,
		281
	],
	"./applications/app/marker-io/": [
		834,
		9,
		281
	],
	"./applications/app/marker-io/hooks": [
		2991,
		9,
		1815
	],
	"./applications/app/marker-io/hooks.tsx": [
		2991,
		9,
		1815
	],
	"./applications/app/marker-io/index": [
		834,
		9,
		281
	],
	"./applications/app/marker-io/index.tsx": [
		834,
		9,
		281
	],
	"./applications/app/satismeter": [
		837,
		9,
		306
	],
	"./applications/app/satismeter/": [
		837,
		9,
		306
	],
	"./applications/app/satismeter/index": [
		837,
		9,
		306
	],
	"./applications/app/satismeter/index.tsx": [
		837,
		9,
		306
	],
	"./applications/app/sentry": [
		359,
		9
	],
	"./applications/app/sentry/": [
		359,
		9
	],
	"./applications/app/sentry/filterConst": [
		663,
		9
	],
	"./applications/app/sentry/filterConst.ts": [
		663,
		9
	],
	"./applications/app/sentry/hooks": [
		280,
		9
	],
	"./applications/app/sentry/hooks.tsx": [
		280,
		9
	],
	"./applications/app/sentry/index": [
		359,
		9
	],
	"./applications/app/sentry/index.ts": [
		359,
		9
	],
	"./applications/app/signalR": [
		860,
		9,
		276,
		233
	],
	"./applications/app/signalR/": [
		860,
		9,
		276,
		233
	],
	"./applications/app/signalR/index": [
		860,
		9,
		276,
		233
	],
	"./applications/app/signalR/index.tsx": [
		860,
		9,
		276,
		233
	],
	"./applications/app/timeoutPopover": [
		358,
		9
	],
	"./applications/app/timeoutPopover/": [
		358,
		9
	],
	"./applications/app/timeoutPopover/index": [
		358,
		9
	],
	"./applications/app/timeoutPopover/index.tsx": [
		358,
		9
	],
	"./applications/payroll/payroll": [
		3536,
		9,
		1816
	],
	"./applications/payroll/payroll.tsx": [
		3536,
		9,
		1816
	],
	"./assets/images/3-starts.svg": [
		4086,
		9,
		2940
	],
	"./assets/images/404.svg": [
		4087,
		9,
		2941
	],
	"./assets/images/Vector.svg": [
		4088,
		9,
		2942
	],
	"./assets/images/account-locked.svg": [
		4017,
		9,
		2943
	],
	"./assets/images/accountingDashboard/add-first-client.svg": [
		4089,
		9,
		2944
	],
	"./assets/images/accountingDashboard/discountImg.png": [
		4034,
		9,
		3168
	],
	"./assets/images/accountingDashboard/discountStars/10_complete.png": [
		4035,
		9,
		3169
	],
	"./assets/images/accountingDashboard/discountStars/10_incomplete.png": [
		4036,
		9,
		3170
	],
	"./assets/images/accountingDashboard/discountStars/15_complete.png": [
		4037,
		9,
		3171
	],
	"./assets/images/accountingDashboard/discountStars/15_incomplete.png": [
		4038,
		9,
		3172
	],
	"./assets/images/accountingDashboard/discountStars/20_complete.png": [
		4039,
		9,
		3173
	],
	"./assets/images/accountingDashboard/discountStars/20_incomplete.png": [
		4040,
		9,
		3174
	],
	"./assets/images/accountingDashboard/empty-account-verification.svg": [
		4005,
		9,
		2945
	],
	"./assets/images/accountingDashboard/empty-client-requests.svg": [
		4006,
		9,
		2946
	],
	"./assets/images/accountingDashboard/empty-onboarding-progress.svg": [
		4007,
		9,
		2947
	],
	"./assets/images/accountingDashboard/helpArticles/greenPersonComputer.png": [
		3994,
		9,
		3175
	],
	"./assets/images/accountingDashboard/helpArticles/pinkSittingMap.png": [
		3995,
		9,
		3176
	],
	"./assets/images/accountingDashboard/helpArticles/purpleComputerTalk.png": [
		3996,
		9,
		3177
	],
	"./assets/images/accountingDashboard/helpArticles/yellowHandItems.png": [
		3997,
		9,
		3178
	],
	"./assets/images/accountingDashboard/payroll-calendar/banking-holiday-icon.svg": [
		3966,
		9,
		2948
	],
	"./assets/images/accountingDashboard/payroll-calendar/empty-calendar.svg": [
		3976,
		9,
		2949
	],
	"./assets/images/accountingDashboard/payroll-calendar/invoice-due-icon.svg": [
		3967,
		9,
		2950
	],
	"./assets/images/accountingDashboard/payroll-calendar/other-events-icon.svg": [
		3968,
		9,
		2951
	],
	"./assets/images/accountingDashboard/payroll-calendar/pay-date-icon.svg": [
		3969,
		9,
		2952
	],
	"./assets/images/accountingDashboard/payroll-calendar/processing-date-icon.svg": [
		3970,
		9,
		2953
	],
	"./assets/images/accountingDashboard/star-shadow.svg": [
		4090,
		9,
		2954
	],
	"./assets/images/accountingDashboard/star.svg": [
		4091,
		9,
		2955
	],
	"./assets/images/add-ons/XERO_logo.png": [
		3980,
		9,
		3179
	],
	"./assets/images/add-ons/addons_preview.svg": [
		4092,
		9,
		2956
	],
	"./assets/images/add-ons/check-list-icon.svg": [
		4093,
		9,
		2957
	],
	"./assets/images/add-ons/import-hours.svg": [
		3971,
		9,
		2958
	],
	"./assets/images/add-ons/payroll_finalized_bg.svg": [
		3961,
		9,
		2959
	],
	"./assets/images/add-ons/people-by-wagepoint/people-logo.png": [
		3987,
		9,
		3180
	],
	"./assets/images/add-ons/qbo/link_supplier_success_state.svg": [
		4094,
		9,
		2960
	],
	"./assets/images/add-ons/qbo/link_supplier_zero_state.svg": [
		4095,
		9,
		2961
	],
	"./assets/images/add-ons/qbo_button.svg": [
		4096,
		9,
		2962
	],
	"./assets/images/add-ons/qbo_button_fr.svg": [
		4097,
		9,
		2963
	],
	"./assets/images/add-ons/qbo_logo.svg": [
		3981,
		9,
		2964
	],
	"./assets/images/add-ons/red-cross-icon.svg": [
		4098,
		9,
		2965
	],
	"./assets/images/add-ons/red_ellipse.svg": [
		4099,
		9,
		2966
	],
	"./assets/images/add-ons/time-by-wagepoint/not-log-in.svg": [
		4100,
		9,
		2967
	],
	"./assets/images/add-ons/time-by-wagepoint/time_logo.svg": [
		3988,
		9,
		2968
	],
	"./assets/images/add-ons/time_carousel1.png": [
		4101,
		9,
		3181
	],
	"./assets/images/add-ons/xero_connect.svg": [
		4102,
		9,
		2969
	],
	"./assets/images/add-ons/xero_disconnect.svg": [
		4103,
		9,
		2970
	],
	"./assets/images/add-ons/zero_state.svg": [
		4104,
		9,
		2971
	],
	"./assets/images/alert_orange.svg": [
		3973,
		9,
		2972
	],
	"./assets/images/alert_red.svg": [
		4008,
		9,
		2973
	],
	"./assets/images/app-bg/background-texture.png": [
		4068,
		9,
		3182
	],
	"./assets/images/associatedcompanies/ribbon_checkmark.svg": [
		4041,
		9,
		2974
	],
	"./assets/images/background-texture-blue.png": [
		4004,
		9,
		3183
	],
	"./assets/images/banking/canada_voidcheque.svg": [
		3958,
		9,
		2975
	],
	"./assets/images/banking/usa_voidcheque.svg": [
		3962,
		9,
		2976
	],
	"./assets/images/bell_on.svg": [
		906,
		9
	],
	"./assets/images/billing/calculator_red_shadow.svg": [
		4105,
		9,
		2977
	],
	"./assets/images/billing/clock.svg": [
		4106,
		9,
		2978
	],
	"./assets/images/billing/enter.svg": [
		4107,
		9,
		2979
	],
	"./assets/images/billing/enter_inactive.svg": [
		4108,
		9,
		2980
	],
	"./assets/images/billing/hand.svg": [
		4109,
		9,
		2981
	],
	"./assets/images/billing/hand_wave.svg": [
		4110,
		9,
		2982
	],
	"./assets/images/billing/leaf.svg": [
		4111,
		9,
		2983
	],
	"./assets/images/billing/money_coin.svg": [
		4112,
		9,
		2984
	],
	"./assets/images/billing/plants_zero.svg": [
		4113,
		9,
		2985
	],
	"./assets/images/billing/stars.svg": [
		4114,
		9,
		2986
	],
	"./assets/images/billing/time_circle_solid.svg": [
		4115,
		9,
		2987
	],
	"./assets/images/canadaFTU/people/stepIsNotCompleted.svg": [
		3991,
		9,
		2988
	],
	"./assets/images/check-circle-solid.svg": [
		4020,
		9,
		2989
	],
	"./assets/images/check-complete.svg": [
		3992,
		9,
		2990
	],
	"./assets/images/client-directory/bell_off.svg": [
		4116,
		9,
		2991
	],
	"./assets/images/client-directory/clent_fees.svg": [
		3982,
		9,
		2992
	],
	"./assets/images/client-directory/dollar-sign-regular.svg": [
		4021,
		9,
		2993
	],
	"./assets/images/client-directory/lock.svg": [
		4117,
		9,
		2994
	],
	"./assets/images/client-directory/money_card.svg": [
		4118,
		9,
		2995
	],
	"./assets/images/client-directory/present_purple.svg": [
		4119,
		9,
		2996
	],
	"./assets/images/client-directory/year-to-date-img.svg": [
		4120,
		9,
		2997
	],
	"./assets/images/client-directory/zero-state-administrators.svg": [
		4121,
		9,
		2998
	],
	"./assets/images/client-directory/zero_add_shadow_person.svg": [
		4022,
		9,
		2999
	],
	"./assets/images/clock-stars.svg": [
		4073,
		9,
		3000
	],
	"./assets/images/closeaccount/wp-check-circle-solid.svg": [
		4023,
		9,
		3001
	],
	"./assets/images/closeaccount/wp-checked-items-list.svg": [
		4122,
		9,
		3002
	],
	"./assets/images/closeaccount/wp-checklist.svg": [
		4123,
		9,
		3003
	],
	"./assets/images/closeaccount/wp-close-account.svg": [
		4124,
		9,
		3004
	],
	"./assets/images/closeaccount/wp-stars-duotone.svg": [
		3983,
		9,
		3005
	],
	"./assets/images/company-settings/light.svg": [
		4125,
		9,
		3006
	],
	"./assets/images/default-avatar.png": [
		4126,
		9,
		3184
	],
	"./assets/images/default_avatar.svg": [
		391,
		9
	],
	"./assets/images/default_avatar1.png": [
		4009,
		9,
		3185
	],
	"./assets/images/digit-sitting.svg": [
		4024,
		9,
		3007
	],
	"./assets/images/doc-with-check.svg": [
		4010,
		9,
		3008
	],
	"./assets/images/employeeportal/dollar-symbol-shadow.svg": [
		4127,
		9,
		3009
	],
	"./assets/images/employeeportal/profile-complete.svg": [
		4128,
		9,
		3010
	],
	"./assets/images/employeeportal/year-to-date-img.svg": [
		4129,
		9,
		3011
	],
	"./assets/images/empty-notification.svg": [
		4130,
		9,
		3012
	],
	"./assets/images/empty_state.svg": [
		3959,
		9,
		3013
	],
	"./assets/images/error-boundary.svg": [
		4131,
		9,
		3014
	],
	"./assets/images/exclamation-circle-solid.svg": [
		3978,
		9,
		3015
	],
	"./assets/images/firstTimeUser/completed.svg": [
		4132,
		9,
		3016
	],
	"./assets/images/firstTimeUser/current.svg": [
		4133,
		9,
		3017
	],
	"./assets/images/firstTimeUser/not-completed.svg": [
		4134,
		9,
		3018
	],
	"./assets/images/firstTimeUser/stars.svg": [
		4135,
		9,
		3019
	],
	"./assets/images/firstTimeUser/step1.svg": [
		4136,
		9,
		3020
	],
	"./assets/images/firstTimeUser/step2.svg": [
		4137,
		9,
		3021
	],
	"./assets/images/firstTimeUser/step3.svg": [
		4138,
		9,
		3022
	],
	"./assets/images/firstTimeUser/step4.svg": [
		4139,
		9,
		3023
	],
	"./assets/images/firstTimeUser/step5.svg": [
		4140,
		9,
		3024
	],
	"./assets/images/firstTimeUser/step6.svg": [
		4141,
		9,
		3025
	],
	"./assets/images/firstTimeUser/thumbUp.png": [
		4142,
		9,
		3186
	],
	"./assets/images/header/alert-alarm-bell-2-solid.svg": [
		4143,
		9,
		3026
	],
	"./assets/images/header/alert-alarm-bell-2.svg": [
		4144,
		9,
		3027
	],
	"./assets/images/header/arrows-button-down.svg": [
		4145,
		9,
		3028
	],
	"./assets/images/header/arrows-button-up.svg": [
		4146,
		9,
		3029
	],
	"./assets/images/header/digit-logo-white.png": [
		4042,
		9,
		3187
	],
	"./assets/images/header/file-multiple.svg": [
		4147,
		9,
		3030
	],
	"./assets/images/header/help-question-circle-solid.svg": [
		4148,
		9,
		3031
	],
	"./assets/images/header/help-question-circle.svg": [
		4149,
		9,
		3032
	],
	"./assets/images/header/setting.svg": [
		4150,
		9,
		3033
	],
	"./assets/images/header/user-circle.svg": [
		4151,
		9,
		3034
	],
	"./assets/images/help.svg": [
		4152,
		9,
		3035
	],
	"./assets/images/holiday-list/light-bulb-solid.svg": [
		4074,
		9,
		3036
	],
	"./assets/images/illustrations/departments.svg": [
		4153,
		9,
		3037
	],
	"./assets/images/illustrations/jobtitle.svg": [
		4154,
		9,
		3038
	],
	"./assets/images/illustrations/memos.svg": [
		4155,
		9,
		3039
	],
	"./assets/images/illustrations/payroll-complete.svg": [
		3993,
		9,
		3040
	],
	"./assets/images/illustrations/payroll-start.svg": [
		4156,
		9,
		3041
	],
	"./assets/images/illustrations/payroll-verify.svg": [
		4157,
		9,
		3042
	],
	"./assets/images/illustrations/roe.svg": [
		4158,
		9,
		3043
	],
	"./assets/images/illustrations/verify.svg": [
		4043,
		9,
		3044
	],
	"./assets/images/income_amount.svg": [
		3974,
		9,
		3045
	],
	"./assets/images/income_hours.svg": [
		3975,
		9,
		3046
	],
	"./assets/images/info-circle-solid.svg": [
		3979,
		9,
		3047
	],
	"./assets/images/info_purple.svg": [
		4011,
		9,
		3048
	],
	"./assets/images/inviteClients.png": [
		4025,
		9,
		3188
	],
	"./assets/images/logo.png": [
		4159,
		9,
		3189
	],
	"./assets/images/migrate_all_clients.svg": [
		4044,
		9,
		3049
	],
	"./assets/images/money_green.svg": [
		4012,
		9,
		3050
	],
	"./assets/images/nothing-created.svg": [
		3972,
		9,
		3051
	],
	"./assets/images/notifications.svg": [
		4160,
		9,
		3052
	],
	"./assets/images/onboard/account_verification.svg": [
		3949,
		9,
		3053
	],
	"./assets/images/onboard/airplane_green_money_shadow.svg": [
		3950,
		9,
		3054
	],
	"./assets/images/onboard/authorized_signatory.svg": [
		3953,
		9,
		3055
	],
	"./assets/images/onboard/authorized_signatory_new.svg": [
		3956,
		9,
		3056
	],
	"./assets/images/onboard/dollar_bill_shadow.svg": [
		3951,
		9,
		3057
	],
	"./assets/images/onboard/map.svg": [
		3952,
		9,
		3058
	],
	"./assets/images/onboard/paygroup_review.svg": [
		3957,
		9,
		3059
	],
	"./assets/images/onboard/reports_shared.svg": [
		3948,
		9,
		3060
	],
	"./assets/images/payroll/adjustments/emptyAdjustments.svg": [
		4161,
		9,
		3061
	],
	"./assets/images/payroll/adjustments/enter.svg": [
		4162,
		9,
		3062
	],
	"./assets/images/payroll/adjustments/enter_inactive.svg": [
		4163,
		9,
		3063
	],
	"./assets/images/payroll/adjustments/er_tax.svg": [
		4164,
		9,
		3064
	],
	"./assets/images/payroll/adjustments/er_tax_inactive.svg": [
		4165,
		9,
		3065
	],
	"./assets/images/payroll/adjustments/noAdjustmentAccess.svg": [
		4166,
		9,
		3066
	],
	"./assets/images/payroll/adjustments/review.svg": [
		4167,
		9,
		3067
	],
	"./assets/images/payroll/adjustments/review_inactive.svg": [
		4168,
		9,
		3068
	],
	"./assets/images/payroll/adjustments/tax.svg": [
		4169,
		9,
		3069
	],
	"./assets/images/payroll/adjustments/tax_inactive.svg": [
		4170,
		9,
		3070
	],
	"./assets/images/payroll/calendar.svg": [
		4171,
		9,
		3071
	],
	"./assets/images/payroll/check.svg": [
		4045,
		9,
		3072
	],
	"./assets/images/payroll/clock.svg": [
		4013,
		9,
		3073
	],
	"./assets/images/payroll/electronic_submission.svg": [
		4075,
		9,
		3074
	],
	"./assets/images/payroll/employee-disabled.svg": [
		4046,
		9,
		3075
	],
	"./assets/images/payroll/employee.svg": [
		4047,
		9,
		3076
	],
	"./assets/images/payroll/grid_view.svg": [
		4076,
		9,
		3077
	],
	"./assets/images/payroll/hoursincome.svg": [
		4048,
		9,
		3078
	],
	"./assets/images/payroll/hoursincome_disabled.svg": [
		4049,
		9,
		3079
	],
	"./assets/images/payroll/idea.svg": [
		4172,
		9,
		3080
	],
	"./assets/images/payroll/manual_submission.svg": [
		4077,
		9,
		3081
	],
	"./assets/images/payroll/noAccess.svg": [
		4173,
		9,
		3082
	],
	"./assets/images/payroll/payment-disabled.svg": [
		4050,
		9,
		3083
	],
	"./assets/images/payroll/payment.svg": [
		4051,
		9,
		3084
	],
	"./assets/images/payroll/review.svg": [
		3998,
		9,
		3085
	],
	"./assets/images/payroll/review_disabled.svg": [
		3999,
		9,
		3086
	],
	"./assets/images/payroll/selectdate.svg": [
		4052,
		9,
		3087
	],
	"./assets/images/payroll/single_view.svg": [
		4078,
		9,
		3088
	],
	"./assets/images/payroll/tax.svg": [
		4000,
		9,
		3089
	],
	"./assets/images/payroll/tax_disabled.svg": [
		4001,
		9,
		3090
	],
	"./assets/images/payroll/year_end_form.svg": [
		4174,
		9,
		3091
	],
	"./assets/images/payrollreports/deposit_cheque.svg": [
		4175,
		9,
		3092
	],
	"./assets/images/payrollreports/wagepoint-logo.svg": [
		3955,
		9,
		3093
	],
	"./assets/images/payrollreports/zeroPayrollRun.svg": [
		3963,
		9,
		3094
	],
	"./assets/images/payrollsettings/approve-active.svg": [
		4026,
		9,
		3095
	],
	"./assets/images/payrollsettings/approve-inactive.svg": [
		4027,
		9,
		3096
	],
	"./assets/images/payrollsettings/block.svg": [
		4176,
		9,
		3097
	],
	"./assets/images/payrollsettings/check.svg": [
		4177,
		9,
		3098
	],
	"./assets/images/payrollsettings/employee-active.svg": [
		4028,
		9,
		3099
	],
	"./assets/images/payrollsettings/emptyPaygroup.svg": [
		4178,
		9,
		3100
	],
	"./assets/images/payrollsettings/nothing-created.svg": [
		3989,
		9,
		3101
	],
	"./assets/images/payrollsettings/selectdates-active.svg": [
		4029,
		9,
		3102
	],
	"./assets/images/payrollsettings/selectdates-inactive.svg": [
		4030,
		9,
		3103
	],
	"./assets/images/payrollsettings/wp-amount-hours-icon.svg": [
		3984,
		9,
		3104
	],
	"./assets/images/payrollsettings/wp-amount-icon.svg": [
		3985,
		9,
		3105
	],
	"./assets/images/payrollsettings/wp-default-avatar.svg": [
		4179,
		9,
		3106
	],
	"./assets/images/payrollsettings/wp-hours-icon.svg": [
		4031,
		9,
		3107
	],
	"./assets/images/payrollsettings/wp-light-bulb-icon.svg": [
		4079,
		9,
		3108
	],
	"./assets/images/payrollsettings/wp-rect-icon.svg": [
		4053,
		9,
		3109
	],
	"./assets/images/payrollsettings/wp-star-icon.svg": [
		4180,
		9,
		3110
	],
	"./assets/images/payrollsettings/zeropaygroup.svg": [
		3990,
		9,
		3111
	],
	"./assets/images/paystubmemo/plus-light.svg": [
		4181,
		9,
		3112
	],
	"./assets/images/paystubmemo/sort-down.svg": [
		4080,
		9,
		3113
	],
	"./assets/images/paystubmemo/user-solid.svg": [
		4182,
		9,
		3114
	],
	"./assets/images/paystubmemo/users-duotone.svg": [
		4183,
		9,
		3115
	],
	"./assets/images/plaid-logo.png": [
		4002,
		9,
		3190
	],
	"./assets/images/preferences/default_avatar.svg": [
		4184,
		9,
		3116
	],
	"./assets/images/preferences/qr_code.svg": [
		3965,
		9,
		3117
	],
	"./assets/images/recordofemployment/green.svg": [
		4054,
		9,
		3118
	],
	"./assets/images/recordofemployment/import-contractors-employees-active.svg": [
		4055,
		9,
		3119
	],
	"./assets/images/recordofemployment/import-contractors-employees-inactive.svg": [
		4056,
		9,
		3120
	],
	"./assets/images/recordofemployment/incomes-active.svg": [
		4057,
		9,
		3121
	],
	"./assets/images/recordofemployment/red.svg": [
		4185,
		9,
		3122
	],
	"./assets/images/recordofemployment/rejected.svg": [
		4186,
		9,
		3123
	],
	"./assets/images/recordofemployment/yellow.svg": [
		4058,
		9,
		3124
	],
	"./assets/images/sample-report.png": [
		4014,
		9,
		3191
	],
	"./assets/images/second-logo.png": [
		3986,
		9,
		3192
	],
	"./assets/images/sidebar/content-chart.svg": [
		4187,
		9,
		3125
	],
	"./assets/images/sidebar/file-multiple.svg": [
		4188,
		9,
		3126
	],
	"./assets/images/sidebar/home.svg": [
		4189,
		9,
		3127
	],
	"./assets/images/sidebar/interface-user-multiple.svg": [
		4190,
		9,
		3128
	],
	"./assets/images/sidebar/money-cash-dollar-coin.svg": [
		4191,
		9,
		3129
	],
	"./assets/images/sidebar/money-cash-subscription-cashflow.svg": [
		4192,
		9,
		3130
	],
	"./assets/images/sidebar/programming-module-puzzle-2.svg": [
		4193,
		9,
		3131
	],
	"./assets/images/sidebar/setting-cog.svg": [
		4194,
		9,
		3132
	],
	"./assets/images/sidebar/setting-slider-horizontal-square.svg": [
		4195,
		9,
		3133
	],
	"./assets/images/sidebar/shopping-store-1.svg": [
		4196,
		9,
		3134
	],
	"./assets/images/sidebar/user-circle.svg": [
		4197,
		9,
		3135
	],
	"./assets/images/signup-login-cropped.svg": [
		4019,
		9,
		3136
	],
	"./assets/images/statutoryHolidays/star-icon.svg": [
		4003,
		9,
		3137
	],
	"./assets/images/statutoryHolidays/zero_state.svg": [
		4032,
		9,
		3138
	],
	"./assets/images/successSubmitted.png": [
		4015,
		9,
		3193
	],
	"./assets/images/t4aoptout.svg": [
		4059,
		9,
		3139
	],
	"./assets/images/taxdocuments/wp-tax-documents.svg": [
		4198,
		9,
		3140
	],
	"./assets/images/taxsettings/wp-calculator-icon.svg": [
		4199,
		9,
		3141
	],
	"./assets/images/taxsettings/wp-completed.svg": [
		4200,
		9,
		3142
	],
	"./assets/images/taxsettings/wp-info-icon.svg": [
		4201,
		9,
		3143
	],
	"./assets/images/taxsettings/wp-number-1.svg": [
		4060,
		9,
		3144
	],
	"./assets/images/taxsettings/wp-number-2.svg": [
		4061,
		9,
		3145
	],
	"./assets/images/taxsettings/wp-number-3.svg": [
		4062,
		9,
		3146
	],
	"./assets/images/taxsettings/wp-number-4.svg": [
		4063,
		9,
		3147
	],
	"./assets/images/taxsettings/wp-share-checklist.svg": [
		4064,
		9,
		3148
	],
	"./assets/images/taxsettings/wp-tax-exem-threshold.svg": [
		4202,
		9,
		3149
	],
	"./assets/images/taxsettings/wp-tax-info-icon.svg": [
		4203,
		9,
		3150
	],
	"./assets/images/taxsettings/wp-tax-read-icon.svg": [
		4204,
		9,
		3151
	],
	"./assets/images/taxsettings/wp-tax-setup.svg": [
		4065,
		9,
		3152
	],
	"./assets/images/up-arrow.svg": [
		4205,
		9,
		3153
	],
	"./assets/images/upcoming-payroll.svg": [
		4081,
		9,
		3154
	],
	"./assets/images/upload.png": [
		4206,
		9,
		3194
	],
	"./assets/images/useraccounts/accounting-firm-card.svg": [
		4207,
		9,
		3155
	],
	"./assets/images/useraccounts/no-access.svg": [
		4208,
		9,
		3156
	],
	"./assets/images/useraccounts/review-active.svg": [
		4209,
		9,
		3157
	],
	"./assets/images/useraccounts/zero_add_admin.svg": [
		4210,
		9,
		3158
	],
	"./assets/images/watch.svg": [
		4211,
		9,
		3159
	],
	"./assets/images/wp-info-icon.svg": [
		4212,
		9,
		3160
	],
	"./assets/images/wp-logo.svg": [
		4018,
		9,
		3161
	],
	"./assets/images/wp-no-results.svg": [
		4016,
		9,
		3162
	],
	"./assets/images/wp-person.png": [
		4213,
		9,
		3195
	],
	"./assets/images/wp-robot-wait.png": [
		4214,
		9,
		3196
	],
	"./assets/images/year-end-checklist-help.svg": [
		4066,
		9,
		3163
	],
	"./assets/images/year-end-checklist-preview.svg": [
		4067,
		9,
		3164
	],
	"./config/apps": [
		587,
		9
	],
	"./config/apps.ts": [
		587,
		9
	],
	"./enums/maskingFormats": [
		1073,
		9,
		1817
	],
	"./enums/maskingFormats.ts": [
		1073,
		9,
		1817
	],
	"./i18n/config": [
		392,
		9
	],
	"./i18n/config.ts": [
		392,
		9
	],
	"./i18n/i18n": [
		231,
		9
	],
	"./i18n/i18n-format": [
		647,
		9
	],
	"./i18n/i18n-format.ts": [
		647,
		9
	],
	"./i18n/i18n.ts": [
		231,
		9
	],
	"./index": [
		393,
		9
	],
	"./index.tsx": [
		393,
		9
	],
	"./pages/account-setup/accountSetupContainer": [
		3213,
		9,
		1,
		345
	],
	"./pages/account-setup/accountSetupContainer.tsx": [
		3213,
		9,
		1,
		345
	],
	"./pages/accounting-dashboard/client-directory/clientDirectoryContainer": [
		3214,
		9,
		124,
		378
	],
	"./pages/accounting-dashboard/client-directory/clientDirectoryContainer.tsx": [
		3214,
		9,
		124,
		378
	],
	"./pages/accounting-dashboard/client-directory/components/big-field-item/bigFieldItem": [
		3537,
		9,
		1818
	],
	"./pages/accounting-dashboard/client-directory/components/big-field-item/bigFieldItem.tsx": [
		3537,
		9,
		1818
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-cards/billingSetupCards": [
		1882,
		9,
		749
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-cards/billingSetupCards.tsx": [
		1882,
		9,
		749
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-cards/styles": [
		1804,
		9,
		1819
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-cards/styles.ts": [
		1804,
		9,
		1819
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-cards/types": [
		3538,
		9,
		1820
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-cards/types.ts": [
		3538,
		9,
		1820
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-cards/useBillingSetup": [
		1803,
		9,
		1248
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-cards/useBillingSetup.ts": [
		1803,
		9,
		1248
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-radio/billingSetupRadio": [
		1805,
		9,
		631
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-radio/billingSetupRadio.tsx": [
		1805,
		9,
		631
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-radio/useBillingSetup": [
		1883,
		9,
		1821
	],
	"./pages/accounting-dashboard/client-directory/components/billing-setup-radio/useBillingSetup.ts": [
		1883,
		9,
		1821
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/acceptButtonBlock": [
		2372,
		9,
		1092
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/acceptButtonBlock.tsx": [
		2372,
		9,
		1092
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/horizontalBlock": [
		2194,
		9,
		1249
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/horizontalBlock.tsx": [
		2194,
		9,
		1249
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/notificationMessage": [
		1884,
		9,
		1449
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/notificationMessage.tsx": [
		1884,
		9,
		1449
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/payGroupBlock": [
		2679,
		9,
		1450
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/payGroupBlock.tsx": [
		2679,
		9,
		1450
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/paymentBlock": [
		2680,
		9,
		1822
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/paymentBlock.tsx": [
		2680,
		9,
		1822
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/textBlock": [
		1952,
		9,
		1823
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/textBlock.tsx": [
		1952,
		9,
		1823
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/verticalBlock": [
		1447,
		9,
		1251
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/verticalBlock.tsx": [
		1447,
		9,
		1251
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/verticalWithButton": [
		2215,
		9,
		993
	],
	"./pages/accounting-dashboard/client-directory/components/blocks/verticalWithButton.tsx": [
		2215,
		9,
		993
	],
	"./pages/accounting-dashboard/client-directory/components/button/commonButton": [
		2216,
		9,
		1824
	],
	"./pages/accounting-dashboard/client-directory/components/button/commonButton.tsx": [
		2216,
		9,
		1824
	],
	"./pages/accounting-dashboard/client-directory/components/checkbox-with-tooltip/checkboxWithTooltip": [
		3539,
		9,
		1093
	],
	"./pages/accounting-dashboard/client-directory/components/checkbox-with-tooltip/checkboxWithTooltip.tsx": [
		3539,
		9,
		1093
	],
	"./pages/accounting-dashboard/client-directory/components/checkbox-with-tooltip/checkboxWithTooltipStyles": [
		3301,
		9,
		1825
	],
	"./pages/accounting-dashboard/client-directory/components/checkbox-with-tooltip/checkboxWithTooltipStyles.ts": [
		3301,
		9,
		1825
	],
	"./pages/accounting-dashboard/client-directory/components/client-company-service-wrapper/clientCompanyServiceWrapper": [
		3300,
		9,
		1252
	],
	"./pages/accounting-dashboard/client-directory/components/client-company-service-wrapper/clientCompanyServiceWrapper.tsx": [
		3300,
		9,
		1252
	],
	"./pages/accounting-dashboard/client-directory/components/client-company-service-wrapper/useClientDirectoryRequests": [
		2193,
		9,
		1826
	],
	"./pages/accounting-dashboard/client-directory/components/client-company-service-wrapper/useClientDirectoryRequests.ts": [
		2193,
		9,
		1826
	],
	"./pages/accounting-dashboard/client-directory/components/current-subscription-plan/currentSubscriptionPlan": [
		2217,
		9,
		1253
	],
	"./pages/accounting-dashboard/client-directory/components/current-subscription-plan/currentSubscriptionPlan.tsx": [
		2217,
		9,
		1253
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/constants": [
		1659,
		9,
		1827
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/constants.ts": [
		1659,
		9,
		1827
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/deleteInviteModal": [
		2992,
		9,
		1828
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/deleteInviteModal.tsx": [
		2992,
		9,
		1828
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/disconnectClientModal": [
		2191,
		9,
		996
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/disconnectClientModal.tsx": [
		2191,
		9,
		996
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/hooks": [
		1881,
		9,
		1451
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/hooks.ts": [
		1881,
		9,
		1451
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/modalContent": [
		1951,
		9,
		1094
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/modalContent.tsx": [
		1951,
		9,
		1094
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/styles": [
		1880,
		9,
		1829
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/styles.ts": [
		1880,
		9,
		1829
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/types": [
		3540,
		9,
		1830
	],
	"./pages/accounting-dashboard/client-directory/components/disconnect-client-modal/types.ts": [
		3540,
		9,
		1830
	],
	"./pages/accounting-dashboard/client-directory/components/grey-statements/greyStatements": [
		2394,
		9,
		1452
	],
	"./pages/accounting-dashboard/client-directory/components/grey-statements/greyStatements.tsx": [
		2394,
		9,
		1452
	],
	"./pages/accounting-dashboard/client-directory/components/grey-statements/greyStatementsStyles": [
		2218,
		9,
		1831
	],
	"./pages/accounting-dashboard/client-directory/components/grey-statements/greyStatementsStyles.ts": [
		2218,
		9,
		1831
	],
	"./pages/accounting-dashboard/client-directory/components/grid-wrapper/gridWrapper": [
		3541,
		9,
		1254
	],
	"./pages/accounting-dashboard/client-directory/components/grid-wrapper/gridWrapper.tsx": [
		3541,
		9,
		1254
	],
	"./pages/accounting-dashboard/client-directory/components/grid-wrapper/gridWrapperStyles": [
		3302,
		9,
		1832
	],
	"./pages/accounting-dashboard/client-directory/components/grid-wrapper/gridWrapperStyles.ts": [
		3302,
		9,
		1832
	],
	"./pages/accounting-dashboard/client-directory/components/image-wrapper/imageWrapper": [
		2395,
		9,
		1833
	],
	"./pages/accounting-dashboard/client-directory/components/image-wrapper/imageWrapper.tsx": [
		2395,
		9,
		1833
	],
	"./pages/accounting-dashboard/client-directory/components/label-with-tooltip/labelWithTooltip": [
		2393,
		9,
		1453
	],
	"./pages/accounting-dashboard/client-directory/components/label-with-tooltip/labelWithTooltip.tsx": [
		2393,
		9,
		1453
	],
	"./pages/accounting-dashboard/client-directory/components/layout/layout": [
		3510,
		9,
		124
	],
	"./pages/accounting-dashboard/client-directory/components/layout/layout.tsx": [
		3510,
		9,
		124
	],
	"./pages/accounting-dashboard/client-directory/components/layout/layoutStyles": [
		3298,
		9,
		1834
	],
	"./pages/accounting-dashboard/client-directory/components/layout/layoutStyles.ts": [
		3298,
		9,
		1834
	],
	"./pages/accounting-dashboard/client-directory/components/menu-button/disconnectMenuButton": [
		2645,
		9,
		1255
	],
	"./pages/accounting-dashboard/client-directory/components/menu-button/disconnectMenuButton.tsx": [
		2645,
		9,
		1255
	],
	"./pages/accounting-dashboard/client-directory/components/menu-button/loginMenuButton": [
		2646,
		9,
		787
	],
	"./pages/accounting-dashboard/client-directory/components/menu-button/loginMenuButton.tsx": [
		2646,
		9,
		787
	],
	"./pages/accounting-dashboard/client-directory/components/menu-button/menuButton": [
		1806,
		9,
		1835
	],
	"./pages/accounting-dashboard/client-directory/components/menu-button/menuButton.tsx": [
		1806,
		9,
		1835
	],
	"./pages/accounting-dashboard/client-directory/components/menu-button/overViewMenuButton": [
		2647,
		9,
		1096
	],
	"./pages/accounting-dashboard/client-directory/components/menu-button/overViewMenuButton.tsx": [
		2647,
		9,
		1096
	],
	"./pages/accounting-dashboard/client-directory/components/migration-empty-state/MigrationEmptyState": [
		3303,
		9,
		1097
	],
	"./pages/accounting-dashboard/client-directory/components/migration-empty-state/MigrationEmptyState.tsx": [
		3303,
		9,
		1097
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-client-billing-setup/addClientBillingSetup": [
		2681,
		9,
		581
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-client-billing-setup/addClientBillingSetup.tsx": [
		2681,
		9,
		581
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-client-billing-setup/styles": [
		2682,
		9,
		1836
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-client-billing-setup/styles.ts": [
		2682,
		9,
		1836
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-client-current-subscription-plan/addClientCurrentSubscriptionPlan": [
		2683,
		9,
		995
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-client-current-subscription-plan/addClientCurrentSubscriptionPlan.tsx": [
		2683,
		9,
		995
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-existing-client-form/addExistingClientForm": [
		2993,
		9,
		459
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-existing-client-form/addExistingClientForm.tsx": [
		2993,
		9,
		459
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-existing-client-form/companyCheckInSystem": [
		2684,
		9,
		1837
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-existing-client-form/companyCheckInSystem.tsx": [
		2684,
		9,
		1837
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-new-client-form/addNewClientForm": [
		3304,
		9,
		130,
		9,
		90,
		668
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-new-client-form/addNewClientForm.tsx": [
		3304,
		9,
		130,
		9,
		90,
		668
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-new-client-form/addNewClientFormStyles": [
		3542,
		9,
		1838
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-new-client-form/addNewClientFormStyles.ts": [
		3542,
		9,
		1838
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-pure-client-form/addPureClientForm": [
		3305,
		9,
		9,
		90,
		846
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-pure-client-form/addPureClientForm.tsx": [
		3305,
		9,
		9,
		90,
		846
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-pure-client-form/addPureClientFormStyles": [
		3306,
		9,
		1839
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/add-pure-client-form/addPureClientFormStyles.ts": [
		3306,
		9,
		1839
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/addNewClient": [
		3511,
		9,
		130,
		9,
		90,
		356,
		1095
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/addNewClient.tsx": [
		3511,
		9,
		130,
		9,
		90,
		356,
		1095
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/bread-crumbs/breadCrumbs": [
		3543,
		9,
		1840
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/bread-crumbs/breadCrumbs.tsx": [
		3543,
		9,
		1840
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/country-selection/countrySelection": [
		3544,
		9,
		1454
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/country-selection/countrySelection.tsx": [
		3544,
		9,
		1454
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/discount-notification/discountNotification": [
		3503,
		9,
		786
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/discount-notification/discountNotification.tsx": [
		3503,
		9,
		786
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/discount-notification/discountNotificationStyles": [
		2997,
		9,
		1841
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/discount-notification/discountNotificationStyles.ts": [
		2997,
		9,
		1841
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/discount-notification/hooks": [
		2998,
		9,
		1842
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/discount-notification/hooks.ts": [
		2998,
		9,
		1842
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/queries/partner/queryKeys": [
		3310,
		9,
		1843
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/queries/partner/queryKeys.ts": [
		3310,
		9,
		1843
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/queries/partner/types": [
		3545,
		9,
		1844
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/queries/partner/types.ts": [
		3545,
		9,
		1844
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/queries/partner/useGetBillingCycle": [
		3546,
		9,
		1455
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/queries/partner/useGetBillingCycle.ts": [
		3546,
		9,
		1455
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/role-selection/roleSelection": [
		2685,
		9,
		1256
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/role-selection/roleSelection.tsx": [
		2685,
		9,
		1256
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/select-grid-card/selectGridCard": [
		2995,
		9,
		1456
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/select-grid-card/selectGridCard.tsx": [
		2995,
		9,
		1456
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/select-grid-card/styles": [
		2689,
		9,
		1845
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/select-grid-card/styles.ts": [
		2689,
		9,
		1845
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/select-grid-card/types": [
		3547,
		9,
		1846
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/select-grid-card/types.ts": [
		3547,
		9,
		1846
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-card-loading/subscriptionCardLoading": [
		2690,
		9,
		1257
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-card-loading/subscriptionCardLoading.tsx": [
		2690,
		9,
		1257
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-card/styles": [
		2396,
		9,
		1847
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-card/styles.ts": [
		2396,
		9,
		1847
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-card/subscriptionCard": [
		2691,
		9,
		994
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-card/subscriptionCard.tsx": [
		2691,
		9,
		994
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-card/types": [
		3548,
		9,
		1848
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-card/types.ts": [
		3548,
		9,
		1848
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-cards/hooks": [
		2996,
		9,
		9,
		633
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-cards/hooks.tsx": [
		2996,
		9,
		9,
		633
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-cards/subscriptionCards": [
		3307,
		9,
		9,
		542
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-cards/subscriptionCards.tsx": [
		3307,
		9,
		9,
		542
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-cards/subscriptionCardsStyles": [
		2994,
		9,
		1849
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/subscription-cards/subscriptionCardsStyles.ts": [
		2994,
		9,
		1849
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/termsOfService/termsOfService": [
		2687,
		9,
		1098
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/termsOfService/termsOfService.tsx": [
		2687,
		9,
		1098
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/text-fields/textFieldsStyles": [
		3549,
		9,
		1850
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/text-fields/textFieldsStyles.ts": [
		3549,
		9,
		1850
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/useAddClient": [
		3309,
		9,
		1457
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/useAddClient.ts": [
		3309,
		9,
		1457
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/useCompanyFound": [
		1721,
		9,
		1851
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/useCompanyFound.ts": [
		1721,
		9,
		1851
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/useGetClientInfo": [
		2373,
		9,
		1458
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/useGetClientInfo.ts": [
		2373,
		9,
		1458
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/useValidation": [
		3308,
		9,
		1258
	],
	"./pages/accounting-dashboard/client-directory/components/page-add-new-client/useValidation.ts": [
		3308,
		9,
		1258
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/administrators": [
		3512,
		9,
		79,
		358
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/administrators.tsx": [
		3512,
		9,
		79,
		358
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/administratorsStyles": [
		3550,
		9,
		1852
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/administratorsStyles.ts": [
		3550,
		9,
		1852
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/admins-grid/adminsGrid": [
		3313,
		9,
		79,
		669
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/admins-grid/adminsGrid.tsx": [
		3313,
		9,
		79,
		669
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/grid-header/gridHeader": [
		3000,
		9,
		1853
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/grid-header/gridHeader.tsx": [
		3000,
		9,
		1853
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/modal-context/modalContext": [
		2195,
		9,
		1854
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/modal-context/modalContext.tsx": [
		2195,
		9,
		1854
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/modals/assignAdminsDialog": [
		3311,
		9,
		997
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/modals/assignAdminsDialog.tsx": [
		3311,
		9,
		997
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/modals/modalsStyles": [
		2999,
		9,
		1855
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/modals/modalsStyles.ts": [
		2999,
		9,
		1855
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/modals/removeDisconnectAdminsDialog": [
		3312,
		9,
		1259
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/modals/removeDisconnectAdminsDialog.tsx": [
		3312,
		9,
		1259
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/useAdministratorsActionRequests": [
		2219,
		9,
		1856
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/useAdministratorsActionRequests.ts": [
		2219,
		9,
		1856
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/useAdministratorsForGrid": [
		553,
		9
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/useAdministratorsForGrid.ts": [
		553,
		9
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/useAdministratorsQueries": [
		533,
		9
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/useAdministratorsQueries.ts": [
		533,
		9
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/zero-state-image/zeroStateImage": [
		3287,
		9,
		79
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/zero-state-image/zeroStateImage.tsx": [
		3287,
		9,
		79
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/zero-state-text/zeroStateText": [
		2695,
		9,
		1459
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/zero-state-text/zeroStateText.tsx": [
		2695,
		9,
		1459
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/zero-state-text/zeroStateTextStyles": [
		2397,
		9,
		1857
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/zero-state-text/zeroStateTextStyles.ts": [
		2397,
		9,
		1857
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/zero-state/zeroState": [
		3001,
		9,
		79,
		1099
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/zero-state/zeroState.tsx": [
		3001,
		9,
		79,
		1099
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/zero-state/zeroStateStyles": [
		2694,
		9,
		1858
	],
	"./pages/accounting-dashboard/client-directory/components/page-administrators/zero-state/zeroStateStyles.ts": [
		2694,
		9,
		1858
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-discounts/clientDiscounts": [
		3002,
		9,
		552
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-discounts/clientDiscounts.tsx": [
		3002,
		9,
		552
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/card-data/cardData": [
		2696,
		9,
		721
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/card-data/cardData.tsx": [
		2696,
		9,
		721
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/card-data/innerCardDataStyles": [
		2398,
		9,
		1859
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/card-data/innerCardDataStyles.ts": [
		2398,
		9,
		1859
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/container/container": [
		3003,
		9,
		495
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/container/container.tsx": [
		3003,
		9,
		495
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/inner-info/innerInfo": [
		2399,
		9,
		1100
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/inner-info/innerInfo.tsx": [
		2399,
		9,
		1100
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/inner-info/innerInfoStyles": [
		3551,
		9,
		1860
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/inner-info/innerInfoStyles.ts": [
		3551,
		9,
		1860
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/zero-state/zeroState": [
		2400,
		9,
		1101
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/client-update-card/zero-state/zeroState.tsx": [
		2400,
		9,
		1101
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/clientDirectory": [
		3314,
		9,
		0,
		4,
		11,
		119,
		445
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/clientDirectory.tsx": [
		3314,
		9,
		0,
		4,
		11,
		119,
		445
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/clientDirectoryQueries": [
		1591,
		9,
		1460
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/clientDirectoryQueries.ts": [
		1591,
		9,
		1460
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/clients-grid/clientsGrid": [
		3315,
		9,
		0,
		4,
		11,
		119,
		583
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/clients-grid/clientsGrid.tsx": [
		3315,
		9,
		0,
		4,
		11,
		119,
		583
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/clients-grid/useWpTableFilterAndSorting": [
		3321,
		9,
		1461
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/clients-grid/useWpTableFilterAndSorting.tsx": [
		3321,
		9,
		1461
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/grid-header/gridHeader": [
		3318,
		9,
		1102
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/grid-header/gridHeader.tsx": [
		3318,
		9,
		1102
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/grid-header/gridHeaderStyles": [
		3552,
		9,
		1861
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/grid-header/gridHeaderStyles.ts": [
		3552,
		9,
		1861
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/grid-header/useFilterOptions": [
		3004,
		9,
		1862
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/grid-header/useFilterOptions.ts": [
		3004,
		9,
		1862
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/grid-table-title/gridTableHeaderTitle": [
		2196,
		9,
		1863
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/grid-table-title/gridTableHeaderTitle.tsx": [
		2196,
		9,
		1863
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/migrated-customer-banner/MigrationBanner": [
		3005,
		9,
		1103
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/migrated-customer-banner/MigrationBanner.tsx": [
		3005,
		9,
		1103
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/modal-context/modalContext": [
		1660,
		9,
		1864
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/modal-context/modalContext.tsx": [
		1660,
		9,
		1864
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/modals/disconnectClientDialog": [
		3317,
		9,
		582
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/modals/disconnectClientDialog.tsx": [
		3317,
		9,
		582
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/modals/types": [
		3553,
		9,
		1865
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/modals/types.ts": [
		3553,
		9,
		1865
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/statements/autoAdminAssignStmt": [
		2401,
		9,
		998
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/statements/autoAdminAssignStmt.tsx": [
		2401,
		9,
		998
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/styles": [
		2697,
		9,
		1866
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/styles.ts": [
		2697,
		9,
		1866
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/upgrade-clients": [
		838,
		9,
		282
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/upgrade-clients/": [
		838,
		9,
		282
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/upgrade-clients/index": [
		838,
		9,
		282
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/upgrade-clients/index.tsx": [
		838,
		9,
		282
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/useClients": [
		1808,
		9,
		1260
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/useClients.ts": [
		1808,
		9,
		1260
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/useGridColumns": [
		3319,
		9,
		600
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/useGridColumns.tsx": [
		3319,
		9,
		600
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/useWpTableColumns": [
		3320,
		9,
		601
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/useWpTableColumns.tsx": [
		3320,
		9,
		601
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/zero-state-image/zeroStateImage": [
		2698,
		9,
		1462
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/zero-state-image/zeroStateImage.tsx": [
		2698,
		9,
		1462
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/zero-state-text/zeroStateText": [
		3554,
		9,
		931
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/zero-state-text/zeroStateText.tsx": [
		3554,
		9,
		931
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/zero-state-text/zeroStateTextStyles": [
		3322,
		9,
		1867
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/zero-state-text/zeroStateTextStyles.ts": [
		3322,
		9,
		1867
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/zero-state/zeroState": [
		3316,
		9,
		999
	],
	"./pages/accounting-dashboard/client-directory/components/page-client-directory/zero-state/zeroState.tsx": [
		3316,
		9,
		999
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/components/notification-list/notificationList": [
		3006,
		9,
		788
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/components/notification-list/notificationList.tsx": [
		3006,
		9,
		788
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/components/notifications-form/notificationsForm": [
		3323,
		9,
		9,
		553
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/components/notifications-form/notificationsForm.tsx": [
		3323,
		9,
		9,
		553
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/notificationQueries": [
		2699,
		9,
		1463
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/notificationQueries.ts": [
		2699,
		9,
		1463
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/notifications": [
		3513,
		9,
		9,
		350
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/notifications.tsx": [
		3513,
		9,
		9,
		350
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/notificationsStyles": [
		3324,
		9,
		1868
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/notificationsStyles.ts": [
		3324,
		9,
		1868
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/useNotifications": [
		3007,
		9,
		9,
		844
	],
	"./pages/accounting-dashboard/client-directory/components/page-notifications/useNotifications.ts": [
		3007,
		9,
		9,
		844
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/accept-company-billing-content/acceptCompanyBillingContent": [
		3215,
		9,
		92,
		1266
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/accept-company-billing-content/acceptCompanyBillingContent.tsx": [
		3215,
		9,
		92,
		1266
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/accept-company-billing-content/acceptCompanyBillingContentStyle": [
		3325,
		9,
		1869
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/accept-company-billing-content/acceptCompanyBillingContentStyle.ts": [
		3325,
		9,
		1869
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-company-details/cardCompanyDetails": [
		3008,
		9,
		9,
		750
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-company-details/cardCompanyDetails.tsx": [
		3008,
		9,
		9,
		750
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-main-info/cardMainInfo": [
		3009,
		9,
		9,
		620
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-main-info/cardMainInfo.tsx": [
		3009,
		9,
		9,
		620
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-main-info/cardMainInfoStyles": [
		2700,
		9,
		1870
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-main-info/cardMainInfoStyles.ts": [
		2700,
		9,
		1870
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-main-info/emailISection/emailSection": [
		2702,
		9,
		9,
		719
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-main-info/emailISection/emailSection.tsx": [
		2702,
		9,
		9,
		719
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-main-info/emailISection/useValidation": [
		2403,
		9,
		1871
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-main-info/emailISection/useValidation.ts": [
		2403,
		9,
		1871
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-permissions/cardPermissions": [
		3200,
		9,
		1872
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-permissions/cardPermissions.tsx": [
		3200,
		9,
		1872
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-subscription-plan/cardSubscriptionPlan": [
		3010,
		9,
		9,
		51,
		529
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-subscription-plan/cardSubscriptionPlan.tsx": [
		3010,
		9,
		9,
		51,
		529
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-tax-details/cardTaxDetailStyles": [
		2197,
		9,
		1873
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-tax-details/cardTaxDetailStyles.ts": [
		2197,
		9,
		1873
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-tax-details/cardTaxDetailsCA": [
		3011,
		9,
		9,
		691
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-tax-details/cardTaxDetailsCA.tsx": [
		3011,
		9,
		9,
		691
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-tax-details/cardTaxDetailsUS": [
		3012,
		9,
		9,
		565
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-tax-details/cardTaxDetailsUS.tsx": [
		3012,
		9,
		9,
		565
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-tax-details/useUSColumns": [
		2705,
		9,
		9,
		720
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-tax-details/useUSColumns.tsx": [
		2705,
		9,
		9,
		720
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-year-to-date-breakdown/cardYearToDateBreakdown": [
		3201,
		9,
		1250
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/card-year-to-date-breakdown/cardYearToDateBreakdown.tsx": [
		3201,
		9,
		1250
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/connect-client-form/connectClientForm": [
		2706,
		9,
		551
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/connect-client-form/connectClientForm.tsx": [
		2706,
		9,
		551
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/connect-client-form/connectClientFormStyles": [
		2406,
		9,
		1874
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/connect-client-form/connectClientFormStyles.ts": [
		2406,
		9,
		1874
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/login-button/loginButton": [
		3299,
		9,
		1875
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/login-button/loginButton.tsx": [
		3299,
		9,
		1875
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modal-context/modalContext": [
		1505,
		9,
		1876
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modal-context/modalContext.tsx": [
		1505,
		9,
		1876
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/acceptCompanyDialog": [
		3013,
		9,
		92,
		932
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/acceptCompanyDialog.tsx": [
		3013,
		9,
		92,
		932
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/billingSetupDialog": [
		3014,
		9,
		541
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/billingSetupDialog.tsx": [
		3014,
		9,
		541
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/connectClientDialog": [
		3015,
		9,
		520
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/connectClientDialog.tsx": [
		3015,
		9,
		520
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/declineCompanyDialog": [
		3016,
		9,
		1464
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/declineCompanyDialog.tsx": [
		3016,
		9,
		1464
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/disconnectClientDialog": [
		2943,
		9,
		634
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/disconnectClientDialog.tsx": [
		2943,
		9,
		634
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/payGroupsModal": [
		3017,
		9,
		1000
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/payGroupsModal.tsx": [
		3017,
		9,
		1000
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/styles": [
		2707,
		9,
		1877
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/styles.ts": [
		2707,
		9,
		1877
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/useBillingForm": [
		2222,
		9,
		1878
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/useBillingForm.ts": [
		2222,
		9,
		1878
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/useConnectClientValidation": [
		2708,
		9,
		1879
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/modals/useConnectClientValidation.ts": [
		2708,
		9,
		1879
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notification-context/notificationProvider": [
		1722,
		9,
		1880
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notification-context/notificationProvider.tsx": [
		1722,
		9,
		1880
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/acceptInvitationNotification": [
		3326,
		9,
		929
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/acceptInvitationNotification.tsx": [
		3326,
		9,
		929
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/closedAccountNotification": [
		3327,
		9,
		785
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/closedAccountNotification.tsx": [
		3327,
		9,
		785
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/inviteNotification/InviteNotificationWithTermsOfServiceForm": [
		3019,
		9,
		667
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/inviteNotification/InviteNotificationWithTermsOfServiceForm.tsx": [
		3019,
		9,
		667
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/inviteNotification/inviteNotification": [
		3328,
		9,
		718
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/inviteNotification/inviteNotification.tsx": [
		3328,
		9,
		718
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/inviteNotification/inviteNotificationStyles": [
		2408,
		9,
		1881
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/inviteNotification/inviteNotificationStyles.ts": [
		2408,
		9,
		1881
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/inviteNotification/inviteNotificationWithTermsOfService": [
		3329,
		9,
		632
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/inviteNotification/inviteNotificationWithTermsOfService.tsx": [
		3329,
		9,
		632
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/inviteNotification/useTermsOfServiceValidation": [
		2710,
		9,
		1882
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/inviteNotification/useTermsOfServiceValidation.ts": [
		2710,
		9,
		1882
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/notificationStyles": [
		3018,
		9,
		1883
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/notificationStyles.ts": [
		3018,
		9,
		1883
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/onboardingVerificationNotification": [
		3330,
		9,
		992
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/onboardingVerificationNotification.tsx": [
		3330,
		9,
		992
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/reconnectClientNotification": [
		3331,
		9,
		930
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/notifications/reconnectClientNotification.tsx": [
		3331,
		9,
		930
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/overview": [
		3333,
		9,
		9,
		51,
		92,
		122,
		420
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/overview-notification-card/overviewNotificationCard": [
		1934,
		9,
		1465
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/overview-notification-card/overviewNotificationCard.tsx": [
		1934,
		9,
		1465
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/overview-notification-card/overviewNotificationStyles": [
		1961,
		9,
		1884
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/overview-notification-card/overviewNotificationStyles.ts": [
		1961,
		9,
		1884
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/overview-notification/overviewNotification": [
		3332,
		9,
		122,
		1430
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/overview-notification/overviewNotification.tsx": [
		3332,
		9,
		122,
		1430
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/overview.tsx": [
		3333,
		9,
		9,
		51,
		92,
		122,
		420
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/overviewStyles": [
		3020,
		9,
		1885
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/overviewStyles.ts": [
		3020,
		9,
		1885
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/pay-proup-list/payGroupList": [
		2709,
		9,
		1262
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/pay-proup-list/payGroupList.tsx": [
		2709,
		9,
		1262
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/pay-proup-list/payGroupListStyles": [
		2407,
		9,
		1886
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/pay-proup-list/payGroupListStyles.ts": [
		2407,
		9,
		1886
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/table-text/tableBody": [
		2405,
		9,
		1887
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/table-text/tableBody.tsx": [
		2405,
		9,
		1887
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/table-text/tableHeader": [
		2404,
		9,
		1888
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/table-text/tableHeader.tsx": [
		2404,
		9,
		1888
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/two-step-approval-setting/twoStepApprovalSetting": [
		2701,
		9,
		1263
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/two-step-approval-setting/twoStepApprovalSetting.tsx": [
		2701,
		9,
		1263
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/two-step-approval-setting/twoStepApprovalSettingStyles": [
		2402,
		9,
		1889
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/two-step-approval-setting/twoStepApprovalSettingStyles.ts": [
		2402,
		9,
		1889
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/useOverviewActionRequests": [
		2047,
		9,
		1264
	],
	"./pages/accounting-dashboard/client-directory/components/page-overview/useOverviewActionRequests.ts": [
		2047,
		9,
		1264
	],
	"./pages/accounting-dashboard/client-directory/components/pricing-link/pricingLink": [
		1953,
		9,
		1466
	],
	"./pages/accounting-dashboard/client-directory/components/pricing-link/pricingLink.tsx": [
		1953,
		9,
		1466
	],
	"./pages/accounting-dashboard/client-directory/components/pricing-link/pricingLinkStyles": [
		1954,
		9,
		1890
	],
	"./pages/accounting-dashboard/client-directory/components/pricing-link/pricingLinkStyles.ts": [
		1954,
		9,
		1890
	],
	"./pages/accounting-dashboard/client-directory/components/radio-field-item/radioFieldItemStyles": [
		3555,
		9,
		1891
	],
	"./pages/accounting-dashboard/client-directory/components/radio-field-item/radioFieldItemStyles.ts": [
		3555,
		9,
		1891
	],
	"./pages/accounting-dashboard/client-directory/components/radio-field-item/radioFiledItem": [
		2688,
		9,
		1892
	],
	"./pages/accounting-dashboard/client-directory/components/radio-field-item/radioFiledItem.tsx": [
		2688,
		9,
		1892
	],
	"./pages/accounting-dashboard/client-directory/components/search-empty-state/searchEmptyState": [
		2693,
		9,
		1467
	],
	"./pages/accounting-dashboard/client-directory/components/search-empty-state/searchEmptyState.tsx": [
		2693,
		9,
		1467
	],
	"./pages/accounting-dashboard/client-directory/components/search-empty-state/searchEmptyStateStyles": [
		3556,
		9,
		1893
	],
	"./pages/accounting-dashboard/client-directory/components/search-empty-state/searchEmptyStateStyles.ts": [
		3556,
		9,
		1893
	],
	"./pages/accounting-dashboard/client-directory/components/small-field-item/smallFieldItem": [
		3557,
		9,
		1894
	],
	"./pages/accounting-dashboard/client-directory/components/small-field-item/smallFieldItem.tsx": [
		3557,
		9,
		1894
	],
	"./pages/accounting-dashboard/client-directory/components/text/dataLabel": [
		1350,
		9,
		1895
	],
	"./pages/accounting-dashboard/client-directory/components/text/dataLabel.tsx": [
		1350,
		9,
		1895
	],
	"./pages/accounting-dashboard/client-directory/components/text/dataValue": [
		1351,
		9,
		1896
	],
	"./pages/accounting-dashboard/client-directory/components/text/dataValue.tsx": [
		1351,
		9,
		1896
	],
	"./pages/accounting-dashboard/client-directory/components/text/errorText": [
		3558,
		9,
		1897
	],
	"./pages/accounting-dashboard/client-directory/components/text/errorText.tsx": [
		3558,
		9,
		1897
	],
	"./pages/accounting-dashboard/client-directory/components/text/selected": [
		2704,
		9,
		1898
	],
	"./pages/accounting-dashboard/client-directory/components/text/selected.tsx": [
		2704,
		9,
		1898
	],
	"./pages/accounting-dashboard/client-directory/components/text/subtitle": [
		3559,
		9,
		1899
	],
	"./pages/accounting-dashboard/client-directory/components/text/subtitle.tsx": [
		3559,
		9,
		1899
	],
	"./pages/accounting-dashboard/client-directory/components/text/title": [
		3560,
		9,
		1900
	],
	"./pages/accounting-dashboard/client-directory/components/text/title.tsx": [
		3560,
		9,
		1900
	],
	"./pages/accounting-dashboard/client-directory/components/translated-terms-of-service/translatedTermsOfService": [
		2077,
		9,
		1901
	],
	"./pages/accounting-dashboard/client-directory/components/translated-terms-of-service/translatedTermsOfService.tsx": [
		2077,
		9,
		1901
	],
	"./pages/accounting-dashboard/client-directory/constants": [
		260,
		9
	],
	"./pages/accounting-dashboard/client-directory/constants/": [
		260,
		9
	],
	"./pages/accounting-dashboard/client-directory/constants/index": [
		260,
		9
	],
	"./pages/accounting-dashboard/client-directory/constants/index.ts": [
		260,
		9
	],
	"./pages/accounting-dashboard/client-directory/constants/noValueStr": [
		572,
		9
	],
	"./pages/accounting-dashboard/client-directory/constants/noValueStr.ts": [
		572,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums": [
		110,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/": [
		110,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/addClientFormEnum": [
		584,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/addClientFormEnum.ts": [
		584,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/administratorsModalEnum": [
		579,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/administratorsModalEnum.ts": [
		579,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/billingTypeEnum": [
		578,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/billingTypeEnum.ts": [
		578,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/clientDirectoryBucketEnum": [
		580,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/clientDirectoryBucketEnum.ts": [
		580,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/clientDirectoryFilterOptionIdEnum": [
		581,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/clientDirectoryFilterOptionIdEnum.ts": [
		581,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/clientDirectoryPageModalEnum": [
		582,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/clientDirectoryPageModalEnum.ts": [
		582,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/helpSetupCompanyEnum": [
		576,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/helpSetupCompanyEnum.ts": [
		576,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/index": [
		110,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/index.ts": [
		110,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/monthEnum": [
		583,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/monthEnum.ts": [
		583,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/overviewModalEnum": [
		577,
		9
	],
	"./pages/accounting-dashboard/client-directory/enums/overviewModalEnum.ts": [
		577,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks": [
		335,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/": [
		335,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/index": [
		335,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/index.ts": [
		335,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useActivateModal": [
		568,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useActivateModal.ts": [
		568,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useAdministratorRoleName": [
		571,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useAdministratorRoleName.ts": [
		571,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useBillingTranslation": [
		573,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useBillingTranslation.ts": [
		573,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useCheckBelonging": [
		536,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useCheckBelonging.ts": [
		536,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useClientId": [
		357,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useClientId.ts": [
		357,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useDefaultBilling": [
		585,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useDefaultBilling.ts": [
		585,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useGetCompanyOverview": [
		2192,
		9,
		1902
	],
	"./pages/accounting-dashboard/client-directory/hooks/useGetCompanyOverview.ts": [
		2192,
		9,
		1902
	],
	"./pages/accounting-dashboard/client-directory/hooks/useHasClientInfoAccess": [
		570,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useHasClientInfoAccess.ts": [
		570,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useMonthOptions": [
		575,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useMonthOptions.ts": [
		575,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useRoleDescriptionName": [
		2223,
		9,
		1903
	],
	"./pages/accounting-dashboard/client-directory/hooks/useRoleDescriptionName.ts": [
		2223,
		9,
		1903
	],
	"./pages/accounting-dashboard/client-directory/hooks/useTabs": [
		569,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useTabs.ts": [
		569,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useWrapActionApi": [
		574,
		9
	],
	"./pages/accounting-dashboard/client-directory/hooks/useWrapActionApi.ts": [
		574,
		9
	],
	"./pages/accounting-dashboard/client-directory/interfaces": [
		868,
		9,
		214
	],
	"./pages/accounting-dashboard/client-directory/interfaces/": [
		868,
		9,
		214
	],
	"./pages/accounting-dashboard/client-directory/interfaces/addNewClientForm.interface": [
		3216,
		9,
		1904
	],
	"./pages/accounting-dashboard/client-directory/interfaces/addNewClientForm.interface.ts": [
		3216,
		9,
		1904
	],
	"./pages/accounting-dashboard/client-directory/interfaces/billingForm.interface": [
		3217,
		9,
		1905
	],
	"./pages/accounting-dashboard/client-directory/interfaces/billingForm.interface.ts": [
		3217,
		9,
		1905
	],
	"./pages/accounting-dashboard/client-directory/interfaces/clientDirectoryParams.type": [
		3218,
		9,
		1906
	],
	"./pages/accounting-dashboard/client-directory/interfaces/clientDirectoryParams.type.ts": [
		3218,
		9,
		1906
	],
	"./pages/accounting-dashboard/client-directory/interfaces/connectClientForm.interface": [
		3219,
		9,
		1907
	],
	"./pages/accounting-dashboard/client-directory/interfaces/connectClientForm.interface.ts": [
		3219,
		9,
		1907
	],
	"./pages/accounting-dashboard/client-directory/interfaces/filterOptionsWithDisabled.interface": [
		3220,
		9,
		1908
	],
	"./pages/accounting-dashboard/client-directory/interfaces/filterOptionsWithDisabled.interface.ts": [
		3220,
		9,
		1908
	],
	"./pages/accounting-dashboard/client-directory/interfaces/index": [
		868,
		9,
		214
	],
	"./pages/accounting-dashboard/client-directory/interfaces/index.ts": [
		868,
		9,
		214
	],
	"./pages/accounting-dashboard/client-directory/interfaces/maybe.type": [
		3222,
		9,
		1909
	],
	"./pages/accounting-dashboard/client-directory/interfaces/maybe.type.ts": [
		3222,
		9,
		1909
	],
	"./pages/accounting-dashboard/client-directory/interfaces/modalProps.interface": [
		3224,
		9,
		1910
	],
	"./pages/accounting-dashboard/client-directory/interfaces/modalProps.interface.ts": [
		3224,
		9,
		1910
	],
	"./pages/accounting-dashboard/client-directory/interfaces/modalReturn.type": [
		3221,
		9,
		1911
	],
	"./pages/accounting-dashboard/client-directory/interfaces/modalReturn.type.ts": [
		3221,
		9,
		1911
	],
	"./pages/accounting-dashboard/client-directory/interfaces/normalizedNotification.type": [
		3223,
		9,
		1912
	],
	"./pages/accounting-dashboard/client-directory/interfaces/normalizedNotification.type.ts": [
		3223,
		9,
		1912
	],
	"./pages/accounting-dashboard/client-directory/queries/partner/constants": [
		1367,
		9,
		1913
	],
	"./pages/accounting-dashboard/client-directory/queries/partner/constants.ts": [
		1367,
		9,
		1913
	],
	"./pages/accounting-dashboard/client-directory/queries/partner/queryKeys": [
		1246,
		9,
		1914
	],
	"./pages/accounting-dashboard/client-directory/queries/partner/queryKeys.ts": [
		1246,
		9,
		1914
	],
	"./pages/accounting-dashboard/client-directory/queries/partner/types": [
		3561,
		9,
		1915
	],
	"./pages/accounting-dashboard/client-directory/queries/partner/types.ts": [
		3561,
		9,
		1915
	],
	"./pages/accounting-dashboard/client-directory/queries/partner/useGetCompany": [
		2686,
		9,
		1468
	],
	"./pages/accounting-dashboard/client-directory/queries/partner/useGetCompany.ts": [
		2686,
		9,
		1468
	],
	"./pages/accounting-dashboard/client-directory/queries/partner/useGetPartner": [
		1319,
		9,
		1267
	],
	"./pages/accounting-dashboard/client-directory/queries/partner/useGetPartner.ts": [
		1319,
		9,
		1267
	],
	"./pages/accounting-dashboard/client-directory/routes": [
		265,
		9
	],
	"./pages/accounting-dashboard/client-directory/routes.ts": [
		265,
		9
	],
	"./pages/accounting-dashboard/client-directory/utils": [
		721,
		9,
		9,
		264
	],
	"./pages/accounting-dashboard/client-directory/utils/": [
		721,
		9,
		9,
		264
	],
	"./pages/accounting-dashboard/client-directory/utils/getFeesToShow": [
		1304,
		9,
		1916
	],
	"./pages/accounting-dashboard/client-directory/utils/getFeesToShow.ts": [
		1304,
		9,
		1916
	],
	"./pages/accounting-dashboard/client-directory/utils/index": [
		721,
		9,
		9,
		264
	],
	"./pages/accounting-dashboard/client-directory/utils/index.ts": [
		721,
		9,
		9,
		264
	],
	"./pages/accounting-dashboard/client-directory/utils/normalizeNotification": [
		1303,
		9,
		9,
		1917
	],
	"./pages/accounting-dashboard/client-directory/utils/normalizeNotification.ts": [
		1303,
		9,
		9,
		1917
	],
	"./pages/accounting-dashboard/client-directory/utils/showStringOrDash": [
		1302,
		9,
		1918
	],
	"./pages/accounting-dashboard/client-directory/utils/showStringOrDash.ts": [
		1302,
		9,
		1918
	],
	"./pages/accounting-dashboard/commonHooks/useAdministratorsTableColumns": [
		2078,
		9,
		1469
	],
	"./pages/accounting-dashboard/commonHooks/useAdministratorsTableColumns.tsx": [
		2078,
		9,
		1469
	],
	"./pages/accounting-dashboard/commonHooks/useAdministratorsTableColumnsUserAccounts": [
		2224,
		9,
		1105
	],
	"./pages/accounting-dashboard/commonHooks/useAdministratorsTableColumnsUserAccounts.tsx": [
		2224,
		9,
		1105
	],
	"./pages/accounting-dashboard/commonHooks/useCheckSecurityRoleType": [
		255,
		9
	],
	"./pages/accounting-dashboard/commonHooks/useCheckSecurityRoleType.tsx": [
		255,
		9
	],
	"./pages/accounting-dashboard/commonHooks/useRemoveInvitationId": [
		2076,
		9,
		1919
	],
	"./pages/accounting-dashboard/commonHooks/useRemoveInvitationId.ts": [
		2076,
		9,
		1919
	],
	"./pages/accounting-dashboard/dashboard/components/accordion-layout/accordionLayout": [
		1592,
		9,
		847
	],
	"./pages/accounting-dashboard/dashboard/components/accordion-layout/accordionLayout.tsx": [
		1592,
		9,
		847
	],
	"./pages/accounting-dashboard/dashboard/components/accordion-layout/accordionLayoutStyles": [
		1647,
		9,
		1920
	],
	"./pages/accounting-dashboard/dashboard/components/accordion-layout/accordionLayoutStyles.ts": [
		1647,
		9,
		1920
	],
	"./pages/accounting-dashboard/dashboard/components/card-helping-started/helpingStarted": [
		2711,
		9,
		1106
	],
	"./pages/accounting-dashboard/dashboard/components/card-helping-started/helpingStarted.tsx": [
		2711,
		9,
		1106
	],
	"./pages/accounting-dashboard/dashboard/components/card-helping-started/helpingStartedStyles": [
		2409,
		9,
		1921
	],
	"./pages/accounting-dashboard/dashboard/components/card-helping-started/helpingStartedStyles.ts": [
		2409,
		9,
		1921
	],
	"./pages/accounting-dashboard/dashboard/components/card-invite-clients/inviteClients": [
		2712,
		9,
		1002
	],
	"./pages/accounting-dashboard/dashboard/components/card-invite-clients/inviteClients.tsx": [
		2712,
		9,
		1002
	],
	"./pages/accounting-dashboard/dashboard/components/card-invite-clients/inviteClientsStyles": [
		2410,
		9,
		1922
	],
	"./pages/accounting-dashboard/dashboard/components/card-invite-clients/inviteClientsStyles.ts": [
		2410,
		9,
		1922
	],
	"./pages/accounting-dashboard/dashboard/components/card-no-clients/noClientsCard": [
		2225,
		9,
		1470
	],
	"./pages/accounting-dashboard/dashboard/components/card-no-clients/noClientsCard.tsx": [
		2225,
		9,
		1470
	],
	"./pages/accounting-dashboard/dashboard/components/grid-administrators/administratorsGrid": [
		2713,
		9,
		496
	],
	"./pages/accounting-dashboard/dashboard/components/grid-administrators/administratorsGrid.tsx": [
		2713,
		9,
		496
	],
	"./pages/accounting-dashboard/dashboard/components/grid-administrators/helpers/useAdminSorting": [
		2411,
		9,
		1923
	],
	"./pages/accounting-dashboard/dashboard/components/grid-administrators/helpers/useAdminSorting.tsx": [
		2411,
		9,
		1923
	],
	"./pages/accounting-dashboard/dashboard/components/grid-first-payrolls-to-run/firstPayrollToRunGrid": [
		2714,
		9,
		0,
		4,
		471
	],
	"./pages/accounting-dashboard/dashboard/components/grid-first-payrolls-to-run/firstPayrollToRunGrid.tsx": [
		2714,
		9,
		0,
		4,
		471
	],
	"./pages/accounting-dashboard/dashboard/components/grid-first-payrolls-to-run/firstPayrollToRunGridStyles": [
		2413,
		9,
		1924
	],
	"./pages/accounting-dashboard/dashboard/components/grid-first-payrolls-to-run/firstPayrollToRunGridStyles.ts": [
		2413,
		9,
		1924
	],
	"./pages/accounting-dashboard/dashboard/components/grid-first-payrolls-to-run/helpers/useGridSorting": [
		2412,
		9,
		1925
	],
	"./pages/accounting-dashboard/dashboard/components/grid-first-payrolls-to-run/helpers/useGridSorting.tsx": [
		2412,
		9,
		1925
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/helpers/useGridFilterAndSorting": [
		2226,
		9,
		1471
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/helpers/useGridFilterAndSorting.tsx": [
		2226,
		9,
		1471
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/helpers/usePayrollsDueTodayGridColumns": [
		2227,
		9,
		848
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/helpers/usePayrollsDueTodayGridColumns.tsx": [
		2227,
		9,
		848
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/helpers/usePayrollsDueTodayWpTableColumns": [
		2228,
		9,
		849
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/helpers/usePayrollsDueTodayWpTableColumns.tsx": [
		2228,
		9,
		849
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/helpers/useWpTableFilterAndSorting": [
		2229,
		9,
		1472
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/helpers/useWpTableFilterAndSorting.tsx": [
		2229,
		9,
		1472
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/helpers/withTooltip": [
		1594,
		9,
		1926
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/helpers/withTooltip.tsx": [
		1594,
		9,
		1926
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/payrollsDueTodayGrid": [
		2230,
		9,
		0,
		4,
		11,
		462
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/payrollsDueTodayGrid.tsx": [
		2230,
		9,
		0,
		4,
		11,
		462
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/payrollsDueTodayGridStyles": [
		1595,
		9,
		1927
	],
	"./pages/accounting-dashboard/dashboard/components/grid-payrolls-due-today/payrollsDueTodayGridStyles.ts": [
		1595,
		9,
		1927
	],
	"./pages/accounting-dashboard/dashboard/components/grid-reports-ready-for-viewing/helpers/useReportFilterandSotringData": [
		2715,
		9,
		1473
	],
	"./pages/accounting-dashboard/dashboard/components/grid-reports-ready-for-viewing/helpers/useReportFilterandSotringData.tsx": [
		2715,
		9,
		1473
	],
	"./pages/accounting-dashboard/dashboard/components/grid-reports-ready-for-viewing/reportsReadyForViewingGrid": [
		2945,
		9,
		168,
		1085
	],
	"./pages/accounting-dashboard/dashboard/components/grid-reports-ready-for-viewing/reportsReadyForViewingGrid.tsx": [
		2945,
		9,
		168,
		1085
	],
	"./pages/accounting-dashboard/dashboard/components/grid-reports-ready-for-viewing/reportsReadyForViewingGridStyles": [
		2716,
		9,
		1928
	],
	"./pages/accounting-dashboard/dashboard/components/grid-reports-ready-for-viewing/reportsReadyForViewingGridStyles.ts": [
		2716,
		9,
		1928
	],
	"./pages/accounting-dashboard/dashboard/components/help-articles/helpArticles": [
		1963,
		9,
		1003
	],
	"./pages/accounting-dashboard/dashboard/components/help-articles/helpArticles.tsx": [
		1963,
		9,
		1003
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/common/commonFiledBlock": [
		1964,
		9,
		1929
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/common/commonFiledBlock.tsx": [
		1964,
		9,
		1929
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/common/eventDetailsContent": [
		1810,
		9,
		692
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/common/eventDetailsContent.tsx": [
		1810,
		9,
		692
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/day-event/dayEvent": [
		1786,
		9,
		84,
		1930
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/day-event/dayEvent.tsx": [
		1786,
		9,
		84,
		1930
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/day-event/eventPopover": [
		2051,
		9,
		602
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/day-event/eventPopover.tsx": [
		2051,
		9,
		602
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/day-view-calendar/dayViewCalendar": [
		2231,
		9,
		84,
		850
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/day-view-calendar/dayViewCalendar.tsx": [
		2231,
		9,
		84,
		850
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/day-view-calendar/dayViewCalendarStyles": [
		2082,
		9,
		1931
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/day-view-calendar/dayViewCalendarStyles.ts": [
		2082,
		9,
		1931
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/helpers/helpers": [
		1217,
		9,
		852
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/helpers/helpers.ts": [
		1217,
		9,
		852
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/helpers/useCalendarFilter": [
		2232,
		9,
		1474
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/helpers/useCalendarFilter.tsx": [
		2232,
		9,
		1474
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/helpers/useGetEventList": [
		2233,
		9,
		751
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/helpers/useGetEventList.tsx": [
		2233,
		9,
		751
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/helpers/useGetEventTitle": [
		2083,
		9,
		1932
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/helpers/useGetEventTitle.tsx": [
		2083,
		9,
		1932
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/payrollCalendar": [
		2234,
		9,
		65,
		84,
		584
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/payrollCalendar.tsx": [
		2234,
		9,
		65,
		84,
		584
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/payrollCalendarStyles": [
		2236,
		9,
		1933
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/payrollCalendarStyles.ts": [
		2236,
		9,
		1933
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/week-view-calendar/weekViewCalendar": [
		2235,
		9,
		84,
		851
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/week-view-calendar/weekViewCalendar.tsx": [
		2235,
		9,
		84,
		851
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/week-view-calendar/weekViewCalendarStyles": [
		2084,
		9,
		1934
	],
	"./pages/accounting-dashboard/dashboard/components/payroll-calendar/week-view-calendar/weekViewCalendarStyles.ts": [
		2084,
		9,
		1934
	],
	"./pages/accounting-dashboard/dashboard/components/placeholder/placeholder": [
		1379,
		9,
		1107
	],
	"./pages/accounting-dashboard/dashboard/components/placeholder/placeholder.tsx": [
		1379,
		9,
		1107
	],
	"./pages/accounting-dashboard/dashboard/components/placeholder/placeholderStyles": [
		1593,
		9,
		1935
	],
	"./pages/accounting-dashboard/dashboard/components/placeholder/placeholderStyles.ts": [
		1593,
		9,
		1935
	],
	"./pages/accounting-dashboard/dashboard/components/post-migration-actions/newMigratedUserIntro": [
		3021,
		9,
		1936
	],
	"./pages/accounting-dashboard/dashboard/components/post-migration-actions/newMigratedUserIntro.tsx": [
		3021,
		9,
		1936
	],
	"./pages/accounting-dashboard/dashboard/dashboard": [
		3334,
		9,
		0,
		4,
		11,
		65,
		403
	],
	"./pages/accounting-dashboard/dashboard/dashboard-by-roles/accountOwnerAndAdminDashboard": [
		3022,
		9,
		0,
		4,
		11,
		65,
		422
	],
	"./pages/accounting-dashboard/dashboard/dashboard-by-roles/accountOwnerAndAdminDashboard.tsx": [
		3022,
		9,
		0,
		4,
		11,
		65,
		422
	],
	"./pages/accounting-dashboard/dashboard/dashboard-by-roles/autoAssignBanner": [
		2415,
		9,
		843
	],
	"./pages/accounting-dashboard/dashboard/dashboard-by-roles/autoAssignBanner.tsx": [
		2415,
		9,
		843
	],
	"./pages/accounting-dashboard/dashboard/dashboard-by-roles/payrollAdministratorDashboard": [
		3023,
		9,
		0,
		4,
		11,
		65,
		442
	],
	"./pages/accounting-dashboard/dashboard/dashboard-by-roles/payrollAdministratorDashboard.tsx": [
		3023,
		9,
		0,
		4,
		11,
		65,
		442
	],
	"./pages/accounting-dashboard/dashboard/dashboard-by-roles/reportsManagerDashboard": [
		3024,
		9,
		168,
		635
	],
	"./pages/accounting-dashboard/dashboard/dashboard-by-roles/reportsManagerDashboard.tsx": [
		3024,
		9,
		168,
		635
	],
	"./pages/accounting-dashboard/dashboard/dashboard.interface": [
		468,
		9
	],
	"./pages/accounting-dashboard/dashboard/dashboard.interface.ts": [
		468,
		9
	],
	"./pages/accounting-dashboard/dashboard/dashboard.tsx": [
		3334,
		9,
		0,
		4,
		11,
		65,
		403
	],
	"./pages/accounting-dashboard/dashboard/dashboardContainer": [
		3225,
		9,
		0,
		4,
		11,
		65,
		337
	],
	"./pages/accounting-dashboard/dashboard/dashboardContainer.tsx": [
		3225,
		9,
		0,
		4,
		11,
		65,
		337
	],
	"./pages/accounting-dashboard/dashboard/dashboardQueries": [
		1362,
		9,
		752
	],
	"./pages/accounting-dashboard/dashboard/dashboardQueries.ts": [
		1362,
		9,
		752
	],
	"./pages/accounting-dashboard/dashboard/dashboardStyles": [
		2414,
		9,
		1937
	],
	"./pages/accounting-dashboard/dashboard/dashboardStyles.ts": [
		2414,
		9,
		1937
	],
	"./pages/accounting-dashboard/dashboard/helpers/helpers": [
		1312,
		9,
		1938
	],
	"./pages/accounting-dashboard/dashboard/helpers/helpers.ts": [
		1312,
		9,
		1938
	],
	"./pages/accounting-dashboard/dashboard/helpers/usePayrollActions": [
		1517,
		9,
		1108
	],
	"./pages/accounting-dashboard/dashboard/helpers/usePayrollActions.tsx": [
		1517,
		9,
		1108
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationContainer": [
		3226,
		9,
		1,
		3,
		5,
		68,
		427
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationContainer.tsx": [
		3226,
		9,
		1,
		3,
		5,
		68,
		427
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationEdit/accountVerificationEdit": [
		3026,
		9,
		1,
		3,
		68,
		28,
		461
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationEdit/accountVerificationEdit.tsx": [
		3026,
		9,
		1,
		3,
		68,
		28,
		461
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationEmptyPage/accountVerificationEmptyPage": [
		3027,
		9,
		5,
		1939
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationEmptyPage/accountVerificationEmptyPage.tsx": [
		3027,
		9,
		5,
		1939
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/accountVerificationForm": [
		2719,
		9,
		1,
		3,
		68,
		28,
		463
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/accountVerificationForm.tsx": [
		2719,
		9,
		1,
		3,
		68,
		28,
		463
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/bank-verification-type-field/bankVerificationTypeField": [
		2420,
		9,
		753
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/bank-verification-type-field/bankVerificationTypeField.tsx": [
		2420,
		9,
		753
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/bank-verification-type-field/bankVerificationTypeFieldStyles": [
		2239,
		9,
		1940
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/bank-verification-type-field/bankVerificationTypeFieldStyles.ts": [
		2239,
		9,
		1940
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/bank-verification-type-field/emailVerificationPartner": [
		2423,
		9,
		1268
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/bank-verification-type-field/emailVerificationPartner.tsx": [
		2423,
		9,
		1268
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/business-verification-fields/businessVerificationFields": [
		2419,
		9,
		1109
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/business-verification-fields/businessVerificationFields.tsx": [
		2419,
		9,
		1109
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/footer/accountVerificationFooter": [
		2422,
		9,
		1,
		1004
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/footer/accountVerificationFooter.tsx": [
		2422,
		9,
		1,
		1004
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/hooks/useIsEnabledActions": [
		2243,
		9,
		1,
		1475
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/hooks/useIsEnabledActions.ts": [
		2243,
		9,
		1,
		1475
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/types": [
		3562,
		9,
		1941
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/types.ts": [
		3562,
		9,
		1941
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/verification-types-fields/instantVerificationFields": [
		2240,
		9,
		1269
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/verification-types-fields/instantVerificationFields.tsx": [
		2240,
		9,
		1269
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/verification-types-fields/manualVerivicationFields/accountValidationField/accountValidationField": [
		2242,
		9,
		1,
		3,
		68,
		28,
		693
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/verification-types-fields/manualVerivicationFields/accountValidationField/accountValidationField.tsx": [
		2242,
		9,
		1,
		3,
		68,
		28,
		693
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/verification-types-fields/manualVerivicationFields/microDepositField/microDepositField": [
		2241,
		9,
		1110
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/verification-types-fields/manualVerivicationFields/microDepositField/microDepositField.tsx": [
		2241,
		9,
		1110
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/verification-types-fields/manualVerivicationFields/microDepositField/unverifiedDeposit": [
		2088,
		9,
		1942
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/verification-types-fields/manualVerivicationFields/microDepositField/unverifiedDeposit.tsx": [
		2088,
		9,
		1942
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/verification-types-fields/verificationTypesFields": [
		2421,
		9,
		1,
		3,
		68,
		28,
		543
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationForm/verification-types-fields/verificationTypesFields.tsx": [
		2421,
		9,
		1,
		3,
		68,
		28,
		543
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationView/accountVerificationView": [
		3025,
		9,
		1,
		3,
		488
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/accountVerificationView/accountVerificationView.tsx": [
		3025,
		9,
		1,
		3,
		488
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/additionalDocumentsCard/additionalDocumentsCard": [
		1886,
		9,
		3,
		754
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/additionalDocumentsCard/additionalDocumentsCard.tsx": [
		1886,
		9,
		3,
		754
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/additionalDocumentsCard/submitButton": [
		1811,
		9,
		1943
	],
	"./pages/accounting-dashboard/firm-settings/components/accountVerification/additionalDocumentsCard/submitButton.tsx": [
		1811,
		9,
		1943
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/authSignatoryCard/authSignatoryCard": [
		2720,
		9,
		722
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/authSignatoryCard/authSignatoryCard.tsx": [
		2720,
		9,
		722
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/authSignatoryForm/authAgreementFields/authAgreementFields": [
		1966,
		9,
		1,
		3,
		63,
		28,
		694
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/authSignatoryForm/authAgreementFields/authAgreementFields.tsx": [
		1966,
		9,
		1,
		3,
		63,
		28,
		694
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/authSignatoryForm/authSignatoryForm": [
		3028,
		9,
		1,
		3,
		44,
		63,
		444
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/authSignatoryForm/authSignatoryForm.tsx": [
		3028,
		9,
		1,
		3,
		44,
		63,
		444
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/authSignatoryForm/authSignatoryFormFields": [
		1967,
		9,
		1,
		3,
		44,
		63,
		458
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/authSignatoryForm/authSignatoryFormFields.tsx": [
		1967,
		9,
		1,
		3,
		44,
		63,
		458
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/authSignatoryForm/signingOfficerField/signingOfficerField": [
		1968,
		9,
		44,
		745
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/authSignatoryForm/signingOfficerField/signingOfficerField.tsx": [
		1968,
		9,
		44,
		745
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingCard/bankingCard": [
		2721,
		9,
		755
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingCard/bankingCard.tsx": [
		2721,
		9,
		755
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingContainer": [
		3227,
		9,
		1,
		3,
		5,
		44,
		421
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingContainer.tsx": [
		3227,
		9,
		1,
		3,
		5,
		44,
		421
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingForm/bankingForm": [
		3029,
		9,
		1,
		3,
		920,
		112,
		670
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingForm/bankingForm.tsx": [
		3029,
		9,
		1,
		3,
		920,
		112,
		670
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingForm/bankingFormFields": [
		2089,
		9,
		3,
		112,
		935
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingForm/bankingFormFields.tsx": [
		2089,
		9,
		3,
		112,
		935
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingForm/selectedBankFields": [
		2244,
		9,
		3,
		112,
		1239
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingForm/selectedBankFields.tsx": [
		2244,
		9,
		3,
		112,
		1239
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingView/bankingView": [
		3030,
		9,
		1,
		3,
		44,
		63,
		426
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/bankingView/bankingView.tsx": [
		3030,
		9,
		1,
		3,
		44,
		63,
		426
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/createAdministratorForm/administratorTypeFields": [
		1519,
		9,
		1944
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/createAdministratorForm/administratorTypeFields.tsx": [
		1519,
		9,
		1944
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/createAdministratorForm/createAdministratorForm": [
		1558,
		9,
		1005
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/createAdministratorForm/createAdministratorForm.tsx": [
		1558,
		9,
		1005
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/createAdministratorForm/hooks/useValidationSchema": [
		1520,
		9,
		1270
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/createAdministratorForm/hooks/useValidationSchema.ts": [
		1520,
		9,
		1270
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/createAdministratorForm/types": [
		1345,
		9,
		1945
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/createAdministratorForm/types.ts": [
		1345,
		9,
		1945
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/initBankingForm/authSignatoryFieldsContainer": [
		2424,
		9,
		1,
		3,
		44,
		63,
		447
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/initBankingForm/authSignatoryFieldsContainer.tsx": [
		2424,
		9,
		1,
		3,
		44,
		63,
		447
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/initBankingForm/formValidationSchema": [
		2425,
		9,
		1,
		789
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/initBankingForm/formValidationSchema.ts": [
		2425,
		9,
		1,
		789
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/initBankingForm/initBankingForm": [
		2722,
		9,
		1,
		3,
		44,
		63,
		432
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/initBankingForm/initBankingForm.tsx": [
		2722,
		9,
		1,
		3,
		44,
		63,
		432
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/routes": [
		1937,
		9,
		1946
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/routes.ts": [
		1937,
		9,
		1946
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/types": [
		3563,
		9,
		1947
	],
	"./pages/accounting-dashboard/firm-settings/components/banking-old/types.ts": [
		3563,
		9,
		1947
	],
	"./pages/accounting-dashboard/firm-settings/components/general/companyLogo/companyLogo": [
		3335,
		9,
		3,
		936
	],
	"./pages/accounting-dashboard/firm-settings/components/general/companyLogo/companyLogo.tsx": [
		3335,
		9,
		3,
		936
	],
	"./pages/accounting-dashboard/firm-settings/components/general/companyLogo/companyLogoStyles": [
		3031,
		9,
		1948
	],
	"./pages/accounting-dashboard/firm-settings/components/general/companyLogo/companyLogoStyles.ts": [
		3031,
		9,
		1948
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmCard/firmCard": [
		3032,
		9,
		937
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmCard/firmCard.tsx": [
		3032,
		9,
		937
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmCard/firmCardStyles": [
		2723,
		9,
		1949
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmCard/firmCardStyles.ts": [
		2723,
		9,
		1949
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmForm/autoAdminAssignSection": [
		861,
		9,
		283
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmForm/autoAdminAssignSection/": [
		861,
		9,
		283
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmForm/autoAdminAssignSection/autoAssignPrompt": [
		3033,
		9,
		1476
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmForm/autoAdminAssignSection/autoAssignPrompt.tsx": [
		3033,
		9,
		1476
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmForm/autoAdminAssignSection/index": [
		861,
		9,
		283
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmForm/autoAdminAssignSection/index.tsx": [
		861,
		9,
		283
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmForm/autoAdminAssignSection/useSafetyHook": [
		1516,
		9,
		1950
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmForm/autoAdminAssignSection/useSafetyHook.ts": [
		1516,
		9,
		1950
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmForm/firmForm": [
		3336,
		9,
		131,
		126,
		1751
	],
	"./pages/accounting-dashboard/firm-settings/components/general/firmForm/firmForm.tsx": [
		3336,
		9,
		131,
		126,
		1751
	],
	"./pages/accounting-dashboard/firm-settings/components/general/generalContainer": [
		3228,
		9,
		131,
		126,
		1006
	],
	"./pages/accounting-dashboard/firm-settings/components/general/generalContainer.tsx": [
		3228,
		9,
		131,
		126,
		1006
	],
	"./pages/accounting-dashboard/firm-settings/components/general/generalFields/generalFields": [
		3337,
		9,
		713
	],
	"./pages/accounting-dashboard/firm-settings/components/general/generalFields/generalFields.tsx": [
		3337,
		9,
		713
	],
	"./pages/accounting-dashboard/firm-settings/components/general/uploadLogoField/uploadLogoField": [
		3564,
		9,
		3,
		853
	],
	"./pages/accounting-dashboard/firm-settings/components/general/uploadLogoField/uploadLogoField.tsx": [
		3564,
		9,
		3,
		853
	],
	"./pages/accounting-dashboard/firm-settings/components/general/useValidationSchema": [
		3338,
		9,
		1447
	],
	"./pages/accounting-dashboard/firm-settings/components/general/useValidationSchema.ts": [
		3338,
		9,
		1447
	],
	"./pages/accounting-dashboard/firm-settings/components/notifications/components/notificationCheckboxCell": [
		3339,
		9,
		1951
	],
	"./pages/accounting-dashboard/firm-settings/components/notifications/components/notificationCheckboxCell.tsx": [
		3339,
		9,
		1951
	],
	"./pages/accounting-dashboard/firm-settings/components/notifications/components/notificationTitleCell": [
		3340,
		9,
		1111
	],
	"./pages/accounting-dashboard/firm-settings/components/notifications/components/notificationTitleCell.tsx": [
		3340,
		9,
		1111
	],
	"./pages/accounting-dashboard/firm-settings/components/notifications/notificationsContainer": [
		3341,
		9,
		0,
		4,
		9,
		363,
		1752
	],
	"./pages/accounting-dashboard/firm-settings/components/notifications/notificationsContainer.tsx": [
		3341,
		9,
		0,
		4,
		9,
		363,
		1752
	],
	"./pages/accounting-dashboard/firm-settings/components/notifications/notificationsContainerStyles": [
		3342,
		9,
		1952
	],
	"./pages/accounting-dashboard/firm-settings/components/notifications/notificationsContainerStyles.ts": [
		3342,
		9,
		1952
	],
	"./pages/accounting-dashboard/firm-settings/firmSettingsContainer": [
		3229,
		9,
		132,
		364
	],
	"./pages/accounting-dashboard/firm-settings/firmSettingsContainer.tsx": [
		3229,
		9,
		132,
		364
	],
	"./pages/accounting-dashboard/firm-settings/firmSettingsLinks": [
		3343,
		9,
		1271
	],
	"./pages/accounting-dashboard/firm-settings/firmSettingsLinks.tsx": [
		3343,
		9,
		1271
	],
	"./pages/accounting-dashboard/firm-settings/firmSettingsQueries": [
		1098,
		9,
		1953
	],
	"./pages/accounting-dashboard/firm-settings/firmSettingsQueries.ts": [
		1098,
		9,
		1953
	],
	"./pages/accounting-dashboard/firm-settings/firmSettingsView": [
		3344,
		9,
		1272
	],
	"./pages/accounting-dashboard/firm-settings/firmSettingsView.tsx": [
		3344,
		9,
		1272
	],
	"./pages/accounting-dashboard/firm-settings/hooks/useIsAccountVerificationEnabled": [
		2946,
		9,
		132,
		1431
	],
	"./pages/accounting-dashboard/firm-settings/hooks/useIsAccountVerificationEnabled.ts": [
		2946,
		9,
		132,
		1431
	],
	"./pages/accounting-dashboard/firm-settings/types": [
		3345,
		9,
		1954
	],
	"./pages/accounting-dashboard/firm-settings/types.ts": [
		3345,
		9,
		1954
	],
	"./pages/accounting-dashboard/routes": [
		466,
		9
	],
	"./pages/accounting-dashboard/routes.ts": [
		466,
		9
	],
	"./pages/accounting-dashboard/subscription/components/billingTable/billingTable": [
		3034,
		9,
		1241
	],
	"./pages/accounting-dashboard/subscription/components/billingTable/billingTable.tsx": [
		3034,
		9,
		1241
	],
	"./pages/accounting-dashboard/subscription/components/billingTable/billingTableStyles": [
		2724,
		9,
		1955
	],
	"./pages/accounting-dashboard/subscription/components/billingTable/billingTableStyles.ts": [
		2724,
		9,
		1955
	],
	"./pages/accounting-dashboard/subscription/invoices/companyQueries": [
		3035,
		9,
		1956
	],
	"./pages/accounting-dashboard/subscription/invoices/companyQueries.ts": [
		3035,
		9,
		1956
	],
	"./pages/accounting-dashboard/subscription/invoices/invoiceQueries": [
		2427,
		9,
		1273
	],
	"./pages/accounting-dashboard/subscription/invoices/invoiceQueries.ts": [
		2427,
		9,
		1273
	],
	"./pages/accounting-dashboard/subscription/invoices/invoiceView/invoiceView": [
		3230,
		9,
		1,
		12,
		14,
		16,
		185
	],
	"./pages/accounting-dashboard/subscription/invoices/invoiceView/invoiceView.tsx": [
		3230,
		9,
		1,
		12,
		14,
		16,
		185
	],
	"./pages/accounting-dashboard/subscription/invoices/invoiceView/invoiceViewStyles": [
		3346,
		9,
		1957
	],
	"./pages/accounting-dashboard/subscription/invoices/invoiceView/invoiceViewStyles.ts": [
		3346,
		9,
		1957
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/filters/filters": [
		3347,
		9,
		856
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/filters/filters.tsx": [
		3347,
		9,
		856
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/filters/hooks": [
		3036,
		9,
		1114
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/filters/hooks.ts": [
		3036,
		9,
		1114
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/filters/types": [
		2198,
		9,
		1958
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/filters/types.ts": [
		2198,
		9,
		1958
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/filters/wpHooks": [
		3348,
		9,
		1009
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/filters/wpHooks.ts": [
		3348,
		9,
		1009
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/table/table": [
		3349,
		9,
		1444
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/table/table.tsx": [
		3349,
		9,
		1444
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/table/types": [
		3565,
		9,
		1959
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/components/table/types.ts": [
		3565,
		9,
		1959
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/constants": [
		2247,
		9,
		1960
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/constants.ts": [
		2247,
		9,
		1960
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/invoicesList": [
		3232,
		9,
		0,
		4,
		11,
		156
	],
	"./pages/accounting-dashboard/subscription/invoices/invoicesList/invoicesList.tsx": [
		3232,
		9,
		0,
		4,
		11,
		156
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/billingGlanceCard": [
		3352,
		9,
		93,
		94,
		1961
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/billingGlanceCard.tsx": [
		3352,
		9,
		93,
		94,
		1961
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/billingGlanceTable/billingGlanceTable": [
		3356,
		9,
		93
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/billingGlanceTable/billingGlanceTable.tsx": [
		3356,
		9,
		93
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/billingGlanceTable/hooks": [
		3358,
		9,
		790
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/billingGlanceTable/hooks.tsx": [
		3358,
		9,
		790
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/billingGlanceTable/types": [
		2947,
		9,
		1962
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/billingGlanceTable/types.ts": [
		2947,
		9,
		1962
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/changesTrouser/changesTrouser": [
		3353,
		9,
		94,
		1797
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/changesTrouser/changesTrouser.tsx": [
		3353,
		9,
		94,
		1797
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/changesTrouser/changesTrouserStyles": [
		3354,
		9,
		1963
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/changesTrouser/changesTrouserStyles.ts": [
		3354,
		9,
		1963
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/changesTrouser/hooks": [
		3355,
		9,
		1479
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/changesTrouser/hooks.ts": [
		3355,
		9,
		1479
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/changesTrouser/types": [
		3037,
		9,
		1964
	],
	"./pages/accounting-dashboard/subscription/overview/billingGlanceCard/changesTrouser/types.ts": [
		3037,
		9,
		1964
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/discountCard": [
		3504,
		9,
		938
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/discountCard.tsx": [
		3504,
		9,
		938
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/hooks": [
		3042,
		9,
		1480
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/hooks.ts": [
		3042,
		9,
		1480
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/progressBar/progressBar": [
		3040,
		9,
		1481
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/progressBar/progressBar.tsx": [
		3040,
		9,
		1481
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/progressBar/progressBarStyles": [
		2725,
		9,
		1965
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/progressBar/progressBarStyles.ts": [
		2725,
		9,
		1965
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/styles": [
		3041,
		9,
		1966
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/styles.ts": [
		3041,
		9,
		1966
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/types": [
		3566,
		9,
		1967
	],
	"./pages/accounting-dashboard/subscription/overview/discountCard/types.ts": [
		3566,
		9,
		1967
	],
	"./pages/accounting-dashboard/subscription/overview/helpers": [
		2726,
		9,
		1968
	],
	"./pages/accounting-dashboard/subscription/overview/helpers.ts": [
		2726,
		9,
		1968
	],
	"./pages/accounting-dashboard/subscription/overview/infoCard/infoCard": [
		3359,
		9,
		577
	],
	"./pages/accounting-dashboard/subscription/overview/infoCard/infoCard.tsx": [
		3359,
		9,
		577
	],
	"./pages/accounting-dashboard/subscription/overview/infoCard/types": [
		3567,
		9,
		1969
	],
	"./pages/accounting-dashboard/subscription/overview/infoCard/types.ts": [
		3567,
		9,
		1969
	],
	"./pages/accounting-dashboard/subscription/overview/overviewContainer": [
		3360,
		9,
		93,
		94,
		344
	],
	"./pages/accounting-dashboard/subscription/overview/overviewContainer.tsx": [
		3360,
		9,
		93,
		94,
		344
	],
	"./pages/accounting-dashboard/subscription/overview/overviewQueries": [
		2220,
		9,
		1970
	],
	"./pages/accounting-dashboard/subscription/overview/overviewQueries.ts": [
		2220,
		9,
		1970
	],
	"./pages/accounting-dashboard/subscription/overview/partnerNotPayFeesCard/partnerNotPayFeesCard": [
		3045,
		9,
		922
	],
	"./pages/accounting-dashboard/subscription/overview/partnerNotPayFeesCard/partnerNotPayFeesCard.tsx": [
		3045,
		9,
		922
	],
	"./pages/accounting-dashboard/subscription/overview/partnerNotPayFeesCard/styles": [
		2728,
		9,
		1971
	],
	"./pages/accounting-dashboard/subscription/overview/partnerNotPayFeesCard/styles.ts": [
		2728,
		9,
		1971
	],
	"./pages/accounting-dashboard/subscription/overview/partnerOverviewCard/partnerOverviewCard": [
		3044,
		9,
		836
	],
	"./pages/accounting-dashboard/subscription/overview/partnerOverviewCard/partnerOverviewCard.tsx": [
		3044,
		9,
		836
	],
	"./pages/accounting-dashboard/subscription/overview/queries/billing/constants": [
		3038,
		9,
		1972
	],
	"./pages/accounting-dashboard/subscription/overview/queries/billing/constants.ts": [
		3038,
		9,
		1972
	],
	"./pages/accounting-dashboard/subscription/overview/queries/billing/queryKeys": [
		3039,
		9,
		1973
	],
	"./pages/accounting-dashboard/subscription/overview/queries/billing/queryKeys.ts": [
		3039,
		9,
		1973
	],
	"./pages/accounting-dashboard/subscription/overview/queries/billing/types": [
		3568,
		9,
		1974
	],
	"./pages/accounting-dashboard/subscription/overview/queries/billing/types.ts": [
		3568,
		9,
		1974
	],
	"./pages/accounting-dashboard/subscription/overview/queries/billing/useInvoiceList": [
		3357,
		9,
		1274
	],
	"./pages/accounting-dashboard/subscription/overview/queries/billing/useInvoiceList.ts": [
		3357,
		9,
		1274
	],
	"./pages/accounting-dashboard/subscription/overview/queries/plan/queryKeys": [
		1446,
		9,
		1975
	],
	"./pages/accounting-dashboard/subscription/overview/queries/plan/queryKeys.ts": [
		1446,
		9,
		1975
	],
	"./pages/accounting-dashboard/subscription/overview/queries/plan/useGetSubscriptionPlanList": [
		1545,
		9,
		1482
	],
	"./pages/accounting-dashboard/subscription/overview/queries/plan/useGetSubscriptionPlanList.ts": [
		1545,
		9,
		1482
	],
	"./pages/accounting-dashboard/subscription/overview/zeroClients/styles": [
		2727,
		9,
		1976
	],
	"./pages/accounting-dashboard/subscription/overview/zeroClients/styles.ts": [
		2727,
		9,
		1976
	],
	"./pages/accounting-dashboard/subscription/overview/zeroClients/zeroClients": [
		3043,
		9,
		923
	],
	"./pages/accounting-dashboard/subscription/overview/zeroClients/zeroClients.tsx": [
		3043,
		9,
		923
	],
	"./pages/accounting-dashboard/subscription/subscriptionContainer": [
		3233,
		9,
		367
	],
	"./pages/accounting-dashboard/subscription/subscriptionContainer.tsx": [
		3233,
		9,
		367
	],
	"./pages/accounting-dashboard/subscription/subscriptionLinks": [
		3361,
		9,
		1113
	],
	"./pages/accounting-dashboard/subscription/subscriptionLinks.tsx": [
		3361,
		9,
		1113
	],
	"./pages/accounting-dashboard/subscription/subscriptionView": [
		3362,
		9,
		1977
	],
	"./pages/accounting-dashboard/subscription/subscriptionView.tsx": [
		3362,
		9,
		1977
	],
	"./pages/accounting-dashboard/subscription/tempSubscriptionContainer": [
		3234,
		9,
		376
	],
	"./pages/accounting-dashboard/subscription/tempSubscriptionContainer.tsx": [
		3234,
		9,
		376
	],
	"./pages/accounting-dashboard/subscription/utils": [
		3350,
		9,
		1978
	],
	"./pages/accounting-dashboard/subscription/utils.ts": [
		3350,
		9,
		1978
	],
	"./pages/accounting-dashboard/user-accounts/administrators/administratorsView": [
		3363,
		9,
		40,
		477
	],
	"./pages/accounting-dashboard/user-accounts/administrators/administratorsView.tsx": [
		3363,
		9,
		40,
		477
	],
	"./pages/accounting-dashboard/user-accounts/administrators/components/addAdministrator/addadmin": [
		3046,
		9,
		756
	],
	"./pages/accounting-dashboard/user-accounts/administrators/components/addAdministrator/addadmin.tsx": [
		3046,
		9,
		756
	],
	"./pages/accounting-dashboard/user-accounts/administrators/components/addAdministrator/rolesRadioGroup": [
		2731,
		9,
		1979
	],
	"./pages/accounting-dashboard/user-accounts/administrators/components/addAdministrator/rolesRadioGroup.tsx": [
		2731,
		9,
		1979
	],
	"./pages/accounting-dashboard/user-accounts/administrators/components/administrators": [
		3048,
		9,
		933
	],
	"./pages/accounting-dashboard/user-accounts/administrators/components/administrators.tsx": [
		3048,
		9,
		933
	],
	"./pages/accounting-dashboard/user-accounts/administrators/components/transferOwnership": [
		3047,
		9,
		758
	],
	"./pages/accounting-dashboard/user-accounts/administrators/components/transferOwnership.tsx": [
		3047,
		9,
		758
	],
	"./pages/accounting-dashboard/user-accounts/common": [
		158,
		9
	],
	"./pages/accounting-dashboard/user-accounts/common.tsx": [
		158,
		9
	],
	"./pages/accounting-dashboard/user-accounts/components/administratorsTable/actionsCellTable": [
		2081,
		9,
		1275
	],
	"./pages/accounting-dashboard/user-accounts/components/administratorsTable/actionsCellTable.tsx": [
		2081,
		9,
		1275
	],
	"./pages/accounting-dashboard/user-accounts/components/administratorsTable/actionsCellTableDeprecated": [
		3569,
		9,
		1483
	],
	"./pages/accounting-dashboard/user-accounts/components/administratorsTable/actionsCellTableDeprecated.tsx": [
		3569,
		9,
		1483
	],
	"./pages/accounting-dashboard/user-accounts/components/administratorsTable/administratorsTable": [
		2378,
		9,
		1001
	],
	"./pages/accounting-dashboard/user-accounts/components/administratorsTable/administratorsTable.tsx": [
		2378,
		9,
		1001
	],
	"./pages/accounting-dashboard/user-accounts/components/administratorsTable/skeletonTable/skeletonTable": [
		3570,
		9,
		1115
	],
	"./pages/accounting-dashboard/user-accounts/components/administratorsTable/skeletonTable/skeletonTable.tsx": [
		3570,
		9,
		1115
	],
	"./pages/accounting-dashboard/user-accounts/components/administratorsTable/skeletonTable/skeletonTableStyles": [
		3367,
		9,
		1484
	],
	"./pages/accounting-dashboard/user-accounts/components/administratorsTable/skeletonTable/skeletonTableStyles.ts": [
		3367,
		9,
		1484
	],
	"./pages/accounting-dashboard/user-accounts/components/clientsList/assignedClientsList": [
		2433,
		9,
		1485
	],
	"./pages/accounting-dashboard/user-accounts/components/clientsList/assignedClientsList.tsx": [
		2433,
		9,
		1485
	],
	"./pages/accounting-dashboard/user-accounts/components/clientsList/assignedClientsView": [
		2733,
		9,
		1486
	],
	"./pages/accounting-dashboard/user-accounts/components/clientsList/assignedClientsView.tsx": [
		2733,
		9,
		1486
	],
	"./pages/accounting-dashboard/user-accounts/components/clientsList/clientListsQueries": [
		1813,
		9,
		1980
	],
	"./pages/accounting-dashboard/user-accounts/components/clientsList/clientListsQueries.ts": [
		1813,
		9,
		1980
	],
	"./pages/accounting-dashboard/user-accounts/components/clientsList/clientsList": [
		2376,
		9,
		1487
	],
	"./pages/accounting-dashboard/user-accounts/components/clientsList/clientsList.tsx": [
		2376,
		9,
		1487
	],
	"./pages/accounting-dashboard/user-accounts/components/dialogs/disableDialog": [
		1885,
		9,
		1981
	],
	"./pages/accounting-dashboard/user-accounts/components/dialogs/disableDialog.tsx": [
		1885,
		9,
		1981
	],
	"./pages/accounting-dashboard/user-accounts/components/dialogs/inviteAdmins": [
		1962,
		9,
		1982
	],
	"./pages/accounting-dashboard/user-accounts/components/dialogs/inviteAdmins.tsx": [
		1962,
		9,
		1982
	],
	"./pages/accounting-dashboard/user-accounts/components/edit/components/editRole": [
		2732,
		9,
		1276
	],
	"./pages/accounting-dashboard/user-accounts/components/edit/components/editRole.tsx": [
		2732,
		9,
		1276
	],
	"./pages/accounting-dashboard/user-accounts/components/edit/editView": [
		2948,
		9,
		40,
		939
	],
	"./pages/accounting-dashboard/user-accounts/components/edit/editView.tsx": [
		2948,
		9,
		40,
		939
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/adminListField": [
		2430,
		9,
		1983
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/adminListField.tsx": [
		2430,
		9,
		1983
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/hooks/useTransferOwnershipForm": [
		2650,
		9,
		1116
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/hooks/useTransferOwnershipForm.ts": [
		2650,
		9,
		1116
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/hooks/useValidationSchema": [
		2432,
		9,
		1984
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/hooks/useValidationSchema.ts": [
		2432,
		9,
		1984
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/managerFields": [
		2250,
		9,
		1985
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/managerFields.tsx": [
		2250,
		9,
		1985
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/transferOwnershipForm": [
		2649,
		9,
		1010
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/transferOwnershipForm.tsx": [
		2649,
		9,
		1010
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/transferTypeFields": [
		2431,
		9,
		1277
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/transferTypeFields.tsx": [
		2431,
		9,
		1277
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/types": [
		1938,
		9,
		1986
	],
	"./pages/accounting-dashboard/user-accounts/components/transferOwnershipForm/types.ts": [
		1938,
		9,
		1986
	],
	"./pages/accounting-dashboard/user-accounts/hooks/useHelperAutoAssigment": [
		2377,
		9,
		1477
	],
	"./pages/accounting-dashboard/user-accounts/hooks/useHelperAutoAssigment.tsx": [
		2377,
		9,
		1477
	],
	"./pages/accounting-dashboard/user-accounts/permission/components/EditButton": [
		3366,
		9,
		1488
	],
	"./pages/accounting-dashboard/user-accounts/permission/components/EditButton.tsx": [
		3366,
		9,
		1488
	],
	"./pages/accounting-dashboard/user-accounts/permission/components/customizationDialog": [
		3365,
		9,
		1987
	],
	"./pages/accounting-dashboard/user-accounts/permission/components/customizationDialog.tsx": [
		3365,
		9,
		1987
	],
	"./pages/accounting-dashboard/user-accounts/permission/components/resetDialog": [
		3364,
		9,
		1988
	],
	"./pages/accounting-dashboard/user-accounts/permission/components/resetDialog.tsx": [
		3364,
		9,
		1988
	],
	"./pages/accounting-dashboard/user-accounts/permission/components/unsaveDialog": [
		2730,
		9,
		1989
	],
	"./pages/accounting-dashboard/user-accounts/permission/components/unsaveDialog.tsx": [
		2730,
		9,
		1989
	],
	"./pages/accounting-dashboard/user-accounts/permission/permissionTable": [
		3049,
		9,
		40
	],
	"./pages/accounting-dashboard/user-accounts/permission/permissionTable.tsx": [
		3049,
		9,
		40
	],
	"./pages/accounting-dashboard/user-accounts/permission/permissionTableStyles": [
		2949,
		9,
		1990
	],
	"./pages/accounting-dashboard/user-accounts/permission/permissionTableStyles.ts": [
		2949,
		9,
		1990
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/assign/assignRole": [
		3368,
		9,
		854
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/assign/assignRole.tsx": [
		3368,
		9,
		854
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/assign/validationShema": [
		3050,
		9,
		1489
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/assign/validationShema.ts": [
		3050,
		9,
		1489
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/roleContainer": [
		3051,
		9,
		40,
		52,
		64,
		1265
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/roleContainer.tsx": [
		3051,
		9,
		40,
		52,
		64,
		1265
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/roleContainerStyles": [
		3571,
		9,
		1991
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/roleContainerStyles.ts": [
		3571,
		9,
		1991
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/rolesAssignedPeople": [
		3369,
		9,
		934
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/rolesAssignedPeople.tsx": [
		3369,
		9,
		934
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/rolesTabsLinks": [
		2734,
		9,
		1992
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/rolesTabsLinks.tsx": [
		2734,
		9,
		1992
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/rolesTabsView": [
		3235,
		9,
		40,
		52,
		64
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/rolesTabsView.tsx": [
		3235,
		9,
		40,
		52,
		64
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/transferOwnership/transferOwnership": [
		3514,
		9,
		52
	],
	"./pages/accounting-dashboard/user-accounts/roles/role/transferOwnership/transferOwnership.tsx": [
		3514,
		9,
		52
	],
	"./pages/accounting-dashboard/user-accounts/roles/roles/rolesContainer": [
		3052,
		9,
		1104
	],
	"./pages/accounting-dashboard/user-accounts/roles/roles/rolesContainer.tsx": [
		3052,
		9,
		1104
	],
	"./pages/accounting-dashboard/user-accounts/roles/roles/rolesStyles": [
		2735,
		9,
		1993
	],
	"./pages/accounting-dashboard/user-accounts/roles/roles/rolesStyles.ts": [
		2735,
		9,
		1993
	],
	"./pages/accounting-dashboard/user-accounts/roles/rolesListQueries": [
		2736,
		9,
		1994
	],
	"./pages/accounting-dashboard/user-accounts/roles/rolesListQueries.ts": [
		2736,
		9,
		1994
	],
	"./pages/accounting-dashboard/user-accounts/roles/rolesView": [
		3370,
		9,
		40,
		52,
		64,
		845
	],
	"./pages/accounting-dashboard/user-accounts/roles/rolesView.tsx": [
		3370,
		9,
		40,
		52,
		64,
		845
	],
	"./pages/accounting-dashboard/user-accounts/userAccountsContainer": [
		3236,
		9,
		40,
		52,
		64,
		127,
		379
	],
	"./pages/accounting-dashboard/user-accounts/userAccountsContainer.tsx": [
		3236,
		9,
		40,
		52,
		64,
		127,
		379
	],
	"./pages/accounting-dashboard/user-accounts/userAccountsLinks": [
		3371,
		9,
		1995
	],
	"./pages/accounting-dashboard/user-accounts/userAccountsLinks.tsx": [
		3371,
		9,
		1995
	],
	"./pages/accounting-dashboard/user-accounts/userAccountsView": [
		3515,
		9,
		40,
		52,
		64,
		127
	],
	"./pages/accounting-dashboard/user-accounts/userAccountsView.tsx": [
		3515,
		9,
		40,
		52,
		64,
		127
	],
	"./pages/accounting-dashboard/user-accounts/validationSchema": [
		2729,
		9,
		1490
	],
	"./pages/accounting-dashboard/user-accounts/validationSchema.ts": [
		2729,
		9,
		1490
	],
	"./pages/addons/addonsContainer": [
		3237,
		9,
		0,
		1,
		4,
		12,
		333
	],
	"./pages/addons/addonsContainer.tsx": [
		3237,
		9,
		0,
		1,
		4,
		12,
		333
	],
	"./pages/addons/addonsContext": [
		1369,
		9,
		1996
	],
	"./pages/addons/addonsContext.ts": [
		1369,
		9,
		1996
	],
	"./pages/addons/addonsOverview": [
		3376,
		9,
		10,
		759
	],
	"./pages/addons/addonsOverview.tsx": [
		3376,
		9,
		10,
		759
	],
	"./pages/addons/components/additional-mappings-table/additionalMappingsTable": [
		1939,
		9,
		1117
	],
	"./pages/addons/components/additional-mappings-table/additionalMappingsTable.tsx": [
		1939,
		9,
		1117
	],
	"./pages/addons/components/additional-mappings-table/additionalMappingsTableStyles": [
		1887,
		9,
		1997
	],
	"./pages/addons/components/additional-mappings-table/additionalMappingsTableStyles.ts": [
		1887,
		9,
		1997
	],
	"./pages/addons/components/additional-setup/additionalSetup": [
		1514,
		9,
		1998
	],
	"./pages/addons/components/additional-setup/additionalSetup.tsx": [
		1514,
		9,
		1998
	],
	"./pages/addons/components/additional-trouser/additionalTrouser": [
		1940,
		9,
		672
	],
	"./pages/addons/components/additional-trouser/additionalTrouser.tsx": [
		1940,
		9,
		672
	],
	"./pages/addons/components/carousel/carousel": [
		1599,
		9,
		1118
	],
	"./pages/addons/components/carousel/carousel.tsx": [
		1599,
		9,
		1118
	],
	"./pages/addons/components/carousel/carouselStyles": [
		1560,
		9,
		1999
	],
	"./pages/addons/components/carousel/carouselStyles.ts": [
		1560,
		9,
		1999
	],
	"./pages/addons/components/disconnect/disconnectButton": [
		1522,
		9,
		10,
		20,
		1119
	],
	"./pages/addons/components/disconnect/disconnectButton.tsx": [
		1522,
		9,
		10,
		20,
		1119
	],
	"./pages/addons/components/disconnect/disconnectCard": [
		1506,
		9,
		10,
		20,
		941
	],
	"./pages/addons/components/disconnect/disconnectCard.tsx": [
		1506,
		9,
		10,
		20,
		941
	],
	"./pages/addons/components/disconnect/disconnectModal": [
		1470,
		9,
		1493
	],
	"./pages/addons/components/disconnect/disconnectModal.tsx": [
		1470,
		9,
		1493
	],
	"./pages/addons/components/form-controllers/tableSelectItemController": [
		3377,
		9,
		1494
	],
	"./pages/addons/components/form-controllers/tableSelectItemController.tsx": [
		3377,
		9,
		1494
	],
	"./pages/addons/components/integration-active-layout/integrationActiveLayout": [
		1096,
		9,
		2000
	],
	"./pages/addons/components/integration-active-layout/integrationActiveLayout.tsx": [
		1096,
		9,
		2000
	],
	"./pages/addons/components/integration-card/integrationCard": [
		2746,
		9,
		10,
		1011
	],
	"./pages/addons/components/integration-card/integrationCard.tsx": [
		2746,
		9,
		10,
		1011
	],
	"./pages/addons/components/integration-card/integrationCardStyles": [
		2451,
		9,
		2001
	],
	"./pages/addons/components/integration-card/integrationCardStyles.ts": [
		2451,
		9,
		2001
	],
	"./pages/addons/components/integration-details-block/integrationDetailsBlock": [
		1437,
		9,
		858
	],
	"./pages/addons/components/integration-details-block/integrationDetailsBlock.tsx": [
		1437,
		9,
		858
	],
	"./pages/addons/components/integration-details-block/integrationDetailsBlockStyles": [
		1521,
		9,
		2002
	],
	"./pages/addons/components/integration-details-block/integrationDetailsBlockStyles.ts": [
		1521,
		9,
		2002
	],
	"./pages/addons/components/integration-details-layout/integrationDetailsLayout": [
		2052,
		9,
		1120
	],
	"./pages/addons/components/integration-details-layout/integrationDetailsLayout.tsx": [
		2052,
		9,
		1120
	],
	"./pages/addons/components/integration-details-skeleton/integrationDetailsSkeleton": [
		1581,
		9,
		1497
	],
	"./pages/addons/components/integration-details-skeleton/integrationDetailsSkeleton.tsx": [
		1581,
		9,
		1497
	],
	"./pages/addons/components/mapping-table/mappingDropdown": [
		1727,
		9,
		1121
	],
	"./pages/addons/components/mapping-table/mappingDropdown.tsx": [
		1727,
		9,
		1121
	],
	"./pages/addons/components/mapping-table/mappingTable": [
		1385,
		9,
		1498
	],
	"./pages/addons/components/mapping-table/mappingTable.tsx": [
		1385,
		9,
		1498
	],
	"./pages/addons/components/mapping-table/mappingTableStyles": [
		1234,
		9,
		2003
	],
	"./pages/addons/components/mapping-table/mappingTableStyles.ts": [
		1234,
		9,
		2003
	],
	"./pages/addons/components/missingAccounts/missingAccounts": [
		1944,
		9,
		1499
	],
	"./pages/addons/components/missingAccounts/missingAccounts.tsx": [
		1944,
		9,
		1499
	],
	"./pages/addons/components/overview-layout/overviewLayout": [
		3065,
		9,
		10,
		1012
	],
	"./pages/addons/components/overview-layout/overviewLayout.tsx": [
		3065,
		9,
		10,
		1012
	],
	"./pages/addons/components/overview-layout/overviewLayoutStyles": [
		2747,
		9,
		2004
	],
	"./pages/addons/components/overview-layout/overviewLayoutStyles.tsx": [
		2747,
		9,
		2004
	],
	"./pages/addons/components/related-list/relatedList": [
		3572,
		9,
		10,
		940
	],
	"./pages/addons/components/related-list/relatedList.tsx": [
		3572,
		9,
		10,
		940
	],
	"./pages/addons/components/status-pill/statusPill": [
		1463,
		9,
		2005
	],
	"./pages/addons/components/status-pill/statusPill.tsx": [
		1463,
		9,
		2005
	],
	"./pages/addons/components/token-expired": [
		733,
		9,
		10,
		248
	],
	"./pages/addons/components/token-expired/": [
		733,
		9,
		10,
		248
	],
	"./pages/addons/components/token-expired/index": [
		733,
		9,
		10,
		248
	],
	"./pages/addons/components/token-expired/index.tsx": [
		733,
		9,
		10,
		248
	],
	"./pages/addons/constants/constants": [
		1207,
		9,
		2006
	],
	"./pages/addons/constants/constants.ts": [
		1207,
		9,
		2006
	],
	"./pages/addons/constants/types": [
		1306,
		9,
		2009
	],
	"./pages/addons/constants/types.ts": [
		1306,
		9,
		2009
	],
	"./pages/addons/helpers/integrationHelpers": [
		1305,
		9,
		2010
	],
	"./pages/addons/helpers/integrationHelpers.ts": [
		1305,
		9,
		2010
	],
	"./pages/addons/hooks/common/useActiveType": [
		2452,
		9,
		10,
		1491
	],
	"./pages/addons/hooks/common/useActiveType.ts": [
		2452,
		9,
		10,
		1491
	],
	"./pages/addons/hooks/common/useAddonsRoutes": [
		1438,
		9,
		1492
	],
	"./pages/addons/hooks/common/useAddonsRoutes.ts": [
		1438,
		9,
		1492
	],
	"./pages/addons/hooks/common/useCarouselImages": [
		1864,
		9,
		1503
	],
	"./pages/addons/hooks/common/useCarouselImages.tsx": [
		1864,
		9,
		1503
	],
	"./pages/addons/hooks/common/useIntegration": [
		1410,
		9,
		1280
	],
	"./pages/addons/hooks/common/useIntegration.ts": [
		1410,
		9,
		1280
	],
	"./pages/addons/hooks/common/useIntegrationTabs": [
		1561,
		9,
		1278
	],
	"./pages/addons/hooks/common/useIntegrationTabs.ts": [
		1561,
		9,
		1278
	],
	"./pages/addons/hooks/common/useIntegrations": [
		1130,
		9,
		695
	],
	"./pages/addons/hooks/common/useIntegrations.ts": [
		1130,
		9,
		695
	],
	"./pages/addons/hooks/common/useSafetyHookPeopleAddon": [
		1469,
		9,
		2012
	],
	"./pages/addons/hooks/common/useSafetyHookPeopleAddon.ts": [
		1469,
		9,
		2012
	],
	"./pages/addons/hooks/common/useTogglers": [
		3378,
		9,
		2013
	],
	"./pages/addons/hooks/common/useTogglers.ts": [
		3378,
		9,
		2013
	],
	"./pages/addons/hooks/common/useURL": [
		1370,
		9,
		10,
		2014
	],
	"./pages/addons/hooks/common/useURL.ts": [
		1370,
		9,
		10,
		2014
	],
	"./pages/addons/hooks/common/useXeroQueryWithLoader": [
		1176,
		9,
		1500
	],
	"./pages/addons/hooks/common/useXeroQueryWithLoader.ts": [
		1176,
		9,
		1500
	],
	"./pages/addons/hooks/people/useFormatEmployeeData": [
		2745,
		9,
		2015
	],
	"./pages/addons/hooks/people/useFormatEmployeeData.ts": [
		2745,
		9,
		2015
	],
	"./pages/addons/hooks/people/useGetEmployeeList": [
		2742,
		9,
		2016
	],
	"./pages/addons/hooks/people/useGetEmployeeList.tsx": [
		2742,
		9,
		2016
	],
	"./pages/addons/hooks/qbo/useCompareCAO": [
		1661,
		9,
		1506
	],
	"./pages/addons/hooks/qbo/useCompareCAO.ts": [
		1661,
		9,
		1506
	],
	"./pages/addons/hooks/qbo/useGetReportsBlob": [
		2253,
		9,
		12,
		54,
		62,
		7,
		464
	],
	"./pages/addons/hooks/qbo/useGetReportsBlob.tsx": [
		2253,
		9,
		12,
		54,
		62,
		7,
		464
	],
	"./pages/addons/hooks/qbo/usePersistChartOfAccounts": [
		1546,
		9,
		2017
	],
	"./pages/addons/hooks/qbo/usePersistChartOfAccounts.ts": [
		1546,
		9,
		2017
	],
	"./pages/addons/hooks/qbo/useQBOData": [
		1600,
		9,
		20,
		1504
	],
	"./pages/addons/hooks/qbo/useQBOData.ts": [
		1600,
		9,
		20,
		1504
	],
	"./pages/addons/hooks/qbo/useResetQBOQueries": [
		2435,
		9,
		1507
	],
	"./pages/addons/hooks/qbo/useResetQBOQueries.ts": [
		2435,
		9,
		1507
	],
	"./pages/addons/hooks/queries/queryKeys": [
		1080,
		9,
		2018
	],
	"./pages/addons/hooks/queries/queryKeys.ts": [
		1080,
		9,
		2018
	],
	"./pages/addons/hooks/queries/useGetAccountList": [
		1941,
		9,
		1122
	],
	"./pages/addons/hooks/queries/useGetAccountList.ts": [
		1941,
		9,
		1122
	],
	"./pages/addons/hooks/queries/useGetAutoSyncPreference": [
		2442,
		9,
		1508
	],
	"./pages/addons/hooks/queries/useGetAutoSyncPreference.ts": [
		2442,
		9,
		1508
	],
	"./pages/addons/hooks/queries/useGetChartOfAccounts": [
		1787,
		9,
		1123
	],
	"./pages/addons/hooks/queries/useGetChartOfAccounts.ts": [
		1787,
		9,
		1123
	],
	"./pages/addons/hooks/queries/useGetDefaultMapping": [
		1788,
		9,
		1124
	],
	"./pages/addons/hooks/queries/useGetDefaultMapping.ts": [
		1788,
		9,
		1124
	],
	"./pages/addons/hooks/queries/useGetMissingAccounts": [
		1943,
		9,
		1125
	],
	"./pages/addons/hooks/queries/useGetMissingAccounts.ts": [
		1943,
		9,
		1125
	],
	"./pages/addons/hooks/queries/useGetPayPeriod": [
		2091,
		9,
		1509
	],
	"./pages/addons/hooks/queries/useGetPayPeriod.ts": [
		2091,
		9,
		1509
	],
	"./pages/addons/hooks/queries/useGetPayrollInitialState": [
		3573,
		9,
		1281
	],
	"./pages/addons/hooks/queries/useGetPayrollInitialState.ts": [
		3573,
		9,
		1281
	],
	"./pages/addons/hooks/queries/useGetTaxList": [
		1942,
		9,
		1126
	],
	"./pages/addons/hooks/queries/useGetTaxList.ts": [
		1942,
		9,
		1126
	],
	"./pages/addons/hooks/queries/useInitialState": [
		1154,
		9,
		1282
	],
	"./pages/addons/hooks/queries/useInitialState.ts": [
		1154,
		9,
		1282
	],
	"./pages/addons/hooks/time/useGetEmployeeList": [
		1368,
		9,
		1502
	],
	"./pages/addons/hooks/time/useGetEmployeeList.tsx": [
		1368,
		9,
		1502
	],
	"./pages/addons/hooks/time/useGetJobList": [
		2448,
		9,
		2019
	],
	"./pages/addons/hooks/time/useGetJobList.tsx": [
		2448,
		9,
		2019
	],
	"./pages/addons/hooks/time/useIntegrationConnectionStatus": [
		1526,
		9,
		2020
	],
	"./pages/addons/hooks/time/useIntegrationConnectionStatus.tsx": [
		1526,
		9,
		2020
	],
	"./pages/addons/hooks/xero/useChartOfAccounts": [
		3574,
		9,
		2021
	],
	"./pages/addons/hooks/xero/useChartOfAccounts.ts": [
		3574,
		9,
		2021
	],
	"./pages/addons/hooks/xero/useGetSubscriptionInvoiceList": [
		1889,
		9,
		1510
	],
	"./pages/addons/hooks/xero/useGetSubscriptionInvoiceList.ts": [
		1889,
		9,
		1510
	],
	"./pages/addons/hooks/xero/useGetTrackingCategoriesList": [
		1524,
		9,
		1127
	],
	"./pages/addons/hooks/xero/useGetTrackingCategoriesList.ts": [
		1524,
		9,
		1127
	],
	"./pages/addons/hooks/xero/useGetTrackingCategoryMap": [
		1523,
		9,
		1128
	],
	"./pages/addons/hooks/xero/useGetTrackingCategoryMap.ts": [
		1523,
		9,
		1128
	],
	"./pages/addons/hooks/xero/useXEROData": [
		2441,
		9,
		791
	],
	"./pages/addons/hooks/xero/useXEROData.ts": [
		2441,
		9,
		791
	],
	"./pages/addons/pages/page-integration-people/active/active": [
		3064,
		9,
		10,
		20,
		204,
		508
	],
	"./pages/addons/pages/page-integration-people/active/active.tsx": [
		3064,
		9,
		10,
		20,
		204,
		508
	],
	"./pages/addons/pages/page-integration-people/active/activeStyles": [
		3575,
		9,
		2022
	],
	"./pages/addons/pages/page-integration-people/active/activeStyles.ts": [
		3575,
		9,
		2022
	],
	"./pages/addons/pages/page-integration-people/active/additionalSupport": [
		812,
		9,
		10,
		20,
		234
	],
	"./pages/addons/pages/page-integration-people/active/additionalSupport/": [
		812,
		9,
		10,
		20,
		234
	],
	"./pages/addons/pages/page-integration-people/active/additionalSupport/index": [
		812,
		9,
		10,
		20,
		234
	],
	"./pages/addons/pages/page-integration-people/active/additionalSupport/index.tsx": [
		812,
		9,
		10,
		20,
		234
	],
	"./pages/addons/pages/page-integration-people/active/employee-mapping": [
		781,
		9,
		110
	],
	"./pages/addons/pages/page-integration-people/active/employee-mapping/": [
		781,
		9,
		110
	],
	"./pages/addons/pages/page-integration-people/active/employee-mapping/components/addNewProfileModal": [
		2744,
		9,
		2023
	],
	"./pages/addons/pages/page-integration-people/active/employee-mapping/components/addNewProfileModal.tsx": [
		2744,
		9,
		2023
	],
	"./pages/addons/pages/page-integration-people/active/employee-mapping/components/mappingFooter": [
		2743,
		9,
		1279
	],
	"./pages/addons/pages/page-integration-people/active/employee-mapping/components/mappingFooter.tsx": [
		2743,
		9,
		1279
	],
	"./pages/addons/pages/page-integration-people/active/employee-mapping/components/peopleEmployeeDropdown": [
		2950,
		9,
		110
	],
	"./pages/addons/pages/page-integration-people/active/employee-mapping/components/peopleEmployeeDropdown.tsx": [
		2950,
		9,
		110
	],
	"./pages/addons/pages/page-integration-people/active/employee-mapping/index": [
		781,
		9,
		110
	],
	"./pages/addons/pages/page-integration-people/active/employee-mapping/index.tsx": [
		781,
		9,
		110
	],
	"./pages/addons/pages/page-integration-people/active/not-log-in": [
		869,
		9,
		262
	],
	"./pages/addons/pages/page-integration-people/active/not-log-in/": [
		869,
		9,
		262
	],
	"./pages/addons/pages/page-integration-people/active/not-log-in/index": [
		869,
		9,
		262
	],
	"./pages/addons/pages/page-integration-people/active/not-log-in/index.tsx": [
		869,
		9,
		262
	],
	"./pages/addons/pages/page-integration-people/active/overview": [
		811,
		9,
		256
	],
	"./pages/addons/pages/page-integration-people/active/overview/": [
		811,
		9,
		256
	],
	"./pages/addons/pages/page-integration-people/active/overview/index": [
		811,
		9,
		256
	],
	"./pages/addons/pages/page-integration-people/active/overview/index.tsx": [
		811,
		9,
		256
	],
	"./pages/addons/pages/page-integration-people/intro/connect-button/connectButton": [
		3063,
		9,
		1017
	],
	"./pages/addons/pages/page-integration-people/intro/connect-button/connectButton.tsx": [
		3063,
		9,
		1017
	],
	"./pages/addons/pages/page-integration-people/intro/connect-button/connectButtonStyles": [
		2740,
		9,
		2024
	],
	"./pages/addons/pages/page-integration-people/intro/connect-button/connectButtonStyles.ts": [
		2740,
		9,
		2024
	],
	"./pages/addons/pages/page-integration-people/intro/connect-button/useValidationSchema": [
		2741,
		9,
		2025
	],
	"./pages/addons/pages/page-integration-people/intro/connect-button/useValidationSchema.ts": [
		2741,
		9,
		2025
	],
	"./pages/addons/pages/page-integration-people/intro/intro": [
		3239,
		9,
		10,
		189,
		2007
	],
	"./pages/addons/pages/page-integration-people/intro/intro.tsx": [
		3239,
		9,
		10,
		189,
		2007
	],
	"./pages/addons/pages/page-integration-people/pageIntegrationPeople": [
		3375,
		9,
		10,
		20,
		189,
		204,
		538
	],
	"./pages/addons/pages/page-integration-people/pageIntegrationPeople.tsx": [
		3375,
		9,
		10,
		20,
		189,
		204,
		538
	],
	"./pages/addons/pages/page-integration-people/utils/helpers": [
		1969,
		9,
		2026
	],
	"./pages/addons/pages/page-integration-people/utils/helpers.ts": [
		1969,
		9,
		2026
	],
	"./pages/addons/pages/page-integration-people/utils/types": [
		3576,
		9,
		2027
	],
	"./pages/addons/pages/page-integration-people/utils/types.ts": [
		3576,
		9,
		2027
	],
	"./pages/addons/pages/page-integration-qbo/active/active": [
		3053,
		9,
		12,
		54,
		62,
		195,
		404
	],
	"./pages/addons/pages/page-integration-qbo/active/active.tsx": [
		3053,
		9,
		12,
		54,
		62,
		195,
		404
	],
	"./pages/addons/pages/page-integration-qbo/active/additional-support": [
		801,
		9,
		10,
		20,
		235
	],
	"./pages/addons/pages/page-integration-qbo/active/additional-support/": [
		801,
		9,
		10,
		20,
		235
	],
	"./pages/addons/pages/page-integration-qbo/active/additional-support/index": [
		801,
		9,
		10,
		20,
		235
	],
	"./pages/addons/pages/page-integration-qbo/active/additional-support/index.tsx": [
		801,
		9,
		10,
		20,
		235
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync": [
		799,
		9,
		208
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/": [
		799,
		9,
		208
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/errorStatements": [
		2437,
		9,
		1018
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/errorStatements.tsx": [
		2437,
		9,
		1018
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/index": [
		799,
		9,
		208
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/index.tsx": [
		799,
		9,
		208
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/mutations": [
		2251,
		9,
		1135
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/mutations.ts": [
		2251,
		9,
		1135
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/styles": [
		3577,
		9,
		2028
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/styles.ts": [
		3577,
		9,
		2028
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/useAutoSyncValidation": [
		2436,
		9,
		2029
	],
	"./pages/addons/pages/page-integration-qbo/active/automatic-sync/useAutoSyncValidation.ts": [
		2436,
		9,
		2029
	],
	"./pages/addons/pages/page-integration-qbo/active/chart-of-accounts": [
		798,
		9,
		20,
		157
	],
	"./pages/addons/pages/page-integration-qbo/active/chart-of-accounts/": [
		798,
		9,
		20,
		157
	],
	"./pages/addons/pages/page-integration-qbo/active/chart-of-accounts/components/mappingFooter": [
		2434,
		9,
		1013
	],
	"./pages/addons/pages/page-integration-qbo/active/chart-of-accounts/components/mappingFooter.tsx": [
		2434,
		9,
		1013
	],
	"./pages/addons/pages/page-integration-qbo/active/chart-of-accounts/index": [
		798,
		9,
		20,
		157
	],
	"./pages/addons/pages/page-integration-qbo/active/chart-of-accounts/index.tsx": [
		798,
		9,
		20,
		157
	],
	"./pages/addons/pages/page-integration-qbo/active/chart-of-accounts/styles": [
		3578,
		9,
		2030
	],
	"./pages/addons/pages/page-integration-qbo/active/chart-of-accounts/styles.ts": [
		3578,
		9,
		2030
	],
	"./pages/addons/pages/page-integration-qbo/active/link-vendor/linkVendor": [
		2939,
		9,
		1129
	],
	"./pages/addons/pages/page-integration-qbo/active/link-vendor/linkVendor.tsx": [
		2939,
		9,
		1129
	],
	"./pages/addons/pages/page-integration-qbo/active/manual-export": [
		800,
		9,
		12,
		54,
		62,
		7,
		147
	],
	"./pages/addons/pages/page-integration-qbo/active/manual-export/": [
		800,
		9,
		12,
		54,
		62,
		7,
		147
	],
	"./pages/addons/pages/page-integration-qbo/active/manual-export/activeState": [
		2438,
		9,
		12,
		54,
		62,
		7,
		455
	],
	"./pages/addons/pages/page-integration-qbo/active/manual-export/activeState.tsx": [
		2438,
		9,
		12,
		54,
		62,
		7,
		455
	],
	"./pages/addons/pages/page-integration-qbo/active/manual-export/components/attachReports": [
		2252,
		9,
		2031
	],
	"./pages/addons/pages/page-integration-qbo/active/manual-export/components/attachReports.tsx": [
		2252,
		9,
		2031
	],
	"./pages/addons/pages/page-integration-qbo/active/manual-export/index": [
		800,
		9,
		12,
		54,
		62,
		7,
		147
	],
	"./pages/addons/pages/page-integration-qbo/active/manual-export/index.tsx": [
		800,
		9,
		12,
		54,
		62,
		7,
		147
	],
	"./pages/addons/pages/page-integration-qbo/active/manual-export/zeroState": [
		2639,
		9,
		1495
	],
	"./pages/addons/pages/page-integration-qbo/active/manual-export/zeroState.tsx": [
		2639,
		9,
		1495
	],
	"./pages/addons/pages/page-integration-qbo/active/overview": [
		797,
		9,
		284
	],
	"./pages/addons/pages/page-integration-qbo/active/overview/": [
		797,
		9,
		284
	],
	"./pages/addons/pages/page-integration-qbo/active/overview/index": [
		797,
		9,
		284
	],
	"./pages/addons/pages/page-integration-qbo/active/overview/index.tsx": [
		797,
		9,
		284
	],
	"./pages/addons/pages/page-integration-qbo/intro/connect-button/connectButton": [
		2737,
		9,
		10,
		1130
	],
	"./pages/addons/pages/page-integration-qbo/intro/connect-button/connectButton.tsx": [
		2737,
		9,
		10,
		1130
	],
	"./pages/addons/pages/page-integration-qbo/intro/connect-button/connectButtonStyles": [
		2439,
		9,
		2032
	],
	"./pages/addons/pages/page-integration-qbo/intro/connect-button/connectButtonStyles.ts": [
		2439,
		9,
		2032
	],
	"./pages/addons/pages/page-integration-qbo/intro/intro": [
		3054,
		9,
		10,
		603
	],
	"./pages/addons/pages/page-integration-qbo/intro/intro.tsx": [
		3054,
		9,
		10,
		603
	],
	"./pages/addons/pages/page-integration-qbo/pageIntegrationQbo": [
		3372,
		9,
		12,
		54,
		62,
		195,
		402
	],
	"./pages/addons/pages/page-integration-qbo/pageIntegrationQbo.tsx": [
		3372,
		9,
		12,
		54,
		62,
		195,
		402
	],
	"./pages/addons/pages/page-integration-qbo/queries": [
		1789,
		9,
		1511
	],
	"./pages/addons/pages/page-integration-qbo/queries.ts": [
		1789,
		9,
		1511
	],
	"./pages/addons/pages/page-integration-time/active/active": [
		3058,
		9,
		10,
		20,
		111,
		480
	],
	"./pages/addons/pages/page-integration-time/active/active.tsx": [
		3058,
		9,
		10,
		20,
		111,
		480
	],
	"./pages/addons/pages/page-integration-time/active/activeStyles": [
		3579,
		9,
		2033
	],
	"./pages/addons/pages/page-integration-time/active/activeStyles.ts": [
		3579,
		9,
		2033
	],
	"./pages/addons/pages/page-integration-time/active/additionalSupport": [
		810,
		9,
		10,
		20,
		236
	],
	"./pages/addons/pages/page-integration-time/active/additionalSupport/": [
		810,
		9,
		10,
		20,
		236
	],
	"./pages/addons/pages/page-integration-time/active/additionalSupport/index": [
		810,
		9,
		10,
		20,
		236
	],
	"./pages/addons/pages/page-integration-time/active/additionalSupport/index.tsx": [
		810,
		9,
		10,
		20,
		236
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping": [
		809,
		9,
		203
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/": [
		809,
		9,
		203
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/components/autoAddComponents/addTimeProfileModal": [
		3061,
		9,
		2034
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/components/autoAddComponents/addTimeProfileModal.tsx": [
		3061,
		9,
		2034
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/components/autoAddComponents/newTimeEmployeeDropdown": [
		3060,
		9,
		1014
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/components/autoAddComponents/newTimeEmployeeDropdown.tsx": [
		3060,
		9,
		1014
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/components/mappingFooter": [
		2379,
		9,
		1501
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/components/mappingFooter.tsx": [
		2379,
		9,
		1501
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/components/timeEmployeeDropdown": [
		2450,
		9,
		1134
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/components/timeEmployeeDropdown.tsx": [
		2450,
		9,
		1134
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/index": [
		809,
		9,
		203
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/index.tsx": [
		809,
		9,
		203
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/newIndex": [
		3059,
		9,
		111,
		2011
	],
	"./pages/addons/pages/page-integration-time/active/employee-mapping/newIndex.tsx": [
		3059,
		9,
		111,
		2011
	],
	"./pages/addons/pages/page-integration-time/active/job-mapping": [
		807,
		9,
		223
	],
	"./pages/addons/pages/page-integration-time/active/job-mapping/": [
		807,
		9,
		223
	],
	"./pages/addons/pages/page-integration-time/active/job-mapping/components/timeJobsDropdown": [
		2449,
		9,
		1283
	],
	"./pages/addons/pages/page-integration-time/active/job-mapping/components/timeJobsDropdown.tsx": [
		2449,
		9,
		1283
	],
	"./pages/addons/pages/page-integration-time/active/job-mapping/index": [
		807,
		9,
		223
	],
	"./pages/addons/pages/page-integration-time/active/job-mapping/index.tsx": [
		807,
		9,
		223
	],
	"./pages/addons/pages/page-integration-time/active/not-log-in": [
		840,
		9,
		263
	],
	"./pages/addons/pages/page-integration-time/active/not-log-in/": [
		840,
		9,
		263
	],
	"./pages/addons/pages/page-integration-time/active/not-log-in/index": [
		840,
		9,
		263
	],
	"./pages/addons/pages/page-integration-time/active/not-log-in/index.tsx": [
		840,
		9,
		263
	],
	"./pages/addons/pages/page-integration-time/active/overview": [
		808,
		9,
		265
	],
	"./pages/addons/pages/page-integration-time/active/overview/": [
		808,
		9,
		265
	],
	"./pages/addons/pages/page-integration-time/active/overview/index": [
		808,
		9,
		265
	],
	"./pages/addons/pages/page-integration-time/active/overview/index.tsx": [
		808,
		9,
		265
	],
	"./pages/addons/pages/page-integration-time/intro/connect-button/connectButton": [
		3057,
		9,
		10,
		1131
	],
	"./pages/addons/pages/page-integration-time/intro/connect-button/connectButton.tsx": [
		3057,
		9,
		10,
		1131
	],
	"./pages/addons/pages/page-integration-time/intro/connect-button/connectButtonStyles": [
		2739,
		9,
		2035
	],
	"./pages/addons/pages/page-integration-time/intro/connect-button/connectButtonStyles.ts": [
		2739,
		9,
		2035
	],
	"./pages/addons/pages/page-integration-time/intro/intro": [
		3238,
		9,
		10,
		194,
		2008
	],
	"./pages/addons/pages/page-integration-time/intro/intro.tsx": [
		3238,
		9,
		10,
		194,
		2008
	],
	"./pages/addons/pages/page-integration-time/pageIntegrationTime": [
		3374,
		9,
		10,
		20,
		111,
		194,
		486
	],
	"./pages/addons/pages/page-integration-time/pageIntegrationTime.tsx": [
		3374,
		9,
		10,
		20,
		111,
		194,
		486
	],
	"./pages/addons/pages/page-integration-time/utils/helpers": [
		1525,
		9,
		2036
	],
	"./pages/addons/pages/page-integration-time/utils/helpers.ts": [
		1525,
		9,
		2036
	],
	"./pages/addons/pages/page-integration-time/utils/types": [
		3062,
		9,
		2037
	],
	"./pages/addons/pages/page-integration-time/utils/types.ts": [
		3062,
		9,
		2037
	],
	"./pages/addons/pages/page-integration-xero/active/active": [
		3056,
		9,
		0,
		1,
		4,
		30,
		411
	],
	"./pages/addons/pages/page-integration-xero/active/active.tsx": [
		3056,
		9,
		0,
		1,
		4,
		30,
		411
	],
	"./pages/addons/pages/page-integration-xero/active/additional-support": [
		806,
		9,
		10,
		20,
		222
	],
	"./pages/addons/pages/page-integration-xero/active/additional-support/": [
		806,
		9,
		10,
		20,
		222
	],
	"./pages/addons/pages/page-integration-xero/active/additional-support/index": [
		806,
		9,
		10,
		20,
		222
	],
	"./pages/addons/pages/page-integration-xero/active/additional-support/index.tsx": [
		806,
		9,
		10,
		20,
		222
	],
	"./pages/addons/pages/page-integration-xero/active/automatic-sync": [
		804,
		9,
		237
	],
	"./pages/addons/pages/page-integration-xero/active/automatic-sync/": [
		804,
		9,
		237
	],
	"./pages/addons/pages/page-integration-xero/active/automatic-sync/index": [
		804,
		9,
		237
	],
	"./pages/addons/pages/page-integration-xero/active/automatic-sync/index.tsx": [
		804,
		9,
		237
	],
	"./pages/addons/pages/page-integration-xero/active/chart-of-accounts": [
		803,
		9,
		1,
		154
	],
	"./pages/addons/pages/page-integration-xero/active/chart-of-accounts/": [
		803,
		9,
		1,
		154
	],
	"./pages/addons/pages/page-integration-xero/active/chart-of-accounts/index": [
		803,
		9,
		1,
		154
	],
	"./pages/addons/pages/page-integration-xero/active/chart-of-accounts/index.tsx": [
		803,
		9,
		1,
		154
	],
	"./pages/addons/pages/page-integration-xero/active/chart-of-accounts/styles": [
		3580,
		9,
		2038
	],
	"./pages/addons/pages/page-integration-xero/active/chart-of-accounts/styles.ts": [
		3580,
		9,
		2038
	],
	"./pages/addons/pages/page-integration-xero/active/disconnection-button/disconnectionButton": [
		2640,
		9,
		2039
	],
	"./pages/addons/pages/page-integration-xero/active/disconnection-button/disconnectionButton.tsx": [
		2640,
		9,
		2039
	],
	"./pages/addons/pages/page-integration-xero/active/integration-menu-toggler/integrationMenuToggler": [
		3581,
		9,
		1015
	],
	"./pages/addons/pages/page-integration-xero/active/integration-menu-toggler/integrationMenuToggler.tsx": [
		3581,
		9,
		1015
	],
	"./pages/addons/pages/page-integration-xero/active/integration-menu-toggler/styles": [
		3379,
		9,
		2040
	],
	"./pages/addons/pages/page-integration-xero/active/integration-menu-toggler/styles.ts": [
		3379,
		9,
		2040
	],
	"./pages/addons/pages/page-integration-xero/active/integration-table": [
		870,
		9,
		257
	],
	"./pages/addons/pages/page-integration-xero/active/integration-table/": [
		870,
		9,
		257
	],
	"./pages/addons/pages/page-integration-xero/active/integration-table/index": [
		870,
		9,
		257
	],
	"./pages/addons/pages/page-integration-xero/active/integration-table/index.tsx": [
		870,
		9,
		257
	],
	"./pages/addons/pages/page-integration-xero/active/integration-table/styles": [
		3380,
		9,
		2041
	],
	"./pages/addons/pages/page-integration-xero/active/integration-table/styles.ts": [
		3380,
		9,
		2041
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export": [
		805,
		9,
		117,
		175
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/": [
		805,
		9,
		117,
		175
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/activeState": [
		2443,
		9,
		639
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/activeState.tsx": [
		2443,
		9,
		639
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/activeStateFormListener": [
		2256,
		9,
		1132
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/activeStateFormListener.tsx": [
		2256,
		9,
		1132
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/index": [
		805,
		9,
		117,
		175
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/index.tsx": [
		805,
		9,
		117,
		175
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/payGroupDropdowns": [
		2257,
		9,
		1512
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/payGroupDropdowns.tsx": [
		2257,
		9,
		1512
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/payrollSubscription": [
		2254,
		9,
		1016
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/payrollSubscription.tsx": [
		2254,
		9,
		1016
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/styles": [
		3582,
		9,
		2042
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/styles.ts": [
		3582,
		9,
		2042
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/types": [
		3583,
		9,
		2043
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/types.ts": [
		3583,
		9,
		2043
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/useXeroManualExportValidationSchema": [
		2255,
		9,
		2044
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/useXeroManualExportValidationSchema.ts": [
		2255,
		9,
		2044
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/zeroState": [
		2444,
		9,
		117,
		1496
	],
	"./pages/addons/pages/page-integration-xero/active/manual-export/zeroState.tsx": [
		2444,
		9,
		117,
		1496
	],
	"./pages/addons/pages/page-integration-xero/active/overview": [
		802,
		9,
		207
	],
	"./pages/addons/pages/page-integration-xero/active/overview/": [
		802,
		9,
		207
	],
	"./pages/addons/pages/page-integration-xero/active/overview/index": [
		802,
		9,
		207
	],
	"./pages/addons/pages/page-integration-xero/active/overview/index.tsx": [
		802,
		9,
		207
	],
	"./pages/addons/pages/page-integration-xero/active/overview/overviewStyles": [
		2440,
		9,
		2045
	],
	"./pages/addons/pages/page-integration-xero/active/overview/overviewStyles.ts": [
		2440,
		9,
		2045
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/components/createdCategories": [
		2447,
		9,
		0,
		4,
		673
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/components/createdCategories.tsx": [
		2447,
		9,
		0,
		4,
		673
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/components/departmentCategoryTable": [
		2260,
		9,
		0,
		4,
		792
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/components/departmentCategoryTable.tsx": [
		2260,
		9,
		0,
		4,
		792
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/components/missingDepartmentsZeroState": [
		2445,
		9,
		30,
		2046
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/components/missingDepartmentsZeroState.tsx": [
		2445,
		9,
		30,
		2046
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/components/missingTrackingCategoriesZeroState": [
		2446,
		9,
		303,
		1133
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/components/missingTrackingCategoriesZeroState.tsx": [
		2446,
		9,
		303,
		1133
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/components/trackingCategoryAutocomplete": [
		2259,
		9,
		859
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/components/trackingCategoryAutocomplete.tsx": [
		2259,
		9,
		859
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/mutations": [
		2258,
		9,
		1284
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/mutations.ts": [
		2258,
		9,
		1284
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/trackingCategories": [
		2738,
		9,
		0,
		4,
		30,
		303,
		566
	],
	"./pages/addons/pages/page-integration-xero/active/tracking-categories/trackingCategories.tsx": [
		2738,
		9,
		0,
		4,
		30,
		303,
		566
	],
	"./pages/addons/pages/page-integration-xero/intro/connect-button/connectButton": [
		2940,
		9,
		10,
		1505
	],
	"./pages/addons/pages/page-integration-xero/intro/connect-button/connectButton.tsx": [
		2940,
		9,
		10,
		1505
	],
	"./pages/addons/pages/page-integration-xero/intro/intro": [
		3055,
		9,
		10,
		638
	],
	"./pages/addons/pages/page-integration-xero/intro/intro.tsx": [
		3055,
		9,
		10,
		638
	],
	"./pages/addons/pages/page-integration-xero/pageIntegrationXero": [
		3373,
		9,
		0,
		1,
		4,
		30,
		407
	],
	"./pages/addons/pages/page-integration-xero/pageIntegrationXero.tsx": [
		3373,
		9,
		0,
		1,
		4,
		30,
		407
	],
	"./pages/addons/types/types": [
		3584,
		9,
		2047
	],
	"./pages/addons/types/types.ts": [
		3584,
		9,
		2047
	],
	"./pages/addons/utils/prepareAccountList": [
		1235,
		9,
		2048
	],
	"./pages/addons/utils/prepareAccountList.ts": [
		1235,
		9,
		2048
	],
	"./pages/app-notifications": [
		813,
		9,
		38,
		104
	],
	"./pages/app-notifications/": [
		813,
		9,
		38,
		104
	],
	"./pages/app-notifications/app-notification.helper": [
		3066,
		9,
		2049
	],
	"./pages/app-notifications/app-notification.helper.ts": [
		3066,
		9,
		2049
	],
	"./pages/app-notifications/index": [
		813,
		9,
		38,
		104
	],
	"./pages/app-notifications/index.tsx": [
		813,
		9,
		38,
		104
	],
	"./pages/app-notifications/notificationStyles": [
		3067,
		9,
		2050
	],
	"./pages/app-notifications/notificationStyles.ts": [
		3067,
		9,
		2050
	],
	"./pages/app-notifications/notificationView": [
		3381,
		9,
		38,
		544
	],
	"./pages/app-notifications/notificationView.tsx": [
		3381,
		9,
		38,
		544
	],
	"./pages/banking/clientBankingContainer": [
		2748,
		9,
		1,
		3,
		5,
		6,
		400
	],
	"./pages/banking/clientBankingContainer.tsx": [
		2748,
		9,
		1,
		3,
		5,
		6,
		400
	],
	"./pages/banking/edit-banking-page/editBankingPage": [
		2093,
		9,
		1,
		3,
		255,
		490
	],
	"./pages/banking/edit-banking-page/editBankingPage.tsx": [
		2093,
		9,
		1,
		3,
		255,
		490
	],
	"./pages/banking/edit-banking-page/types": [
		3585,
		9,
		2051
	],
	"./pages/banking/edit-banking-page/types.ts": [
		3585,
		9,
		2051
	],
	"./pages/banking/edit-signatory-page/editSignatoryPage": [
		2094,
		9,
		1,
		3,
		99,
		710,
		433
	],
	"./pages/banking/edit-signatory-page/editSignatoryPage.tsx": [
		2094,
		9,
		1,
		3,
		99,
		710,
		433
	],
	"./pages/banking/edit-signatory-page/types": [
		3586,
		9,
		2052
	],
	"./pages/banking/edit-signatory-page/types.ts": [
		3586,
		9,
		2052
	],
	"./pages/banking/firm-banking-empty-page/firmBankingEmptyPage": [
		2426,
		9,
		5,
		2053
	],
	"./pages/banking/firm-banking-empty-page/firmBankingEmptyPage.tsx": [
		2426,
		9,
		5,
		2053
	],
	"./pages/banking/firmBankingContainer": [
		3240,
		9,
		1,
		3,
		5,
		99,
		405
	],
	"./pages/banking/firmBankingContainer.tsx": [
		3240,
		9,
		1,
		3,
		5,
		99,
		405
	],
	"./pages/banking/hooks/useClientSignatoryEdit": [
		2096,
		9,
		675
	],
	"./pages/banking/hooks/useClientSignatoryEdit.tsx": [
		2096,
		9,
		675
	],
	"./pages/banking/hooks/useShowPartnerUpgradeCondition": [
		1247,
		9,
		1136
	],
	"./pages/banking/hooks/useShowPartnerUpgradeCondition.tsx": [
		1247,
		9,
		1136
	],
	"./pages/banking/hooks/useSignatoryAndBankFetch": [
		2085,
		9,
		942
	],
	"./pages/banking/hooks/useSignatoryAndBankFetch.tsx": [
		2085,
		9,
		942
	],
	"./pages/banking/init-banking-page/components/authSignatoryCards": [
		2053,
		9,
		1,
		181,
		1137
	],
	"./pages/banking/init-banking-page/components/authSignatoryCards.tsx": [
		2053,
		9,
		1,
		181,
		1137
	],
	"./pages/banking/init-banking-page/components/bankingInformationCards": [
		1974,
		9,
		1,
		554
	],
	"./pages/banking/init-banking-page/components/bankingInformationCards.tsx": [
		1974,
		9,
		1,
		554
	],
	"./pages/banking/init-banking-page/initBankingPage": [
		2092,
		9,
		1,
		181,
		760
	],
	"./pages/banking/init-banking-page/initBankingPage.tsx": [
		2092,
		9,
		1,
		181,
		760
	],
	"./pages/banking/migration/leavePrompt": [
		1982,
		9,
		1513
	],
	"./pages/banking/migration/leavePrompt.tsx": [
		1982,
		9,
		1513
	],
	"./pages/banking/migration/loadingPadSign": [
		1981,
		9,
		1514
	],
	"./pages/banking/migration/loadingPadSign.tsx": [
		1981,
		9,
		1514
	],
	"./pages/banking/migration/migrationAuthSignatoryInfoCard": [
		1973,
		9,
		1,
		793
	],
	"./pages/banking/migration/migrationAuthSignatoryInfoCard.tsx": [
		1973,
		9,
		1,
		793
	],
	"./pages/banking/migration/migrationEditSignatory": [
		2095,
		9,
		1,
		3,
		921,
		28,
		478
	],
	"./pages/banking/migration/migrationEditSignatory.tsx": [
		2095,
		9,
		1,
		3,
		921,
		28,
		478
	],
	"./pages/banking/migration/migrationSuccessfulPopup": [
		1448,
		9,
		1515
	],
	"./pages/banking/migration/migrationSuccessfulPopup.tsx": [
		1448,
		9,
		1515
	],
	"./pages/banking/routes": [
		1078,
		9,
		2054
	],
	"./pages/banking/routes.ts": [
		1078,
		9,
		2054
	],
	"./pages/banking/useIsBankingAccountEnabled": [
		1965,
		9,
		1478
	],
	"./pages/banking/useIsBankingAccountEnabled.ts": [
		1965,
		9,
		1478
	],
	"./pages/billing/billingContainer": [
		3516,
		9,
		380
	],
	"./pages/billing/billingContainer.tsx": [
		3516,
		9,
		380
	],
	"./pages/billing/billingView": [
		3382,
		9,
		2055
	],
	"./pages/billing/billingView.tsx": [
		3382,
		9,
		2055
	],
	"./pages/billing/components/billingFilter": [
		3383,
		9,
		1019
	],
	"./pages/billing/components/billingFilter.tsx": [
		3383,
		9,
		1019
	],
	"./pages/billing/components/invoices/invoices": [
		3241,
		9,
		95
	],
	"./pages/billing/components/invoices/invoices.tsx": [
		3241,
		9,
		95
	],
	"./pages/choose-app-view": [
		853,
		9,
		134
	],
	"./pages/choose-app-view/": [
		853,
		9,
		134
	],
	"./pages/choose-app-view/choose-app.styles": [
		3384,
		9,
		1516
	],
	"./pages/choose-app-view/choose-app.styles.ts": [
		3384,
		9,
		1516
	],
	"./pages/choose-app-view/index": [
		853,
		9,
		134
	],
	"./pages/choose-app-view/index.tsx": [
		853,
		9,
		134
	],
	"./pages/company-details/companyDetailsContainer": [
		2951,
		9,
		1,
		3,
		5,
		6,
		334
	],
	"./pages/company-details/companyDetailsContainer.tsx": [
		2951,
		9,
		1,
		3,
		5,
		6,
		334
	],
	"./pages/company-details/companyDetailsView": [
		3069,
		9,
		1,
		3,
		5,
		6,
		391
	],
	"./pages/company-details/companyDetailsView.tsx": [
		3069,
		9,
		1,
		3,
		5,
		6,
		391
	],
	"./pages/company-details/components/about/about": [
		2749,
		9,
		179,
		585
	],
	"./pages/company-details/components/about/about.tsx": [
		2749,
		9,
		179,
		585
	],
	"./pages/company-details/components/about/header": [
		3587,
		9,
		621
	],
	"./pages/company-details/components/about/header.tsx": [
		3587,
		9,
		621
	],
	"./pages/company-details/components/about/headerFTU": [
		3386,
		9,
		641
	],
	"./pages/company-details/components/about/headerFTU.tsx": [
		3386,
		9,
		641
	],
	"./pages/company-details/components/account-verification/account-verification-read/accountVerificationRead": [
		1894,
		9,
		1,
		588
	],
	"./pages/company-details/components/account-verification/account-verification-read/accountVerificationRead.tsx": [
		1894,
		9,
		1,
		588
	],
	"./pages/company-details/components/account-verification/accountVerification": [
		2199,
		9,
		1,
		3,
		5,
		6,
		408
	],
	"./pages/company-details/components/account-verification/accountVerification.tsx": [
		2199,
		9,
		1,
		3,
		5,
		6,
		408
	],
	"./pages/company-details/components/account-verification/business-verification-form/businessVerificationForm": [
		2265,
		9,
		1285
	],
	"./pages/company-details/components/account-verification/business-verification-form/businessVerificationForm.tsx": [
		2265,
		9,
		1285
	],
	"./pages/company-details/components/account-verification/footer/accountVerificationFooter": [
		2266,
		9,
		1,
		943
	],
	"./pages/company-details/components/account-verification/footer/accountVerificationFooter.tsx": [
		2266,
		9,
		1,
		943
	],
	"./pages/company-details/components/account-verification/hooks/useIsEnabledActions": [
		2100,
		9,
		1,
		1286
	],
	"./pages/company-details/components/account-verification/hooks/useIsEnabledActions.ts": [
		2100,
		9,
		1,
		1286
	],
	"./pages/company-details/components/account-verification/instant-verification-form/InstantVerificationForm": [
		2268,
		9,
		1,
		678
	],
	"./pages/company-details/components/account-verification/instant-verification-form/InstantVerificationForm.tsx": [
		2268,
		9,
		1,
		678
	],
	"./pages/company-details/components/account-verification/instant-verification-form/InstantVerificationFormStyles": [
		2101,
		9,
		2056
	],
	"./pages/company-details/components/account-verification/instant-verification-form/InstantVerificationFormStyles.ts": [
		2101,
		9,
		2056
	],
	"./pages/company-details/components/account-verification/instant-verification-form/PladInit": [
		1728,
		9,
		1517
	],
	"./pages/company-details/components/account-verification/instant-verification-form/PladInit.tsx": [
		1728,
		9,
		1517
	],
	"./pages/company-details/components/account-verification/manual-verification-form/account-validation-form/accountValidationRequestCard": [
		2102,
		9,
		1,
		3,
		277,
		28,
		642
	],
	"./pages/company-details/components/account-verification/manual-verification-form/account-validation-form/accountValidationRequestCard.tsx": [
		2102,
		9,
		1,
		3,
		277,
		28,
		642
	],
	"./pages/company-details/components/account-verification/manual-verification-form/manualVerificationForm": [
		2269,
		9,
		1,
		3,
		277,
		28,
		586
	],
	"./pages/company-details/components/account-verification/manual-verification-form/manualVerificationForm.tsx": [
		2269,
		9,
		1,
		3,
		277,
		28,
		586
	],
	"./pages/company-details/components/account-verification/manual-verification-form/manualVerificationFormStyles": [
		2103,
		9,
		2057
	],
	"./pages/company-details/components/account-verification/manual-verification-form/manualVerificationFormStyles.ts": [
		2103,
		9,
		2057
	],
	"./pages/company-details/components/account-verification/setup-complete-modal/setupCompleteModal": [
		2270,
		9,
		1,
		1287
	],
	"./pages/company-details/components/account-verification/setup-complete-modal/setupCompleteModal.tsx": [
		2270,
		9,
		1,
		1287
	],
	"./pages/company-details/components/account-verification/verifiction-type-form/verificationTypeForm": [
		2272,
		9,
		1,
		1020
	],
	"./pages/company-details/components/account-verification/verifiction-type-form/verificationTypeForm.tsx": [
		2272,
		9,
		1,
		1020
	],
	"./pages/company-details/components/account-verification/verifiction-type-form/verificationTypeFormStyles": [
		2104,
		9,
		2058
	],
	"./pages/company-details/components/account-verification/verifiction-type-form/verificationTypeFormStyles.ts": [
		2104,
		9,
		2058
	],
	"./pages/company-details/components/authorized-signatory/authorizedSignatory.styles": [
		1893,
		9,
		2059
	],
	"./pages/company-details/components/authorized-signatory/authorizedSignatory.styles.ts": [
		1893,
		9,
		2059
	],
	"./pages/company-details/components/authorized-signatory/authorizedSignatoryCard": [
		2462,
		9,
		1138
	],
	"./pages/company-details/components/authorized-signatory/authorizedSignatoryCard.tsx": [
		2462,
		9,
		1138
	],
	"./pages/company-details/components/authorized-signatory/authorizedSignatoryForm": [
		2461,
		9,
		3,
		659,
		517
	],
	"./pages/company-details/components/authorized-signatory/authorizedSignatoryForm.tsx": [
		2461,
		9,
		3,
		659,
		517
	],
	"./pages/company-details/components/authorized-signatory/components/signatoryAddressFields": [
		1338,
		9,
		714
	],
	"./pages/company-details/components/authorized-signatory/components/signatoryAddressFields.tsx": [
		1338,
		9,
		714
	],
	"./pages/company-details/components/authorized-signatory/components/signedOnRow": [
		2263,
		9,
		2060
	],
	"./pages/company-details/components/authorized-signatory/components/signedOnRow.tsx": [
		2263,
		9,
		2060
	],
	"./pages/company-details/components/banking/bankAccountSetupDialog": [
		2465,
		9,
		1518
	],
	"./pages/company-details/components/banking/bankAccountSetupDialog.tsx": [
		2465,
		9,
		1518
	],
	"./pages/company-details/components/banking/banking": [
		2751,
		9,
		1,
		3,
		5,
		6,
		412
	],
	"./pages/company-details/components/banking/banking.tsx": [
		2751,
		9,
		1,
		3,
		5,
		6,
		412
	],
	"./pages/company-details/components/banking/bankingCard": [
		2460,
		9,
		1139
	],
	"./pages/company-details/components/banking/bankingCard.tsx": [
		2460,
		9,
		1139
	],
	"./pages/company-details/components/banking/bankingFormFooter": [
		2466,
		9,
		1519
	],
	"./pages/company-details/components/banking/bankingFormFooter.tsx": [
		2466,
		9,
		1519
	],
	"./pages/company-details/components/banking/bankingStyles": [
		2459,
		9,
		2061
	],
	"./pages/company-details/components/banking/bankingStyles.ts": [
		2459,
		9,
		2061
	],
	"./pages/company-details/components/banking/headerFTU": [
		2463,
		9,
		1140
	],
	"./pages/company-details/components/banking/headerFTU.tsx": [
		2463,
		9,
		1140
	],
	"./pages/company-details/components/banking/useFormValidationSchema": [
		2464,
		9,
		1,
		861
	],
	"./pages/company-details/components/banking/useFormValidationSchema.ts": [
		2464,
		9,
		1,
		861
	],
	"./pages/company-details/components/company-links/companylinks": [
		3589,
		9,
		1520
	],
	"./pages/company-details/components/company-links/companylinks.tsx": [
		3589,
		9,
		1520
	],
	"./pages/company-details/components/company/FTUSaveAndExitButton": [
		3588,
		9,
		2062
	],
	"./pages/company-details/components/company/FTUSaveAndExitButton.tsx": [
		3588,
		9,
		2062
	],
	"./pages/company-details/components/company/companyCard": [
		2454,
		9,
		862
	],
	"./pages/company-details/components/company/companyCard.tsx": [
		2454,
		9,
		862
	],
	"./pages/company-details/components/company/companyForm": [
		2651,
		9,
		179,
		794
	],
	"./pages/company-details/components/company/companyForm.tsx": [
		2651,
		9,
		179,
		794
	],
	"./pages/company-details/components/company/companyFormFooter": [
		2455,
		9,
		2063
	],
	"./pages/company-details/components/company/companyFormFooter.tsx": [
		2455,
		9,
		2063
	],
	"./pages/company-details/components/company/companyFormValidationSchema": [
		2456,
		9,
		1246
	],
	"./pages/company-details/components/company/companyFormValidationSchema.ts": [
		2456,
		9,
		1246
	],
	"./pages/company-details/components/create-administrator/createAdministrator": [
		2264,
		9,
		1288
	],
	"./pages/company-details/components/create-administrator/createAdministrator.tsx": [
		2264,
		9,
		1288
	],
	"./pages/company-details/components/create-administrator/createAdministratorStyles": [
		2098,
		9,
		2064
	],
	"./pages/company-details/components/create-administrator/createAdministratorStyles.ts": [
		2098,
		9,
		2064
	],
	"./pages/company-details/components/locations/locationCard": [
		2097,
		9,
		2065
	],
	"./pages/company-details/components/locations/locationCard.tsx": [
		2097,
		9,
		2065
	],
	"./pages/company-details/components/locations/locationValidationSchema": [
		2458,
		9,
		1247
	],
	"./pages/company-details/components/locations/locationValidationSchema.ts": [
		2458,
		9,
		1247
	],
	"./pages/company-details/components/locations/locations": [
		2750,
		9,
		689
	],
	"./pages/company-details/components/locations/locations.tsx": [
		2750,
		9,
		689
	],
	"./pages/company-details/components/locations/locationsList": [
		2262,
		9,
		1289
	],
	"./pages/company-details/components/locations/locationsList.tsx": [
		2262,
		9,
		1289
	],
	"./pages/company-details/useCompanyDetailsPermissions": [
		1983,
		9,
		1290
	],
	"./pages/company-details/useCompanyDetailsPermissions.ts": [
		1983,
		9,
		1290
	],
	"./pages/company-details/useIsAutoPlanSelectionEnabled": [
		1151,
		9,
		2066
	],
	"./pages/company-details/useIsAutoPlanSelectionEnabled.ts": [
		1151,
		9,
		2066
	],
	"./pages/demo/launchDarkly": [
		2752,
		9,
		1522
	],
	"./pages/demo/launchDarkly.tsx": [
		2752,
		9,
		1522
	],
	"./pages/firstTimeUser/components/accountVerification": [
		814,
		9,
		1,
		3,
		5,
		6,
		145
	],
	"./pages/firstTimeUser/components/accountVerification/": [
		814,
		9,
		1,
		3,
		5,
		6,
		145
	],
	"./pages/firstTimeUser/components/accountVerification/emailVerificationStatement": [
		1648,
		9,
		1291
	],
	"./pages/firstTimeUser/components/accountVerification/emailVerificationStatement.tsx": [
		1648,
		9,
		1291
	],
	"./pages/firstTimeUser/components/accountVerification/headerFTUVerification": [
		2267,
		9,
		643
	],
	"./pages/firstTimeUser/components/accountVerification/headerFTUVerification.tsx": [
		2267,
		9,
		643
	],
	"./pages/firstTimeUser/components/accountVerification/index": [
		814,
		9,
		1,
		3,
		5,
		6,
		145
	],
	"./pages/firstTimeUser/components/accountVerification/index.tsx": [
		814,
		9,
		1,
		3,
		5,
		6,
		145
	],
	"./pages/firstTimeUser/components/accountVerification/verificationFTUFooter": [
		2271,
		9,
		1523
	],
	"./pages/firstTimeUser/components/accountVerification/verificationFTUFooter.tsx": [
		2271,
		9,
		1523
	],
	"./pages/firstTimeUser/components/common/accountNotification/accountNotification": [
		1464,
		9,
		761
	],
	"./pages/firstTimeUser/components/common/accountNotification/accountNotification.tsx": [
		1464,
		9,
		761
	],
	"./pages/firstTimeUser/components/common/lockedState": [
		761,
		9,
		266
	],
	"./pages/firstTimeUser/components/common/lockedState/": [
		761,
		9,
		266
	],
	"./pages/firstTimeUser/components/common/lockedState/index": [
		761,
		9,
		266
	],
	"./pages/firstTimeUser/components/common/lockedState/index.tsx": [
		761,
		9,
		266
	],
	"./pages/firstTimeUser/components/common/onboardPopup/onboardPopup": [
		3202,
		9,
		1022
	],
	"./pages/firstTimeUser/components/common/onboardPopup/onboardPopup.tsx": [
		3202,
		9,
		1022
	],
	"./pages/firstTimeUser/components/common/onboardSidebar/onboardSidebar": [
		3197,
		9,
		81,
		238
	],
	"./pages/firstTimeUser/components/common/onboardSidebar/onboardSidebar.tsx": [
		3197,
		9,
		81,
		238
	],
	"./pages/firstTimeUser/components/common/stepHeader/stepHeader": [
		1314,
		9,
		1292
	],
	"./pages/firstTimeUser/components/common/stepHeader/stepHeader.tsx": [
		1314,
		9,
		1292
	],
	"./pages/firstTimeUser/components/common/stepHeader/stepSupHeader": [
		1215,
		9,
		2067
	],
	"./pages/firstTimeUser/components/common/stepHeader/stepSupHeader.tsx": [
		1215,
		9,
		2067
	],
	"./pages/firstTimeUser/components/common/stepInformationList": [
		1119,
		9,
		795
	],
	"./pages/firstTimeUser/components/common/stepInformationList.tsx": [
		1119,
		9,
		795
	],
	"./pages/firstTimeUser/components/common/useCurrentStepStatus": [
		1106,
		9,
		2068
	],
	"./pages/firstTimeUser/components/common/useCurrentStepStatus.tsx": [
		1106,
		9,
		2068
	],
	"./pages/firstTimeUser/components/common/usePathOfCurrentStep": [
		3590,
		9,
		762
	],
	"./pages/firstTimeUser/components/common/usePathOfCurrentStep.ts": [
		3590,
		9,
		762
	],
	"./pages/firstTimeUser/components/completedOnboardingPage/FTUModalCompleteOnboarding": [
		2754,
		9,
		1,
		135,
		679
	],
	"./pages/firstTimeUser/components/completedOnboardingPage/FTUModalCompleteOnboarding.tsx": [
		2754,
		9,
		1,
		135,
		679
	],
	"./pages/firstTimeUser/components/completedOnboardingPage/completedOnboardingPage": [
		2274,
		9,
		1,
		135,
		1143
	],
	"./pages/firstTimeUser/components/completedOnboardingPage/completedOnboardingPage.tsx": [
		2274,
		9,
		1,
		135,
		1143
	],
	"./pages/firstTimeUser/components/completedOnboardingPage/completedOnboardingPageStyles": [
		2105,
		9,
		2069
	],
	"./pages/firstTimeUser/components/completedOnboardingPage/completedOnboardingPageStyles.ts": [
		2105,
		9,
		2069
	],
	"./pages/firstTimeUser/components/peopleTeam": [
		862,
		9,
		1,
		3,
		17,
		19,
		137
	],
	"./pages/firstTimeUser/components/peopleTeam/": [
		862,
		9,
		1,
		3,
		17,
		19,
		137
	],
	"./pages/firstTimeUser/components/peopleTeam/dashboardFooter": [
		3072,
		9,
		1293
	],
	"./pages/firstTimeUser/components/peopleTeam/dashboardFooter.tsx": [
		3072,
		9,
		1293
	],
	"./pages/firstTimeUser/components/peopleTeam/dashboardPeopleTeam": [
		2467,
		9,
		1141
	],
	"./pages/firstTimeUser/components/peopleTeam/dashboardPeopleTeam.tsx": [
		2467,
		9,
		1141
	],
	"./pages/firstTimeUser/components/peopleTeam/headerFTUAddPeople": [
		3073,
		9,
		644
	],
	"./pages/firstTimeUser/components/peopleTeam/headerFTUAddPeople.tsx": [
		3073,
		9,
		644
	],
	"./pages/firstTimeUser/components/peopleTeam/headerFTUOnboarding": [
		3071,
		9,
		1142
	],
	"./pages/firstTimeUser/components/peopleTeam/headerFTUOnboarding.tsx": [
		3071,
		9,
		1142
	],
	"./pages/firstTimeUser/components/peopleTeam/index": [
		862,
		9,
		1,
		3,
		17,
		19,
		137
	],
	"./pages/firstTimeUser/components/peopleTeam/index.tsx": [
		862,
		9,
		1,
		3,
		17,
		19,
		137
	],
	"./pages/firstTimeUser/components/peopleTeam/stepHeaderPeopleOnboarding": [
		2753,
		9,
		1524
	],
	"./pages/firstTimeUser/components/peopleTeam/stepHeaderPeopleOnboarding.tsx": [
		2753,
		9,
		1524
	],
	"./pages/firstTimeUser/components/peopleTeam/useFTUPeopleTeamStyles": [
		3070,
		9,
		2070
	],
	"./pages/firstTimeUser/components/peopleTeam/useFTUPeopleTeamStyles.tsx": [
		3070,
		9,
		2070
	],
	"./pages/firstTimeUser/components/welcomePage/ProductTourModal": [
		3074,
		9,
		1294
	],
	"./pages/firstTimeUser/components/welcomePage/ProductTourModal.tsx": [
		3074,
		9,
		1294
	],
	"./pages/firstTimeUser/components/welcomePage/inviteAcceptedModal/inviteAcceptedModal": [
		2675,
		9,
		1144
	],
	"./pages/firstTimeUser/components/welcomePage/inviteAcceptedModal/inviteAcceptedModal.tsx": [
		2675,
		9,
		1144
	],
	"./pages/firstTimeUser/components/welcomePage/inviteAcceptedModal/useModalVisibility": [
		2189,
		9,
		1295
	],
	"./pages/firstTimeUser/components/welcomePage/inviteAcceptedModal/useModalVisibility.ts": [
		2189,
		9,
		1295
	],
	"./pages/firstTimeUser/components/welcomePage/onboardSidebarSkeleton": [
		3591,
		9,
		1296
	],
	"./pages/firstTimeUser/components/welcomePage/onboardSidebarSkeleton.tsx": [
		3591,
		9,
		1296
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModal/rolesRadioGroup": [
		2392,
		9,
		1297
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModal/rolesRadioGroup.tsx": [
		2392,
		9,
		1297
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModal/useModalVisibility": [
		3592,
		9,
		1298
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModal/useModalVisibility.tsx": [
		3592,
		9,
		1298
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModal/welcomeModal": [
		2674,
		9,
		1145
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModal/welcomeModal.tsx": [
		2674,
		9,
		1145
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModalOld/rolesRadioGroup": [
		2670,
		9,
		1299
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModalOld/rolesRadioGroup.tsx": [
		2670,
		9,
		1299
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModalOld/useModalVisibility": [
		2671,
		9,
		1300
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModalOld/useModalVisibility.tsx": [
		2671,
		9,
		1300
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModalOld/welcomeModalOld": [
		2987,
		9,
		863
	],
	"./pages/firstTimeUser/components/welcomePage/welcomeModalOld/welcomeModalOld.tsx": [
		2987,
		9,
		863
	],
	"./pages/firstTimeUser/components/welcomePage/welcomePageStyles": [
		1462,
		9,
		1525
	],
	"./pages/firstTimeUser/components/welcomePage/welcomePageStyles.tsx": [
		1462,
		9,
		1525
	],
	"./pages/firstTimeUser/firstTimeUserContainer": [
		3242,
		9,
		81,
		369
	],
	"./pages/firstTimeUser/firstTimeUserContainer.tsx": [
		3242,
		9,
		81,
		369
	],
	"./pages/firstTimeUser/styles": [
		1601,
		9,
		1526
	],
	"./pages/firstTimeUser/styles.tsx": [
		1601,
		9,
		1526
	],
	"./pages/lock-screens/payrollRunLocked": [
		2652,
		9,
		5,
		381
	],
	"./pages/lock-screens/payrollRunLocked.tsx": [
		2652,
		9,
		5,
		381
	],
	"./pages/locked-account-page/hooks/useDetailsLite": [
		2668,
		9,
		1527
	],
	"./pages/locked-account-page/hooks/useDetailsLite.ts": [
		2668,
		9,
		1527
	],
	"./pages/locked-account-page/lockedAccountPage": [
		2984,
		9,
		796
	],
	"./pages/locked-account-page/lockedAccountPage.tsx": [
		2984,
		9,
		796
	],
	"./pages/main/main": [
		3243,
		9,
		383
	],
	"./pages/main/main.tsx": [
		3243,
		9,
		383
	],
	"./pages/migration/common/hooks/useMigrationDontShowFlags": [
		1103,
		9,
		1528
	],
	"./pages/migration/common/hooks/useMigrationDontShowFlags.tsx": [
		1103,
		9,
		1528
	],
	"./pages/migration/common/hooks/usePadAfterPadSign": [
		1819,
		9,
		1146
	],
	"./pages/migration/common/hooks/usePadAfterPadSign.tsx": [
		1819,
		9,
		1146
	],
	"./pages/migration/common/welcomeModal/partnerWelcome": [
		2990,
		9,
		797
	],
	"./pages/migration/common/welcomeModal/partnerWelcome.tsx": [
		2990,
		9,
		797
	],
	"./pages/migration/common/welcomeModal/useControlPartnerAccessModal": [
		2190,
		9,
		2071
	],
	"./pages/migration/common/welcomeModal/useControlPartnerAccessModal.tsx": [
		2190,
		9,
		2071
	],
	"./pages/migration/common/welcomeModal/useShowPartnerModal": [
		2678,
		9,
		1303
	],
	"./pages/migration/common/welcomeModal/useShowPartnerModal.tsx": [
		2678,
		9,
		1303
	],
	"./pages/migration/common/welcomeModal/validationSchema": [
		2677,
		9,
		2072
	],
	"./pages/migration/common/welcomeModal/validationSchema.tsx": [
		2677,
		9,
		2072
	],
	"./pages/migration/common/welcomeTitle": [
		2418,
		9,
		2073
	],
	"./pages/migration/common/welcomeTitle.tsx": [
		2418,
		9,
		2073
	],
	"./pages/migration/migration": [
		2086,
		9,
		34,
		178
	],
	"./pages/migration/migration.tsx": [
		2086,
		9,
		34,
		178
	],
	"./pages/migration/migrationActionCard": [
		2237,
		9,
		34,
		178
	],
	"./pages/migration/migrationActionCard.tsx": [
		2237,
		9,
		34,
		178
	],
	"./pages/migration/migrationContainer": [
		2953,
		9,
		34,
		355
	],
	"./pages/migration/migrationContainer.tsx": [
		2953,
		9,
		34,
		355
	],
	"./pages/migration/migrationSetupCard": [
		3075,
		9,
		34,
		545
	],
	"./pages/migration/migrationSetupCard.tsx": [
		3075,
		9,
		34,
		545
	],
	"./pages/migration/partner/banner": [
		839,
		9,
		34,
		165
	],
	"./pages/migration/partner/banner/": [
		839,
		9,
		34,
		165
	],
	"./pages/migration/partner/banner/index": [
		839,
		9,
		34,
		165
	],
	"./pages/migration/partner/banner/index.tsx": [
		839,
		9,
		34,
		165
	],
	"./pages/migration/partner/banner/loadingStates": [
		2717,
		9,
		1529
	],
	"./pages/migration/partner/banner/loadingStates.tsx": [
		2717,
		9,
		1529
	],
	"./pages/migration/partner/banner/upgradeWithoutBank": [
		2718,
		9,
		1301
	],
	"./pages/migration/partner/banner/upgradeWithoutBank.tsx": [
		2718,
		9,
		1301
	],
	"./pages/migration/partner/banner/useNeedsAuthorizedSignatory": [
		3068,
		9,
		676
	],
	"./pages/migration/partner/banner/useNeedsAuthorizedSignatory.tsx": [
		3068,
		9,
		676
	],
	"./pages/migration/queries/useMigrationQueries": [
		1102,
		9,
		1530
	],
	"./pages/migration/queries/useMigrationQueries.ts": [
		1102,
		9,
		1530
	],
	"./pages/migration/safetyHooks": [
		328,
		9
	],
	"./pages/migration/safetyHooks/": [
		328,
		9
	],
	"./pages/migration/safetyHooks/index": [
		328,
		9
	],
	"./pages/migration/safetyHooks/index.tsx": [
		328,
		9
	],
	"./pages/migration/stepMigrationList": [
		1183,
		9,
		860
	],
	"./pages/migration/stepMigrationList.tsx": [
		1183,
		9,
		860
	],
	"./pages/migration/unlockAllFeaturesChecklist": [
		2375,
		9,
		1302
	],
	"./pages/migration/unlockAllFeaturesChecklist.tsx": [
		2375,
		9,
		1302
	],
	"./pages/migration/useMigrationChecklistData": [
		2417,
		9,
		1304
	],
	"./pages/migration/useMigrationChecklistData.ts": [
		2417,
		9,
		1304
	],
	"./pages/migration/useMigrationStepInfo": [
		1150,
		9,
		723
	],
	"./pages/migration/useMigrationStepInfo.tsx": [
		1150,
		9,
		723
	],
	"./pages/migration/viewAdministratorsCard": [
		2416,
		9,
		2074
	],
	"./pages/migration/viewAdministratorsCard.tsx": [
		2416,
		9,
		2074
	],
	"./pages/mobile/mobileAccountSetupCard/mobileAccountSetupCard": [
		3387,
		9,
		587
	],
	"./pages/mobile/mobileAccountSetupCard/mobileAccountSetupCard.tsx": [
		3387,
		9,
		587
	],
	"./pages/mobile/mobileAccountSetupCard/styles": [
		3076,
		9,
		1531
	],
	"./pages/mobile/mobileAccountSetupCard/styles.ts": [
		3076,
		9,
		1531
	],
	"./pages/mobile/mobileHeaderContainer/mobileHeaderContainer": [
		3593,
		9,
		48,
		347,
		521
	],
	"./pages/mobile/mobileHeaderContainer/mobileHeaderContainer.tsx": [
		3593,
		9,
		48,
		347,
		521
	],
	"./pages/payroll-reports/components/filter/common": [
		1394,
		9,
		2075
	],
	"./pages/payroll-reports/components/filter/common.tsx": [
		1394,
		9,
		2075
	],
	"./pages/payroll-reports/components/filter/payrollReportsFilter": [
		1395,
		9,
		7,
		23,
		133,
		1024
	],
	"./pages/payroll-reports/components/filter/payrollReportsFilter.tsx": [
		1395,
		9,
		7,
		23,
		133,
		1024
	],
	"./pages/payroll-reports/components/filter/payrollReportsFilterStyles": [
		1359,
		9,
		2076
	],
	"./pages/payroll-reports/components/filter/payrollReportsFilterStyles.ts": [
		1359,
		9,
		2076
	],
	"./pages/payroll-reports/components/filter/types": [
		1083,
		9,
		2077
	],
	"./pages/payroll-reports/components/filter/types.ts": [
		1083,
		9,
		2077
	],
	"./pages/payroll-reports/components/hooks/safetyHooks": [
		352,
		9
	],
	"./pages/payroll-reports/components/hooks/safetyHooks.ts": [
		352,
		9
	],
	"./pages/payroll-reports/components/hooks/useAnnualReportSelectors": [
		2542,
		9,
		2078
	],
	"./pages/payroll-reports/components/hooks/useAnnualReportSelectors.tsx": [
		2542,
		9,
		2078
	],
	"./pages/payroll-reports/components/hooks/useDisableListItem": [
		3430,
		9,
		1532
	],
	"./pages/payroll-reports/components/hooks/useDisableListItem.tsx": [
		3430,
		9,
		1532
	],
	"./pages/payroll-reports/components/payroll-common/empty-report-placeholder/emptyReportPlaceholder": [
		3431,
		9,
		1533
	],
	"./pages/payroll-reports/components/payroll-common/empty-report-placeholder/emptyReportPlaceholder.tsx": [
		3431,
		9,
		1533
	],
	"./pages/payroll-reports/components/payroll-common/empty-report-placeholder/emptyReportPlaceholderStyles": [
		3127,
		9,
		2079
	],
	"./pages/payroll-reports/components/payroll-common/empty-report-placeholder/emptyReportPlaceholderStyles.ts": [
		3127,
		9,
		2079
	],
	"./pages/payroll-reports/components/payroll-common/hooks/useDisplayZeroState": [
		1148,
		9,
		2080
	],
	"./pages/payroll-reports/components/payroll-common/hooks/useDisplayZeroState.ts": [
		1148,
		9,
		2080
	],
	"./pages/payroll-reports/components/payroll-common/hooks/useGetReportHandler": [
		3432,
		9,
		1306
	],
	"./pages/payroll-reports/components/payroll-common/hooks/useGetReportHandler.ts": [
		3432,
		9,
		1306
	],
	"./pages/payroll-reports/components/payroll-common/hooks/useGetTwoStepApprovalInfo": [
		1169,
		9,
		2081
	],
	"./pages/payroll-reports/components/payroll-common/hooks/useGetTwoStepApprovalInfo.ts": [
		1169,
		9,
		2081
	],
	"./pages/payroll-reports/components/payroll-common/pdf-styles/pdfStyles": [
		3617,
		9,
		2082
	],
	"./pages/payroll-reports/components/payroll-common/pdf-styles/pdfStyles.ts": [
		3617,
		9,
		2082
	],
	"./pages/payroll-reports/components/payroll-common/print-header/printHeader": [
		1266,
		9,
		855
	],
	"./pages/payroll-reports/components/payroll-common/print-header/printHeader.tsx": [
		1266,
		9,
		855
	],
	"./pages/payroll-reports/components/payroll-common/print-header/printHeaderStyles": [
		1249,
		9,
		2083
	],
	"./pages/payroll-reports/components/payroll-common/print-header/printHeaderStyles.ts": [
		1249,
		9,
		2083
	],
	"./pages/payroll-reports/components/payroll-common/reports-body": [
		706,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/": [
		706,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/accordion/reportAccordion": [
		1278,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/accordion/reportAccordion.tsx": [
		1278,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/accordion/reportAccordionStyles": [
		1100,
		9,
		2084
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/accordion/reportAccordionStyles.ts": [
		1100,
		9,
		2084
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/accordion/reportAccordionTitlePane": [
		1279,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/accordion/reportAccordionTitlePane.tsx": [
		1279,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/checkbox/reportsCheckbox": [
		1268,
		9,
		1308
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/checkbox/reportsCheckbox.tsx": [
		1268,
		9,
		1308
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/chip/reportsChip": [
		1121,
		9,
		2085
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/chip/reportsChip.tsx": [
		1121,
		9,
		2085
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/dropdown/reportsDropdown": [
		1267,
		9,
		7,
		23,
		1023
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/dropdown/reportsDropdown.tsx": [
		1267,
		9,
		7,
		23,
		1023
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/emptyContainer/emptyConatinerCard": [
		1164,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/emptyContainer/emptyConatinerCard.tsx": [
		1164,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/emptyContainer/emptyContainerStyles": [
		1265,
		9,
		2086
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/emptyContainer/emptyContainerStyles.ts": [
		1265,
		9,
		2086
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/grid/reportsGrid": [
		1163,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/grid/reportsGrid.tsx": [
		1163,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/grid/reportsGridColumns": [
		1277,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/grid/reportsGridColumns.tsx": [
		1277,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/grid/reportsGridStyles": [
		1264,
		9,
		2087
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/grid/reportsGridStyles.ts": [
		1264,
		9,
		2087
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/index": [
		706,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/index.tsx": [
		706,
		9,
		7,
		23,
		39,
		50
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/reportsServiceHandler": [
		1127,
		9,
		7,
		23,
		1147
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/reportsServiceHandler.tsx": [
		1127,
		9,
		7,
		23,
		1147
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/statement/statementContainer": [
		1134,
		9,
		1148
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/statement/statementContainer.tsx": [
		1134,
		9,
		1148
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/statement/statementContainerStyles": [
		1248,
		9,
		2088
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/statement/statementContainerStyles.ts": [
		1248,
		9,
		2088
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/toggle/reportsToggle": [
		3618,
		9,
		946
	],
	"./pages/payroll-reports/components/payroll-common/reports-body/toggle/reportsToggle.tsx": [
		3618,
		9,
		946
	],
	"./pages/payroll-reports/components/payroll-common/reports-header/reportsHeader": [
		1126,
		9,
		1007
	],
	"./pages/payroll-reports/components/payroll-common/reports-header/reportsHeader.tsx": [
		1126,
		9,
		1007
	],
	"./pages/payroll-reports/components/payroll-common/reports-header/reportsHeaderStyles": [
		1250,
		9,
		2089
	],
	"./pages/payroll-reports/components/payroll-common/reports-header/reportsHeaderStyles.ts": [
		1250,
		9,
		2089
	],
	"./pages/payroll-reports/components/payroll-common/reports-title/reportsTitleContainer": [
		1428,
		9,
		674
	],
	"./pages/payroll-reports/components/payroll-common/reports-title/reportsTitleContainer.tsx": [
		1428,
		9,
		674
	],
	"./pages/payroll-reports/components/payroll-common/reports-title/reportsTitleStyles": [
		1540,
		9,
		2090
	],
	"./pages/payroll-reports/components/payroll-common/reports-title/reportsTitleStyles.ts": [
		1540,
		9,
		2090
	],
	"./pages/payroll-reports/components/payroll-common/zero-state/zeroState": [
		1360,
		9,
		1305
	],
	"./pages/payroll-reports/components/payroll-common/zero-state/zeroState.tsx": [
		1360,
		9,
		1305
	],
	"./pages/payroll-reports/components/payrollReportListItemNew": [
		551,
		9
	],
	"./pages/payroll-reports/components/payrollReportListItemNew.tsx": [
		551,
		9
	],
	"./pages/payroll-reports/components/payrollReports": [
		3433,
		9,
		374
	],
	"./pages/payroll-reports/components/payrollReports.tsx": [
		3433,
		9,
		374
	],
	"./pages/payroll-reports/components/payrollReportsListItems": [
		3619,
		9,
		2091
	],
	"./pages/payroll-reports/components/payrollReportsListItems.tsx": [
		3619,
		9,
		2091
	],
	"./pages/payroll-reports/components/payrollReportsStyles": [
		3434,
		9,
		2092
	],
	"./pages/payroll-reports/components/payrollReportsStyles.tsx": [
		3434,
		9,
		2092
	],
	"./pages/payroll-reports/components/reportRoutes": [
		555,
		9
	],
	"./pages/payroll-reports/components/reportRoutes.ts": [
		555,
		9
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report": [
		843,
		9,
		0,
		4,
		11,
		43,
		160
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/": [
		843,
		9,
		0,
		4,
		11,
		43,
		160
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportEmpty": [
		774,
		9,
		267
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportEmpty/": [
		774,
		9,
		267
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportEmpty/index": [
		774,
		9,
		267
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportEmpty/index.tsx": [
		774,
		9,
		267
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportEmpty/loadingReport": [
		2543,
		9,
		1535
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportEmpty/loadingReport.tsx": [
		2543,
		9,
		1535
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportFilter": [
		842,
		9,
		43,
		330
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportFilter/": [
		842,
		9,
		43,
		330
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportFilter/dropdownItem": [
		3435,
		9,
		1309
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportFilter/dropdownItem.tsx": [
		3435,
		9,
		1309
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportFilter/index": [
		842,
		9,
		43,
		330
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportFilter/index.tsx": [
		842,
		9,
		43,
		330
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportModal": [
		2800,
		9,
		43,
		1536
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportModal.tsx": [
		2800,
		9,
		43,
		1536
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsCards": [
		873,
		9,
		218
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsCards/": [
		873,
		9,
		218
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsCards/index": [
		873,
		9,
		218
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsCards/index.tsx": [
		873,
		9,
		218
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable": [
		820,
		9,
		0,
		4,
		11,
		176
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/": [
		820,
		9,
		0,
		4,
		11,
		176
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/annualReportFilters": [
		2544,
		9,
		11,
		698
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/annualReportFilters.tsx": [
		2544,
		9,
		11,
		698
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/annualReportListColumns": [
		2545,
		9,
		2093
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/annualReportListColumns.tsx": [
		2545,
		9,
		2093
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/annualReportPoller": [
		2546,
		9,
		798
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/annualReportPoller.tsx": [
		2546,
		9,
		798
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/annualReportTableConfig": [
		1923,
		9,
		2094
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/annualReportTableConfig.ts": [
		1923,
		9,
		2094
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/generateReportButton": [
		2308,
		9,
		1310
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/generateReportButton.tsx": [
		2308,
		9,
		1310
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/index": [
		820,
		9,
		0,
		4,
		11,
		176
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/annualReportsTable/index.tsx": [
		820,
		9,
		0,
		4,
		11,
		176
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/helpers/useSafetyHooks": [
		2205,
		9,
		2095
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/helpers/useSafetyHooks.tsx": [
		2205,
		9,
		2095
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/helpers/useUpdateModals": [
		1714,
		9,
		2096
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/helpers/useUpdateModals.tsx": [
		1714,
		9,
		2096
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/index": [
		843,
		9,
		0,
		4,
		11,
		43,
		160
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/index.tsx": [
		843,
		9,
		0,
		4,
		11,
		43,
		160
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/services": [
		724,
		9,
		74
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/services/": [
		724,
		9,
		74
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/services/index": [
		724,
		9,
		74
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/services/index.ts": [
		724,
		9,
		74
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/services/mutations/prepareAnnualReportCSV": [
		1869,
		9,
		74
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/services/mutations/prepareAnnualReportCSV.ts": [
		1869,
		9,
		74
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/services/queries/annualReportList": [
		1655,
		9,
		74
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/services/queries/annualReportList.ts": [
		1655,
		9,
		74
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/services/queries/getAnnualReportInitialState": [
		1870,
		9,
		74
	],
	"./pages/payroll-reports/components/reports/annual-payroll-report/services/queries/getAnnualReportInitialState.ts": [
		1870,
		9,
		74
	],
	"./pages/payroll-reports/components/reports/common/logoPrintStyles": [
		1218,
		9,
		2097
	],
	"./pages/payroll-reports/components/reports/common/logoPrintStyles.ts": [
		1218,
		9,
		2097
	],
	"./pages/payroll-reports/components/reports/common/reportsLogoOnPrint": [
		1222,
		9,
		1112
	],
	"./pages/payroll-reports/components/reports/common/reportsLogoOnPrint.tsx": [
		1222,
		9,
		1112
	],
	"./pages/payroll-reports/components/reports/hooks/useReportActions": [
		1541,
		9,
		12,
		14,
		16,
		7,
		680
	],
	"./pages/payroll-reports/components/reports/hooks/useReportActions.tsx": [
		1541,
		9,
		12,
		14,
		16,
		7,
		680
	],
	"./pages/payroll-reports/components/reports/payroll-benefits-report/payrollBenefitsReport": [
		2961,
		9,
		12,
		14,
		16,
		7,
		434
	],
	"./pages/payroll-reports/components/reports/payroll-benefits-report/payrollBenefitsReport.tsx": [
		2961,
		9,
		12,
		14,
		16,
		7,
		434
	],
	"./pages/payroll-reports/components/reports/payroll-deduction-report/payrollDeductionsReport": [
		3250,
		9,
		12,
		14,
		16,
		7,
		435
	],
	"./pages/payroll-reports/components/reports/payroll-deduction-report/payrollDeductionsReport.tsx": [
		3250,
		9,
		12,
		14,
		16,
		7,
		435
	],
	"./pages/payroll-reports/components/reports/payroll-deduction-report/utils": [
		3620,
		9,
		2098
	],
	"./pages/payroll-reports/components/reports/payroll-deduction-report/utils.js": [
		3620,
		9,
		2098
	],
	"./pages/payroll-reports/components/reports/payroll-deposit-summary-report/payrollDepositSummary": [
		3251,
		9,
		12,
		14,
		16,
		7,
		440
	],
	"./pages/payroll-reports/components/reports/payroll-deposit-summary-report/payrollDepositSummary.tsx": [
		3251,
		9,
		12,
		14,
		16,
		7,
		440
	],
	"./pages/payroll-reports/components/reports/payroll-earnings-report/payrollEarningsReport": [
		3252,
		9,
		12,
		14,
		16,
		7,
		436
	],
	"./pages/payroll-reports/components/reports/payroll-earnings-report/payrollEarningsReport.tsx": [
		3252,
		9,
		12,
		14,
		16,
		7,
		436
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/components/invoices-report-grid/invoicesReportGrid": [
		3436,
		9,
		1537
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/components/invoices-report-grid/invoicesReportGrid.tsx": [
		3436,
		9,
		1537
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/components/invoices-report-grid/invoicesReportsGridStyles": [
		3128,
		9,
		2099
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/components/invoices-report-grid/invoicesReportsGridStyles.ts": [
		3128,
		9,
		2099
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/components/invoices-report-header/invoiceReportPrintStyles": [
		3621,
		9,
		2100
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/components/invoices-report-header/invoiceReportPrintStyles.ts": [
		3621,
		9,
		2100
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/components/invoices-report-header/invoicesReportHeader": [
		3437,
		9,
		1008
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/components/invoices-report-header/invoicesReportHeader.tsx": [
		3437,
		9,
		1008
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/components/payroll-invoices-filters/payrollInvoicesFilters": [
		3438,
		9,
		864
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/components/payroll-invoices-filters/payrollInvoicesFilters.tsx": [
		3438,
		9,
		864
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/payrollInvoicesReport": [
		3439,
		9,
		12,
		14,
		16,
		354,
		640
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/payrollInvoicesReport.tsx": [
		3439,
		9,
		12,
		14,
		16,
		354,
		640
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/types": [
		1349,
		9,
		2101
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/types.ts": [
		1349,
		9,
		2101
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/utils": [
		1355,
		9,
		1311
	],
	"./pages/payroll-reports/components/reports/payroll-invoices-report/utils.ts": [
		1355,
		9,
		1311
	],
	"./pages/payroll-reports/components/reports/payroll-paystub-reports/payrollPaystubReports": [
		3253,
		9,
		12,
		14,
		16,
		7,
		431
	],
	"./pages/payroll-reports/components/reports/payroll-paystub-reports/payrollPaystubReports.tsx": [
		3253,
		9,
		12,
		14,
		16,
		7,
		431
	],
	"./pages/payroll-reports/components/reports/payroll-posting-journal-report/payrollPostingJournalReport": [
		3254,
		9,
		12,
		14,
		16,
		7,
		441
	],
	"./pages/payroll-reports/components/reports/payroll-posting-journal-report/payrollPostingJournalReport.tsx": [
		3254,
		9,
		12,
		14,
		16,
		7,
		441
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payroll-preview/hooks/usePreviewParams": [
		1495,
		9,
		2102
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payroll-preview/hooks/usePreviewParams.tsx": [
		1495,
		9,
		2102
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payroll-preview/hooks/useSafetyHooks": [
		1236,
		9,
		2103
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payroll-preview/hooks/useSafetyHooks.tsx": [
		1236,
		9,
		2103
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payroll-preview/hooks/useServiceHook": [
		3129,
		9,
		7,
		23,
		865
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payroll-preview/hooks/useServiceHook.tsx": [
		3129,
		9,
		7,
		23,
		865
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payroll-preview/payrollRegisterPreviewReport": [
		3255,
		9,
		12,
		14,
		16,
		7,
		449
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payroll-preview/payrollRegisterPreviewReport.tsx": [
		3255,
		9,
		12,
		14,
		16,
		7,
		449
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payroll-preview/payrollRegisterPreviewStyles": [
		3130,
		9,
		2104
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payroll-preview/payrollRegisterPreviewStyles.ts": [
		3130,
		9,
		2104
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payrollRegisterReport": [
		3256,
		9,
		12,
		14,
		16,
		7,
		437
	],
	"./pages/payroll-reports/components/reports/payroll-register-report/payrollRegisterReport.tsx": [
		3256,
		9,
		12,
		14,
		16,
		7,
		437
	],
	"./pages/payroll-reports/components/reports/payroll-taxes-report/payrollTaxesReport": [
		3257,
		9,
		12,
		14,
		16,
		7,
		438
	],
	"./pages/payroll-reports/components/reports/payroll-taxes-report/payrollTaxesReport.tsx": [
		3257,
		9,
		12,
		14,
		16,
		7,
		438
	],
	"./pages/payroll-reports/components/reports/payroll-workers-compensation-report/payrollWorkersCompReport": [
		3258,
		9,
		12,
		14,
		16,
		7,
		439
	],
	"./pages/payroll-reports/components/reports/payroll-workers-compensation-report/payrollWorkersCompReport.tsx": [
		3258,
		9,
		12,
		14,
		16,
		7,
		439
	],
	"./pages/payroll-reports/components/reports/payroll-year-to-date-reports/payrollYearToDateReport": [
		3259,
		9,
		7,
		23,
		39,
		133,
		648
	],
	"./pages/payroll-reports/components/reports/payroll-year-to-date-reports/payrollYearToDateReport.tsx": [
		3259,
		9,
		7,
		23,
		39,
		133,
		648
	],
	"./pages/payroll-reports/payrollReportsContainer": [
		3260,
		9,
		0,
		4,
		11,
		43,
		343
	],
	"./pages/payroll-reports/payrollReportsContainer.tsx": [
		3260,
		9,
		0,
		4,
		11,
		43,
		343
	],
	"./pages/payroll-reports/payrollReportsView": [
		3440,
		9,
		0,
		4,
		11,
		43,
		482
	],
	"./pages/payroll-reports/payrollReportsView.tsx": [
		3440,
		9,
		0,
		4,
		11,
		43,
		482
	],
	"./pages/payroll-settings/components/calendar/calendar": [
		1850,
		9,
		22,
		26,
		375
	],
	"./pages/payroll-settings/components/calendar/calendar.tsx": [
		1850,
		9,
		22,
		26,
		375
	],
	"./pages/payroll-settings/components/calendar/calendarStyles": [
		2006,
		9,
		1539
	],
	"./pages/payroll-settings/components/calendar/calendarStyles.ts": [
		2006,
		9,
		1539
	],
	"./pages/payroll-settings/components/calendar/payGroupDetails": [
		2008,
		9,
		866
	],
	"./pages/payroll-settings/components/calendar/payGroupDetails.tsx": [
		2008,
		9,
		866
	],
	"./pages/payroll-settings/components/calendar/payGroupDetailsStyles": [
		1910,
		9,
		1540
	],
	"./pages/payroll-settings/components/calendar/payGroupDetailsStyles.ts": [
		1910,
		9,
		1540
	],
	"./pages/payroll-settings/components/commonUtilis": [
		1442,
		9,
		2105
	],
	"./pages/payroll-settings/components/commonUtilis.ts": [
		1442,
		9,
		2105
	],
	"./pages/payroll-settings/components/company-field-list/companyFieldList": [
		3131,
		9,
		0,
		4,
		11,
		484
	],
	"./pages/payroll-settings/components/company-field-list/companyFieldList.tsx": [
		3131,
		9,
		0,
		4,
		11,
		484
	],
	"./pages/payroll-settings/components/company-field-list/companyFieldListStyles": [
		1924,
		9,
		2106
	],
	"./pages/payroll-settings/components/company-field-list/companyFieldListStyles.ts": [
		1924,
		9,
		2106
	],
	"./pages/payroll-settings/components/company-field-list/hooks/useNewImplementationFF": [
		2811,
		9,
		2107
	],
	"./pages/payroll-settings/components/company-field-list/hooks/useNewImplementationFF.tsx": [
		2811,
		9,
		2107
	],
	"./pages/payroll-settings/components/company-field-list/modals/disableDefaultHours": [
		2810,
		9,
		1313
	],
	"./pages/payroll-settings/components/company-field-list/modals/disableDefaultHours.tsx": [
		2810,
		9,
		1313
	],
	"./pages/payroll-settings/components/company-field/addProvince": [
		2801,
		9,
		1149
	],
	"./pages/payroll-settings/components/company-field/addProvince.tsx": [
		2801,
		9,
		1149
	],
	"./pages/payroll-settings/components/company-field/codeDetails": [
		2802,
		9,
		868
	],
	"./pages/payroll-settings/components/company-field/codeDetails.tsx": [
		2802,
		9,
		868
	],
	"./pages/payroll-settings/components/company-field/codeTypeTooltips": [
		2803,
		9,
		867
	],
	"./pages/payroll-settings/components/company-field/codeTypeTooltips.tsx": [
		2803,
		9,
		867
	],
	"./pages/payroll-settings/components/company-field/companyDefaultLocation": [
		2804,
		9,
		1541
	],
	"./pages/payroll-settings/components/company-field/companyDefaultLocation.tsx": [
		2804,
		9,
		1541
	],
	"./pages/payroll-settings/components/company-field/customizeProvince": [
		2805,
		9,
		2108
	],
	"./pages/payroll-settings/components/company-field/customizeProvince.tsx": [
		2805,
		9,
		2108
	],
	"./pages/payroll-settings/components/company-field/decisionSection": [
		3622,
		9,
		1542
	],
	"./pages/payroll-settings/components/company-field/decisionSection.tsx": [
		3622,
		9,
		1542
	],
	"./pages/payroll-settings/components/company-field/federalTaxFlags": [
		2806,
		9,
		1543
	],
	"./pages/payroll-settings/components/company-field/federalTaxFlags.tsx": [
		2806,
		9,
		1543
	],
	"./pages/payroll-settings/components/company-field/field.helper": [
		1272,
		9,
		2109
	],
	"./pages/payroll-settings/components/company-field/field.helper.ts": [
		1272,
		9,
		2109
	],
	"./pages/payroll-settings/components/company-field/formBoxDetails": [
		2807,
		9,
		1544
	],
	"./pages/payroll-settings/components/company-field/formBoxDetails.tsx": [
		2807,
		9,
		1544
	],
	"./pages/payroll-settings/components/company-field/provinceDetails": [
		2547,
		9,
		1315
	],
	"./pages/payroll-settings/components/company-field/provinceDetails.tsx": [
		2547,
		9,
		1315
	],
	"./pages/payroll-settings/components/company-field/reportingList": [
		2808,
		9,
		1312
	],
	"./pages/payroll-settings/components/company-field/reportingList.tsx": [
		2808,
		9,
		1312
	],
	"./pages/payroll-settings/components/company-field/roeFlags": [
		2809,
		9,
		1316
	],
	"./pages/payroll-settings/components/company-field/roeFlags.tsx": [
		2809,
		9,
		1316
	],
	"./pages/payroll-settings/components/company-field/selectProvince": [
		3623,
		9,
		2110
	],
	"./pages/payroll-settings/components/company-field/selectProvince.tsx": [
		3623,
		9,
		2110
	],
	"./pages/payroll-settings/components/company-field/zeroState": [
		1855,
		9,
		1317
	],
	"./pages/payroll-settings/components/company-field/zeroState.tsx": [
		1855,
		9,
		1317
	],
	"./pages/payroll-settings/components/create-custom-code-details/ROEFlagsStyles": [
		2548,
		9,
		2111
	],
	"./pages/payroll-settings/components/create-custom-code-details/ROEFlagsStyles.ts": [
		2548,
		9,
		2111
	],
	"./pages/payroll-settings/components/create-custom-code-details/createCustomCodeDetails": [
		2962,
		9,
		239,
		947
	],
	"./pages/payroll-settings/components/create-custom-code-details/createCustomCodeDetails.tsx": [
		2962,
		9,
		239,
		947
	],
	"./pages/payroll-settings/components/create-custom-code-details/createCustomCodeDetailsStyles": [
		2812,
		9,
		2112
	],
	"./pages/payroll-settings/components/create-custom-code-details/createCustomCodeDetailsStyles.ts": [
		2812,
		9,
		2112
	],
	"./pages/payroll-settings/components/create-custom-code-details/hoursCoefficient": [
		2814,
		9,
		1546
	],
	"./pages/payroll-settings/components/create-custom-code-details/hoursCoefficient.tsx": [
		2814,
		9,
		1546
	],
	"./pages/payroll-settings/components/create-custom-code-details/useCustomCodeValidation": [
		2813,
		9,
		1547
	],
	"./pages/payroll-settings/components/create-custom-code-details/useCustomCodeValidation.ts": [
		2813,
		9,
		1547
	],
	"./pages/payroll-settings/components/create-custom-code-details/useStaticLists": [
		1433,
		9,
		1548
	],
	"./pages/payroll-settings/components/create-custom-code-details/useStaticLists.ts": [
		1433,
		9,
		1548
	],
	"./pages/payroll-settings/components/create-custom-code-tax-details/createCustomCodeTaxDetails": [
		2963,
		9,
		190,
		988
	],
	"./pages/payroll-settings/components/create-custom-code-tax-details/createCustomCodeTaxDetails.tsx": [
		2963,
		9,
		190,
		988
	],
	"./pages/payroll-settings/components/create-custom-code-tax-details/createCutomCodeTaxDetailsStyles": [
		2815,
		9,
		2113
	],
	"./pages/payroll-settings/components/create-custom-code-tax-details/createCutomCodeTaxDetailsStyles.ts": [
		2815,
		9,
		2113
	],
	"./pages/payroll-settings/components/create-custom-code/createCustomCode": [
		3132,
		9,
		190,
		239,
		699
	],
	"./pages/payroll-settings/components/create-custom-code/createCustomCode.tsx": [
		3132,
		9,
		190,
		239,
		699
	],
	"./pages/payroll-settings/components/create-workers-compensation/components/AlphNumField": [
		2816,
		9,
		2114
	],
	"./pages/payroll-settings/components/create-workers-compensation/components/AlphNumField.tsx": [
		2816,
		9,
		2114
	],
	"./pages/payroll-settings/components/create-workers-compensation/createWorkersCompensation": [
		3133,
		9,
		799
	],
	"./pages/payroll-settings/components/create-workers-compensation/createWorkersCompensation.tsx": [
		3133,
		9,
		799
	],
	"./pages/payroll-settings/components/createpaygroup/common/confirmPayGroupModal": [
		2520,
		9,
		1151
	],
	"./pages/payroll-settings/components/createpaygroup/common/confirmPayGroupModal.tsx": [
		2520,
		9,
		1151
	],
	"./pages/payroll-settings/components/createpaygroup/common/frequencySwitchModal": [
		2289,
		9,
		2115
	],
	"./pages/payroll-settings/components/createpaygroup/common/frequencySwitchModal.tsx": [
		2289,
		9,
		2115
	],
	"./pages/payroll-settings/components/createpaygroup/common/monthlyDropdown": [
		1570,
		9,
		1153
	],
	"./pages/payroll-settings/components/createpaygroup/common/monthlyDropdown.tsx": [
		1570,
		9,
		1153
	],
	"./pages/payroll-settings/components/createpaygroup/common/payDateTitle": [
		1775,
		9,
		1549
	],
	"./pages/payroll-settings/components/createpaygroup/common/payDateTitle.tsx": [
		1775,
		9,
		1549
	],
	"./pages/payroll-settings/components/createpaygroup/common/payDateTitleStyles": [
		1695,
		9,
		2116
	],
	"./pages/payroll-settings/components/createpaygroup/common/payDateTitleStyles.tsx": [
		1695,
		9,
		2116
	],
	"./pages/payroll-settings/components/createpaygroup/common/paySelectionCard": [
		2515,
		9,
		1550
	],
	"./pages/payroll-settings/components/createpaygroup/common/paySelectionCard.tsx": [
		2515,
		9,
		1550
	],
	"./pages/payroll-settings/components/createpaygroup/common/paySelectionCardStyles": [
		2291,
		9,
		2117
	],
	"./pages/payroll-settings/components/createpaygroup/common/paySelectionCardStyles.tsx": [
		2291,
		9,
		2117
	],
	"./pages/payroll-settings/components/createpaygroup/common/useConfirmPaygroupTableConfig": [
		2292,
		9,
		1551
	],
	"./pages/payroll-settings/components/createpaygroup/common/useConfirmPaygroupTableConfig.tsx": [
		2292,
		9,
		1551
	],
	"./pages/payroll-settings/components/createpaygroup/components/autoRunStatements": [
		2521,
		9,
		2118
	],
	"./pages/payroll-settings/components/createpaygroup/components/autoRunStatements.tsx": [
		2521,
		9,
		2118
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours": [
		782,
		9,
		197
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/": [
		782,
		9,
		197
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/annualHourStatement": [
		2136,
		9,
		1026
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/annualHourStatement.tsx": [
		2136,
		9,
		1026
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/autopopulateCustomHoursForm": [
		2138,
		9,
		1027
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/autopopulateCustomHoursForm.tsx": [
		2138,
		9,
		1027
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/customizeHour-modal": [
		2287,
		9,
		765
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/customizeHour-modal.tsx": [
		2287,
		9,
		765
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/hooks": [
		1552,
		9,
		1319
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/hooks.tsx": [
		1552,
		9,
		1319
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/index": [
		782,
		9,
		197
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/index.tsx": [
		782,
		9,
		197
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/schema": [
		2288,
		9,
		1320
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/schema.ts": [
		2288,
		9,
		1320
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/selectCustomHourRadio": [
		1381,
		9,
		1552
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/selectCustomHourRadio.tsx": [
		1381,
		9,
		1552
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/titleDescription": [
		2137,
		9,
		1154
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizeHours/titleDescription.tsx": [
		2137,
		9,
		1154
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizePayDate": [
		2513,
		9,
		869
	],
	"./pages/payroll-settings/components/createpaygroup/components/customizePayDate.tsx": [
		2513,
		9,
		869
	],
	"./pages/payroll-settings/components/createpaygroup/components/monthlyFields/monthlyDateFields": [
		2518,
		9,
		764
	],
	"./pages/payroll-settings/components/createpaygroup/components/monthlyFields/monthlyDateFields.tsx": [
		2518,
		9,
		764
	],
	"./pages/payroll-settings/components/createpaygroup/components/newPayDateFalls": [
		1776,
		9,
		1553
	],
	"./pages/payroll-settings/components/createpaygroup/components/newPayDateFalls.tsx": [
		1776,
		9,
		1553
	],
	"./pages/payroll-settings/components/createpaygroup/components/payDateFalls": [
		2514,
		9,
		1028
	],
	"./pages/payroll-settings/components/createpaygroup/components/payDateFalls.tsx": [
		2514,
		9,
		1028
	],
	"./pages/payroll-settings/components/createpaygroup/components/payGroupExtraPeriodBanner": [
		2517,
		9,
		534
	],
	"./pages/payroll-settings/components/createpaygroup/components/payGroupExtraPeriodBanner.tsx": [
		2517,
		9,
		534
	],
	"./pages/payroll-settings/components/createpaygroup/components/payPeriodDropdown": [
		2510,
		9,
		1029
	],
	"./pages/payroll-settings/components/createpaygroup/components/payPeriodDropdown.tsx": [
		2510,
		9,
		1029
	],
	"./pages/payroll-settings/components/createpaygroup/components/paySelection": [
		2653,
		9,
		164,
		2858
	],
	"./pages/payroll-settings/components/createpaygroup/components/paySelection.tsx": [
		2653,
		9,
		164,
		2858
	],
	"./pages/payroll-settings/components/createpaygroup/components/payrollFrequency": [
		2509,
		9,
		1152
	],
	"./pages/payroll-settings/components/createpaygroup/components/payrollFrequency.tsx": [
		2509,
		9,
		1152
	],
	"./pages/payroll-settings/components/createpaygroup/components/registerValues": [
		1159,
		9,
		1554
	],
	"./pages/payroll-settings/components/createpaygroup/components/registerValues.tsx": [
		1159,
		9,
		1554
	],
	"./pages/payroll-settings/components/createpaygroup/components/semiPaygroupFields": [
		1496,
		9,
		649
	],
	"./pages/payroll-settings/components/createpaygroup/components/semiPaygroupFields.tsx": [
		1496,
		9,
		649
	],
	"./pages/payroll-settings/components/createpaygroup/components/weeklyFields/weeklyPayDateField": [
		2519,
		9,
		948
	],
	"./pages/payroll-settings/components/createpaygroup/components/weeklyFields/weeklyPayDateField.tsx": [
		2519,
		9,
		948
	],
	"./pages/payroll-settings/components/createpaygroup/components/weeklyStartAndEndDate": [
		2511,
		9,
		1555
	],
	"./pages/payroll-settings/components/createpaygroup/components/weeklyStartAndEndDate.tsx": [
		2511,
		9,
		1555
	],
	"./pages/payroll-settings/components/createpaygroup/createPayGroupValidationSchema": [
		2506,
		9,
		1556
	],
	"./pages/payroll-settings/components/createpaygroup/createPayGroupValidationSchema.ts": [
		2506,
		9,
		1556
	],
	"./pages/payroll-settings/components/createpaygroup/createPayGroupValidationSchemaDeprecated": [
		2507,
		9,
		1557
	],
	"./pages/payroll-settings/components/createpaygroup/createPayGroupValidationSchemaDeprecated.ts": [
		2507,
		9,
		1557
	],
	"./pages/payroll-settings/components/createpaygroup/createPaygroup": [
		2784,
		9,
		164,
		451
	],
	"./pages/payroll-settings/components/createpaygroup/createPaygroup.tsx": [
		2784,
		9,
		164,
		451
	],
	"./pages/payroll-settings/components/createpaygroup/createPaygroupStyles": [
		2005,
		9,
		2119
	],
	"./pages/payroll-settings/components/createpaygroup/createPaygroupStyles.ts": [
		2005,
		9,
		2119
	],
	"./pages/payroll-settings/components/createpaygroup/customizeHours": [
		3624,
		9,
		1558
	],
	"./pages/payroll-settings/components/createpaygroup/customizeHours.tsx": [
		3624,
		9,
		1558
	],
	"./pages/payroll-settings/components/createpaygroup/customizePayDate": [
		2290,
		9,
		1322
	],
	"./pages/payroll-settings/components/createpaygroup/customizePayDate.tsx": [
		2290,
		9,
		1322
	],
	"./pages/payroll-settings/components/createpaygroup/enums/paygroupEnums": [
		2139,
		9,
		2120
	],
	"./pages/payroll-settings/components/createpaygroup/enums/paygroupEnums.ts": [
		2139,
		9,
		2120
	],
	"./pages/payroll-settings/components/createpaygroup/headerFTU": [
		3625,
		9,
		645
	],
	"./pages/payroll-settings/components/createpaygroup/headerFTU.tsx": [
		3625,
		9,
		645
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useCalcEventCount": [
		2004,
		9,
		547
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useCalcEventCount.tsx": [
		2004,
		9,
		547
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useCalculations": [
		1797,
		9,
		1560
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useCalculations.tsx": [
		1797,
		9,
		1560
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useCreatePaygroupStatements": [
		2508,
		9,
		1323
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useCreatePaygroupStatements.tsx": [
		2508,
		9,
		1323
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useDateVerification": [
		3626,
		9,
		1559
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useDateVerification.tsx": [
		3626,
		9,
		1559
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useDisabledWithAutoRun": [
		1237,
		9,
		2121
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useDisabledWithAutoRun.ts": [
		1237,
		9,
		2121
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useFormatPaygroupData": [
		1909,
		9,
		569
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useFormatPaygroupData.tsx": [
		1909,
		9,
		569
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useFrequencyType": [
		1347,
		9,
		1321
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useFrequencyType.tsx": [
		1347,
		9,
		1321
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useGetStatements": [
		2516,
		9,
		605
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useGetStatements.tsx": [
		2516,
		9,
		605
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useMonthlyList": [
		1226,
		9,
		1561
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useMonthlyList.tsx": [
		1226,
		9,
		1561
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/usePaygroupConstants": [
		1414,
		9,
		2122
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/usePaygroupConstants.tsx": [
		1414,
		9,
		2122
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useSafetyHooks": [
		1316,
		9,
		2123
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useSafetyHooks.tsx": [
		1316,
		9,
		2123
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useSetCreatePaygroupForm": [
		2003,
		9,
		2124
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useSetCreatePaygroupForm.tsx": [
		2003,
		9,
		2124
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useSetInitStates": [
		2512,
		9,
		590
	],
	"./pages/payroll-settings/components/createpaygroup/hooks/useSetInitStates.tsx": [
		2512,
		9,
		590
	],
	"./pages/payroll-settings/components/createpaygroup/types/types": [
		1624,
		9,
		2125
	],
	"./pages/payroll-settings/components/createpaygroup/types/types.ts": [
		1624,
		9,
		2125
	],
	"./pages/payroll-settings/components/edit-field/editField": [
		3134,
		9,
		225,
		557
	],
	"./pages/payroll-settings/components/edit-field/editField.tsx": [
		3134,
		9,
		225,
		557
	],
	"./pages/payroll-settings/components/edit-field/editFieldStyles": [
		2384,
		9,
		2126
	],
	"./pages/payroll-settings/components/edit-field/editFieldStyles.ts": [
		2384,
		9,
		2126
	],
	"./pages/payroll-settings/components/edit-field/hiddenEditField": [
		2818,
		9,
		2127
	],
	"./pages/payroll-settings/components/edit-field/hiddenEditField.tsx": [
		2818,
		9,
		2127
	],
	"./pages/payroll-settings/components/edit-field/taxDetails": [
		2964,
		9,
		225,
		1084
	],
	"./pages/payroll-settings/components/edit-field/taxDetails.tsx": [
		2964,
		9,
		225,
		1084
	],
	"./pages/payroll-settings/components/edit-field/useEditFieldConstants": [
		2817,
		9,
		2128
	],
	"./pages/payroll-settings/components/edit-field/useEditFieldConstants.ts": [
		2817,
		9,
		2128
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/UnsaveModal": [
		2309,
		9,
		2129
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/UnsaveModal.tsx": [
		2309,
		9,
		2129
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/addAmounts": [
		3135,
		9,
		727
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/addAmounts.tsx": [
		3135,
		9,
		727
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/addAmountsStyles": [
		1779,
		9,
		2130
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/addAmountsStyles.ts": [
		1779,
		9,
		2130
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/customizeFrequency": [
		2819,
		9,
		1150
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/customizeFrequency.tsx": [
		2819,
		9,
		1150
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/dedAndBenefitsAmounts": [
		3136,
		9,
		589
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/dedAndBenefitsAmounts.tsx": [
		3136,
		9,
		589
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/hooks/useGetDedAndBenefitsColumns": [
		2820,
		9,
		1025
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/hooks/useGetDedAndBenefitsColumns.tsx": [
		2820,
		9,
		1025
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/hooks/useGetDedAndBenefitsValidationSchema": [
		2821,
		9,
		2131
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/hooks/useGetDedAndBenefitsValidationSchema.tsx": [
		2821,
		9,
		2131
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/hooks/useHandleBackNavIdb": [
		2310,
		9,
		2132
	],
	"./pages/payroll-settings/components/employee-field/add-amounts/hooks/useHandleBackNavIdb.tsx": [
		2310,
		9,
		2132
	],
	"./pages/payroll-settings/components/employee-field/assign-to-people/assignPeople": [
		3137,
		9,
		726
	],
	"./pages/payroll-settings/components/employee-field/assign-to-people/assignPeople.tsx": [
		3137,
		9,
		726
	],
	"./pages/payroll-settings/components/employee-field/assign-to-people/assignPeopleStyles": [
		2822,
		9,
		2133
	],
	"./pages/payroll-settings/components/employee-field/assign-to-people/assignPeopleStyles.ts": [
		2822,
		9,
		2133
	],
	"./pages/payroll-settings/components/employee-field/assign-to-people/employeeFilter": [
		2823,
		9,
		1318
	],
	"./pages/payroll-settings/components/employee-field/assign-to-people/employeeFilter.tsx": [
		2823,
		9,
		1318
	],
	"./pages/payroll-settings/components/employee-field/paygroup-list/paygroupList": [
		3138,
		9,
		1324
	],
	"./pages/payroll-settings/components/employee-field/paygroup-list/paygroupList.tsx": [
		3138,
		9,
		1324
	],
	"./pages/payroll-settings/components/employee-field/zero-state/zeroState": [
		3139,
		9,
		1545
	],
	"./pages/payroll-settings/components/employee-field/zero-state/zeroState.tsx": [
		3139,
		9,
		1545
	],
	"./pages/payroll-settings/components/listView": [
		816,
		9,
		250
	],
	"./pages/payroll-settings/components/listView/": [
		816,
		9,
		250
	],
	"./pages/payroll-settings/components/listView/components/backbutton": [
		3627,
		9,
		1155
	],
	"./pages/payroll-settings/components/listView/components/backbutton.tsx": [
		3627,
		9,
		1155
	],
	"./pages/payroll-settings/components/listView/hooks/serviceHooks/useGetCalender": [
		2009,
		9,
		1562
	],
	"./pages/payroll-settings/components/listView/hooks/serviceHooks/useGetCalender.tsx": [
		2009,
		9,
		1562
	],
	"./pages/payroll-settings/components/listView/hooks/serviceHooks/useGetPaygroup": [
		2526,
		9,
		1325
	],
	"./pages/payroll-settings/components/listView/hooks/serviceHooks/useGetPaygroup.tsx": [
		2526,
		9,
		1325
	],
	"./pages/payroll-settings/components/listView/hooks/utilityHooks/useGenerateFilter": [
		2527,
		9,
		2134
	],
	"./pages/payroll-settings/components/listView/hooks/utilityHooks/useGenerateFilter.tsx": [
		2527,
		9,
		2134
	],
	"./pages/payroll-settings/components/listView/index": [
		816,
		9,
		250
	],
	"./pages/payroll-settings/components/listView/index.tsx": [
		816,
		9,
		250
	],
	"./pages/payroll-settings/components/non-standard-banner/nonStandardBanner": [
		1708,
		9,
		1563
	],
	"./pages/payroll-settings/components/non-standard-banner/nonStandardBanner.tsx": [
		1708,
		9,
		1563
	],
	"./pages/payroll-settings/components/paygroup-employees/common/breadCrumb": [
		2522,
		9,
		2135
	],
	"./pages/payroll-settings/components/paygroup-employees/common/breadCrumb.tsx": [
		2522,
		9,
		2135
	],
	"./pages/payroll-settings/components/paygroup-employees/payGroupEmployees": [
		2785,
		9,
		728
	],
	"./pages/payroll-settings/components/paygroup-employees/payGroupEmployees.tsx": [
		2785,
		9,
		728
	],
	"./pages/payroll-settings/components/paygroup-employees/review-and-confirm/reviewAndConfirm": [
		2525,
		9,
		2136
	],
	"./pages/payroll-settings/components/paygroup-employees/review-and-confirm/reviewAndConfirm.tsx": [
		2525,
		9,
		2136
	],
	"./pages/payroll-settings/components/paygroup-employees/select-new-pay-group/selectNewPayGroup": [
		2524,
		9,
		2137
	],
	"./pages/payroll-settings/components/paygroup-employees/select-new-pay-group/selectNewPayGroup.tsx": [
		2524,
		9,
		2137
	],
	"./pages/payroll-settings/components/paygroup-employees/select-people/selectPeople": [
		2523,
		9,
		2138
	],
	"./pages/payroll-settings/components/paygroup-employees/select-people/selectPeople.tsx": [
		2523,
		9,
		2138
	],
	"./pages/payroll-settings/components/paygroup/migrationStatements": [
		1914,
		9,
		677
	],
	"./pages/payroll-settings/components/paygroup/migrationStatements.tsx": [
		1914,
		9,
		677
	],
	"./pages/payroll-settings/components/paygroup/payGroupEmptyCard": [
		1694,
		9,
		6,
		2139
	],
	"./pages/payroll-settings/components/paygroup/payGroupEmptyCard.tsx": [
		1694,
		9,
		6,
		2139
	],
	"./pages/payroll-settings/components/paygroup/payGroupList": [
		1912,
		9,
		1564
	],
	"./pages/payroll-settings/components/paygroup/payGroupList.tsx": [
		1912,
		9,
		1564
	],
	"./pages/payroll-settings/components/paygroup/payGroupStyles": [
		1415,
		9,
		2140
	],
	"./pages/payroll-settings/components/paygroup/payGroupStyles.ts": [
		1415,
		9,
		2140
	],
	"./pages/payroll-settings/components/paygroup/paygroup": [
		1532,
		9,
		6,
		22,
		26,
		31,
		555
	],
	"./pages/payroll-settings/components/paygroup/paygroup.tsx": [
		1532,
		9,
		6,
		22,
		26,
		31,
		555
	],
	"./pages/payroll-settings/components/paygroup/zeroActivePayGroup": [
		1913,
		9,
		1565
	],
	"./pages/payroll-settings/components/paygroup/zeroActivePayGroup.tsx": [
		1913,
		9,
		1565
	],
	"./pages/payroll-settings/components/paygroup/zeroPayGroup": [
		1911,
		9,
		1566
	],
	"./pages/payroll-settings/components/paygroup/zeroPayGroup.tsx": [
		1911,
		9,
		1566
	],
	"./pages/payroll-settings/components/payrollsettings-links/payrollSettingsLinks": [
		3628,
		9,
		1567
	],
	"./pages/payroll-settings/components/payrollsettings-links/payrollSettingsLinks.tsx": [
		3628,
		9,
		1567
	],
	"./pages/payroll-settings/components/provider/employeeProvider": [
		1634,
		9,
		2141
	],
	"./pages/payroll-settings/components/provider/employeeProvider.tsx": [
		1634,
		9,
		2141
	],
	"./pages/payroll-settings/components/statutory-holidays-list/container/container": [
		1871,
		9,
		1156
	],
	"./pages/payroll-settings/components/statutory-holidays-list/container/container.tsx": [
		1871,
		9,
		1156
	],
	"./pages/payroll-settings/components/statutory-holidays-list/container/styles": [
		2168,
		9,
		2142
	],
	"./pages/payroll-settings/components/statutory-holidays-list/container/styles.ts": [
		2168,
		9,
		2142
	],
	"./pages/payroll-settings/components/statutory-holidays-list/container/types": [
		3637,
		9,
		2143
	],
	"./pages/payroll-settings/components/statutory-holidays-list/container/types.ts": [
		3637,
		9,
		2143
	],
	"./pages/payroll-settings/components/statutory-holidays-list/delete-holiday/deleteHoliday": [
		3638,
		9,
		1568
	],
	"./pages/payroll-settings/components/statutory-holidays-list/delete-holiday/deleteHoliday.tsx": [
		3638,
		9,
		1568
	],
	"./pages/payroll-settings/components/statutory-holidays-list/delete-holiday/types": [
		3639,
		9,
		2144
	],
	"./pages/payroll-settings/components/statutory-holidays-list/delete-holiday/types.ts": [
		3639,
		9,
		2144
	],
	"./pages/payroll-settings/components/statutory-holidays-list/header/header": [
		2167,
		9,
		1569
	],
	"./pages/payroll-settings/components/statutory-holidays-list/header/header.tsx": [
		2167,
		9,
		1569
	],
	"./pages/payroll-settings/components/statutory-holidays-list/header/styles": [
		1781,
		9,
		2145
	],
	"./pages/payroll-settings/components/statutory-holidays-list/header/styles.ts": [
		1781,
		9,
		2145
	],
	"./pages/payroll-settings/components/statutory-holidays-list/header/subHeader": [
		2169,
		9,
		1570
	],
	"./pages/payroll-settings/components/statutory-holidays-list/header/subHeader.tsx": [
		2169,
		9,
		1570
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/constants": [
		1512,
		9,
		2146
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/constants.ts": [
		1512,
		9,
		2146
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/form": [
		2170,
		9,
		871
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/form.tsx": [
		2170,
		9,
		871
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/holidayForm": [
		2312,
		9,
		766
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/holidayForm.tsx": [
		2312,
		9,
		766
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/schema": [
		2032,
		9,
		1327
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/schema.ts": [
		2032,
		9,
		1327
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/selectHour": [
		2030,
		9,
		1328
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/selectHour.tsx": [
		2030,
		9,
		1328
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/styles": [
		1700,
		9,
		2147
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/styles.ts": [
		1700,
		9,
		2147
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/types": [
		1434,
		9,
		2148
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/types.ts": [
		1434,
		9,
		2148
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/utils": [
		2031,
		9,
		1571
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-form/utils.ts": [
		2031,
		9,
		1571
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-info-content/holidayInfoContent": [
		3640,
		9,
		1030
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-info-content/holidayInfoContent.tsx": [
		3640,
		9,
		1030
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-info-content/slideContent": [
		3443,
		9,
		1329
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-info-content/slideContent.tsx": [
		3443,
		9,
		1329
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-info-content/styles": [
		2965,
		9,
		2149
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-info-content/styles.ts": [
		2965,
		9,
		2149
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-info-content/types": [
		3641,
		9,
		2150
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holiday-info-content/types.ts": [
		3641,
		9,
		2150
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holidays-list-skeleton/holidaysListSkeleton": [
		2828,
		9,
		870
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holidays-list-skeleton/holidaysListSkeleton.tsx": [
		2828,
		9,
		870
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holidays-list-skeleton/styles": [
		2551,
		9,
		2151
	],
	"./pages/payroll-settings/components/statutory-holidays-list/holidays-list-skeleton/styles.ts": [
		2551,
		9,
		2151
	],
	"./pages/payroll-settings/components/statutory-holidays-list/hooks": [
		2829,
		9,
		103,
		1330
	],
	"./pages/payroll-settings/components/statutory-holidays-list/hooks.tsx": [
		2829,
		9,
		103,
		1330
	],
	"./pages/payroll-settings/components/statutory-holidays-list/methods/daily-method/dailyMethod": [
		2830,
		9,
		103,
		2886
	],
	"./pages/payroll-settings/components/statutory-holidays-list/methods/daily-method/dailyMethod.tsx": [
		2830,
		9,
		103,
		2886
	],
	"./pages/payroll-settings/components/statutory-holidays-list/methods/daily-method/types": [
		3642,
		9,
		2152
	],
	"./pages/payroll-settings/components/statutory-holidays-list/methods/daily-method/types.ts": [
		3642,
		9,
		2152
	],
	"./pages/payroll-settings/components/statutory-holidays-list/methods/federal-method/federalMethod": [
		2552,
		9,
		468
	],
	"./pages/payroll-settings/components/statutory-holidays-list/methods/federal-method/federalMethod.tsx": [
		2552,
		9,
		468
	],
	"./pages/payroll-settings/components/statutory-holidays-list/methods/federal-method/types": [
		3643,
		9,
		2153
	],
	"./pages/payroll-settings/components/statutory-holidays-list/methods/federal-method/types.ts": [
		3643,
		9,
		2153
	],
	"./pages/payroll-settings/components/statutory-holidays-list/mockData": [
		3441,
		9,
		2154
	],
	"./pages/payroll-settings/components/statutory-holidays-list/mockData.ts": [
		3441,
		9,
		2154
	],
	"./pages/payroll-settings/components/statutory-holidays-list/statutoryHolidaysList": [
		3141,
		9,
		103,
		767
	],
	"./pages/payroll-settings/components/statutory-holidays-list/statutoryHolidaysList.tsx": [
		3141,
		9,
		103,
		767
	],
	"./pages/payroll-settings/components/statutory-holidays-list/table-menu/style": [
		3444,
		9,
		2155
	],
	"./pages/payroll-settings/components/statutory-holidays-list/table-menu/style.ts": [
		3444,
		9,
		2155
	],
	"./pages/payroll-settings/components/statutory-holidays-list/table-menu/tableMenu": [
		3644,
		9,
		1157
	],
	"./pages/payroll-settings/components/statutory-holidays-list/table-menu/tableMenu.tsx": [
		3644,
		9,
		1157
	],
	"./pages/payroll-settings/components/statutory-holidays-list/table-menu/types": [
		3645,
		9,
		2156
	],
	"./pages/payroll-settings/components/statutory-holidays-list/table-menu/types.ts": [
		3645,
		9,
		2156
	],
	"./pages/payroll-settings/components/statutory-holidays-list/tables/main-table/constants": [
		2172,
		9,
		2157
	],
	"./pages/payroll-settings/components/statutory-holidays-list/tables/main-table/constants.ts": [
		2172,
		9,
		2157
	],
	"./pages/payroll-settings/components/statutory-holidays-list/tables/main-table/hooks": [
		2313,
		9,
		1158
	],
	"./pages/payroll-settings/components/statutory-holidays-list/tables/main-table/hooks.tsx": [
		2313,
		9,
		1158
	],
	"./pages/payroll-settings/components/statutory-holidays-list/tables/main-table/mainTable": [
		2171,
		9,
		624
	],
	"./pages/payroll-settings/components/statutory-holidays-list/tables/main-table/mainTable.tsx": [
		2171,
		9,
		624
	],
	"./pages/payroll-settings/components/statutory-holidays-list/tables/main-table/styles": [
		1872,
		9,
		2158
	],
	"./pages/payroll-settings/components/statutory-holidays-list/tables/main-table/styles.ts": [
		1872,
		9,
		2158
	],
	"./pages/payroll-settings/components/statutory-holidays-list/tables/main-table/types": [
		3646,
		9,
		2159
	],
	"./pages/payroll-settings/components/statutory-holidays-list/tables/main-table/types.ts": [
		3646,
		9,
		2159
	],
	"./pages/payroll-settings/components/statutory-holidays-list/types": [
		3647,
		9,
		2160
	],
	"./pages/payroll-settings/components/statutory-holidays-list/types.ts": [
		3647,
		9,
		2160
	],
	"./pages/payroll-settings/components/statutory-holidays/constants": [
		1588,
		9,
		2161
	],
	"./pages/payroll-settings/components/statutory-holidays/constants.ts": [
		1588,
		9,
		2161
	],
	"./pages/payroll-settings/components/statutory-holidays/footer/footer": [
		3629,
		9,
		800
	],
	"./pages/payroll-settings/components/statutory-holidays/footer/footer.tsx": [
		3629,
		9,
		800
	],
	"./pages/payroll-settings/components/statutory-holidays/footer/styles": [
		3442,
		9,
		2162
	],
	"./pages/payroll-settings/components/statutory-holidays/footer/styles.ts": [
		3442,
		9,
		2162
	],
	"./pages/payroll-settings/components/statutory-holidays/footer/types": [
		3630,
		9,
		2163
	],
	"./pages/payroll-settings/components/statutory-holidays/footer/types.ts": [
		3630,
		9,
		2163
	],
	"./pages/payroll-settings/components/statutory-holidays/header/header": [
		2824,
		9,
		1572
	],
	"./pages/payroll-settings/components/statutory-holidays/header/header.tsx": [
		2824,
		9,
		1572
	],
	"./pages/payroll-settings/components/statutory-holidays/header/styles": [
		2549,
		9,
		2164
	],
	"./pages/payroll-settings/components/statutory-holidays/header/styles.ts": [
		2549,
		9,
		2164
	],
	"./pages/payroll-settings/components/statutory-holidays/hooks": [
		1856,
		9,
		1573
	],
	"./pages/payroll-settings/components/statutory-holidays/hooks.ts": [
		1856,
		9,
		1573
	],
	"./pages/payroll-settings/components/statutory-holidays/method-card/methodCard": [
		1925,
		9,
		681
	],
	"./pages/payroll-settings/components/statutory-holidays/method-card/methodCard.tsx": [
		1925,
		9,
		681
	],
	"./pages/payroll-settings/components/statutory-holidays/method-card/styles": [
		2166,
		9,
		2165
	],
	"./pages/payroll-settings/components/statutory-holidays/method-card/styles.ts": [
		2166,
		9,
		2165
	],
	"./pages/payroll-settings/components/statutory-holidays/method-card/types": [
		3631,
		9,
		2166
	],
	"./pages/payroll-settings/components/statutory-holidays/method-card/types.ts": [
		3631,
		9,
		2166
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/holiday/constants": [
		3632,
		9,
		2167
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/holiday/constants.ts": [
		3632,
		9,
		2167
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/holiday/queryKeys": [
		2311,
		9,
		2168
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/holiday/queryKeys.ts": [
		2311,
		9,
		2168
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/holiday/types": [
		3633,
		9,
		2169
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/holiday/types.ts": [
		3633,
		9,
		2169
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/holiday/useDeleteHoliday": [
		3634,
		9,
		1331
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/holiday/useDeleteHoliday.ts": [
		3634,
		9,
		1331
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/holiday/useGetHolidaysList": [
		2825,
		9,
		1574
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/holiday/useGetHolidaysList.ts": [
		2825,
		9,
		1574
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/method/queryKeys": [
		1501,
		9,
		2170
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/method/queryKeys.ts": [
		1501,
		9,
		2170
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/method/types": [
		3635,
		9,
		2171
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/method/types.ts": [
		3635,
		9,
		2171
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/method/useGetHourlyEmployees": [
		1857,
		9,
		1575
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/method/useGetHourlyEmployees.ts": [
		1857,
		9,
		1575
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/method/useGetPayrollHistory": [
		3636,
		9,
		1576
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/method/useGetPayrollHistory.ts": [
		3636,
		9,
		1576
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/method/useSaveMethod": [
		2029,
		9,
		1031
	],
	"./pages/payroll-settings/components/statutory-holidays/queries/method/useSaveMethod.ts": [
		2029,
		9,
		1031
	],
	"./pages/payroll-settings/components/statutory-holidays/skeleton-container/skeletonContainer": [
		2826,
		9,
		1332
	],
	"./pages/payroll-settings/components/statutory-holidays/skeleton-container/skeletonContainer.tsx": [
		2826,
		9,
		1332
	],
	"./pages/payroll-settings/components/statutory-holidays/skeleton-container/styles": [
		2550,
		9,
		2172
	],
	"./pages/payroll-settings/components/statutory-holidays/skeleton-container/styles.ts": [
		2550,
		9,
		2172
	],
	"./pages/payroll-settings/components/statutory-holidays/statutoryHolidays": [
		3140,
		9,
		535
	],
	"./pages/payroll-settings/components/statutory-holidays/statutoryHolidays.tsx": [
		3140,
		9,
		535
	],
	"./pages/payroll-settings/components/statutory-holidays/zero-state/zeroEmployees": [
		2827,
		9,
		1577
	],
	"./pages/payroll-settings/components/statutory-holidays/zero-state/zeroEmployees.tsx": [
		2827,
		9,
		1577
	],
	"./pages/payroll-settings/components/submit-review/submitReview": [
		3142,
		9,
		1314
	],
	"./pages/payroll-settings/components/submit-review/submitReview.tsx": [
		3142,
		9,
		1314
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationCard": [
		2206,
		9,
		2173
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationCard.tsx": [
		2206,
		9,
		2173
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationList": [
		3143,
		9,
		0,
		4,
		11,
		650
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationList.tsx": [
		3143,
		9,
		0,
		4,
		11,
		650
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationListStyles": [
		2064,
		9,
		2174
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationListStyles.ts": [
		2064,
		9,
		2174
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationTable/useLazyLoad": [
		2554,
		9,
		2175
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationTable/useLazyLoad.tsx": [
		2554,
		9,
		2175
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationTable/usegetWCBTableColumns": [
		2553,
		9,
		1159
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationTable/usegetWCBTableColumns.tsx": [
		2553,
		9,
		1159
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationTable/workersCompensationTable": [
		2831,
		9,
		0,
		4,
		11,
		700
	],
	"./pages/payroll-settings/components/workers-compensation-list/workersCompensationTable/workersCompensationTable.tsx": [
		2831,
		9,
		0,
		4,
		11,
		700
	],
	"./pages/payroll-settings/payrollSettingsContainer": [
		3261,
		9,
		0,
		4,
		11,
		120,
		336
	],
	"./pages/payroll-settings/payrollSettingsContainer.tsx": [
		3261,
		9,
		0,
		4,
		11,
		120,
		336
	],
	"./pages/payroll-settings/payrollSettingsView": [
		3445,
		9,
		0,
		4,
		11,
		120,
		401
	],
	"./pages/payroll-settings/payrollSettingsView.tsx": [
		3445,
		9,
		0,
		4,
		11,
		120,
		401
	],
	"./pages/payroll-tools/components/common/add-memo": [
		783,
		9,
		268
	],
	"./pages/payroll-tools/components/common/add-memo/": [
		783,
		9,
		268
	],
	"./pages/payroll-tools/components/common/add-memo/index": [
		783,
		9,
		268
	],
	"./pages/payroll-tools/components/common/add-memo/index.tsx": [
		783,
		9,
		268
	],
	"./pages/payroll-tools/components/negativeAdjustment": [
		846,
		9,
		161
	],
	"./pages/payroll-tools/components/negativeAdjustment/": [
		846,
		9,
		161
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation": [
		844,
		9,
		82,
		226
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/": [
		844,
		9,
		82,
		226
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common": [
		715,
		9,
		108
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/": [
		715,
		9,
		108
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/columnConfig": [
		1191,
		9,
		114
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/columnConfig.tsx": [
		1191,
		9,
		114
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/config": [
		1233,
		9,
		2176
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/config.ts": [
		1233,
		9,
		2176
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/data-helpers": [
		1273,
		9,
		1578
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/data-helpers.ts": [
		1273,
		9,
		1578
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/footer": [
		1377,
		9,
		1580
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/footer.tsx": [
		1377,
		9,
		1580
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/formControllers": [
		1221,
		9,
		114
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/formControllers.tsx": [
		1221,
		9,
		114
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/index": [
		715,
		9,
		108
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/index.tsx": [
		715,
		9,
		108
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/interfaces": [
		1420,
		9,
		2177
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/interfaces.ts": [
		1420,
		9,
		2177
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/mainWrapper": [
		1419,
		9,
		2178
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/mainWrapper.tsx": [
		1419,
		9,
		2178
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/midPayriseInfo": [
		1296,
		9,
		1581
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/midPayriseInfo.tsx": [
		1296,
		9,
		1581
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/tableWrapper": [
		1341,
		9,
		2179
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/tableWrapper.tsx": [
		1341,
		9,
		2179
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/userInformation": [
		1429,
		9,
		108
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/common/userInformation.tsx": [
		1429,
		9,
		108
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/index": [
		844,
		9,
		82,
		226
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/index.tsx": [
		844,
		9,
		82,
		226
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information": [
		779,
		9,
		82,
		269
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/": [
		779,
		9,
		82,
		269
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/columnConfig": [
		1513,
		9,
		114
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/columnConfig.tsx": [
		1513,
		9,
		114
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/index": [
		779,
		9,
		82,
		269
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/index.tsx": [
		779,
		9,
		82,
		269
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/renderTables": [
		2654,
		9,
		606
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/renderTables.tsx": [
		2654,
		9,
		606
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/reviewPayrollInfo": [
		791,
		9,
		182
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/reviewPayrollInfo/": [
		791,
		9,
		182
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/reviewPayrollInfo/columnConfig": [
		2555,
		9,
		1579
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/reviewPayrollInfo/columnConfig.tsx": [
		2555,
		9,
		1579
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/reviewPayrollInfo/index": [
		791,
		9,
		182
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/reviewPayrollInfo/index.tsx": [
		791,
		9,
		182
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/summaryPayrollInfo": [
		759,
		9,
		285
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/summaryPayrollInfo/": [
		759,
		9,
		285
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/summaryPayrollInfo/index": [
		759,
		9,
		285
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/payroll-information/summaryPayrollInfo/index.tsx": [
		759,
		9,
		285
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/tax-information": [
		780,
		9,
		170
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/tax-information/": [
		780,
		9,
		170
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/tax-information/index": [
		780,
		9,
		170
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/tax-information/index.tsx": [
		780,
		9,
		170
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/tax-information/renderTables": [
		2556,
		9,
		607
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/tax-information/renderTables.tsx": [
		2556,
		9,
		607
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/tax-information/reviewTaxInfo": [
		784,
		9,
		187
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/tax-information/reviewTaxInfo/": [
		784,
		9,
		187
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/tax-information/reviewTaxInfo/index": [
		784,
		9,
		187
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/adjustInformation/tax-information/reviewTaxInfo/index.tsx": [
		784,
		9,
		187
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/runPayroll": [
		821,
		9,
		169
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/runPayroll/": [
		821,
		9,
		169
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/runPayroll/components/controller": [
		2557,
		9,
		1582
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/runPayroll/components/controller.tsx": [
		2557,
		9,
		1582
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/runPayroll/dummy": [
		3648,
		9,
		2180
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/runPayroll/dummy.ts": [
		3648,
		9,
		2180
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/runPayroll/index": [
		821,
		9,
		169
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/runPayroll/index.tsx": [
		821,
		9,
		169
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/zeroState": [
		822,
		9,
		293
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/zeroState/": [
		822,
		9,
		293
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/zeroState/index": [
		822,
		9,
		293
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/landingPage/zeroState/index.tsx": [
		822,
		9,
		293
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/listOfCredits": [
		845,
		9,
		183
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/listOfCredits/": [
		845,
		9,
		183
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/listOfCredits/columnConfig": [
		2832,
		9,
		2181
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/listOfCredits/columnConfig.tsx": [
		2832,
		9,
		2181
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/listOfCredits/dummyData": [
		2833,
		9,
		2182
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/listOfCredits/dummyData.ts": [
		2833,
		9,
		2182
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/listOfCredits/index": [
		845,
		9,
		183
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/listOfCredits/index.tsx": [
		845,
		9,
		183
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/reviewInformations": [
		874,
		9,
		307
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/reviewInformations/": [
		874,
		9,
		307
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/reviewInformations/index": [
		874,
		9,
		307
	],
	"./pages/payroll-tools/components/negativeAdjustment/components/reviewInformations/index.tsx": [
		874,
		9,
		307
	],
	"./pages/payroll-tools/components/negativeAdjustment/index": [
		846,
		9,
		161
	],
	"./pages/payroll-tools/components/negativeAdjustment/index.tsx": [
		846,
		9,
		161
	],
	"./pages/payroll-tools/components/negativeAdjustment/utils": [
		875,
		9,
		308
	],
	"./pages/payroll-tools/components/negativeAdjustment/utils/": [
		875,
		9,
		308
	],
	"./pages/payroll-tools/components/negativeAdjustment/utils/index": [
		875,
		9,
		308
	],
	"./pages/payroll-tools/components/negativeAdjustment/utils/index.ts": [
		875,
		9,
		308
	],
	"./pages/payroll-tools/components/paystubMemo": [
		847,
		9,
		1,
		5,
		6,
		30,
		148
	],
	"./pages/payroll-tools/components/paystubMemo/": [
		847,
		9,
		1,
		5,
		6,
		30,
		148
	],
	"./pages/payroll-tools/components/paystubMemo/components/common/employeeItem.interface": [
		3649,
		9,
		2183
	],
	"./pages/payroll-tools/components/paystubMemo/components/common/employeeItem.interface.ts": [
		3649,
		9,
		2183
	],
	"./pages/payroll-tools/components/paystubMemo/components/common/filter": [
		3650,
		9,
		1160
	],
	"./pages/payroll-tools/components/paystubMemo/components/common/filter.tsx": [
		3650,
		9,
		1160
	],
	"./pages/payroll-tools/components/paystubMemo/components/common/memoCard/memoCard": [
		2559,
		9,
		872
	],
	"./pages/payroll-tools/components/paystubMemo/components/common/memoCard/memoCard.tsx": [
		2559,
		9,
		872
	],
	"./pages/payroll-tools/components/paystubMemo/components/common/useFormatDatePayPeriod": [
		1579,
		9,
		1583
	],
	"./pages/payroll-tools/components/paystubMemo/components/common/useFormatDatePayPeriod.ts": [
		1579,
		9,
		1583
	],
	"./pages/payroll-tools/components/paystubMemo/components/common/utils": [
		3651,
		9,
		2184
	],
	"./pages/payroll-tools/components/paystubMemo/components/common/utils.ts": [
		3651,
		9,
		2184
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/createPaystubMemo": [
		3144,
		9,
		570
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/createPaystubMemo.tsx": [
		3144,
		9,
		570
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/createPaystubMemoStyles": [
		2834,
		9,
		2185
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/createPaystubMemoStyles.ts": [
		2834,
		9,
		2185
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/employee-list/filter": [
		2561,
		9,
		2186
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/employee-list/filter.tsx": [
		2561,
		9,
		2186
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/employee-list/list": [
		2835,
		9,
		651
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/employee-list/list.tsx": [
		2835,
		9,
		651
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/employee-list/listItem": [
		2560,
		9,
		873
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/employee-list/listItem.tsx": [
		2560,
		9,
		873
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/employee-list/listItemHeader": [
		3652,
		9,
		1584
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/employee-list/listItemHeader.tsx": [
		3652,
		9,
		1584
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/useActivateModal": [
		2207,
		9,
		2187
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/useActivateModal.ts": [
		2207,
		9,
		2187
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/useValidation": [
		2836,
		9,
		1585
	],
	"./pages/payroll-tools/components/paystubMemo/components/createPaystubMemo/useValidation.ts": [
		2836,
		9,
		1585
	],
	"./pages/payroll-tools/components/paystubMemo/components/editPaystubMemo/editPayStubMemo": [
		3145,
		9,
		729
	],
	"./pages/payroll-tools/components/paystubMemo/components/editPaystubMemo/editPayStubMemo.tsx": [
		3145,
		9,
		729
	],
	"./pages/payroll-tools/components/paystubMemo/components/editPaystubMemo/selectedText": [
		2837,
		9,
		2188
	],
	"./pages/payroll-tools/components/paystubMemo/components/editPaystubMemo/selectedText.tsx": [
		2837,
		9,
		2188
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/components/filter/filter": [
		2562,
		9,
		1032
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/components/filter/filter.tsx": [
		2562,
		9,
		1032
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/components/filter/filterStyles": [
		2314,
		9,
		2189
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/components/filter/filterStyles.ts": [
		2314,
		9,
		2189
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/components/filter/useValidation": [
		2315,
		9,
		1586
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/components/filter/useValidation.ts": [
		2315,
		9,
		1586
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/filter-interfaces": [
		876,
		9,
		286
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/filter-interfaces/": [
		876,
		9,
		286
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/filter-interfaces/filterData": [
		3262,
		9,
		2190
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/filter-interfaces/filterData.ts": [
		3262,
		9,
		2190
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/filter-interfaces/filterInitialValues": [
		3263,
		9,
		2191
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/filter-interfaces/filterInitialValues.ts": [
		3263,
		9,
		2191
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/filter-interfaces/index": [
		876,
		9,
		286
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/filter-interfaces/index.ts": [
		876,
		9,
		286
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/payStubMemo": [
		823,
		9,
		205
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/payStubMemo/": [
		823,
		9,
		205
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/payStubMemo/index": [
		823,
		9,
		205
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/payStubMemo/index.tsx": [
		823,
		9,
		205
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/zeroState": [
		824,
		9,
		331,
		309
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/zeroState/": [
		824,
		9,
		331,
		309
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/zeroState/index": [
		824,
		9,
		331,
		309
	],
	"./pages/payroll-tools/components/paystubMemo/components/landingPage/zeroState/index.tsx": [
		824,
		9,
		331,
		309
	],
	"./pages/payroll-tools/components/paystubMemo/index": [
		847,
		9,
		1,
		5,
		6,
		30,
		148
	],
	"./pages/payroll-tools/components/paystubMemo/index.tsx": [
		847,
		9,
		1,
		5,
		6,
		30,
		148
	],
	"./pages/payroll-tools/components/paystubMemo/types": [
		877,
		9,
		251
	],
	"./pages/payroll-tools/components/paystubMemo/types/": [
		877,
		9,
		251
	],
	"./pages/payroll-tools/components/paystubMemo/types/companyInitialState": [
		3264,
		9,
		2192
	],
	"./pages/payroll-tools/components/paystubMemo/types/companyInitialState.ts": [
		3264,
		9,
		2192
	],
	"./pages/payroll-tools/components/paystubMemo/types/createPayStubMemoModal": [
		2033,
		9,
		2193
	],
	"./pages/payroll-tools/components/paystubMemo/types/createPayStubMemoModal.ts": [
		2033,
		9,
		2193
	],
	"./pages/payroll-tools/components/paystubMemo/types/filterData": [
		3265,
		9,
		2194
	],
	"./pages/payroll-tools/components/paystubMemo/types/filterData.ts": [
		3265,
		9,
		2194
	],
	"./pages/payroll-tools/components/paystubMemo/types/filterLandingSubmitData": [
		3266,
		9,
		2195
	],
	"./pages/payroll-tools/components/paystubMemo/types/filterLandingSubmitData.ts": [
		3266,
		9,
		2195
	],
	"./pages/payroll-tools/components/paystubMemo/types/index": [
		877,
		9,
		251
	],
	"./pages/payroll-tools/components/paystubMemo/types/index.ts": [
		877,
		9,
		251
	],
	"./pages/payroll-tools/components/paystubMemo/types/menuItems": [
		3267,
		9,
		2196
	],
	"./pages/payroll-tools/components/paystubMemo/types/menuItems.ts": [
		3267,
		9,
		2196
	],
	"./pages/payroll-tools/components/recordOfEmployment": [
		848,
		9,
		0,
		1,
		4,
		5,
		146
	],
	"./pages/payroll-tools/components/recordOfEmployment/": [
		848,
		9,
		0,
		1,
		4,
		5,
		146
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/ServerErrors": [
		1858,
		9,
		874
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/ServerErrors.tsx": [
		1858,
		9,
		874
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/ServerErrorsStyles": [
		2034,
		9,
		2197
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/ServerErrorsStyles.ts": [
		2034,
		9,
		2197
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/formActions": [
		1656,
		9,
		682
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/formActions.tsx": [
		1656,
		9,
		682
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/generateError": [
		1382,
		9,
		2198
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/generateError.tsx": [
		1382,
		9,
		2198
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/helpers": [
		1435,
		9,
		1334
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/helpers.tsx": [
		1435,
		9,
		1334
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/hooks": [
		1553,
		9,
		2199
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/hooks.tsx": [
		1553,
		9,
		2199
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/interfaces": [
		1317,
		9,
		2200
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/interfaces.tsx": [
		1317,
		9,
		2200
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/leavePagePrompt": [
		1926,
		9,
		875
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/leavePagePrompt.tsx": [
		1926,
		9,
		875
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/useClearServerErrros": [
		2035,
		9,
		2201
	],
	"./pages/payroll-tools/components/recordOfEmployment/common/useClearServerErrros.tsx": [
		2035,
		9,
		2201
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/common": [
		769,
		9,
		294
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/common/": [
		769,
		9,
		294
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/common/index": [
		769,
		9,
		294
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/common/index.tsx": [
		769,
		9,
		294
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/config/featureConfigs": [
		1334,
		9,
		2202
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/config/featureConfigs.ts": [
		1334,
		9,
		2202
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/config/hooks": [
		1635,
		9,
		1335
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/config/hooks.tsx": [
		1635,
		9,
		1335
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/RejectedRoeErrors": [
		2065,
		9,
		1333
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/RejectedRoeErrors.tsx": [
		2065,
		9,
		1333
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/RoeStepsWrapper": [
		2838,
		9,
		768
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/RoeStepsWrapper.tsx": [
		2838,
		9,
		768
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/formRecordOfEmployment": [
		3146,
		9,
		0,
		2,
		4,
		116,
		409
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/formRecordOfEmployment.tsx": [
		3146,
		9,
		0,
		2,
		4,
		116,
		409
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/helpers": [
		1502,
		9,
		877
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/helpers.tsx": [
		1502,
		9,
		877
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/statutoryHolidayBannerHelpers": [
		2173,
		9,
		1587
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/statutoryHolidayBannerHelpers.tsx": [
		2173,
		9,
		1587
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/additionalPayments": [
		2839,
		9,
		2,
		576,
		240,
		474
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/additionalPayments.tsx": [
		2839,
		9,
		2,
		576,
		240,
		474
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/additionalPaymentsValidationSchema": [
		2568,
		9,
		1161
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/additionalPaymentsValidationSchema.ts": [
		2568,
		9,
		1161
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/helpers": [
		1580,
		9,
		1588
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/helpers.tsx": [
		1580,
		9,
		1588
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/otherMoniesPayment": [
		2658,
		9,
		2,
		240,
		1240
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/otherMoniesPayment.tsx": [
		2658,
		9,
		2,
		240,
		1240
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/paymentsToward": [
		2570,
		9,
		2,
		701
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/paymentsToward.tsx": [
		2570,
		9,
		2,
		701
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/statutoryHolidayPayment": [
		2569,
		9,
		2,
		801
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/statutoryHolidayPayment.tsx": [
		2569,
		9,
		2,
		801
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/tempDisabledCell": [
		2317,
		9,
		2,
		2203
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/tempDisabledCell.tsx": [
		2317,
		9,
		2,
		2203
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/vacationPayment": [
		2174,
		9,
		2,
		730
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/additionalPayments/vacationPayment.tsx": [
		2174,
		9,
		2,
		730
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/employeeInformation/AutoFillFinalPayPeriodEnd": [
		2655,
		9,
		150
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/employeeInformation/AutoFillFinalPayPeriodEnd.tsx": [
		2655,
		9,
		150
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/employeeInformation/FinalPayPeriodDateWarning": [
		2564,
		9,
		2204
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/employeeInformation/FinalPayPeriodDateWarning.tsx": [
		2564,
		9,
		2204
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/employeeInformation/employeeInformation": [
		2316,
		9,
		150
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/employeeInformation/employeeInformation.tsx": [
		2316,
		9,
		150
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/employeeInformation/employeeInformationValidationSchema": [
		2563,
		9,
		927
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/employeeInformation/employeeInformationValidationSchema.ts": [
		2563,
		9,
		927
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/employeeInformation/helpers": [
		1782,
		9,
		1589
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/employeeInformation/helpers.ts": [
		1782,
		9,
		1589
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/finalPayPeriodInsurableEarnings": [
		792,
		9,
		0,
		2,
		4,
		72,
		69
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/finalPayPeriodInsurableEarnings/": [
		792,
		9,
		0,
		2,
		4,
		72,
		69
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/finalPayPeriodInsurableEarnings/finalPayPeriodInsurableEarningStatutoryBanner": [
		2656,
		9,
		0,
		2,
		4,
		72,
		69
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/finalPayPeriodInsurableEarnings/finalPayPeriodInsurableEarningStatutoryBanner.tsx": [
		2656,
		9,
		0,
		2,
		4,
		72,
		69
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/finalPayPeriodInsurableEarnings/finalPayPeriodInsurableEarningsValidationSchema": [
		2566,
		9,
		1590
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/finalPayPeriodInsurableEarnings/finalPayPeriodInsurableEarningsValidationSchema.ts": [
		2566,
		9,
		1590
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/finalPayPeriodInsurableEarnings/index": [
		792,
		9,
		0,
		2,
		4,
		72,
		69
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/finalPayPeriodInsurableEarnings/index.tsx": [
		792,
		9,
		0,
		2,
		4,
		72,
		69
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/helpers": [
		1503,
		9,
		2205
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/helpers.ts": [
		1503,
		9,
		2205
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/insurableHoursAndEarnings": [
		2036,
		9,
		0,
		2,
		4,
		72,
		69
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/insurableHoursAndEarnings.tsx": [
		2036,
		9,
		0,
		2,
		4,
		72,
		69
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/insurableHoursAndEarningsValidationSchema": [
		2565,
		9,
		1591
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/insurableHoursAndEarningsValidationSchema.ts": [
		2565,
		9,
		1591
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/insurableStatutoryHolidayBanner": [
		2657,
		9,
		0,
		2,
		4,
		72,
		69
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/steps/insurableHoursAndEarnings/insurableStatutoryHolidayBanner.tsx": [
		2657,
		9,
		0,
		2,
		4,
		72,
		69
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/useRecordOfEmploymentStyles": [
		1297,
		9,
		2206
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/createRecordOfEmployment/useRecordOfEmploymentStyles.ts": [
		1297,
		9,
		2206
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/hooks/useInitialState": [
		2841,
		9,
		1592
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/hooks/useInitialState.ts": [
		2841,
		9,
		1592
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/hooks/usePrimaryContact": [
		2842,
		9,
		1336
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/hooks/usePrimaryContact.ts": [
		2842,
		9,
		1336
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/hooks/useSignatoryContact": [
		2843,
		9,
		1337
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/hooks/useSignatoryContact.ts": [
		2843,
		9,
		1337
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/reviewROE/reviewROE": [
		2840,
		9,
		116,
		591
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/reviewROE/reviewROE.tsx": [
		2840,
		9,
		116,
		591
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/roeFormList/formROEList": [
		2844,
		9,
		0,
		1,
		4,
		5,
		446
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/roeFormList/formROEList.tsx": [
		2844,
		9,
		0,
		1,
		4,
		5,
		446
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/roeFormList/formStyles": [
		1657,
		9,
		2207
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/roeFormList/formStyles.tsx": [
		1657,
		9,
		2207
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/roeFormList/useROEListColumns": [
		2572,
		9,
		1033
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/roeFormList/useROEListColumns.tsx": [
		2572,
		9,
		1033
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/roeFormList/zeroStateROE": [
		2571,
		9,
		1,
		5,
		6,
		30,
		466
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/roeFormList/zeroStateROE.tsx": [
		2571,
		9,
		1,
		5,
		6,
		30,
		466
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/createSAT/components/assignSignatoryCard": [
		2845,
		9,
		746
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/createSAT/components/assignSignatoryCard.tsx": [
		2845,
		9,
		746
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/createSAT/components/signAddendumCard": [
		2966,
		9,
		3,
		252,
		1443
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/createSAT/components/signAddendumCard.tsx": [
		2966,
		9,
		3,
		252,
		1443
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/createSAT/createSAT": [
		3147,
		9,
		3,
		708,
		252,
		563
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/createSAT/createSAT.tsx": [
		3147,
		9,
		3,
		708,
		252,
		563
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/createSAT/createSATSchema": [
		2846,
		9,
		1593
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/createSAT/createSATSchema.ts": [
		2846,
		9,
		1593
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/createSAT/createSATStyles": [
		2385,
		9,
		2208
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/createSAT/createSATStyles.ts": [
		2385,
		9,
		2208
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/editSAT/editSATStyles": [
		3653,
		9,
		2209
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/editSAT/editSATStyles.ts": [
		3653,
		9,
		2209
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/listSAT/components/contactCard": [
		2848,
		9,
		1338
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/listSAT/components/contactCard.tsx": [
		2848,
		9,
		1338
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/listSAT/listSAT": [
		3148,
		9,
		769
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/listSAT/listSAT.tsx": [
		3148,
		9,
		769
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/listSAT/listSATStyles": [
		2208,
		9,
		2210
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/listSAT/listSATStyles.ts": [
		2208,
		9,
		2210
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/types": [
		3654,
		9,
		2211
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/types.ts": [
		3654,
		9,
		2211
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/zeroState": [
		825,
		9,
		295
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/zeroState/": [
		825,
		9,
		295
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/zeroState/index": [
		825,
		9,
		295
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/secureAutomatedTransfer/zeroState/index.tsx": [
		825,
		9,
		295
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/viewROE/viewROE": [
		3149,
		9,
		116,
		876
	],
	"./pages/payroll-tools/components/recordOfEmployment/components/viewROE/viewROE.tsx": [
		3149,
		9,
		116,
		876
	],
	"./pages/payroll-tools/components/recordOfEmployment/index": [
		848,
		9,
		0,
		1,
		4,
		5,
		146
	],
	"./pages/payroll-tools/components/recordOfEmployment/index.tsx": [
		848,
		9,
		0,
		1,
		4,
		5,
		146
	],
	"./pages/payroll-tools/components/recordOfEmployment/roeQueries": [
		1715,
		9,
		1339
	],
	"./pages/payroll-tools/components/recordOfEmployment/roeQueries.ts": [
		1715,
		9,
		1339
	],
	"./pages/payroll-tools/hooks/use-callback-prompt": [
		3655,
		9,
		1594
	],
	"./pages/payroll-tools/hooks/use-callback-prompt.ts": [
		3655,
		9,
		1594
	],
	"./pages/payroll-tools/hooks/use-prompt": [
		3446,
		9,
		2212
	],
	"./pages/payroll-tools/hooks/use-prompt.ts": [
		3446,
		9,
		2212
	],
	"./pages/payroll-tools/payrollToolsContainer": [
		3525,
		9,
		0,
		1,
		2,
		3,
		332
	],
	"./pages/payroll-tools/payrollToolsContainer.tsx": [
		3525,
		9,
		0,
		1,
		2,
		3,
		332
	],
	"./pages/payroll-tools/payrollToolsView": [
		3447,
		9,
		0,
		1,
		2,
		3,
		390
	],
	"./pages/payroll-tools/payrollToolsView.tsx": [
		3447,
		9,
		0,
		1,
		2,
		3,
		390
	],
	"./pages/payroll-tools/routes": [
		1195,
		9,
		2213
	],
	"./pages/payroll-tools/routes.ts": [
		1195,
		9,
		2213
	],
	"./pages/payroll/components/adjustments/adjustments": [
		3389,
		9,
		0,
		1,
		2,
		4,
		392
	],
	"./pages/payroll/components/adjustments/adjustments.tsx": [
		3389,
		9,
		0,
		1,
		2,
		4,
		392
	],
	"./pages/payroll/components/adjustments/footer/footer": [
		2773,
		9,
		2,
		260,
		18,
		1341
	],
	"./pages/payroll/components/adjustments/footer/footer.tsx": [
		2773,
		9,
		2,
		260,
		18,
		1341
	],
	"./pages/payroll/components/adjustments/helper/calculations.helper": [
		1115,
		9,
		2,
		107
	],
	"./pages/payroll/components/adjustments/helper/calculations.helper.ts": [
		1115,
		9,
		2,
		107
	],
	"./pages/payroll/components/adjustments/helper/filter.helper": [
		1454,
		9,
		2214
	],
	"./pages/payroll/components/adjustments/helper/filter.helper.ts": [
		1454,
		9,
		2214
	],
	"./pages/payroll/components/adjustments/helper/validation.helper": [
		1214,
		9,
		2215
	],
	"./pages/payroll/components/adjustments/helper/validation.helper.ts": [
		1214,
		9,
		2215
	],
	"./pages/payroll/components/adjustments/hooks/useAdjustmentHistoryData": [
		2777,
		9,
		1,
		1035
	],
	"./pages/payroll/components/adjustments/hooks/useAdjustmentHistoryData.tsx": [
		2777,
		9,
		1,
		1035
	],
	"./pages/payroll/components/adjustments/hooks/useAdjustmentSteps": [
		2938,
		9,
		1090
	],
	"./pages/payroll/components/adjustments/hooks/useAdjustmentSteps.tsx": [
		2938,
		9,
		1090
	],
	"./pages/payroll/components/adjustments/hooks/useAdjustmentText": [
		1413,
		9,
		2216
	],
	"./pages/payroll/components/adjustments/hooks/useAdjustmentText.ts": [
		1413,
		9,
		2216
	],
	"./pages/payroll/components/adjustments/hooks/useCalculatePayment": [
		2492,
		9,
		2,
		536
	],
	"./pages/payroll/components/adjustments/hooks/useCalculatePayment.ts": [
		2492,
		9,
		2,
		536
	],
	"./pages/payroll/components/adjustments/hooks/useCombinedData": [
		1904,
		9,
		2,
		522
	],
	"./pages/payroll/components/adjustments/hooks/useCombinedData.ts": [
		1904,
		9,
		2,
		522
	],
	"./pages/payroll/components/adjustments/hooks/useData": [
		1509,
		9,
		1342
	],
	"./pages/payroll/components/adjustments/hooks/useData.ts": [
		1509,
		9,
		1342
	],
	"./pages/payroll/components/adjustments/hooks/useEmployeeList": [
		2765,
		9,
		2217
	],
	"./pages/payroll/components/adjustments/hooks/useEmployeeList.ts": [
		2765,
		9,
		2217
	],
	"./pages/payroll/components/adjustments/hooks/useGetAdjustmentHistory": [
		2499,
		9,
		2218
	],
	"./pages/payroll/components/adjustments/hooks/useGetAdjustmentHistory.ts": [
		2499,
		9,
		2218
	],
	"./pages/payroll/components/adjustments/hooks/useGetSummary": [
		2497,
		9,
		1595
	],
	"./pages/payroll/components/adjustments/hooks/useGetSummary.ts": [
		2497,
		9,
		1595
	],
	"./pages/payroll/components/adjustments/hooks/useInitialState": [
		2056,
		9,
		2219
	],
	"./pages/payroll/components/adjustments/hooks/useInitialState.ts": [
		2056,
		9,
		2219
	],
	"./pages/payroll/components/adjustments/hooks/useMarkAdjustment": [
		2131,
		9,
		1596
	],
	"./pages/payroll/components/adjustments/hooks/useMarkAdjustment.ts": [
		2131,
		9,
		1596
	],
	"./pages/payroll/components/adjustments/hooks/useNewAdjustment": [
		1197,
		9,
		2,
		18,
		1237
	],
	"./pages/payroll/components/adjustments/hooks/useNewAdjustment.ts": [
		1197,
		9,
		2,
		18,
		1237
	],
	"./pages/payroll/components/adjustments/hooks/useSeparateData": [
		2058,
		9,
		2,
		523
	],
	"./pages/payroll/components/adjustments/hooks/useSeparateData.ts": [
		2058,
		9,
		2,
		523
	],
	"./pages/payroll/components/adjustments/hooks/useStepChanges": [
		2772,
		9,
		2,
		500
	],
	"./pages/payroll/components/adjustments/hooks/useStepChanges.ts": [
		2772,
		9,
		2,
		500
	],
	"./pages/payroll/components/adjustments/hooks/useTaxAdjustment": [
		1867,
		9,
		2,
		18,
		47,
		1238
	],
	"./pages/payroll/components/adjustments/hooks/useTaxAdjustment.ts": [
		1867,
		9,
		2,
		18,
		47,
		1238
	],
	"./pages/payroll/components/adjustments/hooks/useTaxCredits": [
		2281,
		9,
		2220
	],
	"./pages/payroll/components/adjustments/hooks/useTaxCredits.ts": [
		2281,
		9,
		2220
	],
	"./pages/payroll/components/adjustments/hooks/useTransferCredits": [
		2133,
		9,
		1597
	],
	"./pages/payroll/components/adjustments/hooks/useTransferCredits.ts": [
		2133,
		9,
		1597
	],
	"./pages/payroll/components/adjustments/layout-edit/card-details/cardDetails": [
		2134,
		9,
		1344
	],
	"./pages/payroll/components/adjustments/layout-edit/card-details/cardDetails.tsx": [
		2134,
		9,
		1344
	],
	"./pages/payroll/components/adjustments/layout-edit/layoutEdit": [
		2766,
		9,
		2,
		18,
		803
	],
	"./pages/payroll/components/adjustments/layout-edit/layoutEdit.tsx": [
		2766,
		9,
		2,
		18,
		803
	],
	"./pages/payroll/components/adjustments/layout-edit/stepper/stepper": [
		2478,
		9,
		1598
	],
	"./pages/payroll/components/adjustments/layout-edit/stepper/stepper.tsx": [
		2478,
		9,
		1598
	],
	"./pages/payroll/components/adjustments/layout-edit/stepper/stepperStyles": [
		2283,
		9,
		2221
	],
	"./pages/payroll/components/adjustments/layout-edit/stepper/stepperStyles.tsx": [
		2283,
		9,
		2221
	],
	"./pages/payroll/components/adjustments/page-edit/confirm/confirm": [
		2770,
		9,
		1599
	],
	"./pages/payroll/components/adjustments/page-edit/confirm/confirm.tsx": [
		2770,
		9,
		1599
	],
	"./pages/payroll/components/adjustments/page-edit/confirm/confirmStyles": [
		2493,
		9,
		2222
	],
	"./pages/payroll/components/adjustments/page-edit/confirm/confirmStyles.ts": [
		2493,
		9,
		2222
	],
	"./pages/payroll/components/adjustments/page-edit/definations": [
		1569,
		9,
		2223
	],
	"./pages/payroll/components/adjustments/page-edit/definations.ts": [
		1569,
		9,
		2223
	],
	"./pages/payroll/components/adjustments/page-edit/pageEdit": [
		3080,
		9,
		2,
		260,
		18,
		47,
		429
	],
	"./pages/payroll/components/adjustments/page-edit/pageEdit.tsx": [
		3080,
		9,
		2,
		260,
		18,
		47,
		429
	],
	"./pages/payroll/components/adjustments/page-edit/step-employer-taxes/empty-table/emptyTable": [
		2496,
		9,
		2,
		703
	],
	"./pages/payroll/components/adjustments/page-edit/step-employer-taxes/empty-table/emptyTable.tsx": [
		2496,
		9,
		2,
		703
	],
	"./pages/payroll/components/adjustments/page-edit/step-employer-taxes/stepEmployerTaxes": [
		2771,
		9,
		2,
		18,
		47,
		683
	],
	"./pages/payroll/components/adjustments/page-edit/step-employer-taxes/stepEmployerTaxes.tsx": [
		2771,
		9,
		2,
		18,
		47,
		683
	],
	"./pages/payroll/components/adjustments/page-edit/step-enter/section/section": [
		2482,
		9,
		1345
	],
	"./pages/payroll/components/adjustments/page-edit/step-enter/section/section.tsx": [
		2482,
		9,
		1345
	],
	"./pages/payroll/components/adjustments/page-edit/step-enter/stepEnter": [
		2767,
		9,
		2,
		18,
		485
	],
	"./pages/payroll/components/adjustments/page-edit/step-enter/stepEnter.tsx": [
		2767,
		9,
		2,
		18,
		485
	],
	"./pages/payroll/components/adjustments/page-edit/step-enter/stepEnterStyles": [
		2483,
		9,
		2224
	],
	"./pages/payroll/components/adjustments/page-edit/step-enter/stepEnterStyles.ts": [
		2483,
		9,
		2224
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/adjustment-view/adjustmentView": [
		2485,
		9,
		2,
		514
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/adjustment-view/adjustmentView.tsx": [
		2485,
		9,
		2,
		514
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/definations": [
		3594,
		9,
		2225
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/definations.ts": [
		3594,
		9,
		2225
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/enums/enums": [
		1116,
		9,
		2226
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/enums/enums.ts": [
		1116,
		9,
		2226
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-benefits/sectionBenefits": [
		2489,
		9,
		2,
		501
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-benefits/sectionBenefits.tsx": [
		2489,
		9,
		2,
		501
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-deductions/sectionDeductions": [
		2490,
		9,
		2,
		502
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-deductions/sectionDeductions.tsx": [
		2490,
		9,
		2,
		502
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-non-cash/sectionNonCash": [
		2486,
		9,
		2,
		503
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-non-cash/sectionNonCash.tsx": [
		2486,
		9,
		2,
		503
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-pay/sectionPay": [
		2488,
		9,
		2,
		18,
		731
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-pay/sectionPay.tsx": [
		2488,
		9,
		2,
		18,
		731
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-taxes/components/selectTaxMethod": [
		2284,
		9,
		2227
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-taxes/components/selectTaxMethod.tsx": [
		2284,
		9,
		2227
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-taxes/sectionTaxes": [
		2487,
		9,
		2,
		492
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-taxes/sectionTaxes.tsx": [
		2487,
		9,
		2,
		492
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-wage-incomes/sectionWageIncomes": [
		2491,
		9,
		2,
		504
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section-wage-incomes/sectionWageIncomes.tsx": [
		2491,
		9,
		2,
		504
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section/section": [
		1374,
		9,
		2228
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/section/section.tsx": [
		1374,
		9,
		2228
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/stepReview": [
		2769,
		9,
		2,
		18,
		497
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/stepReview.tsx": [
		2769,
		9,
		2,
		18,
		497
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/stepReviewStyles": [
		1906,
		9,
		2229
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/stepReviewStyles.ts": [
		1906,
		9,
		2229
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/table/table": [
		1258,
		9,
		2,
		524
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/table/table.tsx": [
		1258,
		9,
		2,
		524
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/table/tableStyles": [
		1241,
		9,
		2230
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/table/tableStyles.ts": [
		1241,
		9,
		2230
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/table/useTableColumns": [
		1494,
		9,
		1346
	],
	"./pages/payroll/components/adjustments/page-edit/step-review/table/useTableColumns.ts": [
		1494,
		9,
		1346
	],
	"./pages/payroll/components/adjustments/page-edit/step-statuary-deductions/stepStatuaryDeductions": [
		2768,
		9,
		2,
		18,
		47,
		802
	],
	"./pages/payroll/components/adjustments/page-edit/step-statuary-deductions/stepStatuaryDeductions.tsx": [
		2768,
		9,
		2,
		18,
		47,
		802
	],
	"./pages/payroll/components/adjustments/page-history/components/breakDownSection": [
		2498,
		9,
		2231
	],
	"./pages/payroll/components/adjustments/page-history/components/breakDownSection.tsx": [
		2498,
		9,
		2231
	],
	"./pages/payroll/components/adjustments/page-history/components/historyItem": [
		2776,
		9,
		2,
		221,
		548
	],
	"./pages/payroll/components/adjustments/page-history/components/historyItem.tsx": [
		2776,
		9,
		2,
		221,
		548
	],
	"./pages/payroll/components/adjustments/page-history/components/section": [
		2775,
		9,
		2232
	],
	"./pages/payroll/components/adjustments/page-history/components/section.tsx": [
		2775,
		9,
		2232
	],
	"./pages/payroll/components/adjustments/page-history/components/summaryItem": [
		2201,
		9,
		2233
	],
	"./pages/payroll/components/adjustments/page-history/components/summaryItem.tsx": [
		2201,
		9,
		2233
	],
	"./pages/payroll/components/adjustments/page-history/pageHistory": [
		3082,
		9,
		1,
		2,
		221,
		469
	],
	"./pages/payroll/components/adjustments/page-history/pageHistory.tsx": [
		3082,
		9,
		1,
		2,
		221,
		469
	],
	"./pages/payroll/components/adjustments/page-index/layout-clean-table/layoutCleanTable": [
		1144,
		9,
		1600
	],
	"./pages/payroll/components/adjustments/page-index/layout-clean-table/layoutCleanTable.tsx": [
		1144,
		9,
		1600
	],
	"./pages/payroll/components/adjustments/page-index/layout-clean-table/layoutCleanTableStyles": [
		1187,
		9,
		2234
	],
	"./pages/payroll/components/adjustments/page-index/layout-clean-table/layoutCleanTableStyles.ts": [
		1187,
		9,
		2234
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/filter/filter": [
		2472,
		9,
		2,
		106,
		888
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/filter/filter.tsx": [
		2472,
		9,
		2,
		106,
		888
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/filter/filterStyles": [
		2277,
		9,
		2235
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/filter/filterStyles.ts": [
		2277,
		9,
		2235
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/filter/menu/menu": [
		2278,
		9,
		2,
		106,
		1165
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/filter/menu/menu.tsx": [
		2278,
		9,
		2,
		106,
		1165
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/filter/menu/menuStyles": [
		2132,
		9,
		2236
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/filter/menu/menuStyles.ts": [
		2132,
		9,
		2236
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/filter/menu/useWpAdjustmentOptions": [
		2473,
		9,
		2,
		106,
		1347
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/filter/menu/useWpAdjustmentOptions.ts": [
		2473,
		9,
		2,
		106,
		1347
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/card/card": [
		2121,
		9,
		1036
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/card/card.tsx": [
		2121,
		9,
		1036
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/definations": [
		3595,
		9,
		2237
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/definations.ts": [
		3595,
		9,
		2237
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-amounts/detailsAmounts": [
		2125,
		9,
		2,
		879
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-amounts/detailsAmounts.tsx": [
		2125,
		9,
		2,
		879
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-hours/detailsHours": [
		2122,
		9,
		2,
		880
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-hours/detailsHours.tsx": [
		2122,
		9,
		2,
		880
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-non-cash-over/detailsNonCashOver": [
		2129,
		9,
		2,
		881
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-non-cash-over/detailsNonCashOver.tsx": [
		2129,
		9,
		2,
		881
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-non-cash-under/detailsNonCashUnder": [
		2130,
		9,
		2,
		882
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-non-cash-under/detailsNonCashUnder.tsx": [
		2130,
		9,
		2,
		882
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-pay-over/detailsPayOver": [
		2128,
		9,
		2,
		883
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-pay-over/detailsPayOver.tsx": [
		2128,
		9,
		2,
		883
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-pay-under/detailsPayUnder": [
		2127,
		9,
		2,
		884
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-pay-under/detailsPayUnder.tsx": [
		2127,
		9,
		2,
		884
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-tax-credits/detailsTaxCredits": [
		2123,
		9,
		2,
		885
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-tax-credits/detailsTaxCredits.tsx": [
		2123,
		9,
		2,
		885
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-tax-over/detailsTaxOver": [
		2124,
		9,
		2,
		886
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-tax-over/detailsTaxOver.tsx": [
		2124,
		9,
		2,
		886
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-tax-under/detailsTaxUnder": [
		2126,
		9,
		2,
		887
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details-tax-under/detailsTaxUnder.tsx": [
		2126,
		9,
		2,
		887
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details/details": [
		1173,
		9,
		2,
		953
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details/details.tsx": [
		1173,
		9,
		2,
		953
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details/detailsStyles": [
		1452,
		9,
		2238
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/details/detailsStyles.ts": [
		1452,
		9,
		2238
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/itemView": [
		1999,
		9,
		2,
		245,
		457
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/itemView.tsx": [
		1999,
		9,
		2,
		245,
		457
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/tableCheckbox/tableCheckbox": [
		1453,
		9,
		2239
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/item-view/tableCheckbox/tableCheckbox.tsx": [
		1453,
		9,
		2239
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/list/list": [
		2471,
		9,
		2,
		5,
		245,
		448
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/list/list.tsx": [
		2471,
		9,
		2,
		5,
		245,
		448
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/listAdjustments": [
		2757,
		9,
		0,
		2,
		4,
		5,
		419
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/listAdjustments.tsx": [
		2757,
		9,
		0,
		2,
		4,
		5,
		419
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/placeholder-empty/placeholderEmpty": [
		2000,
		9,
		5,
		2240
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/placeholder-empty/placeholderEmpty.tsx": [
		2000,
		9,
		5,
		2240
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/placeholder-empty/placeholderEmptyStyles": [
		3596,
		9,
		2241
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/placeholder-empty/placeholderEmptyStyles.ts": [
		3596,
		9,
		2241
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/placeholder-filtered/placeholderFiltered": [
		2276,
		9,
		2242
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/placeholder-filtered/placeholderFiltered.tsx": [
		2276,
		9,
		2242
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/placeholder-filtered/placeholderFilteredStyles": [
		3597,
		9,
		2243
	],
	"./pages/payroll/components/adjustments/page-index/list-adjustments/placeholder-filtered/placeholderFilteredStyles.ts": [
		3597,
		9,
		2243
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/item-view/itemView": [
		1168,
		9,
		2,
		107
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/item-view/itemView.tsx": [
		1168,
		9,
		2,
		107
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/item-view/statusCreditInfo": [
		1299,
		9,
		2,
		107
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/item-view/statusCreditInfo.tsx": [
		1299,
		9,
		2,
		107
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/list": [
		2475,
		9,
		2,
		259,
		558
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/list.tsx": [
		2475,
		9,
		2,
		259,
		558
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/listStyles": [
		1219,
		9,
		2244
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/listStyles.ts": [
		1219,
		9,
		2244
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/transfer-button/transferButton": [
		2280,
		9,
		1601
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/transfer-button/transferButton.tsx": [
		2280,
		9,
		1601
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/transfer-credit-modal/transferCreditModal": [
		2279,
		9,
		1164
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/list/transfer-credit-modal/transferCreditModal.tsx": [
		2279,
		9,
		1164
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/listCredits": [
		2758,
		9,
		2,
		89,
		259,
		491
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/listCredits.tsx": [
		2758,
		9,
		2,
		89,
		259,
		491
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/placeholder-empty/placeholderEmpty": [
		2474,
		9,
		89,
		2245
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/placeholder-empty/placeholderEmpty.tsx": [
		2474,
		9,
		89,
		2245
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/placeholder-empty/placeholderEmptyStyles": [
		3598,
		9,
		2246
	],
	"./pages/payroll/components/adjustments/page-index/list-credits/placeholder-empty/placeholderEmptyStyles.ts": [
		3598,
		9,
		2246
	],
	"./pages/payroll/components/adjustments/page-index/pageIndex": [
		3203,
		9,
		0,
		2,
		4,
		5,
		410
	],
	"./pages/payroll/components/adjustments/page-index/pageIndex.tsx": [
		3203,
		9,
		0,
		2,
		4,
		5,
		410
	],
	"./pages/payroll/components/adjustments/page-index/tabs/tabs": [
		2756,
		9,
		1602
	],
	"./pages/payroll/components/adjustments/page-index/tabs/tabs.tsx": [
		2756,
		9,
		1602
	],
	"./pages/payroll/components/adjustments/page-index/tabs/tabsStyles": [
		2469,
		9,
		2247
	],
	"./pages/payroll/components/adjustments/page-index/tabs/tabsStyles.ts": [
		2469,
		9,
		2247
	],
	"./pages/payroll/components/adjustments/page-index/useAdjustmentView": [
		1903,
		9,
		2248
	],
	"./pages/payroll/components/adjustments/page-index/useAdjustmentView.ts": [
		1903,
		9,
		2248
	],
	"./pages/payroll/components/adjustments/page-index/useAllPaygroups": [
		1844,
		9,
		2249
	],
	"./pages/payroll/components/adjustments/page-index/useAllPaygroups.ts": [
		1844,
		9,
		2249
	],
	"./pages/payroll/components/adjustments/page-index/useCreditView": [
		1294,
		9,
		2250
	],
	"./pages/payroll/components/adjustments/page-index/useCreditView.ts": [
		1294,
		9,
		2250
	],
	"./pages/payroll/components/adjustments/page-index/useGetPayPeriodList": [
		1905,
		9,
		2,
		549
	],
	"./pages/payroll/components/adjustments/page-index/useGetPayPeriodList.ts": [
		1905,
		9,
		2,
		549
	],
	"./pages/payroll/components/adjustments/page-index/useListAdjustments": [
		2470,
		9,
		2251
	],
	"./pages/payroll/components/adjustments/page-index/useListAdjustments.ts": [
		2470,
		9,
		2251
	],
	"./pages/payroll/components/adjustments/page-index/useListCredits": [
		2476,
		9,
		1343
	],
	"./pages/payroll/components/adjustments/page-index/useListCredits.ts": [
		2476,
		9,
		1343
	],
	"./pages/payroll/components/adjustments/page-index/useMarkAdjustmentItem": [
		3599,
		9,
		2252
	],
	"./pages/payroll/components/adjustments/page-index/useMarkAdjustmentItem.ts": [
		3599,
		9,
		2252
	],
	"./pages/payroll/components/adjustments/page-new/form/actionsFooter": [
		2760,
		9,
		2253
	],
	"./pages/payroll/components/adjustments/page-new/form/actionsFooter.tsx": [
		2760,
		9,
		2253
	],
	"./pages/payroll/components/adjustments/page-new/form/fieldPaydate": [
		2763,
		9,
		2254
	],
	"./pages/payroll/components/adjustments/page-new/form/fieldPaydate.tsx": [
		2763,
		9,
		2254
	],
	"./pages/payroll/components/adjustments/page-new/form/fieldPaygroup": [
		2762,
		9,
		949
	],
	"./pages/payroll/components/adjustments/page-new/form/fieldPaygroup.tsx": [
		2762,
		9,
		949
	],
	"./pages/payroll/components/adjustments/page-new/form/fieldPerson": [
		2761,
		9,
		1603
	],
	"./pages/payroll/components/adjustments/page-new/form/fieldPerson.tsx": [
		2761,
		9,
		1603
	],
	"./pages/payroll/components/adjustments/page-new/form/fieldType": [
		2759,
		9,
		1348
	],
	"./pages/payroll/components/adjustments/page-new/form/fieldType.tsx": [
		2759,
		9,
		1348
	],
	"./pages/payroll/components/adjustments/page-new/form/form": [
		2954,
		9,
		2,
		18,
		167,
		2381
	],
	"./pages/payroll/components/adjustments/page-new/form/form.tsx": [
		2954,
		9,
		2,
		18,
		167,
		2381
	],
	"./pages/payroll/components/adjustments/page-new/form/useFieldsConfig": [
		2764,
		9,
		2255
	],
	"./pages/payroll/components/adjustments/page-new/form/useFieldsConfig.ts": [
		2764,
		9,
		2255
	],
	"./pages/payroll/components/adjustments/page-new/pageNew": [
		3079,
		9,
		2,
		18,
		167,
		1604
	],
	"./pages/payroll/components/adjustments/page-new/pageNew.tsx": [
		3079,
		9,
		2,
		18,
		167,
		1604
	],
	"./pages/payroll/components/adjustments/page-new/pageNewStyles": [
		2057,
		9,
		2256
	],
	"./pages/payroll/components/adjustments/page-new/pageNewStyles.ts": [
		2057,
		9,
		2256
	],
	"./pages/payroll/components/adjustments/page-success/pageSuccess": [
		3081,
		9,
		2,
		18,
		592
	],
	"./pages/payroll/components/adjustments/page-success/pageSuccess.tsx": [
		3081,
		9,
		2,
		18,
		592
	],
	"./pages/payroll/components/adjustments/page-success/section/section": [
		2774,
		9,
		2257
	],
	"./pages/payroll/components/adjustments/page-success/section/section.tsx": [
		2774,
		9,
		2257
	],
	"./pages/payroll/components/adjustments/routes": [
		1401,
		9,
		1605
	],
	"./pages/payroll/components/adjustments/routes.ts": [
		1401,
		9,
		1605
	],
	"./pages/payroll/components/adjustments/table-eht-taxes/tableEHTTaxes": [
		2494,
		9,
		2,
		18,
		47,
		951
	],
	"./pages/payroll/components/adjustments/table-eht-taxes/tableEHTTaxes.tsx": [
		2494,
		9,
		2,
		18,
		47,
		951
	],
	"./pages/payroll/components/adjustments/table-general/add-button/addButton": [
		1846,
		9,
		1349
	],
	"./pages/payroll/components/adjustments/table-general/add-button/addButton.tsx": [
		1846,
		9,
		1349
	],
	"./pages/payroll/components/adjustments/table-general/add-button/addButtonStyles": [
		1774,
		9,
		2258
	],
	"./pages/payroll/components/adjustments/table-general/add-button/addButtonStyles.ts": [
		1774,
		9,
		2258
	],
	"./pages/payroll/components/adjustments/table-general/delete-tax-button/deleteTaxButton": [
		1847,
		9,
		1606
	],
	"./pages/payroll/components/adjustments/table-general/delete-tax-button/deleteTaxButton.tsx": [
		1847,
		9,
		1606
	],
	"./pages/payroll/components/adjustments/table-general/enums": [
		1182,
		9,
		2259
	],
	"./pages/payroll/components/adjustments/table-general/enums.ts": [
		1182,
		9,
		2259
	],
	"./pages/payroll/components/adjustments/table-general/table-field/tableField": [
		1848,
		9,
		1166
	],
	"./pages/payroll/components/adjustments/table-general/table-field/tableField.tsx": [
		1848,
		9,
		1166
	],
	"./pages/payroll/components/adjustments/table-general/tableGeneral": [
		1333,
		9,
		2,
		732
	],
	"./pages/payroll/components/adjustments/table-general/tableGeneral.tsx": [
		1333,
		9,
		2,
		732
	],
	"./pages/payroll/components/adjustments/table-general/tableGeneralStyles": [
		1508,
		9,
		2260
	],
	"./pages/payroll/components/adjustments/table-general/tableGeneralStyles.ts": [
		1508,
		9,
		2260
	],
	"./pages/payroll/components/adjustments/table-specific-benefits/tableSpecificBenefits": [
		2480,
		9,
		2,
		18,
		559
	],
	"./pages/payroll/components/adjustments/table-specific-benefits/tableSpecificBenefits.tsx": [
		2480,
		9,
		2,
		18,
		559
	],
	"./pages/payroll/components/adjustments/table-specific-deductions/tableSpecificDeductions": [
		2481,
		9,
		2,
		18,
		560
	],
	"./pages/payroll/components/adjustments/table-specific-deductions/tableSpecificDeductions.tsx": [
		2481,
		9,
		2,
		18,
		560
	],
	"./pages/payroll/components/adjustments/table-specific-incomes/tableSpecificIncomes": [
		2479,
		9,
		2,
		18,
		561
	],
	"./pages/payroll/components/adjustments/table-specific-incomes/tableSpecificIncomes.tsx": [
		2479,
		9,
		2,
		18,
		561
	],
	"./pages/payroll/components/adjustments/table-specific-taxes/tableSpecificTaxes": [
		2484,
		9,
		2,
		18,
		47,
		952
	],
	"./pages/payroll/components/adjustments/table-specific-taxes/tableSpecificTaxes.tsx": [
		2484,
		9,
		2,
		18,
		47,
		952
	],
	"./pages/payroll/components/adjustments/table-wcb-taxes/confirm-delete-tax/confirmDeleteTax": [
		2285,
		9,
		2261
	],
	"./pages/payroll/components/adjustments/table-wcb-taxes/confirm-delete-tax/confirmDeleteTax.tsx": [
		2285,
		9,
		2261
	],
	"./pages/payroll/components/adjustments/table-wcb-taxes/confirm-delete-tax/confirmStyles": [
		3600,
		9,
		2262
	],
	"./pages/payroll/components/adjustments/table-wcb-taxes/confirm-delete-tax/confirmStyles.ts": [
		3600,
		9,
		2262
	],
	"./pages/payroll/components/adjustments/table-wcb-taxes/tableWCBTaxes": [
		2495,
		9,
		2,
		18,
		47,
		878
	],
	"./pages/payroll/components/adjustments/table-wcb-taxes/tableWCBTaxes.tsx": [
		2495,
		9,
		2,
		18,
		47,
		878
	],
	"./pages/payroll/components/adjustments/table-wrapper/tableWrapper": [
		1845,
		9,
		2263
	],
	"./pages/payroll/components/adjustments/table-wrapper/tableWrapper.tsx": [
		1845,
		9,
		2263
	],
	"./pages/payroll/components/approved/approved": [
		3083,
		9,
		0,
		4,
		70,
		889
	],
	"./pages/payroll/components/approved/approved.tsx": [
		3083,
		9,
		0,
		4,
		70,
		889
	],
	"./pages/payroll/components/common/prioritizeActionOptions": [
		1796,
		9,
		1607
	],
	"./pages/payroll/components/common/prioritizeActionOptions.tsx": [
		1796,
		9,
		1607
	],
	"./pages/payroll/components/common/useColumns": [
		2001,
		9,
		567
	],
	"./pages/payroll/components/common/useColumns.tsx": [
		2001,
		9,
		567
	],
	"./pages/payroll/components/common/usePayrollSortByHook": [
		1530,
		9,
		2264
	],
	"./pages/payroll/components/common/usePayrollSortByHook.tsx": [
		1530,
		9,
		2264
	],
	"./pages/payroll/components/common/useSubmittedByCell": [
		2061,
		9,
		2265
	],
	"./pages/payroll/components/common/useSubmittedByCell.tsx": [
		2061,
		9,
		2265
	],
	"./pages/payroll/components/common/useWpTableColumns": [
		2002,
		9,
		568
	],
	"./pages/payroll/components/common/useWpTableColumns.tsx": [
		2002,
		9,
		568
	],
	"./pages/payroll/components/common/validationWindow": [
		1531,
		9,
		2266
	],
	"./pages/payroll/components/common/validationWindow.tsx": [
		1531,
		9,
		2266
	],
	"./pages/payroll/components/deprecated-stop-deposit/deprecatedStopDeposit": [
		3601,
		9,
		804
	],
	"./pages/payroll/components/deprecated-stop-deposit/deprecatedStopDeposit.tsx": [
		3601,
		9,
		804
	],
	"./pages/payroll/components/finalized/components/components/confirmAgreements": [
		2500,
		9,
		2267
	],
	"./pages/payroll/components/finalized/components/components/confirmAgreements.tsx": [
		2500,
		9,
		2267
	],
	"./pages/payroll/components/finalized/components/components/payrollSelectedCard": [
		2501,
		9,
		1608
	],
	"./pages/payroll/components/finalized/components/components/payrollSelectedCard.tsx": [
		2501,
		9,
		1608
	],
	"./pages/payroll/components/finalized/components/components/selectPeopleOnPayroll": [
		2502,
		9,
		1353
	],
	"./pages/payroll/components/finalized/components/components/selectPeopleOnPayroll.tsx": [
		2502,
		9,
		1353
	],
	"./pages/payroll/components/finalized/components/components/stepFooter": [
		3084,
		9,
		2268
	],
	"./pages/payroll/components/finalized/components/components/stepFooter.tsx": [
		3084,
		9,
		2268
	],
	"./pages/payroll/components/finalized/components/helper": [
		1907,
		9,
		1609
	],
	"./pages/payroll/components/finalized/components/helper.ts": [
		1907,
		9,
		1609
	],
	"./pages/payroll/components/finalized/components/remove-people-from-payroll/removePeopleFromPayroll": [
		3517,
		9,
		360
	],
	"./pages/payroll/components/finalized/components/remove-people-from-payroll/removePeopleFromPayroll.tsx": [
		3517,
		9,
		360
	],
	"./pages/payroll/components/finalized/components/remove-people-from-payroll/steps/review": [
		3393,
		9,
		1610
	],
	"./pages/payroll/components/finalized/components/remove-people-from-payroll/steps/review.tsx": [
		3393,
		9,
		1610
	],
	"./pages/payroll/components/finalized/components/remove-people-from-payroll/steps/selectPeople": [
		3392,
		9,
		954
	],
	"./pages/payroll/components/finalized/components/remove-people-from-payroll/steps/selectPeople.tsx": [
		3392,
		9,
		954
	],
	"./pages/payroll/components/finalized/components/stop-direct-deposit/steps/review": [
		3394,
		9,
		1611
	],
	"./pages/payroll/components/finalized/components/stop-direct-deposit/steps/review.tsx": [
		3394,
		9,
		1611
	],
	"./pages/payroll/components/finalized/components/stop-direct-deposit/steps/selectPeople": [
		3395,
		9,
		955
	],
	"./pages/payroll/components/finalized/components/stop-direct-deposit/steps/selectPeople.tsx": [
		3395,
		9,
		955
	],
	"./pages/payroll/components/finalized/components/stop-direct-deposit/stopDirectDeposit": [
		3518,
		9,
		361
	],
	"./pages/payroll/components/finalized/components/stop-direct-deposit/stopDirectDeposit.tsx": [
		3518,
		9,
		361
	],
	"./pages/payroll/components/finalized/finalized": [
		3085,
		9,
		0,
		4,
		70,
		725
	],
	"./pages/payroll/components/finalized/finalized.tsx": [
		3085,
		9,
		0,
		4,
		70,
		725
	],
	"./pages/payroll/components/finalized/finalizedPayrollsStyles": [
		2778,
		9,
		2269
	],
	"./pages/payroll/components/finalized/finalizedPayrollsStyles.ts": [
		2778,
		9,
		2269
	],
	"./pages/payroll/components/in-progress/InProgress": [
		3086,
		9,
		0,
		4,
		70,
		571
	],
	"./pages/payroll/components/in-progress/InProgress.tsx": [
		3086,
		9,
		0,
		4,
		70,
		571
	],
	"./pages/payroll/components/lockedPage/Lockedpage": [
		3602,
		9,
		1037
	],
	"./pages/payroll/components/lockedPage/Lockedpage.tsx": [
		3602,
		9,
		1037
	],
	"./pages/payroll/components/lockedPage/styles": [
		3396,
		9,
		1612
	],
	"./pages/payroll/components/lockedPage/styles.ts": [
		3396,
		9,
		1612
	],
	"./pages/payroll/components/not-approved/notApproved": [
		2135,
		9,
		0,
		4,
		70,
		593
	],
	"./pages/payroll/components/not-approved/notApproved.tsx": [
		2135,
		9,
		0,
		4,
		70,
		593
	],
	"./pages/payroll/components/overview/autoRunBanner": [
		2779,
		9,
		1091
	],
	"./pages/payroll/components/overview/autoRunBanner.tsx": [
		2779,
		9,
		1091
	],
	"./pages/payroll/components/overview/guidedOnboarding": [
		1292,
		9,
		1,
		512
	],
	"./pages/payroll/components/overview/guidedOnboarding.tsx": [
		1292,
		9,
		1,
		512
	],
	"./pages/payroll/components/overview/noPaygroupPage": [
		2780,
		9,
		6,
		1326
	],
	"./pages/payroll/components/overview/noPaygroupPage.tsx": [
		2780,
		9,
		6,
		1326
	],
	"./pages/payroll/components/overview/overview": [
		3087,
		9,
		1,
		5,
		6,
		30,
		425
	],
	"./pages/payroll/components/overview/overview.tsx": [
		3087,
		9,
		1,
		5,
		6,
		30,
		425
	],
	"./pages/payroll/components/overview/overviewInactive": [
		3603,
		9,
		1613
	],
	"./pages/payroll/components/overview/overviewInactive.tsx": [
		3603,
		9,
		1613
	],
	"./pages/payroll/components/overview/partnerBlocker": [
		2783,
		9,
		6,
		2270
	],
	"./pages/payroll/components/overview/partnerBlocker.tsx": [
		2783,
		9,
		6,
		2270
	],
	"./pages/payroll/components/overview/useIsAccountActive": [
		1313,
		9,
		1614
	],
	"./pages/payroll/components/overview/useIsAccountActive.ts": [
		1313,
		9,
		1614
	],
	"./pages/payroll/components/overview/useIsDeadEnd": [
		1282,
		9,
		1,
		5,
		6,
		30,
		475
	],
	"./pages/payroll/components/overview/useIsDeadEnd.tsx": [
		1282,
		9,
		1,
		5,
		6,
		30,
		475
	],
	"./pages/payroll/components/overview/useStepInfo": [
		1122,
		9,
		696
	],
	"./pages/payroll/components/overview/useStepInfo.tsx": [
		1122,
		9,
		696
	],
	"./pages/payroll/components/pay-group-box/emptyPayGroupBox": [
		2503,
		9,
		2271
	],
	"./pages/payroll/components/pay-group-box/emptyPayGroupBox.tsx": [
		2503,
		9,
		2271
	],
	"./pages/payroll/components/pay-group-box/payGroupBox": [
		2781,
		9,
		550
	],
	"./pages/payroll/components/pay-group-box/payGroupBox.tsx": [
		2781,
		9,
		550
	],
	"./pages/payroll/components/pay-group-box/payGroupBoxStyles": [
		1619,
		9,
		2272
	],
	"./pages/payroll/components/pay-group-box/payGroupBoxStyles.ts": [
		1619,
		9,
		2272
	],
	"./pages/payroll/components/pay-group-box/useAutoRun": [
		2505,
		9,
		926
	],
	"./pages/payroll/components/pay-group-box/useAutoRun.tsx": [
		2505,
		9,
		926
	],
	"./pages/payroll/components/pay-group-box/useDisablePopup": [
		2504,
		9,
		1615
	],
	"./pages/payroll/components/pay-group-box/useDisablePopup.tsx": [
		2504,
		9,
		1615
	],
	"./pages/payroll/components/paygroups/paygroupsContainer": [
		3244,
		9,
		6,
		22,
		26,
		31,
		338
	],
	"./pages/payroll/components/paygroups/paygroupsContainer.tsx": [
		3244,
		9,
		6,
		22,
		26,
		31,
		338
	],
	"./pages/payroll/components/paygroups/paygroupsView": [
		3088,
		9,
		6,
		22,
		26,
		31,
		413
	],
	"./pages/payroll/components/paygroups/paygroupsView.tsx": [
		3088,
		9,
		6,
		22,
		26,
		31,
		413
	],
	"./pages/payroll/components/payroll-executor-wrapper": [
		872,
		9,
		0,
		2,
		4,
		6,
		136
	],
	"./pages/payroll/components/payroll-executor-wrapper/": [
		872,
		9,
		0,
		2,
		4,
		6,
		136
	],
	"./pages/payroll/components/payroll-executor-wrapper/index": [
		872,
		9,
		0,
		2,
		4,
		6,
		136
	],
	"./pages/payroll/components/payroll-executor-wrapper/index.tsx": [
		872,
		9,
		0,
		2,
		4,
		6,
		136
	],
	"./pages/payroll/components/payroll-executor/common/commonStyles": [
		1497,
		9,
		2273
	],
	"./pages/payroll/components/payroll-executor/common/commonStyles.ts": [
		1497,
		9,
		2273
	],
	"./pages/payroll/components/payroll-executor/common/commonUtils": [
		1087,
		9,
		2274
	],
	"./pages/payroll/components/payroll-executor/common/commonUtils.ts": [
		1087,
		9,
		2274
	],
	"./pages/payroll/components/payroll-executor/common/extraPeriodBanner": [
		1709,
		9,
		2275
	],
	"./pages/payroll/components/payroll-executor/common/extraPeriodBanner.tsx": [
		1709,
		9,
		2275
	],
	"./pages/payroll/components/payroll-executor/common/payrollExecutor.footer": [
		1427,
		9,
		2276
	],
	"./pages/payroll/components/payroll-executor/common/payrollExecutor.footer.tsx": [
		1427,
		9,
		2276
	],
	"./pages/payroll/components/payroll-executor/common/payrollExecutorInterfaces": [
		3604,
		9,
		2277
	],
	"./pages/payroll/components/payroll-executor/common/payrollExecutorInterfaces.ts": [
		3604,
		9,
		2277
	],
	"./pages/payroll/components/payroll-executor/common/route-utils/PrivatePages": [
		3089,
		9,
		1619
	],
	"./pages/payroll/components/payroll-executor/common/route-utils/PrivatePages.tsx": [
		3089,
		9,
		1619
	],
	"./pages/payroll/components/payroll-executor/common/route-utils/constants": [
		1225,
		9,
		2278
	],
	"./pages/payroll/components/payroll-executor/common/route-utils/constants.ts": [
		1225,
		9,
		2278
	],
	"./pages/payroll/components/payroll-executor/common/route-utils/useBrowswerNavigation": [
		2293,
		9,
		1620
	],
	"./pages/payroll/components/payroll-executor/common/route-utils/useBrowswerNavigation.ts": [
		2293,
		9,
		1620
	],
	"./pages/payroll/components/payroll-executor/common/route-utils/useInitPayrollProcessing": [
		1710,
		9,
		1356
	],
	"./pages/payroll/components/payroll-executor/common/route-utils/useInitPayrollProcessing.ts": [
		1710,
		9,
		1356
	],
	"./pages/payroll/components/payroll-executor/common/route-utils/useRoutes": [
		1403,
		9,
		1621
	],
	"./pages/payroll/components/payroll-executor/common/route-utils/useRoutes.ts": [
		1403,
		9,
		1621
	],
	"./pages/payroll/components/payroll-executor/common/tableWrapper": [
		1696,
		9,
		2279
	],
	"./pages/payroll/components/payroll-executor/common/tableWrapper.tsx": [
		1696,
		9,
		2279
	],
	"./pages/payroll/components/payroll-executor/common/useActiveIcon": [
		3090,
		9,
		806
	],
	"./pages/payroll/components/payroll-executor/common/useActiveIcon.tsx": [
		3090,
		9,
		806
	],
	"./pages/payroll/components/payroll-executor/common/useDeleteAndSkipModal": [
		2782,
		9,
		1350
	],
	"./pages/payroll/components/payroll-executor/common/useDeleteAndSkipModal.tsx": [
		2782,
		9,
		1350
	],
	"./pages/payroll/components/payroll-executor/common/useDeleteModal": [
		2060,
		9,
		1351
	],
	"./pages/payroll/components/payroll-executor/common/useDeleteModal.tsx": [
		2060,
		9,
		1351
	],
	"./pages/payroll/components/payroll-executor/common/useLeaveModalFeatureFlag": [
		1697,
		9,
		2280
	],
	"./pages/payroll/components/payroll-executor/common/useLeaveModalFeatureFlag.tsx": [
		1697,
		9,
		2280
	],
	"./pages/payroll/components/payroll-executor/common/useSafetyHooks": [
		1391,
		9,
		2281
	],
	"./pages/payroll/components/payroll-executor/common/useSafetyHooks.ts": [
		1391,
		9,
		2281
	],
	"./pages/payroll/components/payroll-executor/common/useSkipModal": [
		2059,
		9,
		1352
	],
	"./pages/payroll/components/payroll-executor/common/useSkipModal.tsx": [
		2059,
		9,
		1352
	],
	"./pages/payroll/components/payroll-executor/common/useUndoModal": [
		1510,
		9,
		1307
	],
	"./pages/payroll/components/payroll-executor/common/useUndoModal.tsx": [
		1510,
		9,
		1307
	],
	"./pages/payroll/components/payroll-executor/common/useUpdateStepAsPerUrl": [
		2786,
		9,
		1357
	],
	"./pages/payroll/components/payroll-executor/common/useUpdateStepAsPerUrl.tsx": [
		2786,
		9,
		1357
	],
	"./pages/payroll/components/payroll-executor/payrollExecutor": [
		2955,
		9,
		0,
		2,
		4,
		6,
		386
	],
	"./pages/payroll/components/payroll-executor/payrollExecutor.styles": [
		2294,
		9,
		2282
	],
	"./pages/payroll/components/payroll-executor/payrollExecutor.styles.ts": [
		2294,
		9,
		2282
	],
	"./pages/payroll/components/payroll-executor/payrollExecutor.tsx": [
		2955,
		9,
		0,
		2,
		4,
		6,
		386
	],
	"./pages/payroll/components/payroll-executor/payrollExecutor_deprecated": [
		3245,
		9,
		0,
		2,
		4,
		6,
		387
	],
	"./pages/payroll/components/payroll-executor/payrollExecutor_deprecated.tsx": [
		3245,
		9,
		0,
		2,
		4,
		6,
		387
	],
	"./pages/payroll/components/payroll-executor/pe-column-settings/peColumnSettings": [
		2012,
		9,
		2283
	],
	"./pages/payroll/components/payroll-executor/pe-column-settings/peColumnSettings.tsx": [
		2012,
		9,
		2283
	],
	"./pages/payroll/components/payroll-executor/pe-final-page": [
		818,
		9,
		174
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/": [
		818,
		9,
		174
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/common/LayoutWrapper": [
		2019,
		9,
		1534
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/common/LayoutWrapper.tsx": [
		2019,
		9,
		1534
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/common/P1Bold": [
		1576,
		9,
		2284
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/common/P1Bold.tsx": [
		1576,
		9,
		2284
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/common/useAmount": [
		1853,
		9,
		1616
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/common/useAmount.ts": [
		1853,
		9,
		1616
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/components/DebitedAmountSplitup": [
		1921,
		9,
		1038
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/components/DebitedAmountSplitup.tsx": [
		1921,
		9,
		1038
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/components/PayrollInfo": [
		2020,
		9,
		578
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/components/PayrollInfo.tsx": [
		2020,
		9,
		578
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/components/UndoPayroll": [
		1920,
		9,
		837
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/components/UndoPayroll.tsx": [
		1920,
		9,
		837
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/index": [
		818,
		9,
		174
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/index.tsx": [
		818,
		9,
		174
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/index_deprecated": [
		3091,
		9,
		528
	],
	"./pages/payroll/components/payroll-executor/pe-final-page/index_deprecated.tsx": [
		3091,
		9,
		528
	],
	"./pages/payroll/components/payroll-executor/pe-footer/peFooter": [
		1366,
		9,
		2285
	],
	"./pages/payroll/components/payroll-executor/pe-footer/peFooter.tsx": [
		1366,
		9,
		2285
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes": [
		817,
		9,
		0,
		2,
		4,
		8,
		143
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/": [
		817,
		9,
		0,
		2,
		4,
		8,
		143
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/columnSetting": [
		1405,
		9,
		2286
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/columnSetting.ts": [
		1405,
		9,
		2286
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/filterOptions": [
		1466,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/filterOptions.ts": [
		1466,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/formatMatrixColumn": [
		1242,
		9,
		1622
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/formatMatrixColumn.ts": [
		1242,
		9,
		1622
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/hooks": [
		1198,
		9,
		1623
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/hooks.tsx": [
		1198,
		9,
		1623
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/peEditCell": [
		1348,
		9,
		684
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/peEditCell.tsx": [
		1348,
		9,
		684
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/queryKeys": [
		1190,
		9,
		2287
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/queryKeys.ts": [
		1190,
		9,
		2287
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/safetyHooks": [
		1133,
		9,
		2288
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/safetyHooks.ts": [
		1133,
		9,
		2288
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/utils": [
		1097,
		9,
		1358
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/common/utils.ts": [
		1097,
		9,
		1358
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/concurrencyIssueConfig": [
		1711,
		9,
		2289
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/concurrencyIssueConfig.ts": [
		1711,
		9,
		2289
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/index": [
		817,
		9,
		0,
		2,
		4,
		8,
		143
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/index.tsx": [
		817,
		9,
		0,
		2,
		4,
		8,
		143
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/index_deprecated": [
		3092,
		9,
		2,
		8,
		15,
		32,
		417
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/index_deprecated.tsx": [
		3092,
		9,
		2,
		8,
		15,
		32,
		417
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/addNewColumn": [
		1626,
		9,
		1359
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/addNewColumn.tsx": [
		1626,
		9,
		1359
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/matrix.coders": [
		1238,
		9,
		8,
		15,
		1360
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/matrix.coders.ts": [
		1238,
		9,
		8,
		15,
		1360
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/peEditEmployee": [
		1511,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/peEditEmployee.interfaces": [
		1285,
		9,
		2290
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/peEditEmployee.interfaces.ts": [
		1285,
		9,
		2290
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/peEditEmployee.style": [
		1627,
		9,
		2291
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/peEditEmployee.style.ts": [
		1627,
		9,
		2291
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/peEditEmployee.tsx": [
		1511,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/peEditFooter": [
		1632,
		9,
		1624
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/peEditFooter.tsx": [
		1632,
		9,
		1624
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/populateFields": [
		1625,
		9,
		8,
		15,
		892
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/populateFields.ts": [
		1625,
		9,
		8,
		15,
		892
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/statHoliday/statHolidayModal": [
		1572,
		9,
		1625
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/statHoliday/statHolidayModal.tsx": [
		1572,
		9,
		1625
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/statHoliday/statutoryValidation": [
		1631,
		9,
		808
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/statHoliday/statutoryValidation.tsx": [
		1631,
		9,
		808
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/utils/comparer": [
		1630,
		9,
		2292
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/utils/comparer.ts": [
		1630,
		9,
		2292
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/utils/hooks": [
		1188,
		9,
		1171
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/utils/hooks.tsx": [
		1188,
		9,
		1171
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/utils/useMathOnString": [
		1628,
		9,
		8,
		15,
		1168
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/utils/useMathOnString.ts": [
		1628,
		9,
		8,
		15,
		1168
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/utils/useServiceHooks": [
		1416,
		9,
		8,
		15,
		35,
		807
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/utils/useServiceHooks.tsx": [
		1416,
		9,
		8,
		15,
		35,
		807
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/utils/useValidationFlags": [
		1629,
		9,
		2293
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/utils/useValidationFlags.tsx": [
		1629,
		9,
		2293
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/validationBlocks": [
		1392,
		9,
		1626
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-edit-employee/validationBlocks.tsx": [
		1392,
		9,
		1626
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view": [
		729,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/": [
		729,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/common/ConditionalWrapper": [
		1537,
		9,
		2294
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/common/ConditionalWrapper.tsx": [
		1537,
		9,
		2294
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/common/EditCell": [
		1534,
		9,
		2,
		8,
		15,
		35,
		1042
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/common/EditCell.tsx": [
		1534,
		9,
		2,
		8,
		15,
		35,
		1042
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/common/grid-view.disabled": [
		1536,
		9,
		2,
		2295
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/common/grid-view.disabled.tsx": [
		1536,
		9,
		2,
		2295
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/common/grid-view.numberField": [
		1535,
		9,
		2,
		8,
		15,
		35,
		1627
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/common/grid-view.numberField.tsx": [
		1535,
		9,
		2,
		8,
		15,
		35,
		1627
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/common/ui-contracts": [
		3605,
		9,
		2296
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/common/ui-contracts.ts": [
		3605,
		9,
		2296
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/dummy": [
		3606,
		3,
		2890
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/dummy.json": [
		3606,
		3,
		2890
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/index": [
		729,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/index.tsx": [
		729,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/pe-grid-addcolumn": [
		734,
		9,
		241
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/pe-grid-addcolumn/": [
		734,
		9,
		241
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/pe-grid-addcolumn/field-list.helper": [
		1573,
		9,
		1628
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/pe-grid-addcolumn/field-list.helper.ts": [
		1573,
		9,
		1628
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/pe-grid-addcolumn/index": [
		734,
		9,
		241
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/pe-grid-addcolumn/index.tsx": [
		734,
		9,
		241
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/pe-grid-hidecolumn": [
		735,
		9,
		2,
		8,
		15,
		35,
		209
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/pe-grid-hidecolumn/": [
		735,
		9,
		2,
		8,
		15,
		35,
		209
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/pe-grid-hidecolumn/index": [
		735,
		9,
		2,
		8,
		15,
		35,
		209
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/pe-grid-hidecolumn/index.tsx": [
		735,
		9,
		2,
		8,
		15,
		35,
		209
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/peGridFilter": [
		1654,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/peGridFilter.tsx": [
		1654,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/peGridView.helper": [
		1358,
		9,
		8,
		15,
		35,
		1629
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/peGridView.helper.tsx": [
		1358,
		9,
		8,
		15,
		35,
		1629
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/peGridView.interface": [
		3607,
		9,
		2297
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/peGridView.interface.ts": [
		3607,
		9,
		2297
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/peGridView.table": [
		1393,
		9,
		2,
		8,
		15,
		35,
		733
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-grid-view/peGridView.table.tsx": [
		1393,
		9,
		2,
		8,
		15,
		35,
		733
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/unsavedModals": [
		2787,
		9,
		1041
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/unsavedModals.tsx": [
		2787,
		9,
		1041
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/useBreakupTooltips": [
		1455,
		9,
		1354
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/useBreakupTooltips.tsx": [
		1455,
		9,
		1354
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/useExitPayrollPrompt": [
		2532,
		9,
		1170
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/useExitPayrollPrompt.tsx": [
		2532,
		9,
		1170
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/useMatrixTooltip": [
		1354,
		9,
		1630
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/useMatrixTooltip.tsx": [
		1354,
		9,
		1630
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/useRenderCurrencyField": [
		1538,
		9,
		1617
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/useRenderCurrencyField.tsx": [
		1538,
		9,
		1617
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/useUnapprovedTime": [
		1227,
		9,
		270
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/components/useUnapprovedTime.tsx": [
		1227,
		9,
		270
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/getColumnInfoFromEnum": [
		1357,
		9,
		8,
		15,
		1174
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/getColumnInfoFromEnum.ts": [
		1357,
		9,
		8,
		15,
		1174
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/hooks/useCheckForCustomCodes": [
		2788,
		9,
		1172
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/hooks/useCheckForCustomCodes.tsx": [
		2788,
		9,
		1172
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/hooks/useDisableConditionsForPayroll": [
		1917,
		9,
		1631
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/hooks/useDisableConditionsForPayroll.tsx": [
		1917,
		9,
		1631
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/hooks/useGetDefaultCodes": [
		1500,
		9,
		2298
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/hooks/useGetDefaultCodes.tsx": [
		1500,
		9,
		2298
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/hooks/useSelectHashValue": [
		1443,
		9,
		2299
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/hooks/useSelectHashValue.tsx": [
		1443,
		9,
		2299
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours": [
		755,
		9,
		224
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/": [
		755,
		9,
		224
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/dataBuilder": [
		1499,
		9,
		809
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/dataBuilder.tsx": [
		1499,
		9,
		809
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/dummy": [
		3608,
		9,
		2300
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/dummy.ts": [
		3608,
		9,
		2300
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/hooks/useImportHours": [
		1291,
		9,
		270
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/hooks/useImportHours.tsx": [
		1291,
		9,
		270
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/hooks/useImportHoursModal": [
		1574,
		9,
		1362
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/hooks/useImportHoursModal.tsx": [
		1574,
		9,
		1362
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/hooks/useSnackMessages": [
		1160,
		9,
		2301
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/hooks/useSnackMessages.tsx": [
		1160,
		9,
		2301
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/hooks/useTakeImportAction": [
		1417,
		9,
		2302
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/hooks/useTakeImportAction.ts": [
		1417,
		9,
		2302
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/index": [
		755,
		9,
		224
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/importHours/index.tsx": [
		755,
		9,
		224
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/loadHandlers/customCodeChecker": [
		2530,
		9,
		1173
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/loadHandlers/customCodeChecker.tsx": [
		2530,
		9,
		1173
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/loadHandlers/disabledConditionLoadHandler": [
		2531,
		9,
		1361
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/loadHandlers/disabledConditionLoadHandler.tsx": [
		2531,
		9,
		1361
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/loadHandlers/filterColumns": [
		2297,
		9,
		2303
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/loadHandlers/filterColumns.tsx": [
		2297,
		9,
		2303
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/loadHandlers/includeAllEmployee": [
		2296,
		9,
		2304
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/loadHandlers/includeAllEmployee.tsx": [
		2296,
		9,
		2304
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/amountBreakupFields": [
		2299,
		9,
		8,
		15,
		35,
		1040
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/amountBreakupFields.tsx": [
		2299,
		9,
		8,
		15,
		35,
		1040
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/columnEditFieldItem": [
		2298,
		9,
		594
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/columnEditFieldItem.tsx": [
		2298,
		9,
		594
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/editTrowserLink": [
		2302,
		9,
		1632
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/editTrowserLink.tsx": [
		2302,
		9,
		1632
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/grossPayColumn": [
		2295,
		9,
		1355
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/grossPayColumn.tsx": [
		2295,
		9,
		1355
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/peHoursIncomecheckBoxField": [
		2300,
		9,
		8,
		15,
		35,
		1633
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/peHoursIncomecheckBoxField.tsx": [
		2300,
		9,
		8,
		15,
		35,
		1633
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/regularPayEmployeeSection": [
		2301,
		9,
		2,
		8,
		15,
		32,
		428
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/columnItems/regularPayEmployeeSection.tsx": [
		2301,
		9,
		2,
		8,
		15,
		32,
		428
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/peWorkWpTableOptimized": [
		2529,
		9,
		0,
		2,
		4,
		8,
		395
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/optimizedTables/peWorkWpTableOptimized.tsx": [
		2529,
		9,
		0,
		2,
		4,
		8,
		395
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/peWorkTable": [
		1311,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/peWorkTable.styles": [
		1575,
		9,
		2305
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/peWorkTable.styles.tsx": [
		1575,
		9,
		2305
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/peWorkTable.stylesDeprecated": [
		1633,
		9,
		2306
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/peWorkTable.stylesDeprecated.tsx": [
		1633,
		9,
		2306
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/peWorkTable.tsx": [
		1311,
		9,
		2,
		8,
		15,
		32,
		55
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/peWorkTableHelper": [
		1118,
		9,
		8,
		15,
		770
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/peWorkTableHelper.ts": [
		1118,
		9,
		8,
		15,
		770
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/peWorkWpTable": [
		3609,
		9,
		0,
		2,
		4,
		8,
		398
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/peWorkWpTable.tsx": [
		3609,
		9,
		0,
		2,
		4,
		8,
		398
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/regex.constants": [
		1533,
		9,
		2307
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/regex.constants.ts": [
		1533,
		9,
		2307
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/table.config": [
		1178,
		9,
		2308
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/table.config.ts": [
		1178,
		9,
		2308
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/tableViewEnums": [
		1092,
		9,
		2309
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/tableViewEnums.ts": [
		1092,
		9,
		2309
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/validationWindowHourIncome": [
		1498,
		9,
		2310
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/pe-work-table/validationWindowHourIncome.tsx": [
		1498,
		9,
		2310
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peHoursAndIncome.filter": [
		2013,
		9,
		2,
		8,
		15,
		32,
		423
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peHoursAndIncome.filter.tsx": [
		2013,
		9,
		2,
		8,
		15,
		32,
		423
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peHoursAndIncome.footer": [
		2528,
		9,
		891
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peHoursAndIncome.footer.tsx": [
		2528,
		9,
		891
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peHoursAndIncome.footer_deprecated": [
		2789,
		9,
		1039
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peHoursAndIncome.footer_deprecated.tsx": [
		2789,
		9,
		1039
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peHoursAndIncomes.interface": [
		3610,
		9,
		2311
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peHoursAndIncomes.interface.ts": [
		3610,
		9,
		2311
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peImportHourReminder": [
		2015,
		9,
		1634
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peImportHourReminder.tsx": [
		2015,
		9,
		1634
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peTaxUpdatePrompt": [
		2014,
		9,
		2312
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peTaxUpdatePrompt.tsx": [
		2014,
		9,
		2312
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peWireTransferPrompt": [
		1465,
		9,
		1176
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peWireTransferPrompt.tsx": [
		1465,
		9,
		1176
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peWorkbookProcessor": [
		1104,
		9,
		8,
		15,
		1635
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/peWorkbookProcessor.ts": [
		1104,
		9,
		8,
		15,
		1635
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/useGetTotalHours": [
		1916,
		9,
		1618
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/useGetTotalHours.ts": [
		1916,
		9,
		1618
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/useGroupedRowData": [
		1467,
		9,
		2313
	],
	"./pages/payroll/components/payroll-executor/pe-hours-and-incomes/useGroupedRowData.ts": [
		1467,
		9,
		2313
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve": [
		756,
		9,
		0,
		4,
		27,
		102
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/": [
		756,
		9,
		0,
		4,
		27,
		102
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval": [
		746,
		9,
		219
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/": [
		746,
		9,
		219
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/common/dueTodayPill": [
		1404,
		9,
		2314
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/common/dueTodayPill.tsx": [
		1404,
		9,
		2314
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals": [
		727,
		9,
		227
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/": [
		727,
		9,
		227
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/PayrollInfo": [
		1271,
		9,
		2315
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/PayrollInfo.tsx": [
		1271,
		9,
		2315
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/approvePayroll": [
		1620,
		9,
		1636
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/approvePayroll.tsx": [
		1620,
		9,
		1636
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/index": [
		727,
		9,
		227
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/index.tsx": [
		727,
		9,
		227
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/payrollUnavailable": [
		1622,
		9,
		2316
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/payrollUnavailable.tsx": [
		1622,
		9,
		2316
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/rejectPayroll": [
		1623,
		9,
		1637
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/rejectPayroll.tsx": [
		1623,
		9,
		1637
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/submitAndReview": [
		1621,
		9,
		1363
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/modals/submitAndReview.tsx": [
		1621,
		9,
		1363
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog": [
		841,
		9,
		6,
		22,
		26,
		31,
		155
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/": [
		841,
		9,
		6,
		22,
		26,
		31,
		155
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/header": [
		2790,
		9,
		2317
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/header.tsx": [
		2790,
		9,
		2317
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/payTable": [
		871,
		9,
		310
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/payTable/": [
		871,
		9,
		310
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/payTable/index": [
		871,
		9,
		310
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/payTable/index.tsx": [
		871,
		9,
		310
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/payrollDetails": [
		2791,
		9,
		2318
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/payrollDetails.tsx": [
		2791,
		9,
		2318
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total": [
		819,
		9,
		6,
		22,
		26,
		31,
		166
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/": [
		819,
		9,
		6,
		22,
		26,
		31,
		166
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/amountTotal": [
		2533,
		9,
		6,
		22,
		26,
		31,
		531
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/amountTotal.tsx": [
		2533,
		9,
		6,
		22,
		26,
		31,
		531
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/hooks": [
		1922,
		9,
		2319
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/hooks.tsx": [
		1922,
		9,
		2319
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/hoursTotal": [
		2534,
		9,
		6,
		22,
		26,
		31,
		532
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/hoursTotal.tsx": [
		2534,
		9,
		6,
		22,
		26,
		31,
		532
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/index": [
		819,
		9,
		6,
		22,
		26,
		31,
		166
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/index.tsx": [
		819,
		9,
		6,
		22,
		26,
		31,
		166
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/selectTab": [
		2535,
		9,
		2320
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/components/table-total/selectTab.tsx": [
		2535,
		9,
		2320
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/index": [
		841,
		9,
		6,
		22,
		26,
		31,
		155
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/components/viewChangelog/index.tsx": [
		841,
		9,
		6,
		22,
		26,
		31,
		155
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/index": [
		746,
		9,
		219
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/2-step-approval/index.tsx": [
		746,
		9,
		219
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/add-bank-trouser": [
		768,
		9,
		27,
		220
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/add-bank-trouser/": [
		768,
		9,
		27,
		220
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/add-bank-trouser/index": [
		768,
		9,
		27,
		220
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/add-bank-trouser/index.tsx": [
		768,
		9,
		27,
		220
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/add-bank-trouser/validationSchema": [
		1479,
		9,
		1043
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/add-bank-trouser/validationSchema.ts": [
		1479,
		9,
		1043
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/changes-affecting-payroll": [
		767,
		9,
		249
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/changes-affecting-payroll/": [
		767,
		9,
		249
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/changes-affecting-payroll/debitBannerCard": [
		1778,
		9,
		1169
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/changes-affecting-payroll/debitBannerCard.tsx": [
		1778,
		9,
		1169
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/changes-affecting-payroll/index": [
		767,
		9,
		249
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/changes-affecting-payroll/index.tsx": [
		767,
		9,
		249
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/dummy": [
		2157,
		9,
		1638
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/dummy.ts": [
		2157,
		9,
		1638
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/index": [
		756,
		9,
		0,
		4,
		27,
		102
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/index.tsx": [
		756,
		9,
		0,
		4,
		27,
		102
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/new-dummy": [
		3611,
		3,
		2891
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/new-dummy.json": [
		3611,
		3,
		2891
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/payrollInfoCard": [
		2155,
		9,
		945
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/payrollInfoCard.tsx": [
		2155,
		9,
		945
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view": [
		766,
		9,
		191
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/": [
		766,
		9,
		191
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/hooks": [
		1919,
		9,
		2321
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/hooks.tsx": [
		1919,
		9,
		2321
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/index": [
		766,
		9,
		191
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/index.tsx": [
		766,
		9,
		191
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/paystubContent": [
		2018,
		9,
		805
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/paystubContent.tsx": [
		2018,
		9,
		805
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/paystubHeader": [
		2017,
		9,
		1639
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/paystubHeader.tsx": [
		2017,
		9,
		1639
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/paystubStyles": [
		1456,
		9,
		2322
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/paystubStyles.ts": [
		1456,
		9,
		2322
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/util": [
		1918,
		9,
		2323
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/paystub-view/util.ts": [
		1918,
		9,
		2323
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/benefitsField": [
		2164,
		9,
		1364
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/benefitsField.tsx": [
		2164,
		9,
		1364
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/common": [
		1220,
		9,
		1640
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/common.tsx": [
		1220,
		9,
		1640
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/commonUtils": [
		1418,
		9,
		2324
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/commonUtils.tsx": [
		1418,
		9,
		2324
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/deductionField": [
		2163,
		9,
		1365
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/deductionField.tsx": [
		2163,
		9,
		1365
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/hsfField": [
		2165,
		9,
		1175
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/hsfField.tsx": [
		2165,
		9,
		1175
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/incomeField": [
		2162,
		9,
		1366
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/incomeField.tsx": [
		2162,
		9,
		1366
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/sourceDeduction": [
		2160,
		9,
		1367
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/sourceDeduction.tsx": [
		2160,
		9,
		1367
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/totalPeopleNew": [
		2159,
		9,
		0,
		4,
		890
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/totalPeopleNew.tsx": [
		2159,
		9,
		0,
		4,
		890
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/totalPeopleOld": [
		2158,
		9,
		956
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/totalPeopleOld.tsx": [
		2158,
		9,
		956
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/wcb": [
		2161,
		9,
		1167
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/table-column-config/wcb.tsx": [
		2161,
		9,
		1167
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/tableContentSelector": [
		2203,
		9,
		0,
		4,
		27,
		102
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/tableContentSelector.tsx": [
		2203,
		9,
		0,
		4,
		27,
		102
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/totalsCard": [
		2156,
		9,
		2325
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/totalsCard.tsx": [
		2156,
		9,
		2325
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/usePreviewReport": [
		1551,
		9,
		1538
	],
	"./pages/payroll/components/payroll-executor/pe-review-and-approve/usePreviewReport.tsx": [
		1551,
		9,
		1538
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/Footer": [
		752,
		9,
		253
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/Footer/": [
		752,
		9,
		253
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/Footer/index": [
		752,
		9,
		253
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/Footer/index.tsx": [
		752,
		9,
		253
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/ControlledFormRadio": [
		1698,
		9,
		2326
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/ControlledFormRadio.tsx": [
		1698,
		9,
		2326
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/useConvertToDateRangeText": [
		2010,
		9,
		2327
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/useConvertToDateRangeText.ts": [
		2010,
		9,
		2327
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/useSetOtherFields": [
		1571,
		9,
		2328
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/useSetOtherFields.ts": [
		1571,
		9,
		2328
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/useSetPayDate": [
		1431,
		9,
		2329
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/useSetPayDate.ts": [
		1431,
		9,
		2329
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/useSetSupportingData": [
		2141,
		9,
		2330
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/useSetSupportingData.ts": [
		2141,
		9,
		2330
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/useWrapTooltip": [
		2143,
		9,
		2331
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/useWrapTooltip.tsx": [
		2143,
		9,
		2331
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/validationModals": [
		1851,
		9,
		1370
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/common/validationModals.tsx": [
		1851,
		9,
		1370
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/components/offCycleSideffects.renderer": [
		2148,
		9,
		1044
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/components/offCycleSideffects.renderer.tsx": [
		2148,
		9,
		1044
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/components/validationModals": [
		1777,
		9,
		2332
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/components/validationModals.tsx": [
		1777,
		9,
		2332
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/helpers/hooks": [
		2149,
		9,
		1641
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/helpers/hooks.tsx": [
		2149,
		9,
		1641
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/helpers/safetyHooks": [
		2011,
		9,
		2333
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/helpers/safetyHooks.tsx": [
		2011,
		9,
		2333
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle": [
		772,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/": [
		772,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor": [
		773,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/": [
		773,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/DatepickerAndSwitch": [
		1868,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/DatepickerAndSwitch.tsx": [
		1868,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/EmployeeSelectDropNew": [
		2147,
		9,
		1642
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/EmployeeSelectDropNew.tsx": [
		2147,
		9,
		1642
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/EmployeeSelectDropdown": [
		2144,
		9,
		1643
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/EmployeeSelectDropdown.tsx": [
		2144,
		9,
		1643
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/PayperiodSelector": [
		2145,
		9,
		1368
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/PayperiodSelector.tsx": [
		2145,
		9,
		1368
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/index": [
		773,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/OffcycleExecutor/index.tsx": [
		773,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/components/ErrorOnRadio": [
		2146,
		9,
		2334
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/components/ErrorOnRadio.tsx": [
		2146,
		9,
		2334
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/components/selectReason": [
		2142,
		9,
		1369
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/components/selectReason.tsx": [
		2142,
		9,
		1369
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/index": [
		772,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/index.tsx": [
		772,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/utils": [
		3612,
		9,
		2335
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/offcycle/utils.ts": [
		3612,
		9,
		2335
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/peSelectDates": [
		1915,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/peSelectDates.tsx": [
		1915,
		9,
		6,
		56
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/peSelectDatesValidations": [
		2140,
		9,
		1644
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/peSelectDatesValidations.ts": [
		2140,
		9,
		1644
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/selectDatesbackup": [
		3613,
		9,
		2336
	],
	"./pages/payroll/components/payroll-executor/pe-select-dates/selectDatesbackup.ts": [
		3613,
		9,
		2336
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/peTaxStyles": [
		2152,
		9,
		2337
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/peTaxStyles.tsx": [
		2152,
		9,
		2337
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/peTaxes": [
		2303,
		9,
		228,
		608
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/peTaxes.filter": [
		2150,
		9,
		2338
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/peTaxes.filter.tsx": [
		2150,
		9,
		2338
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/peTaxes.tsx": [
		2303,
		9,
		228,
		608
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/peTaxesFooter": [
		2153,
		9,
		2339
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/peTaxesFooter.tsx": [
		2153,
		9,
		2339
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/peTaxesMore": [
		2202,
		9,
		228,
		1078
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/peTaxesMore.tsx": [
		2202,
		9,
		228,
		1078
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/utils/useColumns": [
		2154,
		9,
		1177
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/utils/useColumns.tsx": [
		2154,
		9,
		1177
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/utils/useColumnsMore": [
		2151,
		9,
		957
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/utils/useColumnsMore.tsx": [
		2151,
		9,
		957
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/utils/useUpdatedEmployerTax": [
		2016,
		9,
		1645
	],
	"./pages/payroll/components/payroll-executor/pe-taxes/utils/useUpdatedEmployerTax.tsx": [
		2016,
		9,
		1645
	],
	"./pages/payroll/components/payroll-executor/useClosePayrollProcess": [
		1375,
		9,
		2340
	],
	"./pages/payroll/components/payroll-executor/useClosePayrollProcess.ts": [
		1375,
		9,
		2340
	],
	"./pages/payroll/components/payroll-executor/useCompanySettings": [
		1114,
		9,
		2341
	],
	"./pages/payroll/components/payroll-executor/useCompanySettings.ts": [
		1114,
		9,
		2341
	],
	"./pages/payroll/components/payroll-links/payrollLinks": [
		3397,
		9,
		622
	],
	"./pages/payroll/components/payroll-links/payrollLinks.tsx": [
		3397,
		9,
		622
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/checkBoxField": [
		2204,
		9,
		1371
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/checkBoxField.tsx": [
		2204,
		9,
		1371
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/checkBoxFieldTableStyles": [
		2305,
		9,
		2342
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/checkBoxFieldTableStyles.ts": [
		2305,
		9,
		2342
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/checklistContainer": [
		3519,
		9,
		129,
		377
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/checklistContainer.tsx": [
		3519,
		9,
		129,
		377
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/checklistForm": [
		3520,
		9,
		129
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/checklistForm.tsx": [
		3520,
		9,
		129
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/companyDetailsCard": [
		3401,
		9,
		2343
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/companyDetailsCard.tsx": [
		3401,
		9,
		2343
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/confirmEmployeeCheckBox": [
		3398,
		9,
		1046
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/confirmEmployeeCheckBox.tsx": [
		3398,
		9,
		1046
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/earningDiscrepancyCheckBox": [
		3400,
		9,
		958
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/earningDiscrepancyCheckBox.tsx": [
		3400,
		9,
		958
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/inviteYourTeamCheckBox": [
		3399,
		9,
		1047
	],
	"./pages/payroll/components/payroll-year-end-report/checklist/inviteYourTeamCheckBox.tsx": [
		3399,
		9,
		1047
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/addHomeAddressModal": [
		3093,
		9,
		53,
		579
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/addHomeAddressModal.tsx": [
		3093,
		9,
		53,
		579
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/changeSinModal": [
		3094,
		9,
		53,
		715
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/changeSinModal.tsx": [
		3094,
		9,
		53,
		715
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/checkListContainer": [
		3521,
		9,
		0,
		4,
		96,
		53,
		353
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/checkListContainer.tsx": [
		3521,
		9,
		0,
		4,
		96,
		53,
		353
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/checklistContainerStyles": [
		2062,
		9,
		2344
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/checklistContainerStyles.ts": [
		2062,
		9,
		2344
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/peopleInfo": [
		3095,
		9,
		0,
		4,
		96,
		53,
		193
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/peopleInfo.tsx": [
		3095,
		9,
		0,
		4,
		96,
		53,
		193
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/useGetInsurableEarningsTableConfig": [
		3403,
		9,
		1261
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/useGetInsurableEarningsTableConfig.tsx": [
		3403,
		9,
		1261
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/useGetPeopleInfoTableConfig": [
		3247,
		9,
		0,
		4,
		96,
		53,
		193
	],
	"./pages/payroll/components/payroll-year-end-report/checklistNew/useGetPeopleInfoTableConfig.tsx": [
		3247,
		9,
		0,
		4,
		96,
		53,
		193
	],
	"./pages/payroll/components/payroll-year-end-report/components/backButton": [
		2022,
		9,
		1647
	],
	"./pages/payroll/components/payroll-year-end-report/components/backButton.tsx": [
		2022,
		9,
		1647
	],
	"./pages/payroll/components/payroll-year-end-report/components/headerText": [
		1577,
		9,
		2345
	],
	"./pages/payroll/components/payroll-year-end-report/components/headerText.tsx": [
		1577,
		9,
		2345
	],
	"./pages/payroll/components/payroll-year-end-report/components/prepareYEformConfimationModal": [
		2793,
		9,
		1372
	],
	"./pages/payroll/components/payroll-year-end-report/components/prepareYEformConfimationModal.tsx": [
		2793,
		9,
		1372
	],
	"./pages/payroll/components/payroll-year-end-report/components/revertToOriginal": [
		2023,
		9,
		1178
	],
	"./pages/payroll/components/payroll-year-end-report/components/revertToOriginal.tsx": [
		2023,
		9,
		1178
	],
	"./pages/payroll/components/payroll-year-end-report/create-amendments/createAmendments": [
		3522,
		9,
		370
	],
	"./pages/payroll/components/payroll-year-end-report/create-amendments/createAmendments.tsx": [
		3522,
		9,
		370
	],
	"./pages/payroll/components/payroll-year-end-report/create-amendments/createAmendmentsStyles": [
		3404,
		9,
		2346
	],
	"./pages/payroll/components/payroll-year-end-report/create-amendments/createAmendmentsStyles.ts": [
		3404,
		9,
		2346
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useEffectiveDatesHelper": [
		1539,
		9,
		2347
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useEffectiveDatesHelper.ts": [
		1539,
		9,
		2347
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useGetCheckListData": [
		3246,
		9,
		1648
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useGetCheckListData.ts": [
		3246,
		9,
		1648
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useGetPerson": [
		2792,
		9,
		53,
		2885
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useGetPerson.ts": [
		2792,
		9,
		53,
		2885
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useInfinityRefetch": [
		2536,
		9,
		2348
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useInfinityRefetch.ts": [
		2536,
		9,
		2348
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useNewYearEndChecklist": [
		2956,
		9,
		2349
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useNewYearEndChecklist.ts": [
		2956,
		9,
		2349
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/usePrepareSummaryBoxes": [
		2306,
		9,
		1649
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/usePrepareSummaryBoxes.tsx": [
		2306,
		9,
		1649
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useShowNewYearEndForms": [
		1211,
		9,
		2350
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useShowNewYearEndForms.ts": [
		1211,
		9,
		2350
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useShowYearEndMenuInPayroll": [
		501,
		9
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useShowYearEndMenuInPayroll.ts": [
		501,
		9
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useYearEndPackageFetch": [
		2794,
		9,
		1373
	],
	"./pages/payroll/components/payroll-year-end-report/hooks/useYearEndPackageFetch.tsx": [
		2794,
		9,
		1373
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/contractorsInfoTrouser": [
		3405,
		9,
		0,
		4,
		811
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/contractorsInfoTrouser.tsx": [
		3405,
		9,
		0,
		4,
		811
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/createT4A": [
		3406,
		9,
		1650
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/createT4A.tsx": [
		3406,
		9,
		1650
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/defaultContact": [
		3407,
		9,
		0,
		13,
		2352
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/defaultContact.tsx": [
		3407,
		9,
		0,
		13,
		2352
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/dentalBenefits": [
		3408,
		9,
		1374
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/dentalBenefits.tsx": [
		3408,
		9,
		1374
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/hooks/useCreateT4aOptions": [
		2958,
		9,
		2353
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/hooks/useCreateT4aOptions.tsx": [
		2958,
		9,
		2353
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/hooks/useDentalBenefitsOptions": [
		3096,
		9,
		2354
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/hooks/useDentalBenefitsOptions.tsx": [
		3096,
		9,
		2354
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/hooks/usePrepareFormsValidationSchema": [
		3409,
		9,
		2355
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/hooks/usePrepareFormsValidationSchema.ts": [
		3409,
		9,
		2355
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/hooks/usePrepareYearEndForms": [
		3410,
		9,
		1651
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/hooks/usePrepareYearEndForms.ts": [
		3410,
		9,
		1651
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/modeOfSubmittingTaxForm": [
		3411,
		9,
		2356
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/modeOfSubmittingTaxForm.tsx": [
		3411,
		9,
		2356
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/prepareForms": [
		3523,
		9,
		365
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/prepareForms.tsx": [
		3523,
		9,
		365
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/prepareYEForms": [
		3524,
		9,
		0,
		4,
		13,
		368,
		357
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/prepareYEForms.tsx": [
		3524,
		9,
		0,
		4,
		13,
		368,
		357
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/prepareYEformsStyles": [
		2957,
		9,
		2357
	],
	"./pages/payroll/components/payroll-year-end-report/prepare-forms/prepareYEformsStyles.ts": [
		2957,
		9,
		2357
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/additionalInfoCard": [
		1945,
		9,
		1375
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/additionalInfoCard.tsx": [
		1945,
		9,
		1375
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/companyDetailsCard": [
		1713,
		9,
		2358
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/companyDetailsCard.tsx": [
		1713,
		9,
		2358
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/employeeFieldsCard": [
		1946,
		9,
		838
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/employeeFieldsCard.tsx": [
		1946,
		9,
		838
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-grid-view/addBoxWidget": [
		3412,
		9,
		1377
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-grid-view/addBoxWidget.tsx": [
		3412,
		9,
		1377
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-grid-view/boxNameHeader": [
		3413,
		9,
		2359
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-grid-view/boxNameHeader.tsx": [
		3413,
		9,
		2359
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-grid-view/formGridBox": [
		3414,
		9,
		1378
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-grid-view/formGridBox.tsx": [
		3414,
		9,
		1378
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-grid-view/formGridView": [
		2382,
		9,
		67,
		1050
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-grid-view/formGridView.tsx": [
		2382,
		9,
		67,
		1050
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-grid-view/formGridViewStyles": [
		2538,
		9,
		2360
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-grid-view/formGridViewStyles.ts": [
		2538,
		9,
		2360
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/QPPContributionsPremiumsIncomeTax": [
		3416,
		9,
		960
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/QPPContributionsPremiumsIncomeTax.tsx": [
		3416,
		9,
		960
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox27Field": [
		3098,
		9,
		1653
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox27Field.tsx": [
		3098,
		9,
		1653
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox34Field": [
		3099,
		9,
		1654
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox34Field.tsx": [
		3099,
		9,
		1654
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox39Field": [
		3100,
		9,
		1655
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox39Field.tsx": [
		3100,
		9,
		1655
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox41Field": [
		3101,
		9,
		1656
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox41Field.tsx": [
		3101,
		9,
		1656
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox51Field": [
		3102,
		9,
		1657
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox51Field.tsx": [
		3102,
		9,
		1657
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox53Field": [
		3103,
		9,
		1658
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox53Field.tsx": [
		3103,
		9,
		1658
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox70Field": [
		3104,
		9,
		1180
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox70Field.tsx": [
		3104,
		9,
		1180
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox71Field": [
		3105,
		9,
		1181
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox71Field.tsx": [
		3105,
		9,
		1181
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox72Field": [
		3106,
		9,
		1182
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/RL1SummaryBox72Field.tsx": [
		3106,
		9,
		1182
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/WSDRFContribution": [
		3417,
		9,
		652
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/WSDRFContribution.tsx": [
		3417,
		9,
		652
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/certification": [
		3418,
		9,
		1379
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/certification.tsx": [
		3418,
		9,
		1379
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/formRL1Summary": [
		3419,
		9,
		123,
		537
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/formRL1Summary.tsx": [
		3419,
		9,
		123,
		537
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/formRL1SummaryHeader": [
		3420,
		9,
		1376
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/formRL1SummaryHeader.tsx": [
		3420,
		9,
		1376
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/formRL1SummaryStyles": [
		2063,
		9,
		2361
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/formRL1SummaryStyles.ts": [
		2063,
		9,
		2361
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/healthServicesFundContribution": [
		3421,
		9,
		812
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/healthServicesFundContribution.tsx": [
		3421,
		9,
		812
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/labourStandardsContribution": [
		3422,
		9,
		961
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1-summary/labourStandardsContribution.tsx": [
		3422,
		9,
		961
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1/formRL1": [
		3097,
		9,
		67,
		467
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1/formRL1.tsx": [
		3097,
		9,
		67,
		467
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1/formRL1SingleView": [
		2795,
		9,
		511
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-rl1/formRL1SingleView.tsx": [
		2795,
		9,
		511
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-t4/caseStateAutoCompleteField": [
		3423,
		9,
		2362
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-t4/caseStateAutoCompleteField.tsx": [
		3423,
		9,
		2362
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-t4/formT4": [
		3108,
		9,
		46,
		67,
		609
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-t4/formT4.tsx": [
		3108,
		9,
		46,
		67,
		609
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-t4/formT4SingleView": [
		3109,
		9,
		46,
		959
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-t4/formT4SingleView.tsx": [
		3109,
		9,
		46,
		959
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-t4a/formT4A": [
		3110,
		9,
		67,
		476
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-t4a/formT4A.tsx": [
		3110,
		9,
		67,
		476
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-t4a/formT4ASingleView": [
		2540,
		9,
		539
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/form-t4a/formT4ASingleView.tsx": [
		2540,
		9,
		539
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formActionsRow": [
		1798,
		9,
		1048
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formActionsRow.tsx": [
		1798,
		9,
		1048
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formHeaderWithCompany": [
		3107,
		9,
		1652
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formHeaderWithCompany.tsx": [
		3107,
		9,
		1652
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formMoneyField": [
		1174,
		9,
		2363
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formMoneyField.tsx": [
		1174,
		9,
		2363
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formNavBar": [
		2307,
		9,
		1051
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formNavBar.tsx": [
		2307,
		9,
		1051
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formSingleViewContainer": [
		2539,
		9,
		734
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formSingleViewContainer.tsx": [
		2539,
		9,
		734
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formsStepper": [
		3198,
		9,
		1243
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/formsStepper.tsx": [
		3198,
		9,
		1243
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/submit-forms-footer/confirmationModal": [
		2796,
		9,
		2364
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/submit-forms-footer/confirmationModal.tsx": [
		2796,
		9,
		2364
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/submit-forms-footer/submitFormsFooter": [
		3111,
		9,
		704
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/submit-forms-footer/submitFormsFooter.tsx": [
		3111,
		9,
		704
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/submit-forms-footer/submitPackageButton": [
		3614,
		9,
		1381
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/submit-forms-footer/submitPackageButton.tsx": [
		3614,
		9,
		1381
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/addRemittancesLink": [
		3615,
		9,
		1380
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/addRemittancesLink.tsx": [
		3615,
		9,
		1380
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/amendmentsSummary": [
		3112,
		9,
		893
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/amendmentsSummary.tsx": [
		3112,
		9,
		893
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/summary": [
		3113,
		9,
		595
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/summary.tsx": [
		3113,
		9,
		595
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/summaryCard": [
		2541,
		9,
		2365
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/summaryCard.tsx": [
		2541,
		9,
		2365
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/summaryFormRadio": [
		2797,
		9,
		2366
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/summaryFormRadio.tsx": [
		2797,
		9,
		2366
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/summaryStyles": [
		1947,
		9,
		2367
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/summaryStyles.ts": [
		1947,
		9,
		2367
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/whatsNextList": [
		2798,
		9,
		810
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/summary/whatsNextList.tsx": [
		2798,
		9,
		810
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/switchModeButton": [
		2025,
		9,
		2368
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/switchModeButton.tsx": [
		2025,
		9,
		2368
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/validationBanner": [
		2026,
		9,
		1049
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/components/validationBanner.tsx": [
		2026,
		9,
		1049
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/constants": [
		388,
		9
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/constants.ts": [
		388,
		9
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/formPageStyles": [
		1376,
		9,
		1659
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/formPageStyles.ts": [
		1376,
		9,
		1659
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/helpers": [
		1340,
		9,
		2369
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/helpers.tsx": [
		1340,
		9,
		2369
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useConfirmedAccuracyWatch": [
		1854,
		9,
		2370
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useConfirmedAccuracyWatch.tsx": [
		1854,
		9,
		2370
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useGetEmployeeInfo": [
		2537,
		9,
		2371
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useGetEmployeeInfo.ts": [
		2537,
		9,
		2371
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useGridTooltipLabels": [
		3415,
		9,
		2372
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useGridTooltipLabels.tsx": [
		3415,
		9,
		2372
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useOtherInfoFormBoxes": [
		2024,
		9,
		2373
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useOtherInfoFormBoxes.tsx": [
		2024,
		9,
		2373
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useSubmissionTypeWatch": [
		2028,
		9,
		2374
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useSubmissionTypeWatch.tsx": [
		2028,
		9,
		2374
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useSumOfSectionsResults": [
		2027,
		9,
		1660
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/hooks/useSumOfSectionsResults.tsx": [
		2027,
		9,
		1660
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/schema": [
		3114,
		9,
		2375
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/schema.ts": [
		3114,
		9,
		2375
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/submitForms": [
		3424,
		9,
		349,
		46,
		67,
		123,
		460
	],
	"./pages/payroll/components/payroll-year-end-report/submit-forms/submitForms.tsx": [
		3424,
		9,
		349,
		46,
		67,
		123,
		460
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/employeeTaxFormsTable": [
		3115,
		9,
		14,
		46,
		97,
		771
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/employeeTaxFormsTable.tsx": [
		3115,
		9,
		14,
		46,
		97,
		771
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/employeeTaxFormsTableStyles": [
		2799,
		9,
		2376
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/employeeTaxFormsTableStyles.ts": [
		2799,
		9,
		2376
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/printTaxForm": [
		2959,
		9,
		14,
		46,
		97,
		895
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/printTaxForm.tsx": [
		2959,
		9,
		14,
		46,
		97,
		895
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/rl1ActionRequiredCard": [
		3116,
		9,
		1445
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/rl1ActionRequiredCard.tsx": [
		3116,
		9,
		1445
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/taxFormSummaryAccordion": [
		3117,
		9,
		1052
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/taxFormSummaryAccordion.tsx": [
		3117,
		9,
		1052
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/taxFormsPackageView": [
		3426,
		9,
		14,
		366,
		46,
		97,
		660
	],
	"./pages/payroll/components/payroll-year-end-report/tax-forms-package-view/taxFormsPackageView.tsx": [
		3426,
		9,
		14,
		366,
		46,
		97,
		660
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/checkListCard": [
		3118,
		9,
		896
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/checkListCard.tsx": [
		3118,
		9,
		896
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/checkListHelpCard": [
		3119,
		9,
		1382
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/checkListHelpCard.tsx": [
		3119,
		9,
		1382
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/checklistAccordion": [
		3204,
		9,
		772
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/checklistAccordion.tsx": [
		3204,
		9,
		772
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/helpers": [
		2021,
		9,
		1183
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/helpers.ts": [
		2021,
		9,
		1183
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/mainPageStyles": [
		1587,
		9,
		2377
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/mainPageStyles.ts": [
		1587,
		9,
		2377
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/prepareYearEndFormCard": [
		3120,
		9,
		894
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/prepareYearEndFormCard.tsx": [
		3120,
		9,
		894
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/routes": [
		3402,
		9,
		2378
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/routes.ts": [
		3402,
		9,
		2378
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/t4aOptOutCard": [
		3121,
		9,
		813
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/t4aOptOutCard.tsx": [
		3121,
		9,
		813
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/testingComponents/resetPackageColumn": [
		2383,
		9,
		1661
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/testingComponents/resetPackageColumn.tsx": [
		2383,
		9,
		1661
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/testingComponents/yearEndTestingCard": [
		3122,
		9,
		784
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/testingComponents/yearEndTestingCard.tsx": [
		3122,
		9,
		784
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/useYearEndPackageColumns": [
		2960,
		9,
		242,
		2351
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/useYearEndPackageColumns.tsx": [
		2960,
		9,
		242,
		2351
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/yearEndFormsMainPage": [
		3427,
		9,
		0,
		4,
		5,
		362,
		450
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/yearEndFormsMainPage.tsx": [
		3427,
		9,
		0,
		4,
		5,
		362,
		450
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/yearEndPackageList": [
		3124,
		9,
		0,
		4,
		242,
		1179
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/yearEndPackageList.tsx": [
		3124,
		9,
		0,
		4,
		242,
		1179
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/yearEndZeroState": [
		3123,
		9,
		5,
		647
	],
	"./pages/payroll/components/payroll-year-end-report/year-end-forms-main-page/yearEndZeroState.tsx": [
		3123,
		9,
		5,
		647
	],
	"./pages/payroll/components/payroll-year-end-report/yearEndForms.contracts": [
		3616,
		9,
		2379
	],
	"./pages/payroll/components/payroll-year-end-report/yearEndForms.contracts.ts": [
		3616,
		9,
		2379
	],
	"./pages/payroll/components/payroll-year-end-report/yearEndFormsContainer": [
		3248,
		9,
		287
	],
	"./pages/payroll/components/payroll-year-end-report/yearEndFormsContainer.tsx": [
		3248,
		9,
		287
	],
	"./pages/payroll/components/payroll-year-end-report/yearendRoutes": [
		1295,
		9,
		2380
	],
	"./pages/payroll/components/payroll-year-end-report/yearendRoutes.ts": [
		1295,
		9,
		2380
	],
	"./pages/payroll/components/pending-approval/pendingApproval": [
		3125,
		9,
		0,
		4,
		70,
		572
	],
	"./pages/payroll/components/pending-approval/pendingApproval.tsx": [
		3125,
		9,
		0,
		4,
		70,
		572
	],
	"./pages/payroll/helpers/payGroup.helper": [
		1693,
		9,
		1662
	],
	"./pages/payroll/helpers/payGroup.helper.tsx": [
		1693,
		9,
		1662
	],
	"./pages/payroll/payrollContainer": [
		3530,
		9,
		0,
		1,
		4,
		5,
		335
	],
	"./pages/payroll/payrollContainer.tsx": [
		3530,
		9,
		0,
		1,
		4,
		5,
		335
	],
	"./pages/payroll/payrollView": [
		3428,
		9,
		0,
		1,
		4,
		5,
		394
	],
	"./pages/payroll/payrollView.tsx": [
		3428,
		9,
		0,
		1,
		4,
		5,
		394
	],
	"./pages/payroll/route/payrollRouter": [
		3249,
		9,
		382
	],
	"./pages/payroll/route/payrollRouter.tsx": [
		3249,
		9,
		382
	],
	"./pages/payroll/routes": [
		1232,
		9,
		2382
	],
	"./pages/payroll/routes.ts": [
		1232,
		9,
		2382
	],
	"./pages/people-refactor/GridOnboarding": [
		849,
		9,
		2,
		76,
		158
	],
	"./pages/people-refactor/GridOnboarding/": [
		849,
		9,
		2,
		76,
		158
	],
	"./pages/people-refactor/GridOnboarding/components/basicInfo/basicInfo.table": [
		3268,
		9,
		2,
		76,
		841
	],
	"./pages/people-refactor/GridOnboarding/components/basicInfo/basicInfo.table.tsx": [
		3268,
		9,
		2,
		76,
		841
	],
	"./pages/people-refactor/GridOnboarding/components/common/fields/checkbox.grid": [
		2574,
		9,
		1383
	],
	"./pages/people-refactor/GridOnboarding/components/common/fields/checkbox.grid.tsx": [
		2574,
		9,
		1383
	],
	"./pages/people-refactor/GridOnboarding/components/common/fields/datePicker.grid": [
		2576,
		9,
		2,
		1384
	],
	"./pages/people-refactor/GridOnboarding/components/common/fields/datePicker.grid.tsx": [
		2576,
		9,
		2,
		1384
	],
	"./pages/people-refactor/GridOnboarding/components/common/fields/dropdown.grid": [
		2573,
		9,
		2,
		1663
	],
	"./pages/people-refactor/GridOnboarding/components/common/fields/dropdown.grid.tsx": [
		2573,
		9,
		2,
		1663
	],
	"./pages/people-refactor/GridOnboarding/components/common/fields/mask.grid": [
		2577,
		9,
		2,
		814
	],
	"./pages/people-refactor/GridOnboarding/components/common/fields/mask.grid.tsx": [
		2577,
		9,
		2,
		814
	],
	"./pages/people-refactor/GridOnboarding/components/common/fields/textfield.grid": [
		2575,
		9,
		2,
		1664
	],
	"./pages/people-refactor/GridOnboarding/components/common/fields/textfield.grid.tsx": [
		2575,
		9,
		2,
		1664
	],
	"./pages/people-refactor/GridOnboarding/components/common/hooks/useRegisterArray": [
		3152,
		9,
		2383
	],
	"./pages/people-refactor/GridOnboarding/components/common/hooks/useRegisterArray.tsx": [
		3152,
		9,
		2383
	],
	"./pages/people-refactor/GridOnboarding/components/common/hooks/useTableConfig": [
		3153,
		9,
		2384
	],
	"./pages/people-refactor/GridOnboarding/components/common/hooks/useTableConfig.tsx": [
		3153,
		9,
		2384
	],
	"./pages/people-refactor/GridOnboarding/components/common/reuseableColumns": [
		864,
		9,
		288
	],
	"./pages/people-refactor/GridOnboarding/components/common/reuseableColumns/": [
		864,
		9,
		288
	],
	"./pages/people-refactor/GridOnboarding/components/common/reuseableColumns/index": [
		864,
		9,
		288
	],
	"./pages/people-refactor/GridOnboarding/components/common/reuseableColumns/index.tsx": [
		864,
		9,
		288
	],
	"./pages/people-refactor/GridOnboarding/components/common/table": [
		863,
		9,
		2,
		172
	],
	"./pages/people-refactor/GridOnboarding/components/common/table/": [
		863,
		9,
		2,
		172
	],
	"./pages/people-refactor/GridOnboarding/components/common/table/configs": [
		3154,
		9,
		2385
	],
	"./pages/people-refactor/GridOnboarding/components/common/table/configs.ts": [
		3154,
		9,
		2385
	],
	"./pages/people-refactor/GridOnboarding/components/common/table/index": [
		863,
		9,
		2,
		172
	],
	"./pages/people-refactor/GridOnboarding/components/common/table/index.tsx": [
		863,
		9,
		2,
		172
	],
	"./pages/people-refactor/GridOnboarding/components/common/table/tableGridWrapper": [
		3150,
		9,
		2,
		596
	],
	"./pages/people-refactor/GridOnboarding/components/common/table/tableGridWrapper.tsx": [
		3150,
		9,
		2,
		596
	],
	"./pages/people-refactor/GridOnboarding/components/finalReview/finalReview": [
		2850,
		9,
		2386
	],
	"./pages/people-refactor/GridOnboarding/components/finalReview/finalReview.tsx": [
		2850,
		9,
		2386
	],
	"./pages/people-refactor/GridOnboarding/components/idb/idb": [
		2851,
		9,
		2387
	],
	"./pages/people-refactor/GridOnboarding/components/idb/idb.tsx": [
		2851,
		9,
		2387
	],
	"./pages/people-refactor/GridOnboarding/components/jobDetails/jobDetails": [
		2852,
		9,
		2388
	],
	"./pages/people-refactor/GridOnboarding/components/jobDetails/jobDetails.tsx": [
		2852,
		9,
		2388
	],
	"./pages/people-refactor/GridOnboarding/components/paymentInfo/paymentInfo": [
		2853,
		9,
		2389
	],
	"./pages/people-refactor/GridOnboarding/components/paymentInfo/paymentInfo.tsx": [
		2853,
		9,
		2389
	],
	"./pages/people-refactor/GridOnboarding/components/priorPayroll/priorPayroll": [
		2854,
		9,
		2390
	],
	"./pages/people-refactor/GridOnboarding/components/priorPayroll/priorPayroll.tsx": [
		2854,
		9,
		2390
	],
	"./pages/people-refactor/GridOnboarding/components/taxInfo/taxInfo": [
		2855,
		9,
		2391
	],
	"./pages/people-refactor/GridOnboarding/components/taxInfo/taxInfo.tsx": [
		2855,
		9,
		2391
	],
	"./pages/people-refactor/GridOnboarding/contracts/gridOnboarding.interfaces": [
		2175,
		9,
		2392
	],
	"./pages/people-refactor/GridOnboarding/contracts/gridOnboarding.interfaces.tsx": [
		2175,
		9,
		2392
	],
	"./pages/people-refactor/GridOnboarding/dummyRow": [
		3448,
		3,
		2892
	],
	"./pages/people-refactor/GridOnboarding/dummyRow.json": [
		3448,
		3,
		2892
	],
	"./pages/people-refactor/GridOnboarding/helpers/mergeData": [
		1422,
		9,
		2393
	],
	"./pages/people-refactor/GridOnboarding/helpers/mergeData.ts": [
		1422,
		9,
		2393
	],
	"./pages/people-refactor/GridOnboarding/hooks/useColumnGenerator": [
		2849,
		9,
		2,
		610
	],
	"./pages/people-refactor/GridOnboarding/hooks/useColumnGenerator.ts": [
		2849,
		9,
		2,
		610
	],
	"./pages/people-refactor/GridOnboarding/hooks/useGridSteps": [
		2856,
		9,
		2394
	],
	"./pages/people-refactor/GridOnboarding/hooks/useGridSteps.ts": [
		2856,
		9,
		2394
	],
	"./pages/people-refactor/GridOnboarding/hooks/useSchemaGenerator": [
		3151,
		9,
		2395
	],
	"./pages/people-refactor/GridOnboarding/hooks/useSchemaGenerator.ts": [
		3151,
		9,
		2395
	],
	"./pages/people-refactor/GridOnboarding/index": [
		849,
		9,
		2,
		76,
		158
	],
	"./pages/people-refactor/GridOnboarding/index.tsx": [
		849,
		9,
		2,
		76,
		158
	],
	"./pages/people-refactor/addBank": [
		728,
		9,
		27,
		291
	],
	"./pages/people-refactor/addBank/": [
		728,
		9,
		27,
		291
	],
	"./pages/people-refactor/addBank/addBank.helpers": [
		1090,
		9,
		2396
	],
	"./pages/people-refactor/addBank/addBank.helpers.ts": [
		1090,
		9,
		2396
	],
	"./pages/people-refactor/addBank/addBank.interfaces": [
		1086,
		9,
		2397
	],
	"./pages/people-refactor/addBank/addBank.interfaces.ts": [
		1086,
		9,
		2397
	],
	"./pages/people-refactor/addBank/addBank.style": [
		1473,
		9,
		2398
	],
	"./pages/people-refactor/addBank/addBank.style.ts": [
		1473,
		9,
		2398
	],
	"./pages/people-refactor/addBank/components/accountType": [
		1477,
		9,
		1385
	],
	"./pages/people-refactor/addBank/components/accountType.tsx": [
		1477,
		9,
		1385
	],
	"./pages/people-refactor/addBank/components/bankInfoLink": [
		1180,
		9,
		2399
	],
	"./pages/people-refactor/addBank/components/bankInfoLink.tsx": [
		1180,
		9,
		2399
	],
	"./pages/people-refactor/addBank/components/bankInfoPopup": [
		1474,
		9,
		1386
	],
	"./pages/people-refactor/addBank/components/bankInfoPopup.tsx": [
		1474,
		9,
		1386
	],
	"./pages/people-refactor/addBank/components/bankPriority": [
		1478,
		9,
		1184
	],
	"./pages/people-refactor/addBank/components/bankPriority.tsx": [
		1478,
		9,
		1184
	],
	"./pages/people-refactor/addBank/components/common/autocomplete.addBank": [
		1449,
		9,
		2400
	],
	"./pages/people-refactor/addBank/components/common/autocomplete.addBank.tsx": [
		1449,
		9,
		2400
	],
	"./pages/people-refactor/addBank/components/common/numberField.addBank": [
		1170,
		9,
		2401
	],
	"./pages/people-refactor/addBank/components/common/numberField.addBank.tsx": [
		1170,
		9,
		2401
	],
	"./pages/people-refactor/addBank/components/common/textField.addBank": [
		1387,
		9,
		2402
	],
	"./pages/people-refactor/addBank/components/common/textField.addBank.tsx": [
		1387,
		9,
		2402
	],
	"./pages/people-refactor/addBank/components/institutionNumber": [
		1388,
		9,
		815
	],
	"./pages/people-refactor/addBank/components/institutionNumber.tsx": [
		1388,
		9,
		815
	],
	"./pages/people-refactor/addBank/components/otherBankFields": [
		1261,
		9,
		653
	],
	"./pages/people-refactor/addBank/components/otherBankFields.tsx": [
		1261,
		9,
		653
	],
	"./pages/people-refactor/addBank/components/selectBankDropdown": [
		1476,
		9,
		897
	],
	"./pages/people-refactor/addBank/components/selectBankDropdown.tsx": [
		1476,
		9,
		897
	],
	"./pages/people-refactor/addBank/components/transitAndAccountFields": [
		1389,
		9,
		735
	],
	"./pages/people-refactor/addBank/components/transitAndAccountFields.tsx": [
		1389,
		9,
		735
	],
	"./pages/people-refactor/addBank/hooks/useNormalizeError": [
		1475,
		9,
		1665
	],
	"./pages/people-refactor/addBank/hooks/useNormalizeError.tsx": [
		1475,
		9,
		1665
	],
	"./pages/people-refactor/addBank/index": [
		728,
		9,
		27,
		291
	],
	"./pages/people-refactor/addBank/index.tsx": [
		728,
		9,
		27,
		291
	],
	"./pages/people-refactor/addBank/useBankValidationSchema": [
		1140,
		9,
		1185
	],
	"./pages/people-refactor/addBank/useBankValidationSchema.ts": [
		1140,
		9,
		1185
	],
	"./pages/people-refactor/addPeople": [
		850,
		9,
		121,
		217
	],
	"./pages/people-refactor/addPeople/": [
		850,
		9,
		121,
		217
	],
	"./pages/people-refactor/addPeople/addPeopleSchema": [
		3449,
		9,
		2403
	],
	"./pages/people-refactor/addPeople/addPeopleSchema.ts": [
		3449,
		9,
		2403
	],
	"./pages/people-refactor/addPeople/components/addPeopleFooter": [
		3450,
		9,
		1387
	],
	"./pages/people-refactor/addPeople/components/addPeopleFooter.tsx": [
		3450,
		9,
		1387
	],
	"./pages/people-refactor/addPeople/components/addPeopleRadioSelect": [
		3155,
		9,
		1666
	],
	"./pages/people-refactor/addPeople/components/addPeopleRadioSelect.tsx": [
		3155,
		9,
		1666
	],
	"./pages/people-refactor/addPeople/components/addPeopleTitle": [
		3451,
		9,
		604
	],
	"./pages/people-refactor/addPeople/components/addPeopleTitle.tsx": [
		3451,
		9,
		604
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions": [
		865,
		9,
		210
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/": [
		865,
		9,
		210
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/index": [
		865,
		9,
		210
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/index.tsx": [
		865,
		9,
		210
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/useDisableOptions": [
		3156,
		9,
		962
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/useDisableOptions.ts": [
		3156,
		9,
		962
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/useDontShowOption": [
		3158,
		9,
		1388
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/useDontShowOption.ts": [
		3158,
		9,
		1388
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/useGetQuestionList": [
		1767,
		9,
		2404
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/useGetQuestionList.ts": [
		1767,
		9,
		2404
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/useHiddenOptions": [
		3157,
		9,
		1668
	],
	"./pages/people-refactor/addPeople/components/guidedOnboardingQuestions/useHiddenOptions.ts": [
		3157,
		9,
		1668
	],
	"./pages/people-refactor/addPeople/components/onBoardingCards": [
		3452,
		9,
		2405
	],
	"./pages/people-refactor/addPeople/components/onBoardingCards.tsx": [
		3452,
		9,
		2405
	],
	"./pages/people-refactor/addPeople/index": [
		850,
		9,
		121,
		217
	],
	"./pages/people-refactor/addPeople/index.tsx": [
		850,
		9,
		121,
		217
	],
	"./pages/people-refactor/common/helpers": [
		1582,
		9,
		2406
	],
	"./pages/people-refactor/common/helpers.ts": [
		1582,
		9,
		2406
	],
	"./pages/people-refactor/common/hooks": [
		1067,
		9,
		2407
	],
	"./pages/people-refactor/common/hooks.tsx": [
		1067,
		9,
		2407
	],
	"./pages/people-refactor/common/people-ui-contract": [
		1077,
		9,
		2408
	],
	"./pages/people-refactor/common/people-ui-contract.ts": [
		1077,
		9,
		2408
	],
	"./pages/people-refactor/common/useAllStepsFilled": [
		2209,
		9,
		2409
	],
	"./pages/people-refactor/common/useAllStepsFilled.tsx": [
		2209,
		9,
		2409
	],
	"./pages/people-refactor/common/useCreateDefaultJob": [
		1606,
		9,
		2410
	],
	"./pages/people-refactor/common/useCreateDefaultJob.tsx": [
		1606,
		9,
		2410
	],
	"./pages/people-refactor/common/useCurrentStepFilled": [
		1424,
		9,
		1676
	],
	"./pages/people-refactor/common/useCurrentStepFilled.tsx": [
		1424,
		9,
		1676
	],
	"./pages/people-refactor/common/useGetSelfBoardingQuestionsList": [
		1563,
		9,
		2411
	],
	"./pages/people-refactor/common/useGetSelfBoardingQuestionsList.tsx": [
		1563,
		9,
		2411
	],
	"./pages/people-refactor/common/useGetStepStatus": [
		1364,
		9,
		2412
	],
	"./pages/people-refactor/common/useGetStepStatus.tsx": [
		1364,
		9,
		2412
	],
	"./pages/people-refactor/common/useGetVocationsInfo": [
		1315,
		9,
		2413
	],
	"./pages/people-refactor/common/useGetVocationsInfo.tsx": [
		1315,
		9,
		2413
	],
	"./pages/people-refactor/common/useRequiredFields": [
		1373,
		9,
		2414
	],
	"./pages/people-refactor/common/useRequiredFields.ts": [
		1373,
		9,
		2414
	],
	"./pages/people-refactor/dashboard": [
		830,
		9,
		0,
		1,
		4,
		5,
		142
	],
	"./pages/people-refactor/dashboard/": [
		830,
		9,
		0,
		1,
		4,
		5,
		142
	],
	"./pages/people-refactor/dashboard/common/customDropdown": [
		757,
		9,
		311
	],
	"./pages/people-refactor/dashboard/common/customDropdown/": [
		757,
		9,
		311
	],
	"./pages/people-refactor/dashboard/common/customDropdown/index": [
		757,
		9,
		311
	],
	"./pages/people-refactor/dashboard/common/customDropdown/index.tsx": [
		757,
		9,
		311
	],
	"./pages/people-refactor/dashboard/dashboard-field-card/department": [
		2176,
		9,
		6,
		22,
		278,
		26,
		453
	],
	"./pages/people-refactor/dashboard/dashboard-field-card/department.tsx": [
		2176,
		9,
		6,
		22,
		278,
		26,
		453
	],
	"./pages/people-refactor/dashboard/dashboard-field-card/jobTitles": [
		3159,
		9,
		6,
		22,
		278,
		2888,
		443
	],
	"./pages/people-refactor/dashboard/dashboard-field-card/jobTitles.tsx": [
		3159,
		9,
		6,
		22,
		278,
		2888,
		443
	],
	"./pages/people-refactor/dashboard/dashboard-field-card/popup/department": [
		2318,
		9,
		1679
	],
	"./pages/people-refactor/dashboard/dashboard-field-card/popup/department.tsx": [
		2318,
		9,
		1679
	],
	"./pages/people-refactor/dashboard/dashboard-field-card/popup/jobTitle": [
		2857,
		9,
		1680
	],
	"./pages/people-refactor/dashboard/dashboard-field-card/popup/jobTitle.tsx": [
		2857,
		9,
		1680
	],
	"./pages/people-refactor/dashboard/dashboard-field-card/popup/nameExistsCommon": [
		2066,
		9,
		2415
	],
	"./pages/people-refactor/dashboard/dashboard-field-card/popup/nameExistsCommon.tsx": [
		2066,
		9,
		2415
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/bulkCheckAssign": [
		2067,
		9,
		1681
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/bulkCheckAssign.tsx": [
		2067,
		9,
		1681
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/components/userAvatar": [
		2319,
		9,
		1395
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/components/userAvatar.tsx": [
		2319,
		9,
		1395
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardFieldList": [
		3160,
		9,
		1,
		5,
		6,
		22,
		393
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardFieldList.tsx": [
		3160,
		9,
		1,
		5,
		6,
		22,
		393
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardFieldListStyles": [
		1927,
		9,
		2416
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardFieldListStyles.ts": [
		1927,
		9,
		2416
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardPeopleList": [
		3161,
		9,
		0,
		1,
		4,
		5,
		397
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardPeopleList.tsx": [
		3161,
		9,
		0,
		1,
		4,
		5,
		397
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardPeopleListBulkActions": [
		2861,
		9,
		1682
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardPeopleListBulkActions.tsx": [
		2861,
		9,
		1682
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardSlide/customFields": [
		1843,
		9,
		1683
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardSlide/customFields.tsx": [
		1843,
		9,
		1683
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardSlide/customSlide": [
		2320,
		9,
		36,
		737
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardSlide/customSlide.tsx": [
		2320,
		9,
		36,
		737
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardSlide/customSlideChangeStatus": [
		1795,
		9,
		1059
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardSlide/customSlideChangeStatus.tsx": [
		1795,
		9,
		1059
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardSlide/customizePopup": [
		2321,
		9,
		2417
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/dashboardSlide/customizePopup.tsx": [
		2321,
		9,
		2417
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/hooks/useBulkAssign": [
		2858,
		9,
		1060
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/hooks/useBulkAssign.tsx": [
		2858,
		9,
		1060
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/hooks/useBulkAssignV2": [
		2860,
		9,
		1061
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/hooks/useBulkAssignV2.tsx": [
		2860,
		9,
		1061
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/hooks/useCustomSlideError": [
		2322,
		9,
		2418
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/hooks/useCustomSlideError.ts": [
		2322,
		9,
		2418
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/hooks/usePopup": [
		1783,
		9,
		2419
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/hooks/usePopup.tsx": [
		1783,
		9,
		2419
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/hooks/usePossibleRowCount": [
		2859,
		9,
		2420
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/hooks/usePossibleRowCount.ts": [
		2859,
		9,
		2420
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/deletePersonPopup": [
		2328,
		9,
		2421
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/deletePersonPopup.tsx": [
		2328,
		9,
		2421
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/department": [
		2324,
		9,
		1677
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/department.tsx": [
		2324,
		9,
		1677
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/enablePersonPopup": [
		2329,
		9,
		2422
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/enablePersonPopup.tsx": [
		2329,
		9,
		2422
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/invitePopup": [
		2327,
		9,
		2423
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/invitePopup.tsx": [
		2327,
		9,
		2423
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/jobTitle": [
		2323,
		9,
		1678
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/jobTitle.tsx": [
		2323,
		9,
		1678
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/location": [
		2326,
		9,
		2424
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/location.tsx": [
		2326,
		9,
		2424
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/removePersonPopup": [
		1567,
		9,
		2425
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/removePersonPopup.tsx": [
		1567,
		9,
		2425
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/reset2FaPopup": [
		1840,
		9,
		2426
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/reset2FaPopup.tsx": [
		1840,
		9,
		2426
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/workersCompensationPopup": [
		2325,
		9,
		1685
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/popup/workersCompensationPopup.tsx": [
		2325,
		9,
		1685
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/primaryJob": [
		2330,
		9,
		1686
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/primaryJob.tsx": [
		2330,
		9,
		1686
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/queries/dashboardPeopleQueries": [
		2862,
		9,
		2427
	],
	"./pages/people-refactor/dashboard/dashboard-field-list/queries/dashboardPeopleQueries.ts": [
		2862,
		9,
		2427
	],
	"./pages/people-refactor/dashboard/index": [
		830,
		9,
		0,
		1,
		4,
		5,
		142
	],
	"./pages/people-refactor/dashboard/index.tsx": [
		830,
		9,
		0,
		1,
		4,
		5,
		142
	],
	"./pages/people-refactor/form-change-status/field-hire-date/fieldHireDate": [
		1481,
		9,
		1396
	],
	"./pages/people-refactor/form-change-status/field-hire-date/fieldHireDate.tsx": [
		1481,
		9,
		1396
	],
	"./pages/people-refactor/form-change-status/field-last-working-date/fieldLastWorkingDate": [
		1482,
		9,
		1397
	],
	"./pages/people-refactor/form-change-status/field-last-working-date/fieldLastWorkingDate.tsx": [
		1482,
		9,
		1397
	],
	"./pages/people-refactor/form-change-status/field-mid-cycle/fieldMidCycle": [
		1483,
		9,
		818
	],
	"./pages/people-refactor/form-change-status/field-mid-cycle/fieldMidCycle.tsx": [
		1483,
		9,
		818
	],
	"./pages/people-refactor/form-change-status/field-off-cycle-payment/fieldOffCyclePayment": [
		1484,
		9,
		1194
	],
	"./pages/people-refactor/form-change-status/field-off-cycle-payment/fieldOffCyclePayment.tsx": [
		1484,
		9,
		1194
	],
	"./pages/people-refactor/form-change-status/field-return-date/fieldReturnDate": [
		1485,
		9,
		2428
	],
	"./pages/people-refactor/form-change-status/field-return-date/fieldReturnDate.tsx": [
		1485,
		9,
		2428
	],
	"./pages/people-refactor/form-change-status/field-state-type/fieldStateType": [
		1486,
		9,
		1398
	],
	"./pages/people-refactor/form-change-status/field-state-type/fieldStateType.tsx": [
		1486,
		9,
		1398
	],
	"./pages/people-refactor/form-change-status/footer/footer": [
		1490,
		9,
		1399
	],
	"./pages/people-refactor/form-change-status/footer/footer.tsx": [
		1490,
		9,
		1399
	],
	"./pages/people-refactor/form-change-status/form/config": [
		1089,
		9,
		1687
	],
	"./pages/people-refactor/form-change-status/form/config.injectValidationSchema": [
		3656,
		9,
		2429
	],
	"./pages/people-refactor/form-change-status/form/config.injectValidationSchema.ts": [
		3656,
		9,
		2429
	],
	"./pages/people-refactor/form-change-status/form/config.tsx": [
		1089,
		9,
		1687
	],
	"./pages/people-refactor/form-change-status/form/fields": [
		1834,
		9,
		41,
		1766
	],
	"./pages/people-refactor/form-change-status/form/fields.tsx": [
		1834,
		9,
		41,
		1766
	],
	"./pages/people-refactor/form-change-status/form/form": [
		1833,
		9,
		41,
		1199
	],
	"./pages/people-refactor/form-change-status/form/form.tsx": [
		1833,
		9,
		41,
		1199
	],
	"./pages/people-refactor/form-change-status/form/new-fields": [
		1772,
		9,
		505
	],
	"./pages/people-refactor/form-change-status/form/new-fields.tsx": [
		1772,
		9,
		505
	],
	"./pages/people-refactor/form-change-status/form/types": [
		3657,
		9,
		2430
	],
	"./pages/people-refactor/form-change-status/form/types.ts": [
		3657,
		9,
		2430
	],
	"./pages/people-refactor/form-change-status/formChangeStatus": [
		1771,
		9,
		41,
		58,
		1767
	],
	"./pages/people-refactor/form-change-status/formChangeStatus.tsx": [
		1771,
		9,
		41,
		58,
		1767
	],
	"./pages/people-refactor/form-change-status/statement/cancelledOnLeavePending.": [
		1492,
		9,
		1195
	],
	"./pages/people-refactor/form-change-status/statement/cancelledOnLeavePending..tsx": [
		1492,
		9,
		1195
	],
	"./pages/people-refactor/form-change-status/statement/cancelledTerminatedPending": [
		1491,
		9,
		1196
	],
	"./pages/people-refactor/form-change-status/statement/cancelledTerminatedPending.tsx": [
		1491,
		9,
		1196
	],
	"./pages/people-refactor/form-change-status/statement/payperiodFirst": [
		1487,
		9,
		1400
	],
	"./pages/people-refactor/form-change-status/statement/payperiodFirst.tsx": [
		1487,
		9,
		1400
	],
	"./pages/people-refactor/form-change-status/statement/payperiodInProgress": [
		1488,
		9,
		1197
	],
	"./pages/people-refactor/form-change-status/statement/payperiodInProgress.tsx": [
		1488,
		9,
		1197
	],
	"./pages/people-refactor/form-change-status/statement/payperiodVacation": [
		1489,
		9,
		1198
	],
	"./pages/people-refactor/form-change-status/statement/payperiodVacation.tsx": [
		1489,
		9,
		1198
	],
	"./pages/people-refactor/form-change-status/statement/payperiodWillBe": [
		1835,
		9,
		1401
	],
	"./pages/people-refactor/form-change-status/statement/payperiodWillBe.tsx": [
		1835,
		9,
		1401
	],
	"./pages/people-refactor/form-change-status/useRunOffCyclePayroll": [
		1836,
		9,
		1162
	],
	"./pages/people-refactor/form-change-status/useRunOffCyclePayroll.ts": [
		1836,
		9,
		1162
	],
	"./pages/people-refactor/form-change-status/useRunOnboarding": [
		1837,
		9,
		1163
	],
	"./pages/people-refactor/form-change-status/useRunOnboarding.ts": [
		1837,
		9,
		1163
	],
	"./pages/people-refactor/form-change-status/useRunRoeCreation": [
		1838,
		9,
		1034
	],
	"./pages/people-refactor/form-change-status/useRunRoeCreation.ts": [
		1838,
		9,
		1034
	],
	"./pages/people-refactor/form-change-status/useSubmit": [
		1839,
		9,
		967
	],
	"./pages/people-refactor/form-change-status/useSubmit.ts": [
		1839,
		9,
		967
	],
	"./pages/people-refactor/mid-cycle/midCycle": [
		1691,
		9,
		1402
	],
	"./pages/people-refactor/mid-cycle/midCycle.tsx": [
		1691,
		9,
		1402
	],
	"./pages/people-refactor/mid-cycle/midCycleStyles": [
		1617,
		9,
		2431
	],
	"./pages/people-refactor/mid-cycle/midCycleStyles.ts": [
		1617,
		9,
		2431
	],
	"./pages/people-refactor/mid-cycle/new-midCycle": [
		1692,
		9,
		1688
	],
	"./pages/people-refactor/mid-cycle/new-midCycle.tsx": [
		1692,
		9,
		1688
	],
	"./pages/people-refactor/onboard": [
		851,
		9,
		1,
		3,
		17,
		19,
		140
	],
	"./pages/people-refactor/onboard/": [
		851,
		9,
		1,
		3,
		17,
		19,
		140
	],
	"./pages/people-refactor/onboard/components/basicInfo": [
		741,
		9,
		3,
		19,
		27,
		45,
		151
	],
	"./pages/people-refactor/onboard/components/basicInfo/": [
		741,
		9,
		3,
		19,
		27,
		45,
		151
	],
	"./pages/people-refactor/onboard/components/basicInfo/basicInfoFTUSchema": [
		1673,
		9,
		1053
	],
	"./pages/people-refactor/onboard/components/basicInfo/basicInfoFTUSchema.tsx": [
		1673,
		9,
		1053
	],
	"./pages/people-refactor/onboard/components/basicInfo/basicInfoSchema": [
		1667,
		9,
		1186
	],
	"./pages/people-refactor/onboard/components/basicInfo/basicInfoSchema.tsx": [
		1667,
		9,
		1186
	],
	"./pages/people-refactor/onboard/components/basicInfo/basicInfoStyles": [
		1665,
		9,
		2432
	],
	"./pages/people-refactor/onboard/components/basicInfo/basicInfoStyles.ts": [
		1665,
		9,
		2432
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/InviteEmployee": [
		739,
		9,
		258
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/InviteEmployee/": [
		739,
		9,
		258
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/InviteEmployee/index": [
		739,
		9,
		258
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/InviteEmployee/index.tsx": [
		739,
		9,
		258
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/InviteEmployee/inviteEmployeeModal": [
		1363,
		9,
		2433
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/InviteEmployee/inviteEmployeeModal.tsx": [
		1363,
		9,
		2433
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/InviteEmployee/inviteModalWrapper": [
		1607,
		9,
		1188
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/InviteEmployee/inviteModalWrapper.tsx": [
		1607,
		9,
		1188
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/addBank": [
		1669,
		9,
		27,
		1062
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/addBank.tsx": [
		1669,
		9,
		27,
		1062
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/common/datepicker.basicInfo": [
		1372,
		9,
		2434
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/common/datepicker.basicInfo.tsx": [
		1372,
		9,
		2434
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/common/masked.basicInfo": [
		1289,
		9,
		900
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/common/masked.basicInfo.tsx": [
		1289,
		9,
		900
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/common/textField.basicInfo": [
		1196,
		9,
		1389
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/common/textField.basicInfo.tsx": [
		1196,
		9,
		1389
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/emergencyContact": [
		1670,
		9,
		1669
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/emergencyContact.tsx": [
		1670,
		9,
		1669
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/ftuHomeAddress": [
		1674,
		9,
		628
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/ftuHomeAddress.tsx": [
		1674,
		9,
		628
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/manageProvincePopup": [
		1666,
		9,
		1200
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/manageProvincePopup.tsx": [
		1666,
		9,
		1200
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/pastProvinceModal/pastProvinceModal": [
		1284,
		9,
		289
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/pastProvinceModal/pastProvinceModal.tsx": [
		1284,
		9,
		289
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/pastProvinceModal/provinceSchema": [
		1507,
		9,
		289
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/pastProvinceModal/provinceSchema.tsx": [
		1507,
		9,
		289
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/pastProvinceModal/removePastProvince": [
		1472,
		9,
		2435
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/pastProvinceModal/removePastProvince.tsx": [
		1472,
		9,
		2435
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/provinceDropdown": [
		3658,
		9,
		964
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/provinceDropdown.tsx": [
		3658,
		9,
		964
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/uploadProfilePic": [
		1729,
		9,
		3,
		1063
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/uploadProfilePic.tsx": [
		1729,
		9,
		3,
		1063
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane": [
		737,
		9,
		3,
		45,
		173
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/": [
		737,
		9,
		3,
		45,
		173
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/contractorFields": [
		1604,
		9,
		661
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/contractorFields.tsx": [
		1604,
		9,
		661
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/hireDateAndOtherFields": [
		1603,
		9,
		1054
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/hireDateAndOtherFields.tsx": [
		1603,
		9,
		1054
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/homeAddressPane": [
		1365,
		9,
		662
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/homeAddressPane.tsx": [
		1365,
		9,
		662
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/index": [
		737,
		9,
		3,
		45,
		173
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/index.tsx": [
		737,
		9,
		3,
		45,
		173
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/nameAndProvinceFields": [
		1706,
		9,
		3,
		45,
		1811
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/nameAndProvinceFields.tsx": [
		1706,
		9,
		3,
		45,
		1811
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/notesField": [
		1672,
		9,
		1201
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/notesField.tsx": [
		1672,
		9,
		1201
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/phoneNumber": [
		1605,
		9,
		1189
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/phoneNumber.tsx": [
		1605,
		9,
		1189
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/sinAndOtherFields": [
		1602,
		9,
		617
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/sinAndOtherFields.tsx": [
		1602,
		9,
		617
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/sinField": [
		1371,
		9,
		747
	],
	"./pages/people-refactor/onboard/components/basicInfo/components/userDetailsPane/sinField.tsx": [
		1371,
		9,
		747
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks": [
		738,
		9,
		312
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/": [
		738,
		9,
		312
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/index": [
		738,
		9,
		312
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/index.tsx": [
		738,
		9,
		312
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/useBackgroundServices": [
		1230,
		9,
		625
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/useBackgroundServices.ts": [
		1230,
		9,
		625
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/useNewOnboardServices": [
		1668,
		9,
		525
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/useNewOnboardServices.ts": [
		1668,
		9,
		525
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/usePayrollProgressLabels": [
		1283,
		9,
		1670
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/usePayrollProgressLabels.tsx": [
		1283,
		9,
		1670
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/useSavedPersonBasicInfo": [
		3659,
		9,
		2436
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/useSavedPersonBasicInfo.ts": [
		3659,
		9,
		2436
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/useSelfOnboardingAlert": [
		1671,
		9,
		2437
	],
	"./pages/people-refactor/onboard/components/basicInfo/hooks/useSelfOnboardingAlert.tsx": [
		1671,
		9,
		2437
	],
	"./pages/people-refactor/onboard/components/basicInfo/index": [
		741,
		9,
		3,
		19,
		27,
		45,
		151
	],
	"./pages/people-refactor/onboard/components/basicInfo/index.tsx": [
		741,
		9,
		3,
		19,
		27,
		45,
		151
	],
	"./pages/people-refactor/onboard/components/common-utils/types": [
		3660,
		9,
		2438
	],
	"./pages/people-refactor/onboard/components/common-utils/types.ts": [
		3660,
		9,
		2438
	],
	"./pages/people-refactor/onboard/components/common-utils/useGetPayGroupInfo": [
		1288,
		9,
		2439
	],
	"./pages/people-refactor/onboard/components/common-utils/useGetPayGroupInfo.tsx": [
		1288,
		9,
		2439
	],
	"./pages/people-refactor/onboard/components/common-utils/useGetPayPeriodDetails": [
		1741,
		9,
		2440
	],
	"./pages/people-refactor/onboard/components/common-utils/useGetPayPeriodDetails.tsx": [
		1741,
		9,
		2440
	],
	"./pages/people-refactor/onboard/components/common-utils/useGetPeopleRoutes": [
		2863,
		9,
		1690
	],
	"./pages/people-refactor/onboard/components/common-utils/useGetPeopleRoutes.ts": [
		2863,
		9,
		1690
	],
	"./pages/people-refactor/onboard/components/common-utils/useGetStateName": [
		1157,
		9,
		2441
	],
	"./pages/people-refactor/onboard/components/common-utils/useGetStateName.tsx": [
		1157,
		9,
		2441
	],
	"./pages/people-refactor/onboard/components/common-utils/useInitialData": [
		1549,
		9,
		1692
	],
	"./pages/people-refactor/onboard/components/common-utils/useInitialData.tsx": [
		1549,
		9,
		1692
	],
	"./pages/people-refactor/onboard/components/common-utils/useProgressStepwiseServices": [
		1112,
		9,
		1390
	],
	"./pages/people-refactor/onboard/components/common-utils/useProgressStepwiseServices.tsx": [
		1112,
		9,
		1390
	],
	"./pages/people-refactor/onboard/components/common-utils/useSetSharedData": [
		1664,
		9,
		2442
	],
	"./pages/people-refactor/onboard/components/common-utils/useSetSharedData.ts": [
		1664,
		9,
		2442
	],
	"./pages/people-refactor/onboard/components/common-utils/useSkipStepService": [
		1398,
		9,
		2443
	],
	"./pages/people-refactor/onboard/components/common-utils/useSkipStepService.ts": [
		1398,
		9,
		2443
	],
	"./pages/people-refactor/onboard/components/finalReview": [
		794,
		9,
		77,
		125,
		180
	],
	"./pages/people-refactor/onboard/components/finalReview/": [
		794,
		9,
		77,
		125,
		180
	],
	"./pages/people-refactor/onboard/components/finalReview/components/basicInfo": [
		785,
		9,
		216
	],
	"./pages/people-refactor/onboard/components/finalReview/components/basicInfo/": [
		785,
		9,
		216
	],
	"./pages/people-refactor/onboard/components/finalReview/components/basicInfo/index": [
		785,
		9,
		216
	],
	"./pages/people-refactor/onboard/components/finalReview/components/basicInfo/index.tsx": [
		785,
		9,
		216
	],
	"./pages/people-refactor/onboard/components/finalReview/components/basicInfo/styles": [
		2331,
		9,
		2444
	],
	"./pages/people-refactor/onboard/components/finalReview/components/basicInfo/styles.ts": [
		2331,
		9,
		2444
	],
	"./pages/people-refactor/onboard/components/finalReview/components/common/placeholder": [
		1928,
		9,
		1403
	],
	"./pages/people-refactor/onboard/components/finalReview/components/common/placeholder.tsx": [
		1928,
		9,
		1403
	],
	"./pages/people-refactor/onboard/components/finalReview/components/common/styles": [
		2040,
		9,
		2445
	],
	"./pages/people-refactor/onboard/components/finalReview/components/common/styles.ts": [
		2040,
		9,
		2445
	],
	"./pages/people-refactor/onboard/components/finalReview/components/incomesDeductionsBenefits": [
		786,
		9,
		163
	],
	"./pages/people-refactor/onboard/components/finalReview/components/incomesDeductionsBenefits/": [
		786,
		9,
		163
	],
	"./pages/people-refactor/onboard/components/finalReview/components/incomesDeductionsBenefits/gridBlock": [
		2332,
		9,
		1202
	],
	"./pages/people-refactor/onboard/components/finalReview/components/incomesDeductionsBenefits/gridBlock.tsx": [
		2332,
		9,
		1202
	],
	"./pages/people-refactor/onboard/components/finalReview/components/incomesDeductionsBenefits/index": [
		786,
		9,
		163
	],
	"./pages/people-refactor/onboard/components/finalReview/components/incomesDeductionsBenefits/index.tsx": [
		786,
		9,
		163
	],
	"./pages/people-refactor/onboard/components/finalReview/components/incomesDeductionsBenefits/styles": [
		1873,
		9,
		2446
	],
	"./pages/people-refactor/onboard/components/finalReview/components/incomesDeductionsBenefits/styles.ts": [
		1873,
		9,
		2446
	],
	"./pages/people-refactor/onboard/components/finalReview/components/inviteEmployee": [
		787,
		9,
		313
	],
	"./pages/people-refactor/onboard/components/finalReview/components/inviteEmployee/": [
		787,
		9,
		313
	],
	"./pages/people-refactor/onboard/components/finalReview/components/inviteEmployee/index": [
		787,
		9,
		313
	],
	"./pages/people-refactor/onboard/components/finalReview/components/inviteEmployee/index.tsx": [
		787,
		9,
		313
	],
	"./pages/people-refactor/onboard/components/finalReview/components/jobDetails": [
		793,
		9,
		77,
		198
	],
	"./pages/people-refactor/onboard/components/finalReview/components/jobDetails/": [
		793,
		9,
		77,
		198
	],
	"./pages/people-refactor/onboard/components/finalReview/components/jobDetails/index": [
		793,
		9,
		77,
		198
	],
	"./pages/people-refactor/onboard/components/finalReview/components/jobDetails/index.tsx": [
		793,
		9,
		77,
		198
	],
	"./pages/people-refactor/onboard/components/finalReview/components/jobDetails/job": [
		2580,
		9,
		966
	],
	"./pages/people-refactor/onboard/components/finalReview/components/jobDetails/job.tsx": [
		2580,
		9,
		966
	],
	"./pages/people-refactor/onboard/components/finalReview/components/jobDetails/styles": [
		2041,
		9,
		2447
	],
	"./pages/people-refactor/onboard/components/finalReview/components/jobDetails/styles.ts": [
		2041,
		9,
		2447
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/accordionLayout": [
		736,
		9,
		184
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/accordionLayout/": [
		736,
		9,
		184
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/accordionLayout/index": [
		736,
		9,
		184
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/accordionLayout/index.tsx": [
		736,
		9,
		184
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/accordionLayout/insideSectionAccordion": [
		1717,
		9,
		906
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/accordionLayout/insideSectionAccordion.tsx": [
		1717,
		9,
		906
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/accordionLayout/mainSectionAccordion": [
		1716,
		9,
		738
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/accordionLayout/mainSectionAccordion.tsx": [
		1716,
		9,
		738
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/accordionLayout/styles": [
		1589,
		9,
		2448
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/accordionLayout/styles.ts": [
		1589,
		9,
		2448
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/commonFieldBlock": [
		748,
		9,
		314
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/commonFieldBlock/": [
		748,
		9,
		314
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/commonFieldBlock/index": [
		748,
		9,
		314
	],
	"./pages/people-refactor/onboard/components/finalReview/components/layouts/commonFieldBlock/index.tsx": [
		748,
		9,
		314
	],
	"./pages/people-refactor/onboard/components/finalReview/components/priorPayroll": [
		788,
		9,
		162
	],
	"./pages/people-refactor/onboard/components/finalReview/components/priorPayroll/": [
		788,
		9,
		162
	],
	"./pages/people-refactor/onboard/components/finalReview/components/priorPayroll/gridBlock": [
		2333,
		9,
		1693
	],
	"./pages/people-refactor/onboard/components/finalReview/components/priorPayroll/gridBlock.tsx": [
		2333,
		9,
		1693
	],
	"./pages/people-refactor/onboard/components/finalReview/components/priorPayroll/index": [
		788,
		9,
		162
	],
	"./pages/people-refactor/onboard/components/finalReview/components/priorPayroll/index.tsx": [
		788,
		9,
		162
	],
	"./pages/people-refactor/onboard/components/finalReview/components/priorPayroll/styles": [
		1874,
		9,
		2449
	],
	"./pages/people-refactor/onboard/components/finalReview/components/priorPayroll/styles.ts": [
		1874,
		9,
		2449
	],
	"./pages/people-refactor/onboard/components/finalReview/components/priorPayroll/useFormatPriorPayrollData": [
		2334,
		9,
		1691
	],
	"./pages/people-refactor/onboard/components/finalReview/components/priorPayroll/useFormatPriorPayrollData.tsx": [
		2334,
		9,
		1691
	],
	"./pages/people-refactor/onboard/components/finalReview/components/taxInfo": [
		789,
		9,
		271
	],
	"./pages/people-refactor/onboard/components/finalReview/components/taxInfo/": [
		789,
		9,
		271
	],
	"./pages/people-refactor/onboard/components/finalReview/components/taxInfo/incomeTaxApplied": [
		2335,
		9,
		1694
	],
	"./pages/people-refactor/onboard/components/finalReview/components/taxInfo/incomeTaxApplied.tsx": [
		2335,
		9,
		1694
	],
	"./pages/people-refactor/onboard/components/finalReview/components/taxInfo/index": [
		789,
		9,
		271
	],
	"./pages/people-refactor/onboard/components/finalReview/components/taxInfo/index.tsx": [
		789,
		9,
		271
	],
	"./pages/people-refactor/onboard/components/finalReview/components/taxInfo/styles": [
		1875,
		9,
		2450
	],
	"./pages/people-refactor/onboard/components/finalReview/components/taxInfo/styles.ts": [
		1875,
		9,
		2450
	],
	"./pages/people-refactor/onboard/components/finalReview/index": [
		794,
		9,
		77,
		125,
		180
	],
	"./pages/people-refactor/onboard/components/finalReview/index.tsx": [
		794,
		9,
		77,
		125,
		180
	],
	"./pages/people-refactor/onboard/components/finalReview/useExpandedStep": [
		2581,
		9,
		2451
	],
	"./pages/people-refactor/onboard/components/finalReview/useExpandedStep.ts": [
		2581,
		9,
		2451
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions": [
		743,
		9,
		17,
		29,
		60,
		87,
		254
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/": [
		743,
		9,
		17,
		29,
		60,
		87,
		254
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/benefits": [
		1689,
		9,
		29,
		526
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/benefits.tsx": [
		1689,
		9,
		29,
		526
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/common/hooks": [
		1155,
		9,
		272
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/common/hooks.tsx": [
		1155,
		9,
		272
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/common/serviceHooks": [
		1380,
		9,
		272
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/common/serviceHooks.tsx": [
		1380,
		9,
		272
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/common/statements": [
		1142,
		9,
		2452
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/common/statements.tsx": [
		1142,
		9,
		2452
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/components/ManageIDB": [
		718,
		9,
		29,
		275
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/components/ManageIDB/": [
		718,
		9,
		29,
		275
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/components/ManageIDB/index": [
		718,
		9,
		29,
		275
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/components/ManageIDB/index.tsx": [
		718,
		9,
		29,
		275
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/components/ManageIDB/selectIDBAmountType": [
		1764,
		9,
		2453
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/components/ManageIDB/selectIDBAmountType.tsx": [
		1764,
		9,
		2453
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/components/ManageIDB/showGarnishments": [
		1765,
		9,
		2454
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/components/ManageIDB/showGarnishments.tsx": [
		1765,
		9,
		2454
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/customFrequency": [
		1762,
		9,
		2455
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/customFrequency.tsx": [
		1762,
		9,
		2455
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/customiseIncomeCodes": [
		1566,
		9,
		1203
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/customiseIncomeCodes.tsx": [
		1566,
		9,
		1203
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/deduction": [
		1766,
		9,
		29,
		60,
		709
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/deduction.tsx": [
		1766,
		9,
		29,
		60,
		709
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/deleteIDBPopup": [
		1332,
		9,
		2456
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/deleteIDBPopup.tsx": [
		1332,
		9,
		2456
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/gridView": [
		1331,
		9,
		1404
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/gridView.tsx": [
		1331,
		9,
		1404
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/idbSchema": [
		1761,
		9,
		2457
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/idbSchema.tsx": [
		1761,
		9,
		2457
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/idbTrouserPrompt": [
		1763,
		9,
		2458
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/idbTrouserPrompt.tsx": [
		1763,
		9,
		2458
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/idbhelper": [
		1120,
		9,
		1695
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/idbhelper.tsx": [
		1120,
		9,
		1695
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/incomeDefaultCodes": [
		1615,
		9,
		908
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/incomeDefaultCodes.tsx": [
		1615,
		9,
		908
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/incomes": [
		1688,
		9,
		17,
		29,
		686
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/incomes.tsx": [
		1688,
		9,
		17,
		29,
		686
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/index": [
		743,
		9,
		17,
		29,
		60,
		87,
		254
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/index.tsx": [
		743,
		9,
		17,
		29,
		60,
		87,
		254
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/jobView": [
		1707,
		9,
		17,
		29,
		60,
		774
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/jobView.tsx": [
		1707,
		9,
		17,
		29,
		60,
		774
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/manageTrouser": [
		1690,
		9,
		29,
		907
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/manageTrouser.tsx": [
		1690,
		9,
		29,
		907
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/styles": [
		1166,
		9,
		2459
	],
	"./pages/people-refactor/onboard/components/incomeAndDeductions/styles.ts": [
		1166,
		9,
		2459
	],
	"./pages/people-refactor/onboard/components/jobDetails": [
		744,
		9,
		59,
		73,
		61,
		86,
		244
	],
	"./pages/people-refactor/onboard/components/jobDetails/": [
		744,
		9,
		59,
		73,
		61,
		86,
		244
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/common/statements": [
		1209,
		9,
		2460
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/common/statements.tsx": [
		1209,
		9,
		2460
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/datesAndPayGroup": [
		1731,
		9,
		965
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/datesAndPayGroup.tsx": [
		1731,
		9,
		965
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/department": [
		1733,
		9,
		1055
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/department.tsx": [
		1733,
		9,
		1055
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/dropdownsSection": [
		1737,
		9,
		901
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/dropdownsSection.tsx": [
		1737,
		9,
		901
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/employmentType": [
		1736,
		9,
		905
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/employmentType.tsx": [
		1736,
		9,
		905
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/hoursType": [
		1735,
		9,
		736
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/hoursType.tsx": [
		1735,
		9,
		736
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/jobTitle": [
		1732,
		9,
		1190
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/jobTitle.tsx": [
		1732,
		9,
		1190
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/midCycleHire": [
		1734,
		9,
		819
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/midCycleHire.tsx": [
		1734,
		9,
		819
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/payTypeBlock": [
		1793,
		9,
		59,
		2833
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/payTypeBlock.tsx": [
		1793,
		9,
		59,
		2833
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/payrollModal": [
		1738,
		9,
		909
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generate-jobs-components/payrollModal.tsx": [
		1738,
		9,
		909
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generateJobs": [
		1792,
		9,
		59,
		73,
		1803
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/generateJobs.tsx": [
		1792,
		9,
		59,
		73,
		1803
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/modal-update-compensation": [
		750,
		9,
		61,
		199
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/modal-update-compensation/": [
		750,
		9,
		61,
		199
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/modal-update-compensation/index": [
		750,
		9,
		61,
		199
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/modal-update-compensation/index.tsx": [
		750,
		9,
		61,
		199
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/modal-update-compensation/midCyclePayChange": [
		1742,
		9,
		1204
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/modal-update-compensation/midCyclePayChange.tsx": [
		1742,
		9,
		1204
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/modal-update-compensation/modalStyles": [
		1740,
		9,
		2461
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/modal-update-compensation/modalStyles.ts": [
		1740,
		9,
		2461
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/modal-update-compensation/validationSchema": [
		1743,
		9,
		1405
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/modal-update-compensation/validationSchema.ts": [
		1743,
		9,
		1405
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/resetFormData": [
		1745,
		9,
		1064
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/resetFormData.tsx": [
		1745,
		9,
		1064
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/vocationBlock": [
		1739,
		9,
		817
	],
	"./pages/people-refactor/onboard/components/jobDetails/components/vocationBlock.tsx": [
		1739,
		9,
		817
	],
	"./pages/people-refactor/onboard/components/jobDetails/hooks/useEditModal": [
		1269,
		9,
		2462
	],
	"./pages/people-refactor/onboard/components/jobDetails/hooks/useEditModal.tsx": [
		1269,
		9,
		2462
	],
	"./pages/people-refactor/onboard/components/jobDetails/hooks/useEffectiveDateMessage": [
		1450,
		9,
		1696
	],
	"./pages/people-refactor/onboard/components/jobDetails/hooks/useEffectiveDateMessage.ts": [
		1450,
		9,
		1696
	],
	"./pages/people-refactor/onboard/components/jobDetails/hooks/useHasUserChangedComp": [
		1439,
		9,
		2463
	],
	"./pages/people-refactor/onboard/components/jobDetails/hooks/useHasUserChangedComp.tsx": [
		1439,
		9,
		2463
	],
	"./pages/people-refactor/onboard/components/jobDetails/hooks/useJobDetailsSubmit": [
		1744,
		9,
		1191
	],
	"./pages/people-refactor/onboard/components/jobDetails/hooks/useJobDetailsSubmit.tsx": [
		1744,
		9,
		1191
	],
	"./pages/people-refactor/onboard/components/jobDetails/hooks/useJobFields": [
		1117,
		9,
		1205
	],
	"./pages/people-refactor/onboard/components/jobDetails/hooks/useJobFields.tsx": [
		1117,
		9,
		1205
	],
	"./pages/people-refactor/onboard/components/jobDetails/index": [
		744,
		9,
		59,
		73,
		61,
		86,
		244
	],
	"./pages/people-refactor/onboard/components/jobDetails/index.tsx": [
		744,
		9,
		59,
		73,
		61,
		86,
		244
	],
	"./pages/people-refactor/onboard/components/jobDetails/jobDetails.context": [
		1094,
		9,
		2464
	],
	"./pages/people-refactor/onboard/components/jobDetails/jobDetails.context.ts": [
		1094,
		9,
		2464
	],
	"./pages/people-refactor/onboard/components/jobDetails/jobDetails.interfaces": [
		3661,
		9,
		2465
	],
	"./pages/people-refactor/onboard/components/jobDetails/jobDetails.interfaces.ts": [
		3661,
		9,
		2465
	],
	"./pages/people-refactor/onboard/components/jobDetails/jobDetailsStyles": [
		1145,
		9,
		2466
	],
	"./pages/people-refactor/onboard/components/jobDetails/jobDetailsStyles.ts": [
		1145,
		9,
		2466
	],
	"./pages/people-refactor/onboard/components/jobDetails/validationSchema": [
		1730,
		9,
		2467
	],
	"./pages/people-refactor/onboard/components/jobDetails/validationSchema.ts": [
		1730,
		9,
		2467
	],
	"./pages/people-refactor/onboard/components/onBoardFooter": [
		770,
		9,
		211
	],
	"./pages/people-refactor/onboard/components/onBoardFooter/": [
		770,
		9,
		211
	],
	"./pages/people-refactor/onboard/components/onBoardFooter/index": [
		770,
		9,
		211
	],
	"./pages/people-refactor/onboard/components/onBoardFooter/index.tsx": [
		770,
		9,
		211
	],
	"./pages/people-refactor/onboard/components/onBoardFooter/useResetBoard": [
		1550,
		9,
		2468
	],
	"./pages/people-refactor/onboard/components/onBoardFooter/useResetBoard.tsx": [
		1550,
		9,
		2468
	],
	"./pages/people-refactor/onboard/components/onBoardFooterRehire": [
		826,
		9,
		296
	],
	"./pages/people-refactor/onboard/components/onBoardFooterRehire/": [
		826,
		9,
		296
	],
	"./pages/people-refactor/onboard/components/onBoardFooterRehire/index": [
		826,
		9,
		296
	],
	"./pages/people-refactor/onboard/components/onBoardFooterRehire/index.tsx": [
		826,
		9,
		296
	],
	"./pages/people-refactor/onboard/components/onBoardModals": [
		732,
		9,
		315
	],
	"./pages/people-refactor/onboard/components/onBoardModals/": [
		732,
		9,
		315
	],
	"./pages/people-refactor/onboard/components/onBoardModals/index": [
		732,
		9,
		315
	],
	"./pages/people-refactor/onboard/components/onBoardModals/index.tsx": [
		732,
		9,
		315
	],
	"./pages/people-refactor/onboard/components/onBoardModals/useCancelModal": [
		2039,
		9,
		969
	],
	"./pages/people-refactor/onboard/components/onBoardModals/useCancelModal.tsx": [
		2039,
		9,
		969
	],
	"./pages/people-refactor/onboard/components/onBoardModals/useSaveExitModal": [
		2038,
		9,
		1697
	],
	"./pages/people-refactor/onboard/components/onBoardModals/useSaveExitModal.tsx": [
		2038,
		9,
		1697
	],
	"./pages/people-refactor/onboard/components/onboardLayout": [
		827,
		9,
		1,
		3,
		17,
		19,
		141
	],
	"./pages/people-refactor/onboard/components/onboardLayout/": [
		827,
		9,
		1,
		3,
		17,
		19,
		141
	],
	"./pages/people-refactor/onboard/components/onboardLayout/helpers/usePopulateSharedData": [
		1308,
		9,
		2469
	],
	"./pages/people-refactor/onboard/components/onboardLayout/helpers/usePopulateSharedData.tsx": [
		1308,
		9,
		2469
	],
	"./pages/people-refactor/onboard/components/onboardLayout/index": [
		827,
		9,
		1,
		3,
		17,
		19,
		141
	],
	"./pages/people-refactor/onboard/components/onboardLayout/index.tsx": [
		827,
		9,
		1,
		3,
		17,
		19,
		141
	],
	"./pages/people-refactor/onboard/components/priorPayroll": [
		745,
		9,
		57,
		80,
		247
	],
	"./pages/people-refactor/onboard/components/priorPayroll/": [
		745,
		9,
		57,
		80,
		247
	],
	"./pages/people-refactor/onboard/components/priorPayroll/common/dummy": [
		3662,
		3,
		2893
	],
	"./pages/people-refactor/onboard/components/priorPayroll/common/dummy.json": [
		3662,
		3,
		2893
	],
	"./pages/people-refactor/onboard/components/priorPayroll/common/getValidationTypes": [
		1171,
		9,
		1672
	],
	"./pages/people-refactor/onboard/components/priorPayroll/common/getValidationTypes.ts": [
		1171,
		9,
		1672
	],
	"./pages/people-refactor/onboard/components/priorPayroll/common/ppNumberField": [
		1650,
		9,
		71
	],
	"./pages/people-refactor/onboard/components/priorPayroll/common/ppNumberField.tsx": [
		1650,
		9,
		71
	],
	"./pages/people-refactor/onboard/components/priorPayroll/common/ppTotalFields": [
		1609,
		9,
		1057
	],
	"./pages/people-refactor/onboard/components/priorPayroll/common/ppTotalFields.tsx": [
		1609,
		9,
		1057
	],
	"./pages/people-refactor/onboard/components/priorPayroll/common/priorPayrollEnums": [
		3663,
		9,
		2470
	],
	"./pages/people-refactor/onboard/components/priorPayroll/common/priorPayrollEnums.ts": [
		3663,
		9,
		2470
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/PPradioCheck": [
		1747,
		9,
		1673
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/PPradioCheck.tsx": [
		1747,
		9,
		1673
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/countryTabSelect": [
		1746,
		9,
		968
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/countryTabSelect.tsx": [
		1746,
		9,
		968
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/customizePP": [
		1753,
		9,
		1187
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/customizePP.tsx": [
		1753,
		9,
		1187
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable": [
		751,
		9,
		57,
		246
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/": [
		751,
		9,
		57,
		246
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/PPAddSection": [
		1750,
		9,
		1406
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/PPAddSection.tsx": [
		1750,
		9,
		1406
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/columnSettings": [
		1752,
		9,
		611
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/columnSettings.tsx": [
		1752,
		9,
		611
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/deletePPModal": [
		1749,
		9,
		2471
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/deletePPModal.tsx": [
		1749,
		9,
		2471
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/index": [
		751,
		9,
		57,
		246
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/index.tsx": [
		751,
		9,
		57,
		246
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/pensionableEarnings": [
		1751,
		9,
		626
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/pensionableEarnings.tsx": [
		1751,
		9,
		626
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/ppReadOnlyInput": [
		1610,
		9,
		1698
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/ppReadOnlyInput.tsx": [
		1610,
		9,
		1698
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/useInputFields": [
		1329,
		9,
		71
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/priorPayrollTable/useInputFields.tsx": [
		1329,
		9,
		71
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/rehireStatement": [
		1758,
		9,
		1699
	],
	"./pages/people-refactor/onboard/components/priorPayroll/components/rehireStatement.tsx": [
		1758,
		9,
		1699
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useAutoCalExemptions": [
		1231,
		9,
		71
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useAutoCalExemptions.tsx": [
		1231,
		9,
		71
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useAutoCalcLoader": [
		3664,
		9,
		2472
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useAutoCalcLoader.tsx": [
		3664,
		9,
		2472
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useCalcEICPP": [
		1651,
		9,
		71
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useCalcEICPP.tsx": [
		1651,
		9,
		71
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useCalcTotal": [
		1564,
		9,
		2473
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useCalcTotal.tsx": [
		1564,
		9,
		2473
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useFormatPriorPayrollData": [
		1527,
		9,
		2474
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useFormatPriorPayrollData.tsx": [
		1527,
		9,
		2474
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useGetCurrentStateId": [
		1224,
		9,
		2475
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useGetCurrentStateId.tsx": [
		1224,
		9,
		2475
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useGetNotApplicableTaxes": [
		3665,
		9,
		2476
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useGetNotApplicableTaxes.ts": [
		3665,
		9,
		2476
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useInvokeService": [
		1754,
		9,
		1700
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useInvokeService.tsx": [
		1754,
		9,
		1700
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useIsPPAutoCalcInProgress": [
		1562,
		9,
		2477
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useIsPPAutoCalcInProgress.tsx": [
		1562,
		9,
		2477
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useMaxContributionReached": [
		1652,
		9,
		71
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useMaxContributionReached.tsx": [
		1652,
		9,
		71
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useNewValidatePriorpayroll": [
		1756,
		9,
		1058
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useNewValidatePriorpayroll.tsx": [
		1756,
		9,
		1058
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/usePPValidationSnack": [
		1757,
		9,
		2478
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/usePPValidationSnack.tsx": [
		1757,
		9,
		2478
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/usePopulateTableData": [
		1748,
		9,
		2479
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/usePopulateTableData.tsx": [
		1748,
		9,
		2479
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/usePriorTableDataGetter": [
		1184,
		9,
		1393
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/usePriorTableDataGetter.tsx": [
		1184,
		9,
		1393
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useRehireEmployeeRestrict": [
		1143,
		9,
		2480
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useRehireEmployeeRestrict.tsx": [
		1143,
		9,
		2480
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useStateWiseLogic": [
		1608,
		9,
		1674
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useStateWiseLogic.tsx": [
		1608,
		9,
		1674
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useToggleAddOption": [
		1451,
		9,
		2481
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useToggleAddOption.tsx": [
		1451,
		9,
		2481
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useUpdateFieldLoader": [
		1412,
		9,
		2482
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useUpdateFieldLoader.tsx": [
		1412,
		9,
		2482
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useValidatePriorPayrollTable": [
		1755,
		9,
		1193
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useValidatePriorPayrollTable.tsx": [
		1755,
		9,
		1193
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useWagesBenefitsData": [
		1678,
		9,
		1394
	],
	"./pages/people-refactor/onboard/components/priorPayroll/hooks/useWagesBenefitsData.tsx": [
		1678,
		9,
		1394
	],
	"./pages/people-refactor/onboard/components/priorPayroll/index": [
		745,
		9,
		57,
		80,
		247
	],
	"./pages/people-refactor/onboard/components/priorPayroll/index.tsx": [
		745,
		9,
		57,
		80,
		247
	],
	"./pages/people-refactor/onboard/components/taxInfo": [
		742,
		9,
		1,
		152
	],
	"./pages/people-refactor/onboard/components/taxInfo/": [
		742,
		9,
		1,
		152
	],
	"./pages/people-refactor/onboard/components/taxInfo/additionalTaxes": [
		1399,
		9,
		1702
	],
	"./pages/people-refactor/onboard/components/taxInfo/additionalTaxes.tsx": [
		1399,
		9,
		1702
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/controlledFormRadio": [
		1611,
		9,
		2483
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/controlledFormRadio.tsx": [
		1611,
		9,
		2483
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/controlledSwitch": [
		1613,
		9,
		2484
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/controlledSwitch.tsx": [
		1613,
		9,
		2484
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/hooks": [
		1400,
		9,
		2485
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/hooks.tsx": [
		1400,
		9,
		2485
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/nonNegativeNumberField": [
		1529,
		9,
		2486
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/nonNegativeNumberField.tsx": [
		1529,
		9,
		2486
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/taxSettingsName": [
		1185,
		9,
		2487
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/taxSettingsName.ts": [
		1185,
		9,
		2487
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/useSafetyHooks": [
		1425,
		9,
		2488
	],
	"./pages/people-refactor/onboard/components/taxInfo/common/useSafetyHooks.ts": [
		1425,
		9,
		2488
	],
	"./pages/people-refactor/onboard/components/taxInfo/federalTaxation": [
		1685,
		9,
		820
	],
	"./pages/people-refactor/onboard/components/taxInfo/federalTaxation.tsx": [
		1685,
		9,
		820
	],
	"./pages/people-refactor/onboard/components/taxInfo/index": [
		742,
		9,
		1,
		152
	],
	"./pages/people-refactor/onboard/components/taxInfo/index.tsx": [
		742,
		9,
		1,
		152
	],
	"./pages/people-refactor/onboard/components/taxInfo/provinceOfEmployment": [
		1686,
		9,
		1066
	],
	"./pages/people-refactor/onboard/components/taxInfo/provinceOfEmployment.tsx": [
		1686,
		9,
		1066
	],
	"./pages/people-refactor/onboard/components/taxInfo/provincialTaxation": [
		1684,
		9,
		775
	],
	"./pages/people-refactor/onboard/components/taxInfo/provincialTaxation.tsx": [
		1684,
		9,
		775
	],
	"./pages/people-refactor/onboard/components/taxInfo/reachedContributionsStatement": [
		1683,
		9,
		1,
		1407
	],
	"./pages/people-refactor/onboard/components/taxInfo/reachedContributionsStatement.tsx": [
		1683,
		9,
		1,
		1407
	],
	"./pages/people-refactor/onboard/components/taxInfo/readonlyProvinceOfEmployment": [
		1614,
		9,
		2489
	],
	"./pages/people-refactor/onboard/components/taxInfo/readonlyProvinceOfEmployment.tsx": [
		1614,
		9,
		2489
	],
	"./pages/people-refactor/onboard/components/taxInfo/serviceHandlers": [
		740,
		9,
		297
	],
	"./pages/people-refactor/onboard/components/taxInfo/serviceHandlers/": [
		740,
		9,
		297
	],
	"./pages/people-refactor/onboard/components/taxInfo/serviceHandlers/index": [
		740,
		9,
		297
	],
	"./pages/people-refactor/onboard/components/taxInfo/serviceHandlers/index.tsx": [
		740,
		9,
		297
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxHelper": [
		1257,
		9,
		1410
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxHelper.tsx": [
		1257,
		9,
		1410
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxInfoSchema": [
		1679,
		9,
		1408
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxInfoSchema.tsx": [
		1679,
		9,
		1408
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxInfoStyles": [
		1612,
		9,
		2490
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxInfoStyles.ts": [
		1612,
		9,
		2490
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxInformationFTUValidationSchema": [
		1687,
		9,
		1409
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxInformationFTUValidationSchema.tsx": [
		1687,
		9,
		1409
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxInformationalLink": [
		1353,
		9,
		2491
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxInformationalLink.tsx": [
		1353,
		9,
		2491
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxSettings": [
		1682,
		9,
		970
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxSettings.tsx": [
		1682,
		9,
		970
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxationScheme": [
		1681,
		9,
		1065
	],
	"./pages/people-refactor/onboard/components/taxInfo/taxationScheme.tsx": [
		1681,
		9,
		1065
	],
	"./pages/people-refactor/onboard/components/taxInfo/utils/combineTaxSettings": [
		1680,
		9,
		2492
	],
	"./pages/people-refactor/onboard/components/taxInfo/utils/combineTaxSettings.ts": [
		1680,
		9,
		2492
	],
	"./pages/people-refactor/onboard/components/taxInfo/utils/getFederalProvincialToggleValue": [
		1309,
		9,
		2493
	],
	"./pages/people-refactor/onboard/components/taxInfo/utils/getFederalProvincialToggleValue.ts": [
		1309,
		9,
		2493
	],
	"./pages/people-refactor/onboard/constants/routes.constants": [
		2579,
		9,
		2494
	],
	"./pages/people-refactor/onboard/constants/routes.constants.ts": [
		2579,
		9,
		2494
	],
	"./pages/people-refactor/onboard/hooks": [
		717,
		9,
		298
	],
	"./pages/people-refactor/onboard/hooks/": [
		717,
		9,
		298
	],
	"./pages/people-refactor/onboard/hooks/index": [
		717,
		9,
		298
	],
	"./pages/people-refactor/onboard/hooks/index.tsx": [
		717,
		9,
		298
	],
	"./pages/people-refactor/onboard/hooks/usePopulateSelfOnboardingData": [
		1866,
		9,
		1667
	],
	"./pages/people-refactor/onboard/hooks/usePopulateSelfOnboardingData.tsx": [
		1866,
		9,
		1667
	],
	"./pages/people-refactor/onboard/index": [
		851,
		9,
		1,
		3,
		17,
		19,
		140
	],
	"./pages/people-refactor/onboard/index.tsx": [
		851,
		9,
		1,
		3,
		17,
		19,
		140
	],
	"./pages/people-refactor/onboard/onboardStyles": [
		2177,
		9,
		2495
	],
	"./pages/people-refactor/onboard/onboardStyles.ts": [
		2177,
		9,
		2495
	],
	"./pages/people-refactor/page-change-return-date/breadcrumbs/breadcrumbs": [
		3162,
		9,
		2496
	],
	"./pages/people-refactor/page-change-return-date/breadcrumbs/breadcrumbs.tsx": [
		3162,
		9,
		2496
	],
	"./pages/people-refactor/page-change-return-date/pageChangeReturnDate": [
		2967,
		9,
		702
	],
	"./pages/people-refactor/page-change-return-date/pageChangeReturnDate.tsx": [
		2967,
		9,
		702
	],
	"./pages/people-refactor/page-change-return-date/statement/changeReturnDate": [
		3163,
		9,
		2497
	],
	"./pages/people-refactor/page-change-return-date/statement/changeReturnDate.tsx": [
		3163,
		9,
		2497
	],
	"./pages/people-refactor/page-change-status/pageChangeStatus": [
		2968,
		9,
		41,
		58,
		971
	],
	"./pages/people-refactor/page-change-status/pageChangeStatus.tsx": [
		2968,
		9,
		41,
		58,
		971
	],
	"./pages/people-refactor/peopleContainer": [
		854,
		9,
		1,
		3,
		17,
		19,
		118
	],
	"./pages/people-refactor/peopleContainer/": [
		854,
		9,
		1,
		3,
		17,
		19,
		118
	],
	"./pages/people-refactor/peopleContainer/index": [
		854,
		9,
		1,
		3,
		17,
		19,
		118
	],
	"./pages/people-refactor/peopleContainer/index.tsx": [
		854,
		9,
		1,
		3,
		17,
		19,
		118
	],
	"./pages/people-refactor/peopleContainer/people-container-styles": [
		3454,
		9,
		2498
	],
	"./pages/people-refactor/peopleContainer/people-container-styles.ts": [
		3454,
		9,
		2498
	],
	"./pages/people-refactor/peopleDefinition": [
		443,
		9
	],
	"./pages/people-refactor/peopleDefinition.ts": [
		443,
		9
	],
	"./pages/people-refactor/peopleView": [
		815,
		9,
		1,
		3,
		17,
		19,
		138
	],
	"./pages/people-refactor/peopleView/": [
		815,
		9,
		1,
		3,
		17,
		19,
		138
	],
	"./pages/people-refactor/peopleView/components/onBoardSideBar": [
		2952,
		9,
		81,
		238
	],
	"./pages/people-refactor/peopleView/components/onBoardSideBar.tsx": [
		2952,
		9,
		81,
		238
	],
	"./pages/people-refactor/peopleView/index": [
		815,
		9,
		1,
		3,
		17,
		19,
		138
	],
	"./pages/people-refactor/peopleView/index.tsx": [
		815,
		9,
		1,
		3,
		17,
		19,
		138
	],
	"./pages/people-refactor/peopleView/onboard.grid": [
		2969,
		9,
		2,
		76,
		470
	],
	"./pages/people-refactor/peopleView/onboard.grid.tsx": [
		2969,
		9,
		2,
		76,
		470
	],
	"./pages/people-refactor/peopleView/onboard.view": [
		2970,
		9,
		1,
		3,
		17,
		19,
		389
	],
	"./pages/people-refactor/peopleView/onboard.view.tsx": [
		2970,
		9,
		1,
		3,
		17,
		19,
		389
	],
	"./pages/people-refactor/peopleView/onboardingLayoutStyles": [
		2582,
		9,
		1703
	],
	"./pages/people-refactor/peopleView/onboardingLayoutStyles.tsx": [
		2582,
		9,
		1703
	],
	"./pages/people-refactor/peopleView/people-view-styles": [
		2273,
		9,
		2499
	],
	"./pages/people-refactor/peopleView/people-view-styles.ts": [
		2273,
		9,
		2499
	],
	"./pages/people-refactor/peopleView/profile.view": [
		2468,
		9,
		1,
		3,
		17,
		19,
		388
	],
	"./pages/people-refactor/peopleView/profile.view.tsx": [
		2468,
		9,
		1,
		3,
		17,
		19,
		388
	],
	"./pages/people-refactor/permissionHooks/useViewPeoplePermission": [
		3453,
		9,
		2500
	],
	"./pages/people-refactor/permissionHooks/useViewPeoplePermission.tsx": [
		3453,
		9,
		2500
	],
	"./pages/people-refactor/person-dropdown/change-status-to-active/changeStatusToActive": [
		1830,
		9,
		41,
		58,
		1411
	],
	"./pages/people-refactor/person-dropdown/change-status-to-active/changeStatusToActive.tsx": [
		1830,
		9,
		41,
		58,
		1411
	],
	"./pages/people-refactor/person-dropdown/invite-person/invitePersonModalWrapper": [
		1842,
		9,
		1689
	],
	"./pages/people-refactor/person-dropdown/invite-person/invitePersonModalWrapper.tsx": [
		1842,
		9,
		1689
	],
	"./pages/people-refactor/person-dropdown/loader/loader": [
		1825,
		9,
		1412
	],
	"./pages/people-refactor/person-dropdown/loader/loader.tsx": [
		1825,
		9,
		1412
	],
	"./pages/people-refactor/person-dropdown/loader/loaderStyles": [
		1770,
		9,
		2501
	],
	"./pages/people-refactor/person-dropdown/loader/loaderStyles.ts": [
		1770,
		9,
		2501
	],
	"./pages/people-refactor/person-dropdown/options": [
		1616,
		9,
		950
	],
	"./pages/people-refactor/person-dropdown/options.tsx": [
		1616,
		9,
		950
	],
	"./pages/people-refactor/person-dropdown/personDropdown": [
		1768,
		9,
		41,
		58,
		105,
		1432
	],
	"./pages/people-refactor/person-dropdown/personDropdown.tsx": [
		1768,
		9,
		41,
		58,
		105,
		1432
	],
	"./pages/people-refactor/person-dropdown/queries/queryKeys": [
		1773,
		9,
		2502
	],
	"./pages/people-refactor/person-dropdown/queries/queryKeys.ts": [
		1773,
		9,
		2502
	],
	"./pages/people-refactor/person-dropdown/queries/useGetOnboardDetails": [
		1841,
		9,
		1413
	],
	"./pages/people-refactor/person-dropdown/queries/useGetOnboardDetails.ts": [
		1841,
		9,
		1413
	],
	"./pages/people-refactor/person-dropdown/remove-person/removePerson": [
		1827,
		9,
		1684
	],
	"./pages/people-refactor/person-dropdown/remove-person/removePerson.tsx": [
		1827,
		9,
		1684
	],
	"./pages/people-refactor/person-dropdown/useOptionPermissions": [
		1769,
		9,
		1704
	],
	"./pages/people-refactor/person-dropdown/useOptionPermissions.ts": [
		1769,
		9,
		1704
	],
	"./pages/people-refactor/person-dropdown/usePersonDisable": [
		1828,
		9,
		1206
	],
	"./pages/people-refactor/person-dropdown/usePersonDisable.ts": [
		1828,
		9,
		1206
	],
	"./pages/people-refactor/person-dropdown/usePersonInvite": [
		1829,
		9,
		2503
	],
	"./pages/people-refactor/person-dropdown/usePersonInvite.ts": [
		1829,
		9,
		2503
	],
	"./pages/people-refactor/person-dropdown/usePersonTaxSettings": [
		1826,
		9,
		2504
	],
	"./pages/people-refactor/person-dropdown/usePersonTaxSettings.ts": [
		1826,
		9,
		2504
	],
	"./pages/people-refactor/poe": [
		831,
		9,
		42,
		78,
		153
	],
	"./pages/people-refactor/poe/": [
		831,
		9,
		42,
		78,
		153
	],
	"./pages/people-refactor/poe/components/poeFooter": [
		2864,
		9,
		2505
	],
	"./pages/people-refactor/poe/components/poeFooter.tsx": [
		2864,
		9,
		2505
	],
	"./pages/people-refactor/poe/components/poeSideBar": [
		3164,
		9,
		963
	],
	"./pages/people-refactor/poe/components/poeSideBar.tsx": [
		3164,
		9,
		963
	],
	"./pages/people-refactor/poe/hooks/keys": [
		2659,
		9,
		2506
	],
	"./pages/people-refactor/poe/hooks/keys.ts": [
		2659,
		9,
		2506
	],
	"./pages/people-refactor/poe/hooks/useGetPersonJobList": [
		3455,
		9,
		1705
	],
	"./pages/people-refactor/poe/hooks/useGetPersonJobList.ts": [
		3455,
		9,
		1705
	],
	"./pages/people-refactor/poe/hooks/useGetStateWage": [
		3456,
		9,
		1706
	],
	"./pages/people-refactor/poe/hooks/useGetStateWage.ts": [
		3456,
		9,
		1706
	],
	"./pages/people-refactor/poe/hooks/useGetWcbRateList": [
		3457,
		9,
		1414
	],
	"./pages/people-refactor/poe/hooks/useGetWcbRateList.ts": [
		3457,
		9,
		1414
	],
	"./pages/people-refactor/poe/index": [
		831,
		9,
		42,
		78,
		153
	],
	"./pages/people-refactor/poe/index.tsx": [
		831,
		9,
		42,
		78,
		153
	],
	"./pages/people-refactor/poe/pages/additionalTaxes": [
		3167,
		9,
		1707
	],
	"./pages/people-refactor/poe/pages/additionalTaxes.tsx": [
		3167,
		9,
		1707
	],
	"./pages/people-refactor/poe/pages/basicInfo": [
		3458,
		9,
		748
	],
	"./pages/people-refactor/poe/pages/basicInfo.tsx": [
		3458,
		9,
		748
	],
	"./pages/people-refactor/poe/pages/finalReview": [
		3460,
		9,
		739
	],
	"./pages/people-refactor/poe/pages/finalReview.tsx": [
		3460,
		9,
		739
	],
	"./pages/people-refactor/poe/pages/job-details/jobDetails": [
		3270,
		9,
		42,
		115
	],
	"./pages/people-refactor/poe/pages/job-details/jobDetails.tsx": [
		3270,
		9,
		42,
		115
	],
	"./pages/people-refactor/poe/pages/job-details/jobDetailsStyles": [
		3666,
		9,
		2507
	],
	"./pages/people-refactor/poe/pages/job-details/jobDetailsStyles.tsx": [
		3666,
		9,
		2507
	],
	"./pages/people-refactor/poe/pages/job-details/locationCard": [
		3526,
		9,
		42,
		115
	],
	"./pages/people-refactor/poe/pages/job-details/locationCard.tsx": [
		3526,
		9,
		42,
		115
	],
	"./pages/people-refactor/poe/pages/job-details/vacationCard": [
		3527,
		9,
		42,
		115
	],
	"./pages/people-refactor/poe/pages/job-details/vacationCard.tsx": [
		3527,
		9,
		42,
		115
	],
	"./pages/people-refactor/poe/pages/taxInfoForm": [
		3459,
		9,
		910
	],
	"./pages/people-refactor/poe/pages/taxInfoForm.tsx": [
		3459,
		9,
		910
	],
	"./pages/people-refactor/poe/poe.view": [
		3166,
		9,
		42,
		78,
		481
	],
	"./pages/people-refactor/poe/poe.view.tsx": [
		3166,
		9,
		42,
		78,
		481
	],
	"./pages/people-refactor/poe/poeLayout": [
		3269,
		9,
		42,
		78,
		494
	],
	"./pages/people-refactor/poe/poeLayout.tsx": [
		3269,
		9,
		42,
		78,
		494
	],
	"./pages/people-refactor/profile": [
		776,
		9,
		1,
		3,
		17,
		19,
		139
	],
	"./pages/people-refactor/profile/": [
		776,
		9,
		1,
		3,
		17,
		19,
		139
	],
	"./pages/people-refactor/profile/Common/NoContent/NoContent": [
		1649,
		9,
		1708
	],
	"./pages/people-refactor/profile/Common/NoContent/NoContent.tsx": [
		1649,
		9,
		1708
	],
	"./pages/people-refactor/profile/Common/NoContent/NoContentStyles": [
		1822,
		9,
		2508
	],
	"./pages/people-refactor/profile/Common/NoContent/NoContentStyles.ts": [
		1822,
		9,
		2508
	],
	"./pages/people-refactor/profile/Edit/Idb": [
		765,
		9,
		17,
		29,
		60,
		87,
		243
	],
	"./pages/people-refactor/profile/Edit/Idb/": [
		765,
		9,
		17,
		29,
		60,
		87,
		243
	],
	"./pages/people-refactor/profile/Edit/Idb/index": [
		765,
		9,
		17,
		29,
		60,
		87,
		243
	],
	"./pages/people-refactor/profile/Edit/Idb/index.tsx": [
		765,
		9,
		17,
		29,
		60,
		87,
		243
	],
	"./pages/people-refactor/profile/Edit/JobDetails": [
		763,
		9,
		59,
		73,
		61,
		86,
		229
	],
	"./pages/people-refactor/profile/Edit/JobDetails/": [
		763,
		9,
		59,
		73,
		61,
		86,
		229
	],
	"./pages/people-refactor/profile/Edit/JobDetails/index": [
		763,
		9,
		59,
		73,
		61,
		86,
		229
	],
	"./pages/people-refactor/profile/Edit/JobDetails/index.tsx": [
		763,
		9,
		59,
		73,
		61,
		86,
		229
	],
	"./pages/people-refactor/profile/Edit/PriorPayrollNew": [
		764,
		9,
		57,
		80,
		230
	],
	"./pages/people-refactor/profile/Edit/PriorPayrollNew/": [
		764,
		9,
		57,
		80,
		230
	],
	"./pages/people-refactor/profile/Edit/PriorPayrollNew/index": [
		764,
		9,
		57,
		80,
		230
	],
	"./pages/people-refactor/profile/Edit/PriorPayrollNew/index.tsx": [
		764,
		9,
		57,
		80,
		230
	],
	"./pages/people-refactor/profile/Edit/Profile": [
		762,
		9,
		3,
		19,
		27,
		45,
		149
	],
	"./pages/people-refactor/profile/Edit/Profile/": [
		762,
		9,
		3,
		19,
		27,
		45,
		149
	],
	"./pages/people-refactor/profile/Edit/Profile/index": [
		762,
		9,
		3,
		19,
		27,
		45,
		149
	],
	"./pages/people-refactor/profile/Edit/Profile/index.tsx": [
		762,
		9,
		3,
		19,
		27,
		45,
		149
	],
	"./pages/people-refactor/profile/Edit/Tax/Tax": [
		2116,
		9,
		1,
		456
	],
	"./pages/people-refactor/profile/Edit/Tax/Tax.tsx": [
		2116,
		9,
		1,
		456
	],
	"./pages/people-refactor/profile/ServiceWrappers/idbWrapper": [
		2113,
		9,
		902
	],
	"./pages/people-refactor/profile/ServiceWrappers/idbWrapper.tsx": [
		2113,
		9,
		902
	],
	"./pages/people-refactor/profile/ServiceWrappers/jobDetailsWrapper": [
		2111,
		9,
		903
	],
	"./pages/people-refactor/profile/ServiceWrappers/jobDetailsWrapper.tsx": [
		2111,
		9,
		903
	],
	"./pages/people-refactor/profile/ServiceWrappers/priorPayrollViewWrapper": [
		2110,
		9,
		1056
	],
	"./pages/people-refactor/profile/ServiceWrappers/priorPayrollViewWrapper.tsx": [
		2110,
		9,
		1056
	],
	"./pages/people-refactor/profile/ServiceWrappers/profileWrapper": [
		2109,
		9,
		904
	],
	"./pages/people-refactor/profile/ServiceWrappers/profileWrapper.tsx": [
		2109,
		9,
		904
	],
	"./pages/people-refactor/profile/ServiceWrappers/taxInfoWrapper": [
		2112,
		9,
		773
	],
	"./pages/people-refactor/profile/ServiceWrappers/taxInfoWrapper.tsx": [
		2112,
		9,
		773
	],
	"./pages/people-refactor/profile/View/components/JobDetails/BasicDetails/BasicDetails": [
		1985,
		9,
		1671
	],
	"./pages/people-refactor/profile/View/components/JobDetails/BasicDetails/BasicDetails.tsx": [
		1985,
		9,
		1671
	],
	"./pages/people-refactor/profile/View/components/JobDetails/JobDetails": [
		2106,
		9,
		705
	],
	"./pages/people-refactor/profile/View/components/JobDetails/JobDetails.tsx": [
		2106,
		9,
		705
	],
	"./pages/people-refactor/profile/View/components/JobDetails/Jobs/JobBox/JobBox": [
		1895,
		9,
		899
	],
	"./pages/people-refactor/profile/View/components/JobDetails/Jobs/JobBox/JobBox.tsx": [
		1895,
		9,
		899
	],
	"./pages/people-refactor/profile/View/components/JobDetails/Jobs/JobBox/JobBoxStyles": [
		1820,
		9,
		2509
	],
	"./pages/people-refactor/profile/View/components/JobDetails/Jobs/JobBox/JobBoxStyles.ts": [
		1820,
		9,
		2509
	],
	"./pages/people-refactor/profile/View/components/JobDetails/Jobs/JobBox/useJobBoxFunctions": [
		1821,
		9,
		1415
	],
	"./pages/people-refactor/profile/View/components/JobDetails/Jobs/JobBox/useJobBoxFunctions.tsx": [
		1821,
		9,
		1415
	],
	"./pages/people-refactor/profile/View/components/JobDetails/Jobs/Jobs": [
		1984,
		9,
		816
	],
	"./pages/people-refactor/profile/View/components/JobDetails/Jobs/Jobs.tsx": [
		1984,
		9,
		816
	],
	"./pages/people-refactor/profile/View/components/PeopleTax/peopleTax": [
		2117,
		9,
		1416
	],
	"./pages/people-refactor/profile/View/components/PeopleTax/peopleTax.tsx": [
		2117,
		9,
		1416
	],
	"./pages/people-refactor/profile/View/components/PeopleTax/peopleTaxStyles": [
		1996,
		9,
		2510
	],
	"./pages/people-refactor/profile/View/components/PeopleTax/peopleTaxStyles.ts": [
		1996,
		9,
		2510
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/PriorPayrollsStyles": [
		1986,
		9,
		2511
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/PriorPayrollsStyles.ts": [
		1986,
		9,
		2511
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/country-tab-select/countryTabSelect": [
		1988,
		9,
		1709
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/country-tab-select/countryTabSelect.tsx": [
		1988,
		9,
		1709
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/country-tab-select/countryTabSelectStyles": [
		1898,
		9,
		2512
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/country-tab-select/countryTabSelectStyles.ts": [
		1898,
		9,
		2512
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/prior-payroll-table/priorPayrollTables": [
		1987,
		9,
		898
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/prior-payroll-table/priorPayrollTables.tsx": [
		1987,
		9,
		898
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/prior-payroll-table/priorPayrollTablesStyles": [
		1896,
		9,
		2513
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/prior-payroll-table/priorPayrollTablesStyles.ts": [
		1896,
		9,
		2513
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/prior-payroll-table/usePriorTableColumnSettings": [
		1897,
		9,
		1675
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/prior-payroll-table/usePriorTableColumnSettings.tsx": [
		1897,
		9,
		1675
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/priorPayrollNew": [
		2107,
		9,
		685
	],
	"./pages/people-refactor/profile/View/components/PriorPayrolls/priorPayrollNew.tsx": [
		2107,
		9,
		685
	],
	"./pages/people-refactor/profile/View/components/Profile/Profile": [
		2114,
		9,
		171,
		716
	],
	"./pages/people-refactor/profile/View/components/Profile/Profile.tsx": [
		2114,
		9,
		171,
		716
	],
	"./pages/people-refactor/profile/View/components/Profile/components/disableBankPopup": [
		1989,
		9,
		2514
	],
	"./pages/people-refactor/profile/View/components/Profile/components/disableBankPopup.tsx": [
		1989,
		9,
		2514
	],
	"./pages/people-refactor/profile/View/components/Profile/components/profileBankInfoCard": [
		2055,
		9,
		171,
		2887
	],
	"./pages/people-refactor/profile/View/components/Profile/components/profileBankInfoCard.tsx": [
		2055,
		9,
		171,
		2887
	],
	"./pages/people-refactor/profile/View/components/Profile/components/profileCardLayout": [
		1583,
		9,
		2515
	],
	"./pages/people-refactor/profile/View/components/Profile/components/profileCardLayout.tsx": [
		1583,
		9,
		2515
	],
	"./pages/people-refactor/profile/View/components/Profile/components/profileContentGenerator": [
		1584,
		9,
		1710
	],
	"./pages/people-refactor/profile/View/components/Profile/components/profileContentGenerator.tsx": [
		1584,
		9,
		1710
	],
	"./pages/people-refactor/profile/View/components/Profile/components/profileEmergencyCard": [
		1990,
		9,
		972
	],
	"./pages/people-refactor/profile/View/components/Profile/components/profileEmergencyCard.tsx": [
		1990,
		9,
		972
	],
	"./pages/people-refactor/profile/View/components/Profile/components/profileUserInfoCard": [
		1991,
		9,
		839
	],
	"./pages/people-refactor/profile/View/components/Profile/components/profileUserInfoCard.tsx": [
		1991,
		9,
		839
	],
	"./pages/people-refactor/profile/View/components/Profile/components/progressPrompt": [
		1675,
		9,
		1391
	],
	"./pages/people-refactor/profile/View/components/Profile/components/progressPrompt.tsx": [
		1675,
		9,
		1391
	],
	"./pages/people-refactor/profile/View/components/Profile/hooks": [
		713,
		9,
		316
	],
	"./pages/people-refactor/profile/View/components/Profile/hooks/": [
		713,
		9,
		316
	],
	"./pages/people-refactor/profile/View/components/Profile/hooks/index": [
		713,
		9,
		316
	],
	"./pages/people-refactor/profile/View/components/Profile/hooks/index.tsx": [
		713,
		9,
		316
	],
	"./pages/people-refactor/profile/View/components/Tax/Tax": [
		2115,
		9,
		573
	],
	"./pages/people-refactor/profile/View/components/Tax/Tax.tsx": [
		2115,
		9,
		573
	],
	"./pages/people-refactor/profile/View/components/Tax/federal-tax/federalTax": [
		1994,
		9,
		973
	],
	"./pages/people-refactor/profile/View/components/Tax/federal-tax/federalTax.tsx": [
		1994,
		9,
		973
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-list-header/incomeTaxListHeader": [
		1900,
		9,
		1711
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-list-header/incomeTaxListHeader.tsx": [
		1900,
		9,
		1711
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-list-header/incomeTaxListHeaderStyle": [
		1823,
		9,
		2516
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-list-header/incomeTaxListHeaderStyle.ts": [
		1823,
		9,
		2516
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-list/incomeTaxList": [
		1901,
		9,
		1417
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-list/incomeTaxList.tsx": [
		1901,
		9,
		1417
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-list/incomeTaxListItem": [
		1824,
		9,
		1712
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-list/incomeTaxListItem.tsx": [
		1824,
		9,
		1712
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-list/incomeTaxListStyles": [
		1759,
		9,
		2517
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-list/incomeTaxListStyles.ts": [
		1759,
		9,
		2517
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-settings/incomeTaxSettings": [
		1993,
		9,
		911
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-settings/incomeTaxSettings.tsx": [
		1993,
		9,
		911
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-settings/useTaxSettings": [
		1902,
		9,
		2518
	],
	"./pages/people-refactor/profile/View/components/Tax/income-tax-settings/useTaxSettings.ts": [
		1902,
		9,
		2518
	],
	"./pages/people-refactor/profile/View/components/Tax/province-of-employment/provinceHistory": [
		1899,
		9,
		2519
	],
	"./pages/people-refactor/profile/View/components/Tax/province-of-employment/provinceHistory.tsx": [
		1899,
		9,
		2519
	],
	"./pages/people-refactor/profile/View/components/Tax/province-of-employment/provinceOfEmployment": [
		1992,
		9,
		1713
	],
	"./pages/people-refactor/profile/View/components/Tax/province-of-employment/provinceOfEmployment.tsx": [
		1992,
		9,
		1713
	],
	"./pages/people-refactor/profile/View/components/Tax/provincial-tax/provincialTax": [
		1995,
		9,
		974
	],
	"./pages/people-refactor/profile/View/components/Tax/provincial-tax/provincialTax.tsx": [
		1995,
		9,
		974
	],
	"./pages/people-refactor/profile/View/components/Tax/tax-card-inner-info/taxCardInnerInfo": [
		1586,
		9,
		1714
	],
	"./pages/people-refactor/profile/View/components/Tax/tax-card-inner-info/taxCardInnerInfo.tsx": [
		1586,
		9,
		1714
	],
	"./pages/people-refactor/profile/View/components/Tax/text/innerCardText": [
		1760,
		9,
		2520
	],
	"./pages/people-refactor/profile/View/components/Tax/text/innerCardText.tsx": [
		1760,
		9,
		2520
	],
	"./pages/people-refactor/profile/View/components/Tax/text/subtitle": [
		1585,
		9,
		2521
	],
	"./pages/people-refactor/profile/View/components/Tax/text/subtitle.tsx": [
		1585,
		9,
		2521
	],
	"./pages/people-refactor/profile/View/components/common/useLockedPayment": [
		1165,
		9,
		1646
	],
	"./pages/people-refactor/profile/View/components/common/useLockedPayment.tsx": [
		1165,
		9,
		1646
	],
	"./pages/people-refactor/profile/View/components/common/viewHeading": [
		1327,
		9,
		1392
	],
	"./pages/people-refactor/profile/View/components/common/viewHeading.tsx": [
		1327,
		9,
		1392
	],
	"./pages/people-refactor/profile/View/components/salaryhistory": [
		2118,
		9,
		2522
	],
	"./pages/people-refactor/profile/View/components/salaryhistory.tsx": [
		2118,
		9,
		2522
	],
	"./pages/people-refactor/profile/View/definations": [
		3667,
		9,
		2523
	],
	"./pages/people-refactor/profile/View/definations.ts": [
		3667,
		9,
		2523
	],
	"./pages/people-refactor/profile/View/hooks": [
		731,
		9,
		299
	],
	"./pages/people-refactor/profile/View/hooks/": [
		731,
		9,
		299
	],
	"./pages/people-refactor/profile/View/hooks/index": [
		731,
		9,
		299
	],
	"./pages/people-refactor/profile/View/hooks/index.ts": [
		731,
		9,
		299
	],
	"./pages/people-refactor/profile/View/hooks/useTaxes": [
		1480,
		9,
		2524
	],
	"./pages/people-refactor/profile/View/hooks/useTaxes.ts": [
		1480,
		9,
		2524
	],
	"./pages/people-refactor/profile/View/personSummeryCard": [
		777,
		9,
		41,
		58,
		105,
		192
	],
	"./pages/people-refactor/profile/View/personSummeryCard/": [
		777,
		9,
		41,
		58,
		105,
		192
	],
	"./pages/people-refactor/profile/View/personSummeryCard/index": [
		777,
		9,
		41,
		58,
		105,
		192
	],
	"./pages/people-refactor/profile/View/personSummeryCard/index.tsx": [
		777,
		9,
		41,
		58,
		105,
		192
	],
	"./pages/people-refactor/profile/View/personSummeryCard/styles": [
		2119,
		9,
		2525
	],
	"./pages/people-refactor/profile/View/personSummeryCard/styles.ts": [
		2119,
		9,
		2525
	],
	"./pages/people-refactor/profile/definations": [
		3668,
		9,
		2526
	],
	"./pages/people-refactor/profile/definations.ts": [
		3668,
		9,
		2526
	],
	"./pages/people-refactor/profile/editFooter": [
		2108,
		9,
		1701
	],
	"./pages/people-refactor/profile/editFooter.tsx": [
		2108,
		9,
		1701
	],
	"./pages/people-refactor/profile/hooks/useEditPageLoading": [
		1794,
		9,
		2527
	],
	"./pages/people-refactor/profile/hooks/useEditPageLoading.tsx": [
		1794,
		9,
		2527
	],
	"./pages/people-refactor/profile/hooks/useInitServiceCalls": [
		1326,
		9,
		2528
	],
	"./pages/people-refactor/profile/hooks/useInitServiceCalls.tsx": [
		1326,
		9,
		2528
	],
	"./pages/people-refactor/profile/hooks/useIsEditPage": [
		1426,
		9,
		2529
	],
	"./pages/people-refactor/profile/hooks/useIsEditPage.tsx": [
		1426,
		9,
		2529
	],
	"./pages/people-refactor/profile/index": [
		776,
		9,
		1,
		3,
		17,
		19,
		139
	],
	"./pages/people-refactor/profile/index.tsx": [
		776,
		9,
		1,
		3,
		17,
		19,
		139
	],
	"./pages/people-refactor/profile/profile-links/profilelinks": [
		2275,
		9,
		1192
	],
	"./pages/people-refactor/profile/profile-links/profilelinks.tsx": [
		2275,
		9,
		1192
	],
	"./pages/people-refactor/routes": [
		1194,
		9,
		1340
	],
	"./pages/people-refactor/routes.ts": [
		1194,
		9,
		1340
	],
	"./pages/preferences/components/header/header": [
		3461,
		9,
		1418
	],
	"./pages/preferences/components/header/header.tsx": [
		3461,
		9,
		1418
	],
	"./pages/preferences/components/header/headerStyles": [
		3168,
		9,
		2530
	],
	"./pages/preferences/components/header/headerStyles.tsx": [
		3168,
		9,
		2530
	],
	"./pages/preferences/components/page-general/formGeneral": [
		3462,
		9,
		0,
		3,
		4,
		9,
		473
	],
	"./pages/preferences/components/page-general/formGeneral.tsx": [
		3462,
		9,
		0,
		3,
		4,
		9,
		473
	],
	"./pages/preferences/components/page-general/pageGeneral": [
		3169,
		9,
		0,
		3,
		4,
		493
	],
	"./pages/preferences/components/page-general/pageGeneral.tsx": [
		3169,
		9,
		0,
		3,
		4,
		493
	],
	"./pages/preferences/components/page-general/profile-details/profileDetails": [
		2865,
		9,
		3,
		687
	],
	"./pages/preferences/components/page-general/profile-details/profileDetails.tsx": [
		2865,
		9,
		3,
		687
	],
	"./pages/preferences/components/page-general/roles-and-permissions/rolesAndPermissons": [
		2866,
		9,
		0,
		4,
		821
	],
	"./pages/preferences/components/page-general/roles-and-permissions/rolesAndPermissons.tsx": [
		2866,
		9,
		0,
		4,
		821
	],
	"./pages/preferences/components/page-general/roles-and-permissions/rolesRows": [
		2587,
		9,
		2531
	],
	"./pages/preferences/components/page-general/roles-and-permissions/rolesRows.tsx": [
		2587,
		9,
		2531
	],
	"./pages/preferences/components/page-general/roles-and-permissions/styles": [
		2586,
		9,
		2532
	],
	"./pages/preferences/components/page-general/roles-and-permissions/styles.ts": [
		2586,
		9,
		2532
	],
	"./pages/preferences/components/page-general/useProfileDetails": [
		2583,
		9,
		1207
	],
	"./pages/preferences/components/page-general/useProfileDetails.tsx": [
		2583,
		9,
		1207
	],
	"./pages/preferences/components/page-notifications/birthday-processing-reminder/birthdayProcessingReminder": [
		3669,
		9,
		822
	],
	"./pages/preferences/components/page-notifications/birthday-processing-reminder/birthdayProcessingReminder.tsx": [
		3669,
		9,
		822
	],
	"./pages/preferences/components/page-notifications/formNotifications": [
		3463,
		9,
		0,
		4,
		9,
		515
	],
	"./pages/preferences/components/page-notifications/formNotifications.tsx": [
		3463,
		9,
		0,
		4,
		9,
		515
	],
	"./pages/preferences/components/page-notifications/pageNotifications": [
		3170,
		9,
		0,
		4,
		612
	],
	"./pages/preferences/components/page-notifications/pageNotifications.tsx": [
		3170,
		9,
		0,
		4,
		612
	],
	"./pages/preferences/components/page-notifications/password-update-reminder/passwordUpdateReminder": [
		3670,
		9,
		823
	],
	"./pages/preferences/components/page-notifications/password-update-reminder/passwordUpdateReminder.tsx": [
		3670,
		9,
		823
	],
	"./pages/preferences/components/page-notifications/payroll-processing-reminder/payrollProcessingReminder": [
		3671,
		9,
		824
	],
	"./pages/preferences/components/page-notifications/payroll-processing-reminder/payrollProcessingReminder.tsx": [
		3671,
		9,
		824
	],
	"./pages/preferences/components/page-notifications/preferred-email/preferredEmail": [
		2867,
		9,
		1715
	],
	"./pages/preferences/components/page-notifications/preferred-email/preferredEmail.tsx": [
		2867,
		9,
		1715
	],
	"./pages/preferences/components/page-notifications/work-anniversary-reminder/workAnniversaryReminder": [
		3672,
		9,
		825
	],
	"./pages/preferences/components/page-notifications/work-anniversary-reminder/workAnniversaryReminder.tsx": [
		3672,
		9,
		825
	],
	"./pages/preferences/components/page-security/email/action-update-email/actionUpdateEmail": [
		2590,
		9,
		740
	],
	"./pages/preferences/components/page-security/email/action-update-email/actionUpdateEmail.tsx": [
		2590,
		9,
		740
	],
	"./pages/preferences/components/page-security/email/action-update-email/actionUpdateEmailNew": [
		2591,
		9,
		975
	],
	"./pages/preferences/components/page-security/email/action-update-email/actionUpdateEmailNew.tsx": [
		2591,
		9,
		975
	],
	"./pages/preferences/components/page-security/email/email": [
		2868,
		9,
		574
	],
	"./pages/preferences/components/page-security/email/email.tsx": [
		2868,
		9,
		574
	],
	"./pages/preferences/components/page-security/formSecurity": [
		3464,
		9,
		0,
		13,
		21,
		36,
		414
	],
	"./pages/preferences/components/page-security/formSecurity.tsx": [
		3464,
		9,
		0,
		13,
		21,
		36,
		414
	],
	"./pages/preferences/components/page-security/login-security/action-update-password/actionUpdatePassword": [
		2593,
		9,
		36,
		597
	],
	"./pages/preferences/components/page-security/login-security/action-update-password/actionUpdatePassword.tsx": [
		2593,
		9,
		36,
		597
	],
	"./pages/preferences/components/page-security/login-security/action-update-password/actionUpdatePasswordStyles": [
		2338,
		9,
		2533
	],
	"./pages/preferences/components/page-security/login-security/action-update-password/actionUpdatePasswordStyles.ts": [
		2338,
		9,
		2533
	],
	"./pages/preferences/components/page-security/login-security/loginSecurity": [
		2869,
		9,
		36,
		575
	],
	"./pages/preferences/components/page-security/login-security/loginSecurity.tsx": [
		2869,
		9,
		36,
		575
	],
	"./pages/preferences/components/page-security/pageSecurity": [
		3171,
		9,
		0,
		13,
		21,
		36,
		416
	],
	"./pages/preferences/components/page-security/pageSecurity.tsx": [
		3171,
		9,
		0,
		13,
		21,
		36,
		416
	],
	"./pages/preferences/components/page-security/two-factor-old/action-disable-2fa/actionDisable2fa": [
		2595,
		9,
		1067
	],
	"./pages/preferences/components/page-security/two-factor-old/action-disable-2fa/actionDisable2fa.tsx": [
		2595,
		9,
		1067
	],
	"./pages/preferences/components/page-security/two-factor-old/action-update-2fa/actionUpdate2fa": [
		2594,
		9,
		0,
		13,
		21,
		36,
		499
	],
	"./pages/preferences/components/page-security/two-factor-old/action-update-2fa/actionUpdate2fa.tsx": [
		2594,
		9,
		0,
		13,
		21,
		36,
		499
	],
	"./pages/preferences/components/page-security/two-factor-old/action-update-2fa/phoneNotSent": [
		2340,
		9,
		0,
		13,
		36,
		928
	],
	"./pages/preferences/components/page-security/two-factor-old/action-update-2fa/phoneNotSent.tsx": [
		2340,
		9,
		0,
		13,
		36,
		928
	],
	"./pages/preferences/components/page-security/two-factor-old/action-update-2fa/phoneSent": [
		2341,
		9,
		0,
		13,
		36,
		840
	],
	"./pages/preferences/components/page-security/two-factor-old/action-update-2fa/phoneSent.tsx": [
		2341,
		9,
		0,
		13,
		36,
		840
	],
	"./pages/preferences/components/page-security/two-factor-old/action-update-2fa/useFormNotSent": [
		2343,
		9,
		1068
	],
	"./pages/preferences/components/page-security/two-factor-old/action-update-2fa/useFormNotSent.ts": [
		2343,
		9,
		1068
	],
	"./pages/preferences/components/page-security/two-factor-old/action-update-2fa/useFormSent": [
		2342,
		9,
		21,
		912
	],
	"./pages/preferences/components/page-security/two-factor-old/action-update-2fa/useFormSent.ts": [
		2342,
		9,
		21,
		912
	],
	"./pages/preferences/components/page-security/two-factor-old/enter-password-modal/enterPasswordModal": [
		2344,
		9,
		976
	],
	"./pages/preferences/components/page-security/two-factor-old/enter-password-modal/enterPasswordModal.tsx": [
		2344,
		9,
		976
	],
	"./pages/preferences/components/page-security/two-factor-old/enter-password-modal/schema/validationSchema": [
		2181,
		9,
		2534
	],
	"./pages/preferences/components/page-security/two-factor-old/enter-password-modal/schema/validationSchema.ts": [
		2181,
		9,
		2534
	],
	"./pages/preferences/components/page-security/two-factor-old/twoFactor": [
		2870,
		9,
		0,
		13,
		21,
		36,
		465
	],
	"./pages/preferences/components/page-security/two-factor-old/twoFactor.tsx": [
		2870,
		9,
		0,
		13,
		21,
		36,
		465
	],
	"./pages/preferences/components/page-security/two-factor-old/twoFactorStyles": [
		2345,
		9,
		2535
	],
	"./pages/preferences/components/page-security/two-factor-old/twoFactorStyles.ts": [
		2345,
		9,
		2535
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/TwoFaSettingsForm": [
		1436,
		9,
		0,
		13,
		188
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/TwoFaSettingsForm.tsx": [
		1436,
		9,
		0,
		13,
		188
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/TwoFaSettingsFormStyles": [
		1406,
		9,
		2536
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/TwoFaSettingsFormStyles.ts": [
		1406,
		9,
		2536
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/googleAuthenticator/codeInput": [
		1554,
		9,
		1208
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/googleAuthenticator/codeInput.tsx": [
		1554,
		9,
		1208
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/googleAuthenticator/nextStepQr": [
		1929,
		9,
		1069
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/googleAuthenticator/nextStepQr.tsx": [
		1929,
		9,
		1069
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/googleAuthenticator/qrCodeGenerator": [
		1860,
		9,
		1716
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/googleAuthenticator/qrCodeGenerator.tsx": [
		1860,
		9,
		1716
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/googleAuthenticator/verificationBlock": [
		1949,
		9,
		0,
		13,
		188
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/googleAuthenticator/verificationBlock.tsx": [
		1949,
		9,
		0,
		13,
		188
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/textMessage/phoneNumber": [
		1636,
		9,
		0,
		13,
		990
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/textMessage/phoneNumber.tsx": [
		1636,
		9,
		0,
		13,
		990
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/textMessage/phoneNumberSent": [
		1861,
		9,
		913
	],
	"./pages/preferences/components/page-security/two-factor/TwoFaSettingsForm/textMessage/phoneNumberSent.tsx": [
		1861,
		9,
		913
	],
	"./pages/preferences/components/page-security/two-factor/action-2fa-disabled/actionDisable2fa": [
		2602,
		9,
		1209
	],
	"./pages/preferences/components/page-security/two-factor/action-2fa-disabled/actionDisable2fa.tsx": [
		2602,
		9,
		1209
	],
	"./pages/preferences/components/page-security/two-factor/action-2fa-enabled/twoFaEnabled": [
		2601,
		9,
		0,
		13,
		518
	],
	"./pages/preferences/components/page-security/two-factor/action-2fa-enabled/twoFaEnabled.tsx": [
		2601,
		9,
		0,
		13,
		518
	],
	"./pages/preferences/components/page-security/two-factor/enter-password-modal/enterPasswordModal": [
		2597,
		9,
		0,
		13,
		519
	],
	"./pages/preferences/components/page-security/two-factor/enter-password-modal/enterPasswordModal.tsx": [
		2597,
		9,
		0,
		13,
		519
	],
	"./pages/preferences/components/page-security/two-factor/enter-password-modal/schema/validationSchema": [
		2346,
		9,
		2537
	],
	"./pages/preferences/components/page-security/two-factor/enter-password-modal/schema/validationSchema.ts": [
		2346,
		9,
		2537
	],
	"./pages/preferences/components/page-security/two-factor/twoFA-settings-modal/schema/validationSchema": [
		2349,
		9,
		2538
	],
	"./pages/preferences/components/page-security/two-factor/twoFA-settings-modal/schema/validationSchema.ts": [
		2349,
		9,
		2538
	],
	"./pages/preferences/components/page-security/two-factor/twoFA-settings-modal/twoFA-settings-modal": [
		2600,
		9,
		0,
		13,
		540
	],
	"./pages/preferences/components/page-security/two-factor/twoFA-settings-modal/twoFA-settings-modal.tsx": [
		2600,
		9,
		0,
		13,
		540
	],
	"./pages/preferences/components/page-security/two-factor/twoFactor": [
		2872,
		9,
		0,
		13,
		454
	],
	"./pages/preferences/components/page-security/two-factor/twoFactor.tsx": [
		2872,
		9,
		0,
		13,
		454
	],
	"./pages/preferences/components/page-security/two-factor/twoFactorModalEnum": [
		2598,
		9,
		2539
	],
	"./pages/preferences/components/page-security/two-factor/twoFactorModalEnum.ts": [
		2598,
		9,
		2539
	],
	"./pages/preferences/components/page-security/two-factor/update-phone-number-modal/schema/phoneNumberValidationSchema": [
		2347,
		9,
		2540
	],
	"./pages/preferences/components/page-security/two-factor/update-phone-number-modal/schema/phoneNumberValidationSchema.ts": [
		2347,
		9,
		2540
	],
	"./pages/preferences/components/page-security/two-factor/update-phone-number-modal/updatePhoneNumberModal": [
		2599,
		9,
		0,
		13,
		599
	],
	"./pages/preferences/components/page-security/two-factor/update-phone-number-modal/updatePhoneNumberModal.tsx": [
		2599,
		9,
		0,
		13,
		599
	],
	"./pages/preferences/components/page-security/two-factor/update-phonenumber-form/updatePhoneNumber": [
		2348,
		9,
		0,
		13,
		663
	],
	"./pages/preferences/components/page-security/two-factor/update-phonenumber-form/updatePhoneNumber.tsx": [
		2348,
		9,
		0,
		13,
		663
	],
	"./pages/preferences/components/page-security/useFormEmail": [
		2871,
		9,
		9,
		826
	],
	"./pages/preferences/components/page-security/useFormEmail.ts": [
		2871,
		9,
		9,
		826
	],
	"./pages/preferences/hooks/useFlaggedPhoneNumber": [
		1158,
		9,
		2541
	],
	"./pages/preferences/hooks/useFlaggedPhoneNumber.ts": [
		1158,
		9,
		2541
	],
	"./pages/preferences/hooks/usePreferences": [
		2042,
		9,
		9,
		977
	],
	"./pages/preferences/hooks/usePreferences.ts": [
		2042,
		9,
		9,
		977
	],
	"./pages/preferences/preferences": [
		2873,
		9,
		0,
		3,
		4,
		13,
		144
	],
	"./pages/preferences/preferences.tsx": [
		2873,
		9,
		0,
		3,
		4,
		13,
		144
	],
	"./pages/preferences/routes": [
		2200,
		9,
		2542
	],
	"./pages/preferences/routes.ts": [
		2200,
		9,
		2542
	],
	"./pages/secure-file-upload/constants/uploadQuery": [
		3466,
		9,
		1717
	],
	"./pages/secure-file-upload/constants/uploadQuery.ts": [
		3466,
		9,
		1717
	],
	"./pages/secure-file-upload/hooks/useUploadedFiles": [
		3467,
		9,
		1070
	],
	"./pages/secure-file-upload/hooks/useUploadedFiles.ts": [
		3467,
		9,
		1070
	],
	"./pages/secure-file-upload/secureFileUpload": [
		2874,
		9,
		3,
		261,
		231
	],
	"./pages/secure-file-upload/secureFileUpload.tsx": [
		2874,
		9,
		3,
		261,
		231
	],
	"./pages/secure-file-upload/secureFileUploadStyles": [
		3468,
		9,
		2543
	],
	"./pages/secure-file-upload/secureFileUploadStyles.ts": [
		3468,
		9,
		2543
	],
	"./pages/secure-file-upload/useUploadFilesLocalization": [
		3469,
		9,
		2544
	],
	"./pages/secure-file-upload/useUploadFilesLocalization.ts": [
		3469,
		9,
		2544
	],
	"./pages/settings/common/hooks": [
		3470,
		9,
		2545
	],
	"./pages/settings/common/hooks.ts": [
		3470,
		9,
		2545
	],
	"./pages/settings/components/accounting-bookkeeping-firm": [
		69,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/": [
		69,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/companyIdOrEmailLayout": [
		74,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/companyIdOrEmailLayout.tsx": [
		74,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/containers/buttonContainer": [
		622,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/containers/buttonContainer.tsx": [
		622,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/containers/formContainer": [
		620,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/containers/formContainer.tsx": [
		620,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/containers/typographyContainer": [
		621,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/containers/typographyContainer.tsx": [
		621,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/containers/validateEmailContainer": [
		623,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/containers/validateEmailContainer.tsx": [
		623,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/containers/zeroStateContainerStyles": [
		366,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/containers/zeroStateContainerStyles.ts": [
		366,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/schema/validationSchema": [
		624,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/schema/validationSchema.tsx": [
		624,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/schema/validationSchemaIDForm": [
		625,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/company-email-layout/schema/validationSchemaIDForm.tsx": [
		625,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/radio-group/rolesRadioGroup": [
		367,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/radio-group/rolesRadioGroup.tsx": [
		367,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/radio-group/rolesRadioGroupStyles": [
		618,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/radio-group/rolesRadioGroupStyles.ts": [
		618,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/radio-group/twoStepStatement": [
		619,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/common/radio-group/twoStepStatement.tsx": [
		619,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-admin/firmAdminContainer": [
		638,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-admin/firmAdminContainer.tsx": [
		638,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-admin/firmAdminGrid": [
		639,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-admin/firmAdminGrid.tsx": [
		639,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-admin/firmAdminGridColumns": [
		640,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-admin/firmAdminGridColumns.tsx": [
		640,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/acceptedCard": [
		636,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/acceptedCard.tsx": [
		636,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/cardsStyles": [
		216,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/cardsStyles.ts": [
		216,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/acceptButton": [
		416,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/acceptButton.tsx": [
		416,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/acceptOrDecline": [
		532,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/acceptOrDecline.tsx": [
		532,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/acceptPartnerPaysModal": [
		633,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/acceptPartnerPaysModal.tsx": [
		633,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/declineModal": [
		634,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/declineModal.tsx": [
		634,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/displayRoles": [
		275,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/displayRoles.tsx": [
		275,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/menu": [
		368,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/common/menu.tsx": [
		368,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/pendingCard": [
		631,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/pendingCard.tsx": [
		631,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/pendingCardApprover": [
		632,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/pendingCardApprover.tsx": [
		632,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/toBeInvitedCard": [
		637,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/components/toBeInvitedCard.tsx": [
		637,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/firmInvitedContainer": [
		630,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-invitations/firmInvitedContainer.tsx": [
		630,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-permission/components/cardContainer": [
		627,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-permission/components/cardContainer.tsx": [
		627,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-permission/components/statementContainer": [
		628,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-permission/components/statementContainer.tsx": [
		628,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-permission/components/titleContainer": [
		629,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-permission/components/titleContainer.tsx": [
		629,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-permission/firmPermissionsContainer": [
		626,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/firm-permission/firmPermissionsContainer.tsx": [
		626,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/hooks/useAccountingFirmListQuery": [
		200,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/hooks/useAccountingFirmListQuery.ts": [
		200,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/index": [
		69,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/index.tsx": [
		69,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/zero-state/zeroState": [
		616,
		9
	],
	"./pages/settings/components/accounting-bookkeeping-firm/zero-state/zeroState.tsx": [
		616,
		9
	],
	"./pages/settings/components/associated-companies/associatedCompanies": [
		3172,
		9,
		664
	],
	"./pages/settings/components/associated-companies/associatedCompanies.tsx": [
		3172,
		9,
		664
	],
	"./pages/settings/components/associated-companies/associatedCompaniesStyles": [
		2876,
		9,
		2546
	],
	"./pages/settings/components/associated-companies/associatedCompaniesStyles.ts": [
		2876,
		9,
		2546
	],
	"./pages/settings/components/associated-companies/formValidationSchema": [
		2875,
		9,
		1718
	],
	"./pages/settings/components/associated-companies/formValidationSchema.ts": [
		2875,
		9,
		1718
	],
	"./pages/settings/components/billing/billingContainer": [
		3673,
		9,
		88,
		95,
		196,
		1071
	],
	"./pages/settings/components/billing/billingContainer.tsx": [
		3673,
		9,
		88,
		95,
		196,
		1071
	],
	"./pages/settings/components/billing/billingLinks": [
		3471,
		9,
		2547
	],
	"./pages/settings/components/billing/billingLinks.tsx": [
		3471,
		9,
		2547
	],
	"./pages/settings/components/billing/billingView": [
		3528,
		9,
		88,
		95,
		196
	],
	"./pages/settings/components/billing/billingView.tsx": [
		3528,
		9,
		88,
		95,
		196
	],
	"./pages/settings/components/closeaccounts": [
		829,
		9,
		88,
		202
	],
	"./pages/settings/components/closeaccounts/": [
		829,
		9,
		88,
		202
	],
	"./pages/settings/components/closeaccounts/closeaccountsStyles": [
		2604,
		9,
		2548
	],
	"./pages/settings/components/closeaccounts/closeaccountsStyles.ts": [
		2604,
		9,
		2548
	],
	"./pages/settings/components/closeaccounts/index": [
		829,
		9,
		88,
		202
	],
	"./pages/settings/components/closeaccounts/index.tsx": [
		829,
		9,
		88,
		202
	],
	"./pages/settings/components/closeaccounts/zeroState": [
		2660,
		9,
		1242
	],
	"./pages/settings/components/closeaccounts/zeroState.tsx": [
		2660,
		9,
		1242
	],
	"./pages/settings/components/companysettings/company-logo/companyLogo": [
		2877,
		9,
		3,
		827
	],
	"./pages/settings/components/companysettings/company-logo/companyLogo.tsx": [
		2877,
		9,
		3,
		827
	],
	"./pages/settings/components/companysettings/company-logo/companyLogoStyles": [
		2605,
		9,
		2549
	],
	"./pages/settings/components/companysettings/company-logo/companyLogoStyles.ts": [
		2605,
		9,
		2549
	],
	"./pages/settings/components/companysettings/company-logo/useUploadLocalization": [
		2606,
		9,
		2550
	],
	"./pages/settings/components/companysettings/company-logo/useUploadLocalization.ts": [
		2606,
		9,
		2550
	],
	"./pages/settings/components/companysettings/company-settings-context/settingsContextProvider": [
		3674,
		9,
		2551
	],
	"./pages/settings/components/companysettings/company-settings-context/settingsContextProvider.tsx": [
		3674,
		9,
		2551
	],
	"./pages/settings/components/companysettings/form-wrapper-with-footer/formWrapperWithFooter": [
		2878,
		9,
		2552
	],
	"./pages/settings/components/companysettings/form-wrapper-with-footer/formWrapperWithFooter.tsx": [
		2878,
		9,
		2552
	],
	"./pages/settings/components/companysettings/form-wrapper-with-footer/formWrapperWithFooterStyles": [
		3675,
		9,
		2553
	],
	"./pages/settings/components/companysettings/form-wrapper-with-footer/formWrapperWithFooterStyles.ts": [
		3675,
		9,
		2553
	],
	"./pages/settings/components/companysettings/generalSettings": [
		3173,
		9,
		3,
		100,
		113,
		509
	],
	"./pages/settings/components/companysettings/generalSettings.tsx": [
		3173,
		9,
		3,
		100,
		113,
		509
	],
	"./pages/settings/components/companysettings/interfaces": [
		878,
		9,
		273
	],
	"./pages/settings/components/companysettings/interfaces/": [
		878,
		9,
		273
	],
	"./pages/settings/components/companysettings/interfaces/autocompleteUser": [
		3271,
		9,
		2554
	],
	"./pages/settings/components/companysettings/interfaces/autocompleteUser.ts": [
		3271,
		9,
		2554
	],
	"./pages/settings/components/companysettings/interfaces/index": [
		878,
		9,
		273
	],
	"./pages/settings/components/companysettings/interfaces/index.ts": [
		878,
		9,
		273
	],
	"./pages/settings/components/companysettings/interfaces/settingsContext": [
		3273,
		9,
		2555
	],
	"./pages/settings/components/companysettings/interfaces/settingsContext.ts": [
		3273,
		9,
		2555
	],
	"./pages/settings/components/companysettings/interfaces/settingsForm": [
		3272,
		9,
		2556
	],
	"./pages/settings/components/companysettings/interfaces/settingsForm.ts": [
		3272,
		9,
		2556
	],
	"./pages/settings/components/companysettings/pay-stubs-section/payStubsSection": [
		2884,
		9,
		1210
	],
	"./pages/settings/components/companysettings/pay-stubs-section/payStubsSection.tsx": [
		2884,
		9,
		1210
	],
	"./pages/settings/components/companysettings/pay-stubs-section/payStubsSectionStyles": [
		2608,
		9,
		2557
	],
	"./pages/settings/components/companysettings/pay-stubs-section/payStubsSectionStyles.ts": [
		2608,
		9,
		2557
	],
	"./pages/settings/components/companysettings/payroll-section/payrollSection": [
		2879,
		9,
		113,
		1045
	],
	"./pages/settings/components/companysettings/payroll-section/payrollSection.tsx": [
		2879,
		9,
		113,
		1045
	],
	"./pages/settings/components/companysettings/payroll-section/payrollSectionStyles": [
		2607,
		9,
		2558
	],
	"./pages/settings/components/companysettings/payroll-section/payrollSectionStyles.ts": [
		2607,
		9,
		2558
	],
	"./pages/settings/components/companysettings/queries": [
		1930,
		9,
		1719
	],
	"./pages/settings/components/companysettings/queries.ts": [
		1930,
		9,
		1719
	],
	"./pages/settings/components/companysettings/settingsStyles": [
		3676,
		9,
		2559
	],
	"./pages/settings/components/companysettings/settingsStyles.ts": [
		3676,
		9,
		2559
	],
	"./pages/settings/components/companysettings/text/description": [
		3677,
		9,
		2560
	],
	"./pages/settings/components/companysettings/text/description.tsx": [
		3677,
		9,
		2560
	],
	"./pages/settings/components/companysettings/turn-off-two-step-approval-modal/turnOffTwoStepApprovalModal": [
		2882,
		9,
		2561
	],
	"./pages/settings/components/companysettings/turn-off-two-step-approval-modal/turnOffTwoStepApprovalModal.tsx": [
		2882,
		9,
		2561
	],
	"./pages/settings/components/companysettings/two-step-approval-tooltip/twoStepApprovalTooltip": [
		3679,
		9,
		1720
	],
	"./pages/settings/components/companysettings/two-step-approval-tooltip/twoStepApprovalTooltip.tsx": [
		3679,
		9,
		1720
	],
	"./pages/settings/components/companysettings/two-step-approval-tooltip/twoStepApprovalTooltipStyles": [
		3472,
		9,
		2562
	],
	"./pages/settings/components/companysettings/two-step-approval-tooltip/twoStepApprovalTooltipStyles.ts": [
		3472,
		9,
		2562
	],
	"./pages/settings/components/companysettings/two-step-approval/twoStepApproval": [
		2880,
		9,
		113,
		2889
	],
	"./pages/settings/components/companysettings/two-step-approval/twoStepApproval.tsx": [
		2880,
		9,
		113,
		2889
	],
	"./pages/settings/components/companysettings/two-step-approval/twoStepApprovalStyles": [
		3678,
		9,
		2563
	],
	"./pages/settings/components/companysettings/two-step-approval/twoStepApprovalStyles.ts": [
		3678,
		9,
		2563
	],
	"./pages/settings/components/companysettings/two-step-approval/useAdminsAndPartnerFor2SA": [
		2883,
		9,
		1419
	],
	"./pages/settings/components/companysettings/two-step-approval/useAdminsAndPartnerFor2SA.ts": [
		2883,
		9,
		1419
	],
	"./pages/settings/components/companysettings/two-step-approval/useValidation": [
		2881,
		9,
		2564
	],
	"./pages/settings/components/companysettings/two-step-approval/useValidation.ts": [
		2881,
		9,
		2564
	],
	"./pages/settings/components/companysettings/useActivateModal": [
		2887,
		9,
		2565
	],
	"./pages/settings/components/companysettings/useActivateModal.ts": [
		2887,
		9,
		2565
	],
	"./pages/settings/components/companysettings/useServerLogic": [
		2886,
		9,
		989
	],
	"./pages/settings/components/companysettings/useServerLogic.ts": [
		2886,
		9,
		989
	],
	"./pages/settings/components/companysettings/useSettings": [
		1784,
		9,
		2566
	],
	"./pages/settings/components/companysettings/useSettings.ts": [
		1784,
		9,
		2566
	],
	"./pages/settings/components/companysettings/useUnsavedChanges": [
		2888,
		9,
		2567
	],
	"./pages/settings/components/companysettings/useUnsavedChanges.ts": [
		2888,
		9,
		2567
	],
	"./pages/settings/components/companysettings/useValidation": [
		2885,
		9,
		2568
	],
	"./pages/settings/components/companysettings/useValidation.ts": [
		2885,
		9,
		2568
	],
	"./pages/settings/components/companysettings/vacation-hours-radio/VacationHoursRadio": [
		3680,
		9,
		1721
	],
	"./pages/settings/components/companysettings/vacation-hours-radio/VacationHoursRadio.tsx": [
		3680,
		9,
		1721
	],
	"./pages/settings/components/companysettings/wp-toggle-switch-label/wpToggleSwitchLabel": [
		1950,
		9,
		2569
	],
	"./pages/settings/components/companysettings/wp-toggle-switch-label/wpToggleSwitchLabel.tsx": [
		1950,
		9,
		2569
	],
	"./pages/settings/components/notifications/addNotificationDetails": [
		2185,
		9,
		9,
		2570
	],
	"./pages/settings/components/notifications/addNotificationDetails.tsx": [
		2185,
		9,
		9,
		2570
	],
	"./pages/settings/components/notifications/notifications-content/notificationsContent": [
		2889,
		9,
		0,
		4,
		9,
		200,
		2571
	],
	"./pages/settings/components/notifications/notifications-content/notificationsContent.tsx": [
		2889,
		9,
		0,
		4,
		9,
		200,
		2571
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/checkbox": [
		2609,
		9,
		1722
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/checkbox.tsx": [
		2609,
		9,
		1722
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/notificationContentColumn": [
		2611,
		9,
		9,
		1072
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/notificationContentColumn.tsx": [
		2611,
		9,
		9,
		1072
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/popOver/formContainer": [
		2186,
		9,
		2572
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/popOver/formContainer.tsx": [
		2186,
		9,
		2572
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/popOver/popOver": [
		2350,
		9,
		1421
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/popOver/popOver.tsx": [
		2350,
		9,
		1421
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/popOver/popOverStyles": [
		2187,
		9,
		2573
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/popOver/popOverStyles.ts": [
		2187,
		9,
		2573
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/toggle": [
		2610,
		9,
		9,
		1211
	],
	"./pages/settings/components/notifications/notifications-grid/notification-grid-columns/toggle.tsx": [
		2610,
		9,
		9,
		1211
	],
	"./pages/settings/components/notifications/notifications-grid/notificationGridStyles": [
		1637,
		9,
		2574
	],
	"./pages/settings/components/notifications/notifications-grid/notificationGridStyles.ts": [
		1637,
		9,
		2574
	],
	"./pages/settings/components/notifications/notifications-grid/notificationsGrid": [
		2661,
		9,
		0,
		4,
		9,
		654
	],
	"./pages/settings/components/notifications/notifications-grid/notificationsGrid.tsx": [
		2661,
		9,
		0,
		4,
		9,
		654
	],
	"./pages/settings/components/notifications/notifications-header/notificationsHeader": [
		2890,
		9,
		2575
	],
	"./pages/settings/components/notifications/notifications-header/notificationsHeader.tsx": [
		2890,
		9,
		2575
	],
	"./pages/settings/components/notifications/notifications-layout/notificationsLayout": [
		3174,
		9,
		0,
		4,
		9,
		200,
		1420
	],
	"./pages/settings/components/notifications/notifications-layout/notificationsLayout.tsx": [
		3174,
		9,
		0,
		4,
		9,
		200,
		1420
	],
	"./pages/settings/components/rolesAndPermissions/rolesAndPermissionsContainer": [
		3274,
		9,
		371
	],
	"./pages/settings/components/rolesAndPermissions/rolesAndPermissionsContainer.tsx": [
		3274,
		9,
		371
	],
	"./pages/settings/components/rolesAndPermissions/rolesAndPermissionsView": [
		3474,
		9,
		1422
	],
	"./pages/settings/components/rolesAndPermissions/rolesAndPermissionsView.tsx": [
		3474,
		9,
		1422
	],
	"./pages/settings/components/rolesAndPermissions/rolesAndPermissionslinks": [
		3473,
		9,
		2576
	],
	"./pages/settings/components/rolesAndPermissions/rolesAndPermissionslinks.tsx": [
		3473,
		9,
		2576
	],
	"./pages/settings/components/rolesAndPermissionsNew/layout": [
		3275,
		9,
		0,
		4,
		11,
		66,
		346
	],
	"./pages/settings/components/rolesAndPermissionsNew/layout.tsx": [
		3275,
		9,
		0,
		4,
		11,
		66,
		346
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/common/useRoleName": [
		2351,
		9,
		1723
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/common/useRoleName.tsx": [
		2351,
		9,
		1723
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/common/usefilteredRoleList": [
		2354,
		9,
		1724
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/common/usefilteredRoleList.tsx": [
		2354,
		9,
		1724
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/container": [
		852,
		9,
		0,
		4,
		215
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/container/": [
		852,
		9,
		0,
		4,
		215
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/container/content-container/content": [
		2891,
		9,
		0,
		4,
		776
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/container/content-container/content.tsx": [
		2891,
		9,
		0,
		4,
		776
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/container/index": [
		852,
		9,
		0,
		4,
		215
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/container/index.tsx": [
		852,
		9,
		0,
		4,
		215
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/enums": [
		730,
		9,
		317
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/enums/": [
		730,
		9,
		317
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/enums/index": [
		730,
		9,
		317
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/enums/index.ts": [
		730,
		9,
		317
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/queries/useGetSecurityList": [
		2353,
		9,
		1725
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/queries/useGetSecurityList.ts": [
		2353,
		9,
		1725
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/rolesAndPermissionsTable/rolesAndPermissionStyles": [
		2352,
		9,
		2577
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/rolesAndPermissionsTable/rolesAndPermissionStyles.ts": [
		2352,
		9,
		2577
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/rolesAndPermissionsTable/rolesAndPermissionsTable": [
		2614,
		9,
		0,
		4,
		828
	],
	"./pages/settings/components/rolesAndPermissionsNew/roles/rolesAndPermissionsTable/rolesAndPermissionsTable.tsx": [
		2614,
		9,
		0,
		4,
		828
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/header/RolesViewHeader": [
		2892,
		9,
		1212
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/header/RolesViewHeader.tsx": [
		2892,
		9,
		1212
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/RoleViewTableStyles": [
		2616,
		9,
		2578
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/RoleViewTableStyles.ts": [
		2616,
		9,
		2578
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/RolesViewTable": [
		2615,
		9,
		0,
		4,
		829
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/RolesViewTable.tsx": [
		2615,
		9,
		0,
		4,
		829
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/RolesViewTableEdit": [
		3176,
		9,
		0,
		4,
		66
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/RolesViewTableEdit.tsx": [
		3176,
		9,
		0,
		4,
		66
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/container": [
		2894,
		9,
		0,
		4,
		11,
		66,
		777
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/container.tsx": [
		2894,
		9,
		0,
		4,
		11,
		66,
		777
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/employeePortalAccess/employeePortalAccessTable": [
		2618,
		9,
		0,
		4,
		11,
		742
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/employeePortalAccess/employeePortalAccessTable.tsx": [
		2618,
		9,
		0,
		4,
		11,
		742
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/employeePortalAccess/mutations": [
		2355,
		9,
		1423
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/employeePortalAccess/mutations.ts": [
		2355,
		9,
		1423
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/employeePortalAccess/queries": [
		1877,
		9,
		2579
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/employeePortalAccess/queries.ts": [
		1877,
		9,
		2579
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/routes": [
		1876,
		9,
		2580
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/table/routes.ts": [
		1876,
		9,
		2580
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/tabs/RolesViewTabs": [
		2893,
		9,
		1073
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/common/tabs/RolesViewTabs.tsx": [
		2893,
		9,
		1073
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/content-container/container": [
		3175,
		9,
		0,
		4,
		11,
		66,
		655
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/content-container/container.tsx": [
		3175,
		9,
		0,
		4,
		11,
		66,
		655
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/content-container/containerStyles": [
		1931,
		9,
		2581
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/content-container/containerStyles.ts": [
		1931,
		9,
		2581
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/hooks/useGetPermissionTableHeader": [
		2617,
		9,
		2582
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/hooks/useGetPermissionTableHeader.tsx": [
		2617,
		9,
		2582
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/queries/queries": [
		1638,
		9,
		1726
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/queries/queries.ts": [
		1638,
		9,
		1726
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/types/types": [
		3476,
		9,
		2583
	],
	"./pages/settings/components/rolesAndPermissionsNew/rolesView/types/types.ts": [
		3476,
		9,
		2583
	],
	"./pages/settings/components/rolesAndPermissionsNew/view": [
		3475,
		9,
		0,
		4,
		11,
		66,
		516
	],
	"./pages/settings/components/rolesAndPermissionsNew/view.tsx": [
		3475,
		9,
		0,
		4,
		11,
		66,
		516
	],
	"./pages/settings/components/settings-links/settingsLinks": [
		3681,
		9,
		2584
	],
	"./pages/settings/components/settings-links/settingsLinks.tsx": [
		3681,
		9,
		2584
	],
	"./pages/settings/components/subscription/closeAccount/closeAccount": [
		3276,
		9,
		85,
		318
	],
	"./pages/settings/components/subscription/closeAccount/closeAccount.tsx": [
		3276,
		9,
		85,
		318
	],
	"./pages/settings/components/subscription/closeAccount/closeAccountStyles": [
		2662,
		9,
		2585
	],
	"./pages/settings/components/subscription/closeAccount/closeAccountStyles.ts": [
		2662,
		9,
		2585
	],
	"./pages/settings/components/subscription/closeAccount/content-container": [
		867,
		9,
		85
	],
	"./pages/settings/components/subscription/closeAccount/content-container/": [
		867,
		9,
		85
	],
	"./pages/settings/components/subscription/closeAccount/content-container/components/dropdown": [
		3478,
		9,
		978
	],
	"./pages/settings/components/subscription/closeAccount/content-container/components/dropdown.tsx": [
		3478,
		9,
		978
	],
	"./pages/settings/components/subscription/closeAccount/content-container/components/footerContainer": [
		3479,
		9,
		2586
	],
	"./pages/settings/components/subscription/closeAccount/content-container/components/footerContainer.tsx": [
		3479,
		9,
		2586
	],
	"./pages/settings/components/subscription/closeAccount/content-container/components/recommendationsCard": [
		3480,
		9,
		1424
	],
	"./pages/settings/components/subscription/closeAccount/content-container/components/recommendationsCard.tsx": [
		3480,
		9,
		1424
	],
	"./pages/settings/components/subscription/closeAccount/content-container/constants": [
		2619,
		9,
		2587
	],
	"./pages/settings/components/subscription/closeAccount/content-container/constants.tsx": [
		2619,
		9,
		2587
	],
	"./pages/settings/components/subscription/closeAccount/content-container/index": [
		867,
		9,
		85
	],
	"./pages/settings/components/subscription/closeAccount/content-container/index.tsx": [
		867,
		9,
		85
	],
	"./pages/settings/components/subscription/closeAccount/queries/useCloseAccountData": [
		3481,
		9,
		2588
	],
	"./pages/settings/components/subscription/closeAccount/queries/useCloseAccountData.ts": [
		3481,
		9,
		2588
	],
	"./pages/settings/components/subscription/closeAccount/schema/useValidationSchema": [
		3477,
		9,
		2589
	],
	"./pages/settings/components/subscription/closeAccount/schema/useValidationSchema.ts": [
		3477,
		9,
		2589
	],
	"./pages/settings/components/subscription/components/activeCard/PriceItem": [
		2090,
		9,
		1727
	],
	"./pages/settings/components/subscription/components/activeCard/PriceItem.tsx": [
		2090,
		9,
		1727
	],
	"./pages/settings/components/subscription/components/activeCard/activeCard": [
		1726,
		9,
		2590
	],
	"./pages/settings/components/subscription/components/activeCard/activeCard.tsx": [
		1726,
		9,
		2590
	],
	"./pages/settings/components/subscription/components/calculatorCard/calculatorCard": [
		2367,
		9,
		1425
	],
	"./pages/settings/components/subscription/components/calculatorCard/calculatorCard.tsx": [
		2367,
		9,
		1425
	],
	"./pages/settings/components/subscription/components/calculatorCard/calculatorCardStyles": [
		2356,
		9,
		2591
	],
	"./pages/settings/components/subscription/components/calculatorCard/calculatorCardStyles.ts": [
		2356,
		9,
		2591
	],
	"./pages/settings/components/subscription/components/card/card": [
		1423,
		9,
		2592
	],
	"./pages/settings/components/subscription/components/card/card.tsx": [
		1423,
		9,
		2592
	],
	"./pages/settings/components/subscription/components/emptyCard/emptyCard": [
		1725,
		9,
		1088
	],
	"./pages/settings/components/subscription/components/emptyCard/emptyCard.tsx": [
		1725,
		9,
		1088
	],
	"./pages/settings/components/subscription/components/emptyCard/emptyCardStyles": [
		1812,
		9,
		2593
	],
	"./pages/settings/components/subscription/components/emptyCard/emptyCardStyles.ts": [
		1812,
		9,
		2593
	],
	"./pages/settings/components/subscription/components/filtersBar/filtersBar": [
		2428,
		9,
		1728
	],
	"./pages/settings/components/subscription/components/filtersBar/filtersBar.tsx": [
		2428,
		9,
		1728
	],
	"./pages/settings/components/subscription/components/filtersBar/filtersBarStyles": [
		2246,
		9,
		2594
	],
	"./pages/settings/components/subscription/components/filtersBar/filtersBarStyles.ts": [
		2246,
		9,
		2594
	],
	"./pages/settings/components/subscription/components/transactionsTable/transactionsTable": [
		2357,
		9,
		1729
	],
	"./pages/settings/components/subscription/components/transactionsTable/transactionsTable.tsx": [
		2357,
		9,
		1729
	],
	"./pages/settings/components/subscription/components/transactionsTable/transactionsTableStyles": [
		2358,
		9,
		2595
	],
	"./pages/settings/components/subscription/components/transactionsTable/transactionsTableStyles.ts": [
		2358,
		9,
		2595
	],
	"./pages/settings/components/subscription/helpers": [
		3482,
		9,
		1730
	],
	"./pages/settings/components/subscription/helpers.ts": [
		3482,
		9,
		1730
	],
	"./pages/settings/components/subscription/invoices/companyQueries": [
		3483,
		9,
		2596
	],
	"./pages/settings/components/subscription/invoices/companyQueries.ts": [
		3483,
		9,
		2596
	],
	"./pages/settings/components/subscription/invoices/hooks": [
		1559,
		9,
		2597
	],
	"./pages/settings/components/subscription/invoices/hooks.ts": [
		1559,
		9,
		2597
	],
	"./pages/settings/components/subscription/invoices/invoiceQueries": [
		3177,
		9,
		2598
	],
	"./pages/settings/components/subscription/invoices/invoiceQueries.ts": [
		3177,
		9,
		2598
	],
	"./pages/settings/components/subscription/invoices/invoiceView/invoiceTable/invoiceTable": [
		3484,
		9,
		1731
	],
	"./pages/settings/components/subscription/invoices/invoiceView/invoiceTable/invoiceTable.tsx": [
		3484,
		9,
		1731
	],
	"./pages/settings/components/subscription/invoices/invoiceView/invoiceTable/invoiceTableStyles": [
		3178,
		9,
		2599
	],
	"./pages/settings/components/subscription/invoices/invoiceView/invoiceTable/invoiceTableStyles.ts": [
		3178,
		9,
		2599
	],
	"./pages/settings/components/subscription/invoices/invoiceView/invoiceView": [
		3277,
		9,
		12,
		14,
		8,
		16,
		212
	],
	"./pages/settings/components/subscription/invoices/invoiceView/invoiceView.tsx": [
		3277,
		9,
		12,
		14,
		8,
		16,
		212
	],
	"./pages/settings/components/subscription/invoices/invoiceView/invoiceViewStyles": [
		3485,
		9,
		2600
	],
	"./pages/settings/components/subscription/invoices/invoiceView/invoiceViewStyles.ts": [
		3485,
		9,
		2600
	],
	"./pages/settings/components/subscription/invoices/invoicesList/components/filters/filters": [
		3486,
		9,
		1075
	],
	"./pages/settings/components/subscription/invoices/invoicesList/components/filters/filters.tsx": [
		3486,
		9,
		1075
	],
	"./pages/settings/components/subscription/invoices/invoicesList/components/filters/types": [
		2663,
		9,
		2601
	],
	"./pages/settings/components/subscription/invoices/invoicesList/components/filters/types.ts": [
		2663,
		9,
		2601
	],
	"./pages/settings/components/subscription/invoices/invoicesList/components/filters/wpFilters": [
		3487,
		9,
		1216
	],
	"./pages/settings/components/subscription/invoices/invoicesList/components/filters/wpFilters.tsx": [
		3487,
		9,
		1216
	],
	"./pages/settings/components/subscription/invoices/invoicesList/invoicesList": [
		3278,
		9,
		0,
		4,
		11,
		89,
		201
	],
	"./pages/settings/components/subscription/invoices/invoicesList/invoicesList.tsx": [
		3278,
		9,
		0,
		4,
		11,
		89,
		201
	],
	"./pages/settings/components/subscription/invoices/invoicesList/useEnumLocale": [
		2048,
		9,
		2602
	],
	"./pages/settings/components/subscription/invoices/invoicesList/useEnumLocale.ts": [
		2048,
		9,
		2602
	],
	"./pages/settings/components/subscription/overview/components/clientCurrentActivityCard/clientCurrentActivityCard": [
		3205,
		9,
		8,
		711
	],
	"./pages/settings/components/subscription/overview/components/clientCurrentActivityCard/clientCurrentActivityCard.tsx": [
		3205,
		9,
		8,
		711
	],
	"./pages/settings/components/subscription/overview/components/clientCurrentActivityCard/clientCurrentActivityCardStyles": [
		2895,
		9,
		2603
	],
	"./pages/settings/components/subscription/overview/components/clientCurrentActivityCard/clientCurrentActivityCardStyles.ts": [
		2895,
		9,
		2603
	],
	"./pages/settings/components/subscription/overview/components/closeAccountCard/closeAccountCard": [
		3179,
		9,
		712
	],
	"./pages/settings/components/subscription/overview/components/closeAccountCard/closeAccountCard.tsx": [
		3179,
		9,
		712
	],
	"./pages/settings/components/subscription/overview/components/closeAccountCard/closeAccountCardStyles": [
		2211,
		9,
		2604
	],
	"./pages/settings/components/subscription/overview/components/closeAccountCard/closeAccountCardStyles.ts": [
		2211,
		9,
		2604
	],
	"./pages/settings/components/subscription/overview/components/closeAccountCard/components/suggestionList": [
		2896,
		9,
		1217
	],
	"./pages/settings/components/subscription/overview/components/closeAccountCard/components/suggestionList.tsx": [
		2896,
		9,
		1217
	],
	"./pages/settings/components/subscription/overview/components/expiredTrialCard/expiredTrialCard": [
		3180,
		9,
		783
	],
	"./pages/settings/components/subscription/overview/components/expiredTrialCard/expiredTrialCard.tsx": [
		3180,
		9,
		783
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/inactiveCard": [
		3181,
		9,
		3,
		98,
		75,
		206,
		487
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/inactiveCard.tsx": [
		3181,
		9,
		3,
		98,
		75,
		206,
		487
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/emptyPaymentListContent": [
		2900,
		9,
		75,
		656
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/emptyPaymentListContent.tsx": [
		2900,
		9,
		75,
		656
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/featureFlagTransferFunds": [
		2902,
		9,
		1732
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/featureFlagTransferFunds.tsx": [
		2902,
		9,
		1732
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/fileActionsMenu": [
		2898,
		9,
		1218
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/fileActionsMenu.tsx": [
		2898,
		9,
		1218
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/paymentListContent": [
		2971,
		9,
		3,
		98,
		206,
		1215
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/paymentListContent.tsx": [
		2971,
		9,
		3,
		98,
		206,
		1215
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/transferFundsContent": [
		2899,
		9,
		2605
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/transferFundsContent.ts": [
		2899,
		9,
		2605
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/uploadFileModal": [
		2897,
		9,
		3,
		830
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsContent/uploadFileModal.tsx": [
		2897,
		9,
		3,
		830
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/transferFields": [
		2359,
		9,
		75,
		1733
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/transferFields.tsx": [
		2359,
		9,
		75,
		1733
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/transferFundsForm": [
		2620,
		9,
		75,
		1219
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/transferFundsForm.tsx": [
		2620,
		9,
		75,
		1219
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/transferTableField/transferTableField": [
		2621,
		9,
		75,
		2884
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/transferTableField/transferTableField.tsx": [
		2621,
		9,
		75,
		2884
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/transferTableField/transferTableFieldStyle": [
		2901,
		9,
		2606
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/transferTableField/transferTableFieldStyle.ts": [
		2901,
		9,
		2606
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/types": [
		1878,
		9,
		2607
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/types.ts": [
		1878,
		9,
		2607
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/useFormValidationSchema": [
		2360,
		9,
		2608
	],
	"./pages/settings/components/subscription/overview/components/inactiveCard/transferFundsForm/useFormValidationSchema.ts": [
		2360,
		9,
		2608
	],
	"./pages/settings/components/subscription/overview/components/offTheHookCard/offTheHookCard": [
		3182,
		9,
		1213
	],
	"./pages/settings/components/subscription/overview/components/offTheHookCard/offTheHookCard.tsx": [
		3182,
		9,
		1213
	],
	"./pages/settings/components/subscription/overview/components/partnerHandlingCard/partnerHandlingCard": [
		3183,
		9,
		1074
	],
	"./pages/settings/components/subscription/overview/components/partnerHandlingCard/partnerHandlingCard.tsx": [
		3183,
		9,
		1074
	],
	"./pages/settings/components/subscription/overview/components/partnerHandlingCard/partnerHandlingCardStyles": [
		2903,
		9,
		2609
	],
	"./pages/settings/components/subscription/overview/components/partnerHandlingCard/partnerHandlingCardStyles.ts": [
		2903,
		9,
		2609
	],
	"./pages/settings/components/subscription/overview/components/planCard/changePlanButton": [
		2944,
		9,
		51,
		109
	],
	"./pages/settings/components/subscription/overview/components/planCard/changePlanButton.tsx": [
		2944,
		9,
		51,
		109
	],
	"./pages/settings/components/subscription/overview/components/planCard/featurePlanCard": [
		3184,
		9,
		51,
		636
	],
	"./pages/settings/components/subscription/overview/components/planCard/featurePlanCard.tsx": [
		3184,
		9,
		51,
		636
	],
	"./pages/settings/components/subscription/overview/components/planCard/getUserQueries": [
		1959,
		9,
		51,
		109
	],
	"./pages/settings/components/subscription/overview/components/planCard/getUserQueries.ts": [
		1959,
		9,
		51,
		109
	],
	"./pages/settings/components/subscription/overview/components/planCard/planCard": [
		2648,
		9,
		51,
		109
	],
	"./pages/settings/components/subscription/overview/components/planCard/planCard.tsx": [
		2648,
		9,
		51,
		109
	],
	"./pages/settings/components/subscription/overview/components/planCard/viewPlanDetails": [
		2374,
		9,
		757
	],
	"./pages/settings/components/subscription/overview/components/planCard/viewPlanDetails.tsx": [
		2374,
		9,
		757
	],
	"./pages/settings/components/subscription/overview/components/referralCard/referralCard": [
		3682,
		9,
		1214
	],
	"./pages/settings/components/subscription/overview/components/referralCard/referralCard.tsx": [
		3682,
		9,
		1214
	],
	"./pages/settings/components/subscription/overview/components/thanksForTheTryCard/thanksForTheTryCard": [
		3206,
		9,
		924
	],
	"./pages/settings/components/subscription/overview/components/thanksForTheTryCard/thanksForTheTryCard.tsx": [
		3206,
		9,
		924
	],
	"./pages/settings/components/subscription/overview/components/thanksForTheTryCard/thanksForTryCardStyles": [
		2904,
		9,
		2610
	],
	"./pages/settings/components/subscription/overview/components/thanksForTheTryCard/thanksForTryCardStyles.ts": [
		2904,
		9,
		2610
	],
	"./pages/settings/components/subscription/overview/components/trialCard/trialCard": [
		3199,
		9,
		1089
	],
	"./pages/settings/components/subscription/overview/components/trialCard/trialCard.tsx": [
		3199,
		9,
		1089
	],
	"./pages/settings/components/subscription/overview/overviewContainer": [
		3279,
		9,
		3,
		8,
		98,
		373,
		415
	],
	"./pages/settings/components/subscription/overview/overviewContainer.tsx": [
		3279,
		9,
		3,
		8,
		98,
		373,
		415
	],
	"./pages/settings/components/subscription/overview/overviewQueries": [
		1555,
		9,
		1734
	],
	"./pages/settings/components/subscription/overview/overviewQueries.ts": [
		1555,
		9,
		1734
	],
	"./pages/settings/components/subscription/plan-selection/components/footerComponent": [
		2044,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/components/footerComponent.tsx": [
		2044,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/components/renderStatus": [
		2909,
		9,
		2611
	],
	"./pages/settings/components/subscription/plan-selection/components/renderStatus.tsx": [
		2909,
		9,
		2611
	],
	"./pages/settings/components/subscription/plan-selection/components/stepHeader": [
		1703,
		9,
		2612
	],
	"./pages/settings/components/subscription/plan-selection/components/stepHeader.tsx": [
		1703,
		9,
		2612
	],
	"./pages/settings/components/subscription/plan-selection/constants": [
		1318,
		9,
		2613
	],
	"./pages/settings/components/subscription/plan-selection/constants.ts": [
		1318,
		9,
		2613
	],
	"./pages/settings/components/subscription/plan-selection/hooks/usePrimaryLocation": [
		1799,
		9,
		1735
	],
	"./pages/settings/components/subscription/plan-selection/hooks/usePrimaryLocation.ts": [
		1799,
		9,
		1735
	],
	"./pages/settings/components/subscription/plan-selection/planSelection": [
		1504,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/planSelection.tsx": [
		1504,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/planSelectionEnums": [
		2188,
		9,
		2614
	],
	"./pages/settings/components/subscription/plan-selection/planSelectionEnums.ts": [
		2188,
		9,
		2614
	],
	"./pages/settings/components/subscription/plan-selection/planSelectionQueries": [
		1383,
		9,
		2615
	],
	"./pages/settings/components/subscription/plan-selection/planSelectionQueries.ts": [
		1383,
		9,
		2615
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/bankingDetailsStepView": [
		2973,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/bankingDetailsStepView.tsx": [
		2973,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/card/card": [
		2632,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/card/card.tsx": [
		2632,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/card/cardStyles": [
		2910,
		9,
		2616
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/card/cardStyles.ts": [
		2910,
		9,
		2616
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/cards/agreementCard": [
		2631,
		9,
		1,
		3,
		25,
		28,
		533
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/cards/agreementCard.tsx": [
		2631,
		9,
		1,
		3,
		25,
		28,
		533
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/form": [
		2908,
		9,
		1,
		3,
		24,
		25,
		430
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/form.tsx": [
		2908,
		9,
		1,
		3,
		24,
		25,
		430
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/accountDetails": [
		2627,
		9,
		706
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/accountDetails.tsx": [
		2627,
		9,
		706
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/accountType": [
		2625,
		9,
		915
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/accountType.tsx": [
		2625,
		9,
		915
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/banksAutocompleteGrid": [
		2626,
		9,
		831
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/banksAutocompleteGrid.tsx": [
		2626,
		9,
		831
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/identityVerificationDoc": [
		2630,
		9,
		3,
		657
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/identityVerificationDoc.tsx": [
		2630,
		9,
		3,
		657
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/ownershipDoc": [
		2628,
		9,
		3,
		627
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/ownershipDoc.tsx": [
		2628,
		9,
		3,
		627
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/signingOfficerFields": [
		2629,
		9,
		24,
		598
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formFields/signingOfficerFields.tsx": [
		2629,
		9,
		24,
		598
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formStyles": [
		1932,
		9,
		2617
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/form/formStyles.ts": [
		1932,
		9,
		2617
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/schema": [
		2069,
		9,
		1,
		979
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/banking-details-step-view/schema.ts": [
		2069,
		9,
		1,
		979
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/card/card": [
		2624,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/card/card.tsx": [
		2624,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/card/cardStyles": [
		2906,
		9,
		2618
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/card/cardStyles.ts": [
		2906,
		9,
		2618
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/companyDetailsStepView": [
		2972,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/companyDetailsStepView.tsx": [
		2972,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/form/form": [
		2905,
		9,
		618
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/form/form.tsx": [
		2905,
		9,
		618
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/form/formFields/addressFields": [
		2623,
		9,
		665
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/form/formFields/addressFields.tsx": [
		2623,
		9,
		665
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/form/formFields/generalDetailFields": [
		2622,
		9,
		717
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/form/formFields/generalDetailFields.tsx": [
		2622,
		9,
		717
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/schema": [
		2907,
		9,
		1448
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/company-details-step-view/schema.ts": [
		2907,
		9,
		1448
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/review-step-view/plan-selected/planSelectedForChangePlanProcess": [
		3683,
		9,
		1,
		3,
		24,
		25,
		406
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/review-step-view/plan-selected/planSelectedForChangePlanProcess.tsx": [
		3683,
		9,
		1,
		3,
		24,
		25,
		406
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/review-step-view/plan-selected/planSelectedForReactivateProcess": [
		2976,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/review-step-view/plan-selected/planSelectedForReactivateProcess.tsx": [
		2976,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/review-step-view/plan-selected/planSelectedStyles": [
		2664,
		9,
		2619
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/review-step-view/plan-selected/planSelectedStyles.ts": [
		2664,
		9,
		2619
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/review-step-view/reviewStepView": [
		2975,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/review-step-view/reviewStepView.tsx": [
		2975,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/account-verification/accountVerification": [
		2974,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/account-verification/accountVerification.tsx": [
		2974,
		9,
		1,
		3,
		24,
		25,
		33
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/account-verification/accountVerificationStyles": [
		3684,
		9,
		2620
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/account-verification/accountVerificationStyles.ts": [
		3684,
		9,
		2620
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/account-verification/business-verification-form/businessVerificationForm": [
		2911,
		9,
		1736
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/account-verification/business-verification-form/businessVerificationForm.tsx": [
		2911,
		9,
		1736
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/account-verification/instant-verification-form/instantVerificationForm": [
		2912,
		9,
		697
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/account-verification/instant-verification-form/instantVerificationForm.tsx": [
		2912,
		9,
		697
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/account-verification/instant-verification-form/instantVerificationFormStyles": [
		2633,
		9,
		2621
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/account-verification/instant-verification-form/instantVerificationFormStyles.ts": [
		2633,
		9,
		2621
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/accountVerificationCard": [
		2913,
		9,
		763
	],
	"./pages/settings/components/subscription/plan-selection/steps-view/verification-step-view/accountVerificationCard.tsx": [
		2913,
		9,
		763
	],
	"./pages/settings/components/subscription/subscriptionContainer": [
		2914,
		9,
		83,
		300
	],
	"./pages/settings/components/subscription/subscriptionContainer.tsx": [
		2914,
		9,
		83,
		300
	],
	"./pages/settings/components/subscription/subscriptionTemporaryContainer": [
		3280,
		9,
		372
	],
	"./pages/settings/components/subscription/subscriptionTemporaryContainer.tsx": [
		3280,
		9,
		372
	],
	"./pages/settings/components/subscription/subscriptionView": [
		3488,
		9,
		83,
		2622
	],
	"./pages/settings/components/subscription/subscriptionView.tsx": [
		3488,
		9,
		83,
		2622
	],
	"./pages/settings/components/subscription/upgrade-plan/components/footer": [
		3685,
		9,
		2623
	],
	"./pages/settings/components/subscription/upgrade-plan/components/footer.tsx": [
		3685,
		9,
		2623
	],
	"./pages/settings/components/subscription/upgrade-plan/components/upgrade-plan-confirmation": [
		1960,
		9,
		2624
	],
	"./pages/settings/components/subscription/upgrade-plan/components/upgrade-plan-confirmation.tsx": [
		1960,
		9,
		2624
	],
	"./pages/settings/components/subscription/upgrade-plan/components/upgrade-selection-card": [
		3490,
		9,
		637
	],
	"./pages/settings/components/subscription/upgrade-plan/components/upgrade-selection-card.tsx": [
		3490,
		9,
		637
	],
	"./pages/settings/components/subscription/upgrade-plan/enums/upgradePlan": [
		2977,
		9,
		2625
	],
	"./pages/settings/components/subscription/upgrade-plan/enums/upgradePlan.ts": [
		2977,
		9,
		2625
	],
	"./pages/settings/components/subscription/upgrade-plan/upgradePlan": [
		3489,
		9,
		83
	],
	"./pages/settings/components/subscription/upgrade-plan/upgradePlan.tsx": [
		3489,
		9,
		83
	],
	"./pages/settings/components/taxSettings/employerTaxSettingsContainer": [
		3281,
		9,
		37,
		49,
		91,
		101,
		352
	],
	"./pages/settings/components/taxSettings/employerTaxSettingsContainer.tsx": [
		3281,
		9,
		37,
		49,
		91,
		101,
		352
	],
	"./pages/settings/components/taxSettings/employerTaxSettingsLinks": [
		3491,
		9,
		1737
	],
	"./pages/settings/components/taxSettings/employerTaxSettingsLinks.tsx": [
		3491,
		9,
		1737
	],
	"./pages/settings/components/taxSettings/employerTaxSettingsView": [
		3492,
		9,
		37,
		49,
		91,
		101,
		613
	],
	"./pages/settings/components/taxSettings/employerTaxSettingsView.tsx": [
		3492,
		9,
		37,
		49,
		91,
		101,
		613
	],
	"./pages/settings/components/useraccounts/admin/addadmin": [
		3185,
		9,
		1738
	],
	"./pages/settings/components/useraccounts/admin/addadmin.tsx": [
		3185,
		9,
		1738
	],
	"./pages/settings/components/useraccounts/admin/adminContainer": [
		3186,
		9,
		2626
	],
	"./pages/settings/components/useraccounts/admin/adminContainer.tsx": [
		3186,
		9,
		2626
	],
	"./pages/settings/components/useraccounts/admin/adminEmailCheckSystem": [
		2920,
		9,
		2627
	],
	"./pages/settings/components/useraccounts/admin/adminEmailCheckSystem.tsx": [
		2920,
		9,
		2627
	],
	"./pages/settings/components/useraccounts/assignedPeopleGroup": [
		122,
		9
	],
	"./pages/settings/components/useraccounts/assignedPeopleGroup.tsx": [
		122,
		9
	],
	"./pages/settings/components/useraccounts/assignedPeopleGroupStyles": [
		654,
		9
	],
	"./pages/settings/components/useraccounts/assignedPeopleGroupStyles.ts": [
		654,
		9
	],
	"./pages/settings/components/useraccounts/assignedPeopleView/statements/disabledPayrollAdmin": [
		414,
		9
	],
	"./pages/settings/components/useraccounts/assignedPeopleView/statements/disabledPayrollAdmin.tsx": [
		414,
		9
	],
	"./pages/settings/components/useraccounts/assignedPeopleView/statements/statementsStyles": [
		602,
		9
	],
	"./pages/settings/components/useraccounts/assignedPeopleView/statements/statementsStyles.ts": [
		602,
		9
	],
	"./pages/settings/components/useraccounts/common": [
		201,
		9
	],
	"./pages/settings/components/useraccounts/common.tsx": [
		201,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/enum/flattenPermissionsEnum": [
		101,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/enum/flattenPermissionsEnum.ts": [
		101,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/flattenEditPermissions/flattenedEditPermissions": [
		417,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/flattenEditPermissions/flattenedEditPermissions.ts": [
		417,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/flattenToServiceStructure/flattenServiceStructure": [
		648,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/flattenToServiceStructure/flattenServiceStructure.ts": [
		648,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/interface/flattenPermissionsInterface": [
		3686,
		9,
		2628
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/interface/flattenPermissionsInterface.ts": [
		3686,
		9,
		2628
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/updatePermissionsHeader": [
		646,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/updatePermissionsHeader.ts": [
		646,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/updatePermissionsListToDisplay": [
		373,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/updatePermissionsListToDisplay.ts": [
		373,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/updatedOriginalPermissionsWithNoAccess": [
		224,
		9
	],
	"./pages/settings/components/useraccounts/common/flattenPermissions/updatedOriginalPermissionsWithNoAccess.ts": [
		224,
		9
	],
	"./pages/settings/components/useraccounts/common/interface/userAccountsInterface": [
		3687,
		9,
		2629
	],
	"./pages/settings/components/useraccounts/common/interface/userAccountsInterface.ts": [
		3687,
		9,
		2629
	],
	"./pages/settings/components/useraccounts/editView": [
		546,
		9
	],
	"./pages/settings/components/useraccounts/editView.tsx": [
		546,
		9
	],
	"./pages/settings/components/useraccounts/editViewStyles": [
		653,
		9
	],
	"./pages/settings/components/useraccounts/editViewStyles.ts": [
		653,
		9
	],
	"./pages/settings/components/useraccounts/hooks/serviceHooks": [
		3688,
		9,
		2630
	],
	"./pages/settings/components/useraccounts/hooks/serviceHooks.ts": [
		3688,
		9,
		2630
	],
	"./pages/settings/components/useraccounts/people/peopleContainer": [
		2613,
		9,
		2631
	],
	"./pages/settings/components/useraccounts/people/peopleContainer.tsx": [
		2613,
		9,
		2631
	],
	"./pages/settings/components/useraccounts/permissionSettingsDialogue": [
		3689,
		9,
		2632
	],
	"./pages/settings/components/useraccounts/permissionSettingsDialogue.tsx": [
		3689,
		9,
		2632
	],
	"./pages/settings/components/useraccounts/permissionSettingsHook": [
		214,
		9
	],
	"./pages/settings/components/useraccounts/permissionSettingsHook.tsx": [
		214,
		9
	],
	"./pages/settings/components/useraccounts/permissionSettingsStyles": [
		3690,
		9,
		2633
	],
	"./pages/settings/components/useraccounts/permissionSettingsStyles.ts": [
		3690,
		9,
		2633
	],
	"./pages/settings/components/useraccounts/permissions": [
		196,
		9
	],
	"./pages/settings/components/useraccounts/permissions/": [
		196,
		9
	],
	"./pages/settings/components/useraccounts/permissions/dialogue/customizationsDialogue": [
		645,
		9
	],
	"./pages/settings/components/useraccounts/permissions/dialogue/customizationsDialogue.tsx": [
		645,
		9
	],
	"./pages/settings/components/useraccounts/permissions/dialogue/permissionSettingsDialogue": [
		644,
		9
	],
	"./pages/settings/components/useraccounts/permissions/dialogue/permissionSettingsDialogue.tsx": [
		644,
		9
	],
	"./pages/settings/components/useraccounts/permissions/index": [
		196,
		9
	],
	"./pages/settings/components/useraccounts/permissions/index.tsx": [
		196,
		9
	],
	"./pages/settings/components/useraccounts/permissions/permissionStyles": [
		641,
		9
	],
	"./pages/settings/components/useraccounts/permissions/permissionStyles.ts": [
		641,
		9
	],
	"./pages/settings/components/useraccounts/roles/assignRole": [
		652,
		9
	],
	"./pages/settings/components/useraccounts/roles/assignRole.tsx": [
		652,
		9
	],
	"./pages/settings/components/useraccounts/roles/assignedRolesContainer/assignedRolesAction/assignedRolesActions": [
		655,
		9
	],
	"./pages/settings/components/useraccounts/roles/assignedRolesContainer/assignedRolesAction/assignedRolesActions.tsx": [
		655,
		9
	],
	"./pages/settings/components/useraccounts/roles/assignedRolesContainer/assignedRolesAction/util/createEmployeeProfile": [
		656,
		9
	],
	"./pages/settings/components/useraccounts/roles/assignedRolesContainer/assignedRolesAction/util/createEmployeeProfile.tsx": [
		656,
		9
	],
	"./pages/settings/components/useraccounts/roles/rolePermission": [
		615,
		9
	],
	"./pages/settings/components/useraccounts/roles/rolePermission.tsx": [
		615,
		9
	],
	"./pages/settings/components/useraccounts/roles/roles": [
		2612,
		9,
		2634
	],
	"./pages/settings/components/useraccounts/roles/roles.tsx": [
		2612,
		9,
		2634
	],
	"./pages/settings/components/useraccounts/roles/rolesAssignedPeople": [
		651,
		9
	],
	"./pages/settings/components/useraccounts/roles/rolesAssignedPeople.tsx": [
		651,
		9
	],
	"./pages/settings/components/useraccounts/roles/rolesContainer": [
		25,
		9
	],
	"./pages/settings/components/useraccounts/roles/rolesContainer.tsx": [
		25,
		9
	],
	"./pages/settings/components/useraccounts/roles/rolesTabsLinks": [
		613,
		9
	],
	"./pages/settings/components/useraccounts/roles/rolesTabsLinks.tsx": [
		613,
		9
	],
	"./pages/settings/components/useraccounts/roles/rolesTabsView": [
		614,
		9
	],
	"./pages/settings/components/useraccounts/roles/rolesTabsView.tsx": [
		614,
		9
	],
	"./pages/settings/components/useraccounts/roles/transferOwnership": [
		369,
		9
	],
	"./pages/settings/components/useraccounts/roles/transferOwnership.tsx": [
		369,
		9
	],
	"./pages/settings/components/useraccounts/zeroStateCards": [
		603,
		9
	],
	"./pages/settings/components/useraccounts/zeroStateCards.tsx": [
		603,
		9
	],
	"./pages/settings/enums": [
		828,
		9,
		290
	],
	"./pages/settings/enums/": [
		828,
		9,
		290
	],
	"./pages/settings/enums/companySettingsModal": [
		2183,
		9,
		2635
	],
	"./pages/settings/enums/companySettingsModal.ts": [
		2183,
		9,
		2635
	],
	"./pages/settings/enums/index": [
		828,
		9,
		290
	],
	"./pages/settings/enums/index.ts": [
		828,
		9,
		290
	],
	"./pages/settings/enums/loadingQueue": [
		2184,
		9,
		2636
	],
	"./pages/settings/enums/loadingQueue.ts": [
		2184,
		9,
		2636
	],
	"./pages/settings/settingsContainer": [
		3283,
		9,
		0,
		3,
		4,
		100,
		339
	],
	"./pages/settings/settingsContainer.tsx": [
		3283,
		9,
		0,
		3,
		4,
		100,
		339
	],
	"./pages/settings/settingsPage": [
		3284,
		9,
		1,
		5,
		6,
		30,
		342
	],
	"./pages/settings/settingsPage.tsx": [
		3284,
		9,
		1,
		5,
		6,
		30,
		342
	],
	"./pages/settings/settingsPageStyles": [
		3691,
		9,
		2637
	],
	"./pages/settings/settingsPageStyles.ts": [
		3691,
		9,
		2637
	],
	"./pages/settings/settingsView": [
		3493,
		9,
		0,
		3,
		4,
		100,
		418
	],
	"./pages/settings/settingsView.tsx": [
		3493,
		9,
		0,
		3,
		4,
		100,
		418
	],
	"./pages/tax-settings/components/employer-taxes/BCEmpTaxes/BCEmployerTaxes": [
		2635,
		9,
		506
	],
	"./pages/tax-settings/components/employer-taxes/BCEmpTaxes/BCEmployerTaxes.tsx": [
		2635,
		9,
		506
	],
	"./pages/tax-settings/components/employer-taxes/BCEmpTaxes/readBCEmpTaxes": [
		2363,
		9,
		980
	],
	"./pages/tax-settings/components/employer-taxes/BCEmpTaxes/readBCEmpTaxes.tsx": [
		2363,
		9,
		980
	],
	"./pages/tax-settings/components/employer-taxes/BCEmpTaxes/updateEHTRateModal": [
		2362,
		9,
		832
	],
	"./pages/tax-settings/components/employer-taxes/BCEmpTaxes/updateEHTRateModal.tsx": [
		2362,
		9,
		832
	],
	"./pages/tax-settings/components/employer-taxes/common/crossThresholdOptions": [
		3692,
		9,
		981
	],
	"./pages/tax-settings/components/employer-taxes/common/crossThresholdOptions.tsx": [
		3692,
		9,
		981
	],
	"./pages/tax-settings/components/employer-taxes/common/empFooter": [
		1542,
		9,
		1426
	],
	"./pages/tax-settings/components/employer-taxes/common/empFooter.tsx": [
		1542,
		9,
		1426
	],
	"./pages/tax-settings/components/employer-taxes/common/employerTaxes.utils": [
		1644,
		9,
		2638
	],
	"./pages/tax-settings/components/employer-taxes/common/employerTaxes.utils.ts": [
		1644,
		9,
		2638
	],
	"./pages/tax-settings/components/employer-taxes/common/employerTaxesInProgress": [
		1933,
		9,
		37,
		2639
	],
	"./pages/tax-settings/components/employer-taxes/common/employerTaxesInProgress.tsx": [
		1933,
		9,
		37,
		2639
	],
	"./pages/tax-settings/components/employer-taxes/common/employerTaxesStyles": [
		1468,
		9,
		2640
	],
	"./pages/tax-settings/components/employer-taxes/common/employerTaxesStyles.tsx": [
		1468,
		9,
		2640
	],
	"./pages/tax-settings/components/employer-taxes/common/exemThresholdModal": [
		1640,
		9,
		916
	],
	"./pages/tax-settings/components/employer-taxes/common/exemThresholdModal.tsx": [
		1640,
		9,
		916
	],
	"./pages/tax-settings/components/employer-taxes/common/exemptionThreshold": [
		1639,
		9,
		1427
	],
	"./pages/tax-settings/components/employer-taxes/common/exemptionThreshold.tsx": [
		1639,
		9,
		1427
	],
	"./pages/tax-settings/components/employer-taxes/common/payrollInProgressMsg": [
		1152,
		9,
		2641
	],
	"./pages/tax-settings/components/employer-taxes/common/payrollInProgressMsg.tsx": [
		1152,
		9,
		2641
	],
	"./pages/tax-settings/components/employer-taxes/common/persistTaxPropertyList": [
		1641,
		9,
		1739
	],
	"./pages/tax-settings/components/employer-taxes/common/persistTaxPropertyList.tsx": [
		1641,
		9,
		1739
	],
	"./pages/tax-settings/components/employer-taxes/common/updateInfoStatement": [
		1361,
		9,
		1740
	],
	"./pages/tax-settings/components/employer-taxes/common/updateInfoStatement.tsx": [
		1361,
		9,
		1740
	],
	"./pages/tax-settings/components/employer-taxes/common/useGetFormatedDate": [
		1658,
		9,
		2642
	],
	"./pages/tax-settings/components/employer-taxes/common/useGetFormatedDate.tsx": [
		1658,
		9,
		2642
	],
	"./pages/tax-settings/components/employer-taxes/common/useSettingsDateValidation": [
		1262,
		9,
		2643
	],
	"./pages/tax-settings/components/employer-taxes/common/useSettingsDateValidation.tsx": [
		1262,
		9,
		2643
	],
	"./pages/tax-settings/components/employer-taxes/common/ytdRemit": [
		1643,
		9,
		1741
	],
	"./pages/tax-settings/components/employer-taxes/common/ytdRemit.tsx": [
		1643,
		9,
		1741
	],
	"./pages/tax-settings/components/employer-taxes/common/ytdRenumeration": [
		1642,
		9,
		2644
	],
	"./pages/tax-settings/components/employer-taxes/common/ytdRenumeration.tsx": [
		1642,
		9,
		2644
	],
	"./pages/tax-settings/components/employer-taxes/employerTaxes": [
		2634,
		9,
		1742
	],
	"./pages/tax-settings/components/employer-taxes/employerTaxes.tsx": [
		2634,
		9,
		1742
	],
	"./pages/tax-settings/components/employer-taxes/manitobaEmpTaxes/manitobaEmployerTaxes": [
		2636,
		9,
		37,
		498
	],
	"./pages/tax-settings/components/employer-taxes/manitobaEmpTaxes/manitobaEmployerTaxes.tsx": [
		2636,
		9,
		37,
		498
	],
	"./pages/tax-settings/components/employer-taxes/manitobaEmpTaxes/readMBEmpTaxes": [
		2365,
		9,
		1076
	],
	"./pages/tax-settings/components/employer-taxes/manitobaEmpTaxes/readMBEmpTaxes.tsx": [
		2365,
		9,
		1076
	],
	"./pages/tax-settings/components/employer-taxes/manitobaEmpTaxes/updateHELEVYRateModal": [
		2364,
		9,
		833
	],
	"./pages/tax-settings/components/employer-taxes/manitobaEmpTaxes/updateHELEVYRateModal.tsx": [
		2364,
		9,
		833
	],
	"./pages/tax-settings/components/employer-taxes/nflEmpTaxes/nflEmployerTaxes": [
		2637,
		9,
		37,
		527
	],
	"./pages/tax-settings/components/employer-taxes/nflEmpTaxes/nflEmployerTaxes.tsx": [
		2637,
		9,
		37,
		527
	],
	"./pages/tax-settings/components/employer-taxes/ontarioEmpTaxes/ontarioEmployerTaxes": [
		2918,
		9,
		49,
		91,
		1086
	],
	"./pages/tax-settings/components/employer-taxes/ontarioEmpTaxes/ontarioEmployerTaxes.tsx": [
		2918,
		9,
		49,
		91,
		1086
	],
	"./pages/tax-settings/components/employer-taxes/ontarioEmpTaxes/updateEHTAccountNumberModal": [
		3282,
		9,
		49,
		1087
	],
	"./pages/tax-settings/components/employer-taxes/ontarioEmpTaxes/updateEHTAccountNumberModal.tsx": [
		3282,
		9,
		49,
		1087
	],
	"./pages/tax-settings/components/employer-taxes/ontarioEmpTaxes/updateEHTRateModal": [
		2919,
		9,
		834
	],
	"./pages/tax-settings/components/employer-taxes/ontarioEmpTaxes/updateEHTRateModal.tsx": [
		2919,
		9,
		834
	],
	"./pages/tax-settings/components/employer-taxes/quebecEmpTaxes/quebecEmployerTaxes": [
		2915,
		9,
		101,
		510
	],
	"./pages/tax-settings/components/employer-taxes/quebecEmpTaxes/quebecEmployerTaxes.tsx": [
		2915,
		9,
		101,
		510
	],
	"./pages/tax-settings/components/employer-taxes/quebecEmpTaxes/updateHSFAccauntNumberModal": [
		2917,
		9,
		629
	],
	"./pages/tax-settings/components/employer-taxes/quebecEmpTaxes/updateHSFAccauntNumberModal.tsx": [
		2917,
		9,
		629
	],
	"./pages/tax-settings/components/employer-taxes/quebecEmpTaxes/updateHSFRateModal": [
		2916,
		9,
		982
	],
	"./pages/tax-settings/components/employer-taxes/quebecEmpTaxes/updateHSFRateModal.tsx": [
		2916,
		9,
		982
	],
	"./pages/tax-settings/components/hooks/useGetFormatedExemThreshold": [
		1335,
		9,
		2645
	],
	"./pages/tax-settings/components/hooks/useGetFormatedExemThreshold.tsx": [
		1335,
		9,
		2645
	],
	"./pages/tax-settings/components/hooks/useRemittanceIfno": [
		2361,
		9,
		2646
	],
	"./pages/tax-settings/components/hooks/useRemittanceIfno.tsx": [
		2361,
		9,
		2646
	],
	"./pages/tax-settings/components/hooks/useRemoveCompanyTaxSetting": [
		1212,
		9,
		2647
	],
	"./pages/tax-settings/components/hooks/useRemoveCompanyTaxSetting.tsx": [
		1212,
		9,
		2647
	],
	"./pages/tax-settings/components/hooks/useResetEmpTaxesState": [
		1543,
		9,
		2648
	],
	"./pages/tax-settings/components/hooks/useResetEmpTaxesState.ts": [
		1543,
		9,
		2648
	],
	"./pages/tax-settings/components/modalSecondStep/modalSecondStep": [
		1785,
		9,
		1221
	],
	"./pages/tax-settings/components/modalSecondStep/modalSecondStep.tsx": [
		1785,
		9,
		1221
	],
	"./pages/tax-settings/components/overview/overview": [
		3187,
		9,
		546
	],
	"./pages/tax-settings/components/overview/overview.tsx": [
		3187,
		9,
		546
	],
	"./pages/tax-settings/components/overview/overviewStyles": [
		2921,
		9,
		2649
	],
	"./pages/tax-settings/components/overview/overviewStyles.tsx": [
		2921,
		9,
		2649
	],
	"./pages/tax-settings/components/provider/companyTaxInfoProvider": [
		3693,
		9,
		1743
	],
	"./pages/tax-settings/components/provider/companyTaxInfoProvider.tsx": [
		3693,
		9,
		1743
	],
	"./pages/tax-settings/components/provider/companyTaxPropertyProvider": [
		3694,
		9,
		1744
	],
	"./pages/tax-settings/components/provider/companyTaxPropertyProvider.tsx": [
		3694,
		9,
		1744
	],
	"./pages/tax-settings/components/provider/companyTaxRemitProvider": [
		3695,
		9,
		1745
	],
	"./pages/tax-settings/components/provider/companyTaxRemitProvider.tsx": [
		3695,
		9,
		1745
	],
	"./pages/tax-settings/components/provider/sourceDeductionsProvider": [
		3696,
		9,
		2650
	],
	"./pages/tax-settings/components/provider/sourceDeductionsProvider.tsx": [
		3696,
		9,
		2650
	],
	"./pages/tax-settings/components/source-deductions/common/SDFooter": [
		1862,
		9,
		2651
	],
	"./pages/tax-settings/components/source-deductions/common/SDFooter.tsx": [
		1862,
		9,
		2651
	],
	"./pages/tax-settings/components/source-deductions/common/bulletpointText": [
		2070,
		9,
		2652
	],
	"./pages/tax-settings/components/source-deductions/common/bulletpointText.tsx": [
		2070,
		9,
		2652
	],
	"./pages/tax-settings/components/source-deductions/common/createSourceDeductions": [
		2922,
		9,
		630
	],
	"./pages/tax-settings/components/source-deductions/common/createSourceDeductions.tsx": [
		2922,
		9,
		630
	],
	"./pages/tax-settings/components/source-deductions/common/headerFTU": [
		3697,
		9,
		646
	],
	"./pages/tax-settings/components/source-deductions/common/headerFTU.tsx": [
		3697,
		9,
		646
	],
	"./pages/tax-settings/components/source-deductions/common/peopleCount": [
		2923,
		9,
		1223
	],
	"./pages/tax-settings/components/source-deductions/common/peopleCount.tsx": [
		2923,
		9,
		1223
	],
	"./pages/tax-settings/components/source-deductions/common/prUpdateSrcDeductions": [
		2924,
		9,
		666
	],
	"./pages/tax-settings/components/source-deductions/common/prUpdateSrcDeductions.tsx": [
		2924,
		9,
		666
	],
	"./pages/tax-settings/components/source-deductions/common/readSourceDeductions": [
		2925,
		9,
		1222
	],
	"./pages/tax-settings/components/source-deductions/common/readSourceDeductions.tsx": [
		2925,
		9,
		1222
	],
	"./pages/tax-settings/components/source-deductions/common/updateSrcDeductions": [
		2926,
		9,
		690
	],
	"./pages/tax-settings/components/source-deductions/common/updateSrcDeductions.tsx": [
		2926,
		9,
		690
	],
	"./pages/tax-settings/components/source-deductions/common/useFormattedAccounts": [
		940,
		9,
		384
	],
	"./pages/tax-settings/components/source-deductions/common/useFormattedAccounts.ts": [
		940,
		9,
		384
	],
	"./pages/tax-settings/components/source-deductions/common/useFormattedAccounts.tsx": [
		4215,
		9,
		2937
	],
	"./pages/tax-settings/components/source-deductions/common/useGetEffectiveDate": [
		2045,
		9,
		2653
	],
	"./pages/tax-settings/components/source-deductions/common/useGetEffectiveDate.ts": [
		2045,
		9,
		2653
	],
	"./pages/tax-settings/components/source-deductions/common/useSourceDeductiondFlagChecker": [
		1263,
		9,
		2654
	],
	"./pages/tax-settings/components/source-deductions/common/useSourceDeductiondFlagChecker.tsx": [
		1263,
		9,
		2654
	],
	"./pages/tax-settings/components/source-deductions/modals/updateCRAAccountNumberModal": [
		2927,
		9,
		564
	],
	"./pages/tax-settings/components/source-deductions/modals/updateCRAAccountNumberModal.tsx": [
		2927,
		9,
		564
	],
	"./pages/tax-settings/components/source-deductions/modals/updateRQAccountNumberModal": [
		2928,
		9,
		619
	],
	"./pages/tax-settings/components/source-deductions/modals/updateRQAccountNumberModal.tsx": [
		2928,
		9,
		619
	],
	"./pages/tax-settings/components/source-deductions/modals/updateReducedEIRateModa": [
		2929,
		9,
		917
	],
	"./pages/tax-settings/components/source-deductions/modals/updateReducedEIRateModa.tsx": [
		2929,
		9,
		917
	],
	"./pages/tax-settings/components/source-deductions/modals/updateRemitScheduleModal": [
		2930,
		9,
		778
	],
	"./pages/tax-settings/components/source-deductions/modals/updateRemitScheduleModal.tsx": [
		2930,
		9,
		778
	],
	"./pages/tax-settings/components/source-deductions/sourceDeductions": [
		2978,
		9,
		351,
		580
	],
	"./pages/tax-settings/components/source-deductions/sourceDeductions.tsx": [
		2978,
		9,
		351,
		580
	],
	"./pages/tax-settings/components/source-deductions/sourceDeductionsStyles": [
		1286,
		9,
		2655
	],
	"./pages/tax-settings/components/source-deductions/sourceDeductionsStyles.tsx": [
		1286,
		9,
		2655
	],
	"./pages/tax-settings/components/tax-documents/taxDocuments": [
		3188,
		9,
		3,
		615
	],
	"./pages/tax-settings/components/tax-documents/taxDocuments.tsx": [
		3188,
		9,
		3,
		615
	],
	"./pages/tax-settings/components/tax-documents/taxDocumentsStyles": [
		2931,
		9,
		2656
	],
	"./pages/tax-settings/components/tax-documents/taxDocumentsStyles.tsx": [
		2931,
		9,
		2656
	],
	"./pages/tax-settings/components/taxsettings-links/taxSettingsLinks": [
		3698,
		9,
		1429
	],
	"./pages/tax-settings/components/taxsettings-links/taxSettingsLinks.tsx": [
		3698,
		9,
		1429
	],
	"./pages/tax-settings/helper": [
		1141,
		9,
		1746
	],
	"./pages/tax-settings/helper.ts": [
		1141,
		9,
		1746
	],
	"./pages/tax-settings/taxSettingsContainer": [
		3285,
		9,
		3,
		37,
		128,
		49,
		340
	],
	"./pages/tax-settings/taxSettingsContainer.tsx": [
		3285,
		9,
		3,
		37,
		128,
		49,
		340
	],
	"./pages/tax-settings/taxSettingsView": [
		3494,
		9,
		3,
		37,
		128,
		49,
		424
	],
	"./pages/tax-settings/taxSettingsView.tsx": [
		3494,
		9,
		3,
		37,
		128,
		49,
		424
	],
	"./pages/tax-settings/useTaxSettingsHooks": [
		1186,
		9,
		1428
	],
	"./pages/tax-settings/useTaxSettingsHooks.tsx": [
		1186,
		9,
		1428
	],
	"./pages/typography/typography": [
		3286,
		9,
		385
	],
	"./pages/typography/typography.tsx": [
		3286,
		9,
		385
	],
	"./query-client/query-client": [
		297,
		9
	],
	"./query-client/query-client.ts": [
		297,
		9
	],
	"./react-app-env.d": [
		3699,
		7,
		2657
	],
	"./react-app-env.d.ts": [
		3699,
		7,
		2657
	],
	"./redux/data/financePersonTaxAccess": [
		1831,
		9,
		2658
	],
	"./redux/data/financePersonTaxAccess.ts": [
		1831,
		9,
		2658
	],
	"./redux/data/people.employeeStatus": [
		1832,
		9,
		2659
	],
	"./redux/data/people.employeeStatus.ts": [
		1832,
		9,
		2659
	],
	"./redux/data/peopleAccess.person": [
		1653,
		9,
		2660
	],
	"./redux/data/peopleAccess.person.ts": [
		1653,
		9,
		2660
	],
	"./redux/data/securityAccess.users": [
		1228,
		9,
		2661
	],
	"./redux/data/securityAccess.users.ts": [
		1228,
		9,
		2661
	],
	"./redux/hooks/hook": [
		17,
		9
	],
	"./redux/hooks/hook.ts": [
		17,
		9
	],
	"./redux/hooks/useLoaders": [
		113,
		9
	],
	"./redux/hooks/useLoaders.ts": [
		113,
		9
	],
	"./redux/hooks/useSnackbar": [
		165,
		9
	],
	"./redux/hooks/useSnackbar.ts": [
		165,
		9
	],
	"./redux/reducers": [
		355,
		9
	],
	"./redux/reducers/": [
		355,
		9
	],
	"./redux/reducers/index": [
		355,
		9
	],
	"./redux/reducers/index.ts": [
		355,
		9
	],
	"./redux/slice/accountingAdministratorTable": [
		502,
		9
	],
	"./redux/slice/accountingAdministratorTable.ts": [
		502,
		9
	],
	"./redux/slice/accountingDashboardSlices/addNewClientSlice": [
		505,
		9
	],
	"./redux/slice/accountingDashboardSlices/addNewClientSlice.ts": [
		505,
		9
	],
	"./redux/slice/accountingDashboardSlices/clientDirectorySlice": [
		190,
		9
	],
	"./redux/slice/accountingDashboardSlices/clientDirectorySlice.ts": [
		190,
		9
	],
	"./redux/slice/accountingDashboardSlices/dashboardSlice": [
		491,
		9
	],
	"./redux/slice/accountingDashboardSlices/dashboardSlice.ts": [
		491,
		9
	],
	"./redux/slice/accountingDashboardSlices/switchingFirmsSlice": [
		487,
		9
	],
	"./redux/slice/accountingDashboardSlices/switchingFirmsSlice.ts": [
		487,
		9
	],
	"./redux/slice/accountingFirmSlice": [
		39,
		9
	],
	"./redux/slice/accountingFirmSlice.ts": [
		39,
		9
	],
	"./redux/slice/accountingPermissionTable": [
		525,
		9
	],
	"./redux/slice/accountingPermissionTable.ts": [
		525,
		9
	],
	"./redux/slice/accountingUserAccount": [
		486,
		9
	],
	"./redux/slice/accountingUserAccount.ts": [
		486,
		9
	],
	"./redux/slice/addBankSlice": [
		489,
		9
	],
	"./redux/slice/addBankSlice.ts": [
		489,
		9
	],
	"./redux/slice/addonsSlices/common/chartOfAccountsSlice": [
		503,
		9
	],
	"./redux/slice/addonsSlices/common/chartOfAccountsSlice.ts": [
		503,
		9
	],
	"./redux/slice/addonsSlices/connectSlice": [
		520,
		9
	],
	"./redux/slice/addonsSlices/connectSlice.ts": [
		520,
		9
	],
	"./redux/slice/addonsSlices/disconnectSlice": [
		499,
		9
	],
	"./redux/slice/addonsSlices/disconnectSlice.ts": [
		499,
		9
	],
	"./redux/slice/addonsSlices/exportPayrollSlice": [
		506,
		9
	],
	"./redux/slice/addonsSlices/exportPayrollSlice.ts": [
		506,
		9
	],
	"./redux/slice/addonsSlices/getChartOfAccountsSlice": [
		513,
		9
	],
	"./redux/slice/addonsSlices/getChartOfAccountsSlice.ts": [
		513,
		9
	],
	"./redux/slice/addonsSlices/getIntegrationStatusSlice": [
		453,
		9
	],
	"./redux/slice/addonsSlices/getIntegrationStatusSlice.ts": [
		453,
		9
	],
	"./redux/slice/addonsSlices/getIntegrationsAccountListSlice": [
		512,
		9
	],
	"./redux/slice/addonsSlices/getIntegrationsAccountListSlice.ts": [
		512,
		9
	],
	"./redux/slice/addonsSlices/getIntegrationsVendorListSlice": [
		517,
		9
	],
	"./redux/slice/addonsSlices/getIntegrationsVendorListSlice.ts": [
		517,
		9
	],
	"./redux/slice/addonsSlices/getTaxRateListSlice": [
		514,
		9
	],
	"./redux/slice/addonsSlices/getTaxRateListSlice.ts": [
		514,
		9
	],
	"./redux/slice/addonsSlices/persistAutoSyncPreferenceSlice": [
		522,
		9
	],
	"./redux/slice/addonsSlices/persistAutoSyncPreferenceSlice.ts": [
		522,
		9
	],
	"./redux/slice/addonsSlices/persistChartOfAccountsSlice": [
		601,
		9
	],
	"./redux/slice/addonsSlices/persistChartOfAccountsSlice.ts": [
		601,
		9
	],
	"./redux/slice/addonsSlices/persistIntegrationsVendorListSlice": [
		661,
		9
	],
	"./redux/slice/addonsSlices/persistIntegrationsVendorListSlice.ts": [
		661,
		9
	],
	"./redux/slice/addonsSlices/xero/xeroSlice": [
		494,
		9
	],
	"./redux/slice/addonsSlices/xero/xeroSlice.ts": [
		494,
		9
	],
	"./redux/slice/annualReportSlice": [
		493,
		9
	],
	"./redux/slice/annualReportSlice.ts": [
		493,
		9
	],
	"./redux/slice/appNotificationSlice": [
		507,
		9
	],
	"./redux/slice/appNotificationSlice.ts": [
		507,
		9
	],
	"./redux/slice/associatedCompaniesSlice": [
		537,
		9
	],
	"./redux/slice/associatedCompaniesSlice.ts": [
		537,
		9
	],
	"./redux/slice/companyBankSlice": [
		504,
		9
	],
	"./redux/slice/companyBankSlice.ts": [
		504,
		9
	],
	"./redux/slice/companyDetailsSlice": [
		446,
		9
	],
	"./redux/slice/companyDetailsSlice.ts": [
		446,
		9
	],
	"./redux/slice/companyFieldSlice": [
		467,
		9
	],
	"./redux/slice/companyFieldSlice.ts": [
		467,
		9
	],
	"./redux/slice/companyPayrollSlice": [
		549,
		9
	],
	"./redux/slice/companyPayrollSlice.ts": [
		549,
		9
	],
	"./redux/slice/companySettingsSlice": [
		207,
		9
	],
	"./redux/slice/companySettingsSlice.ts": [
		207,
		9
	],
	"./redux/slice/configSlice": [
		31,
		9
	],
	"./redux/slice/configSlice.ts": [
		31,
		9
	],
	"./redux/slice/documentAccessSlice": [
		552,
		9
	],
	"./redux/slice/documentAccessSlice.ts": [
		552,
		9
	],
	"./redux/slice/firstTimeUserSlice": [
		326,
		9
	],
	"./redux/slice/firstTimeUserSlice.ts": [
		326,
		9
	],
	"./redux/slice/fromAlfredSlice": [
		166,
		9
	],
	"./redux/slice/fromAlfredSlice.ts": [
		166,
		9
	],
	"./redux/slice/layoutSlice": [
		474,
		9
	],
	"./redux/slice/layoutSlice.ts": [
		474,
		9
	],
	"./redux/slice/loadingIndicatorSlice": [
		43,
		9
	],
	"./redux/slice/loadingIndicatorSlice.ts": [
		43,
		9
	],
	"./redux/slice/migrationSlice": [
		448,
		9
	],
	"./redux/slice/migrationSlice.ts": [
		448,
		9
	],
	"./redux/slice/negativeAdjustmentSlice": [
		490,
		9
	],
	"./redux/slice/negativeAdjustmentSlice.ts": [
		490,
		9
	],
	"./redux/slice/notificationsSlice": [
		496,
		9
	],
	"./redux/slice/notificationsSlice.ts": [
		496,
		9
	],
	"./redux/slice/parentCompanySlice": [
		528,
		9
	],
	"./redux/slice/parentCompanySlice.ts": [
		528,
		9
	],
	"./redux/slice/payrollReportsSlice": [
		442,
		9
	],
	"./redux/slice/payrollReportsSlice.ts": [
		442,
		9
	],
	"./redux/slice/payrollSettingSlice": [
		534,
		9
	],
	"./redux/slice/payrollSettingSlice.ts": [
		534,
		9
	],
	"./redux/slice/payrollSlices/adjustmentsSlice": [
		481,
		9
	],
	"./redux/slice/payrollSlices/adjustmentsSlice.ts": [
		481,
		9
	],
	"./redux/slice/payrollSlices/commonPayrollSlice": [
		164,
		9
	],
	"./redux/slice/payrollSlices/commonPayrollSlice.ts": [
		164,
		9
	],
	"./redux/slice/payrollSlices/gridViewSlice": [
		455,
		9
	],
	"./redux/slice/payrollSlices/gridViewSlice.ts": [
		455,
		9
	],
	"./redux/slice/payrollSlices/hoursIncomeSlice": [
		432,
		9
	],
	"./redux/slice/payrollSlices/hoursIncomeSlice.ts": [
		432,
		9
	],
	"./redux/slice/payrollSlices/payGroupSlice": [
		445,
		9
	],
	"./redux/slice/payrollSlices/payGroupSlice.ts": [
		445,
		9
	],
	"./redux/slice/payrollSlices/payrollFrequencySlice": [
		510,
		9
	],
	"./redux/slice/payrollSlices/payrollFrequencySlice.ts": [
		510,
		9
	],
	"./redux/slice/payrollSlices/payrollHeaderSlice": [
		488,
		9
	],
	"./redux/slice/payrollSlices/payrollHeaderSlice.ts": [
		488,
		9
	],
	"./redux/slice/payrollSlices/payrollSliceHelpers": [
		413,
		9
	],
	"./redux/slice/payrollSlices/payrollSliceHelpers.ts": [
		413,
		9
	],
	"./redux/slice/payrollSlices/reviewapproveSlice": [
		444,
		9
	],
	"./redux/slice/payrollSlices/reviewapproveSlice.ts": [
		444,
		9
	],
	"./redux/slice/payrollSlices/selectDateSlice": [
		462,
		9
	],
	"./redux/slice/payrollSlices/selectDateSlice.ts": [
		462,
		9
	],
	"./redux/slice/payrollSlices/standardWeekHoursSlice": [
		662,
		9
	],
	"./redux/slice/payrollSlices/standardWeekHoursSlice.ts": [
		662,
		9
	],
	"./redux/slice/payrollSlices/taxesSlice": [
		498,
		9
	],
	"./redux/slice/payrollSlices/taxesSlice.ts": [
		498,
		9
	],
	"./redux/slice/peopleExtraSliceFn/peopleDashboard": [
		456,
		9
	],
	"./redux/slice/peopleExtraSliceFn/peopleDashboard.ts": [
		456,
		9
	],
	"./redux/slice/peopleExtraSliceFn/peopleOnboarding": [
		449,
		9
	],
	"./redux/slice/peopleExtraSliceFn/peopleOnboarding.ts": [
		449,
		9
	],
	"./redux/slice/peopleSlice": [
		441,
		9
	],
	"./redux/slice/peopleSlice.ts": [
		441,
		9
	],
	"./redux/slice/peopleSlices/basicInfoSlice": [
		428,
		9
	],
	"./redux/slice/peopleSlices/basicInfoSlice.ts": [
		428,
		9
	],
	"./redux/slice/peopleSlices/finalReviewSlice": [
		473,
		9
	],
	"./redux/slice/peopleSlices/finalReviewSlice.ts": [
		473,
		9
	],
	"./redux/slice/peopleSlices/guidedOnboardingSlice": [
		530,
		9
	],
	"./redux/slice/peopleSlices/guidedOnboardingSlice.ts": [
		530,
		9
	],
	"./redux/slice/peopleSlices/idbSlice": [
		452,
		9
	],
	"./redux/slice/peopleSlices/idbSlice.ts": [
		452,
		9
	],
	"./redux/slice/peopleSlices/jobDetailsSlice": [
		437,
		9
	],
	"./redux/slice/peopleSlices/jobDetailsSlice.ts": [
		437,
		9
	],
	"./redux/slice/peopleSlices/people-slice-config": [
		3700,
		9,
		2662
	],
	"./redux/slice/peopleSlices/people-slice-config.ts": [
		3700,
		9,
		2662
	],
	"./redux/slice/peopleSlices/peopleSharedSlice": [
		426,
		9
	],
	"./redux/slice/peopleSlices/peopleSharedSlice.ts": [
		426,
		9
	],
	"./redux/slice/peopleSlices/peopleSidebarSlice": [
		439,
		9
	],
	"./redux/slice/peopleSlices/peopleSidebarSlice.ts": [
		439,
		9
	],
	"./redux/slice/peopleSlices/personSlice": [
		509,
		9
	],
	"./redux/slice/peopleSlices/personSlice.ts": [
		509,
		9
	],
	"./redux/slice/peopleSlices/priorPayrollSlice": [
		436,
		9
	],
	"./redux/slice/peopleSlices/priorPayrollSlice.ts": [
		436,
		9
	],
	"./redux/slice/peopleSlices/taxInfoSlice": [
		450,
		9
	],
	"./redux/slice/peopleSlices/taxInfoSlice.ts": [
		450,
		9
	],
	"./redux/slice/personalSlice": [
		657,
		9
	],
	"./redux/slice/personalSlice.ts": [
		657,
		9
	],
	"./redux/slice/poeSlice": [
		529,
		9
	],
	"./redux/slice/poeSlice.ts": [
		529,
		9
	],
	"./redux/slice/poeSlices/poeBasicInfoSlice": [
		518,
		9
	],
	"./redux/slice/poeSlices/poeBasicInfoSlice.ts": [
		518,
		9
	],
	"./redux/slice/poeSlices/poeCommonSlice": [
		471,
		9
	],
	"./redux/slice/poeSlices/poeCommonSlice.ts": [
		471,
		9
	],
	"./redux/slice/poeSlices/poeJobDetailsSlice": [
		519,
		9
	],
	"./redux/slice/poeSlices/poeJobDetailsSlice.ts": [
		519,
		9
	],
	"./redux/slice/poeSlices/poeSideBarSlice": [
		484,
		9
	],
	"./redux/slice/poeSlices/poeSideBarSlice.ts": [
		484,
		9
	],
	"./redux/slice/poeSlices/poeTaxInfoSlice": [
		511,
		9
	],
	"./redux/slice/poeSlices/poeTaxInfoSlice.ts": [
		511,
		9
	],
	"./redux/slice/preferences/getPersonPreferencesSlice": [
		478,
		9
	],
	"./redux/slice/preferences/getPersonPreferencesSlice.ts": [
		478,
		9
	],
	"./redux/slice/preferences/getPersonSlice": [
		658,
		9
	],
	"./redux/slice/preferences/getPersonSlice.ts": [
		658,
		9
	],
	"./redux/slice/preferences/persistPersonSlice": [
		659,
		9
	],
	"./redux/slice/preferences/persistPersonSlice.ts": [
		659,
		9
	],
	"./redux/slice/preferences/personProfileSlice": [
		547,
		9
	],
	"./redux/slice/preferences/personProfileSlice.ts": [
		547,
		9
	],
	"./redux/slice/reactivateAccountSlice": [
		535,
		9
	],
	"./redux/slice/reactivateAccountSlice.ts": [
		535,
		9
	],
	"./redux/slice/recordOfEmploymentFormStateSlice": [
		458,
		9
	],
	"./redux/slice/recordOfEmploymentFormStateSlice.ts": [
		458,
		9
	],
	"./redux/slice/security-access/changeEmailSlice": [
		2596,
		9,
		2663
	],
	"./redux/slice/security-access/changeEmailSlice.ts": [
		2596,
		9,
		2663
	],
	"./redux/slice/security-access/changePasswordSlice": [
		542,
		9
	],
	"./redux/slice/security-access/changePasswordSlice.ts": [
		542,
		9
	],
	"./redux/slice/security-access/getSecurityRolesSlice": [
		660,
		9
	],
	"./redux/slice/security-access/getSecurityRolesSlice.ts": [
		660,
		9
	],
	"./redux/slice/security-access/getUserSlice": [
		435,
		9
	],
	"./redux/slice/security-access/getUserSlice.ts": [
		435,
		9
	],
	"./redux/slice/security-access/maintain2faSlice": [
		1460,
		9,
		2664
	],
	"./redux/slice/security-access/maintain2faSlice.ts": [
		1460,
		9,
		2664
	],
	"./redux/slice/security-access/validateEmailSlice": [
		548,
		9
	],
	"./redux/slice/security-access/validateEmailSlice.ts": [
		548,
		9
	],
	"./redux/slice/security-access/verifySmsCodeSlice": [
		2180,
		9,
		2665
	],
	"./redux/slice/security-access/verifySmsCodeSlice.ts": [
		2180,
		9,
		2665
	],
	"./redux/slice/snackbarSlice": [
		71,
		9
	],
	"./redux/slice/snackbarSlice.ts": [
		71,
		9
	],
	"./redux/slice/stateSlice": [
		479,
		9
	],
	"./redux/slice/stateSlice.ts": [
		479,
		9
	],
	"./redux/slice/statusBarSlice": [
		526,
		9
	],
	"./redux/slice/statusBarSlice.ts": [
		526,
		9
	],
	"./redux/slice/taxSettingsSlices/getEmpTaxesSlice": [
		475,
		9
	],
	"./redux/slice/taxSettingsSlices/getEmpTaxesSlice.ts": [
		475,
		9
	],
	"./redux/slice/taxSettingsSlices/overviewSlice": [
		454,
		9
	],
	"./redux/slice/taxSettingsSlices/overviewSlice.ts": [
		454,
		9
	],
	"./redux/slice/taxSettingsSlices/persistEmpTaxesSlice": [
		599,
		9
	],
	"./redux/slice/taxSettingsSlices/persistEmpTaxesSlice.ts": [
		599,
		9
	],
	"./redux/slice/taxSettingsSlices/stateListSlice": [
		521,
		9
	],
	"./redux/slice/taxSettingsSlices/stateListSlice.ts": [
		521,
		9
	],
	"./redux/slice/userAccountsSlice": [
		48,
		9
	],
	"./redux/slice/userAccountsSlice.ts": [
		48,
		9
	],
	"./redux/slice/yearEndSubmitFormStateSlice": [
		464,
		9
	],
	"./redux/slice/yearEndSubmitFormStateSlice.ts": [
		464,
		9
	],
	"./redux/store/store": [
		339,
		9
	],
	"./redux/store/store.ts": [
		339,
		9
	],
	"./reportWebVitals": [
		588,
		9
	],
	"./reportWebVitals.ts": [
		588,
		9
	],
	"./services/acounting-user-roles/securityAccess.contracts": [
		3701,
		9,
		2666
	],
	"./services/acounting-user-roles/securityAccess.contracts.ts": [
		3701,
		9,
		2666
	],
	"./services/acounting-user-roles/securityAccess.service": [
		3702,
		9,
		2667
	],
	"./services/acounting-user-roles/securityAccess.service.ts": [
		3702,
		9,
		2667
	],
	"./services/add-employment-province-access/addPoEAccess.contracts": [
		195,
		9
	],
	"./services/add-employment-province-access/addPoEAccess.contracts.ts": [
		195,
		9
	],
	"./services/add-employment-province-access/addPoEAccess.services": [
		341,
		9
	],
	"./services/add-employment-province-access/addPoEAccess.services.ts": [
		341,
		9
	],
	"./services/address-validation-access/addressValidationAccess.contracts": [
		3703,
		9,
		2668
	],
	"./services/address-validation-access/addressValidationAccess.contracts.ts": [
		3703,
		9,
		2668
	],
	"./services/address-validation-access/addressValidationAccess.service": [
		2457,
		9,
		2669
	],
	"./services/address-validation-access/addressValidationAccess.service.ts": [
		2457,
		9,
		2669
	],
	"./services/app-notification-access/appNotificationAccess.contracts": [
		2261,
		9,
		2670
	],
	"./services/app-notification-access/appNotificationAccess.contracts.ts": [
		2261,
		9,
		2670
	],
	"./services/app-notification-access/appNotificationAcess.service": [
		1547,
		9,
		2671
	],
	"./services/app-notification-access/appNotificationAcess.service.ts": [
		1547,
		9,
		2671
	],
	"./services/appCore/models/access/addressValidationAccess": [
		1229,
		9,
		2672
	],
	"./services/appCore/models/access/addressValidationAccess.ts": [
		1229,
		9,
		2672
	],
	"./services/appCore/models/access/companyAccess": [
		460,
		9
	],
	"./services/appCore/models/access/companyAccess.ts": [
		460,
		9
	],
	"./services/appCore/models/access/companyOnboardAccess": [
		1386,
		9,
		2673
	],
	"./services/appCore/models/access/companyOnboardAccess.ts": [
		1386,
		9,
		2673
	],
	"./services/appCore/models/access/companySettingsAccess": [
		457,
		9
	],
	"./services/appCore/models/access/companySettingsAccess.ts": [
		457,
		9
	],
	"./services/appCore/models/access/partnerAccess": [
		107,
		9
	],
	"./services/appCore/models/access/partnerAccess.ts": [
		107,
		9
	],
	"./services/appCore/models/access/personSettingAccess": [
		411,
		9
	],
	"./services/appCore/models/access/personSettingAccess.ts": [
		411,
		9
	],
	"./services/appCore/models/access/personSettingsAccess": [
		2221,
		9,
		2674
	],
	"./services/appCore/models/access/personSettingsAccess.ts": [
		2221,
		9,
		2674
	],
	"./services/appCore/models/access/securityAccess": [
		1069,
		9,
		2675
	],
	"./services/appCore/models/access/securityAccess.ts": [
		1069,
		9,
		2675
	],
	"./services/appCore/models/access/uiConfigAccess": [
		342,
		9
	],
	"./services/appCore/models/access/uiConfigAccess.ts": [
		342,
		9
	],
	"./services/appCore/models/access/userAccountAccess": [
		1293,
		9,
		2676
	],
	"./services/appCore/models/access/userAccountAccess.ts": [
		1293,
		9,
		2676
	],
	"./services/appCore/models/schema/Schema": [
		38,
		9
	],
	"./services/appCore/models/schema/Schema.ts": [
		38,
		9
	],
	"./services/company-access/companyAccess.contracts": [
		1093,
		9,
		2677
	],
	"./services/company-access/companyAccess.contracts.ts": [
		1093,
		9,
		2677
	],
	"./services/company-access/companyAccess.service": [
		111,
		9
	],
	"./services/company-access/companyAccess.service.ts": [
		111,
		9
	],
	"./services/company-bank-access/companyBankAccess.contracts": [
		1153,
		9,
		2678
	],
	"./services/company-bank-access/companyBankAccess.contracts.ts": [
		1153,
		9,
		2678
	],
	"./services/company-bank-access/companyBankAccess.service": [
		495,
		9
	],
	"./services/company-bank-access/companyBankAccess.service.ts": [
		495,
		9
	],
	"./services/company-close-access/companyCloseAccess.contracts": [
		2182,
		9,
		2679
	],
	"./services/company-close-access/companyCloseAccess.contracts.ts": [
		2182,
		9,
		2679
	],
	"./services/company-close-access/companyCloseAccess.service": [
		2603,
		9,
		2680
	],
	"./services/company-close-access/companyCloseAccess.service.ts": [
		2603,
		9,
		2680
	],
	"./services/company-field-access/companyFieldAccess.contracts": [
		433,
		9
	],
	"./services/company-field-access/companyFieldAccess.contracts.ts": [
		433,
		9
	],
	"./services/company-field-access/companyFieldAccess.service": [
		1216,
		9,
		2681
	],
	"./services/company-field-access/companyFieldAccess.service.ts": [
		1216,
		9,
		2681
	],
	"./services/company-settings-access/companySettingsAccess.contracts": [
		232,
		9
	],
	"./services/company-settings-access/companySettingsAccess.contracts.ts": [
		232,
		9
	],
	"./services/company-settings-access/companySettingsAccess.service": [
		527,
		9
	],
	"./services/company-settings-access/companySettingsAccess.service.ts": [
		527,
		9
	],
	"./services/core-security/coreSecurity.service": [
		483,
		9
	],
	"./services/core-security/coreSecurity.service.ts": [
		483,
		9
	],
	"./services/document-access/documentAccess.contracts": [
		1084,
		9,
		2682
	],
	"./services/document-access/documentAccess.contracts.ts": [
		1084,
		9,
		2682
	],
	"./services/document-access/documentAccess.service": [
		253,
		9
	],
	"./services/document-access/documentAccess.service.ts": [
		253,
		9
	],
	"./services/employee-field-access/employeeFieldAccess.contracts": [
		149,
		9
	],
	"./services/employee-field-access/employeeFieldAccess.contracts.ts": [
		149,
		9
	],
	"./services/employee-field-access/employeeFieldAccess.service": [
		156,
		9
	],
	"./services/employee-field-access/employeeFieldAccess.service.ts": [
		156,
		9
	],
	"./services/field-access/fieldAccess.contracts": [
		1181,
		9,
		2683
	],
	"./services/field-access/fieldAccess.contracts.ts": [
		1181,
		9,
		2683
	],
	"./services/field-access/fieldAccess.service": [
		1859,
		9,
		2684
	],
	"./services/field-access/fieldAccess.service.ts": [
		1859,
		9,
		2684
	],
	"./services/finance-field-access/financeFieldAccess.contracts": [
		3709,
		9,
		2685
	],
	"./services/finance-field-access/financeFieldAccess.contracts.ts": [
		3709,
		9,
		2685
	],
	"./services/finance-field-access/financeFieldAcess.service": [
		1132,
		9,
		2686
	],
	"./services/finance-field-access/financeFieldAcess.service.ts": [
		1132,
		9,
		2686
	],
	"./services/finance/models/access/accountingFirmInvoiceAccess": [
		3704,
		9,
		2687
	],
	"./services/finance/models/access/accountingFirmInvoiceAccess.ts": [
		3704,
		9,
		2687
	],
	"./services/finance/models/access/bankFileAccess": [
		3705,
		9,
		2688
	],
	"./services/finance/models/access/bankFileAccess.ts": [
		3705,
		9,
		2688
	],
	"./services/finance/models/access/billingAccess": [
		83,
		9
	],
	"./services/finance/models/access/billingAccess.ts": [
		83,
		9
	],
	"./services/finance/models/access/companyAccess": [
		94,
		9
	],
	"./services/finance/models/access/companyAccess.ts": [
		94,
		9
	],
	"./services/finance/models/access/companyLinkAccess": [
		87,
		9
	],
	"./services/finance/models/access/companyLinkAccess.ts": [
		87,
		9
	],
	"./services/finance/models/access/companyLinkManager": [
		3706,
		9,
		2689
	],
	"./services/finance/models/access/companyLinkManager.ts": [
		3706,
		9,
		2689
	],
	"./services/finance/models/access/incomingPaymentAccess": [
		2212,
		9,
		2690
	],
	"./services/finance/models/access/incomingPaymentAccess.ts": [
		2212,
		9,
		2690
	],
	"./services/finance/models/access/plaidAccess": [
		2087,
		9,
		2691
	],
	"./services/finance/models/access/plaidAccess.ts": [
		2087,
		9,
		2691
	],
	"./services/finance/models/access/truliooAccess": [
		3707,
		9,
		2692
	],
	"./services/finance/models/access/truliooAccess.ts": [
		3707,
		9,
		2692
	],
	"./services/finance/models/functions/Functions": [
		3708,
		9,
		2693
	],
	"./services/finance/models/functions/Functions.ts": [
		3708,
		9,
		2693
	],
	"./services/finance/models/schema/Schema": [
		249,
		9
	],
	"./services/finance/models/schema/Schema.ts": [
		249,
		9
	],
	"./services/httpClient": [
		5,
		9
	],
	"./services/httpClient.ts": [
		5,
		9
	],
	"./services/integrations-access/accountingManagerAccess": [
		120,
		9
	],
	"./services/integrations-access/accountingManagerAccess.ts": [
		120,
		9
	],
	"./services/integrations-access/hrManager.service": [
		389,
		9
	],
	"./services/integrations-access/hrManager.service.ts": [
		389,
		9
	],
	"./services/integrations-access/integrationsAccess.contracts": [
		257,
		9
	],
	"./services/integrations-access/integrationsAccess.contracts.ts": [
		257,
		9
	],
	"./services/integrations-access/integrationsAccess.service": [
		114,
		9
	],
	"./services/integrations-access/integrationsAccess.service.ts": [
		114,
		9
	],
	"./services/integrations-access/timeIntegrationAccess.service": [
		465,
		9
	],
	"./services/integrations-access/timeIntegrationAccess.service.ts": [
		465,
		9
	],
	"./services/job-access/jobAccess.contracts": [
		167,
		9
	],
	"./services/job-access/jobAccess.contracts.ts": [
		167,
		9
	],
	"./services/job-access/jobAccess.service": [
		79,
		9
	],
	"./services/job-access/jobAccess.service.ts": [
		79,
		9
	],
	"./services/login-manager/loginManager.contracts": [
		3710,
		9,
		2694
	],
	"./services/login-manager/loginManager.contracts.ts": [
		3710,
		9,
		2694
	],
	"./services/login-manager/loginManager.service": [
		3711,
		9,
		2695
	],
	"./services/login-manager/loginManager.service.ts": [
		3711,
		9,
		2695
	],
	"./services/money-movement-access/moneyMovementAccess.contracts": [
		3391,
		9,
		2696
	],
	"./services/money-movement-access/moneyMovementAccess.contracts.ts": [
		3391,
		9,
		2696
	],
	"./services/money-movement-access/moneyMovementAccess.service": [
		3390,
		9,
		2697
	],
	"./services/money-movement-access/moneyMovementAccess.service.ts": [
		3390,
		9,
		2697
	],
	"./services/notification/models/schema/Schema": [
		1275,
		9,
		2698
	],
	"./services/notification/models/schema/Schema.ts": [
		1275,
		9,
		2698
	],
	"./services/onboard-question-access/onboardQuestion.contracts": [
		140,
		9
	],
	"./services/onboard-question-access/onboardQuestion.contracts.ts": [
		140,
		9
	],
	"./services/onboard-question-access/onboardQuestion.service": [
		157,
		9
	],
	"./services/onboard-question-access/onboardQuestion.service.ts": [
		157,
		9
	],
	"./services/paygroup-access/paygroupAccess.contracts": [
		327,
		9
	],
	"./services/paygroup-access/paygroupAccess.contracts.ts": [
		327,
		9
	],
	"./services/paygroup-access/paygroupAccess.service": [
		155,
		9
	],
	"./services/paygroup-access/paygroupAccess.service.ts": [
		155,
		9
	],
	"./services/payperiod-review-access/payPeriodReviewAccess.contracts": [
		3712,
		9,
		2699
	],
	"./services/payperiod-review-access/payPeriodReviewAccess.contracts.ts": [
		3712,
		9,
		2699
	],
	"./services/payperiod-review-access/payPeriodReviewAccess.service": [
		3713,
		9,
		2700
	],
	"./services/payperiod-review-access/payPeriodReviewAccess.service.ts": [
		3713,
		9,
		2700
	],
	"./services/payperiod-schema/payPeriodSchema.contracts": [
		2007,
		9,
		2701
	],
	"./services/payperiod-schema/payPeriodSchema.contracts.ts": [
		2007,
		9,
		2701
	],
	"./services/payroll-company-onboard-access/payrollCompanyOnboardAccess.contracts": [
		290,
		9
	],
	"./services/payroll-company-onboard-access/payrollCompanyOnboardAccess.contracts.ts": [
		290,
		9
	],
	"./services/payroll-company-onboard-access/payrollCompanyOnboardAccess.service": [
		210,
		9
	],
	"./services/payroll-company-onboard-access/payrollCompanyOnboardAccess.service.ts": [
		210,
		9
	],
	"./services/payroll-dashboard-access/payrollDashboardAccess.contracts": [
		1147,
		9,
		2702
	],
	"./services/payroll-dashboard-access/payrollDashboardAccess.contracts.ts": [
		1147,
		9,
		2702
	],
	"./services/payroll-dashboard-access/payrollDashboardAccess.service": [
		1113,
		9,
		2703
	],
	"./services/payroll-dashboard-access/payrollDashboardAccess.service.ts": [
		1113,
		9,
		2703
	],
	"./services/payroll-holidaypay-access/holidayPayAccess.contracts": [
		3715,
		9,
		2704
	],
	"./services/payroll-holidaypay-access/holidayPayAccess.contracts.ts": [
		3715,
		9,
		2704
	],
	"./services/payroll-holidaypay-access/holidayPayAccess.service": [
		412,
		9
	],
	"./services/payroll-holidaypay-access/holidayPayAccess.service.ts": [
		412,
		9
	],
	"./services/payroll-launch-access/payrollLaunchAccess.contracts": [
		1206,
		9,
		2705
	],
	"./services/payroll-launch-access/payrollLaunchAccess.contracts.ts": [
		1206,
		9,
		2705
	],
	"./services/payroll-launch-access/payrollLaunchAccess.service": [
		1908,
		9,
		2706
	],
	"./services/payroll-launch-access/payrollLaunchAccess.service.ts": [
		1908,
		9,
		2706
	],
	"./services/payroll-payperiod-access/payPeriodAccess.contracts": [
		1081,
		9,
		2707
	],
	"./services/payroll-payperiod-access/payPeriodAccess.contracts.ts": [
		1081,
		9,
		2707
	],
	"./services/payroll-payperiod-access/payPeriodAccess.service": [
		1137,
		9,
		2708
	],
	"./services/payroll-payperiod-access/payPeriodAccess.service.ts": [
		1137,
		9,
		2708
	],
	"./services/payroll-payperiodaction-access/payPeriodActionAccess.contracts": [
		1432,
		9,
		2709
	],
	"./services/payroll-payperiodaction-access/payPeriodActionAccess.contracts.ts": [
		1432,
		9,
		2709
	],
	"./services/payroll-payperiodaction-access/payPeriodActionAccess.service": [
		1135,
		9,
		2710
	],
	"./services/payroll-payperiodaction-access/payPeriodActionAccess.service.ts": [
		1135,
		9,
		2710
	],
	"./services/payroll-person-onboard-access/payrollPersonOnboardAccess.contracts": [
		1255,
		9,
		2711
	],
	"./services/payroll-person-onboard-access/payrollPersonOnboardAccess.contracts.ts": [
		1255,
		9,
		2711
	],
	"./services/payroll-person-onboard-access/payrollPersonOnboardAccess.service": [
		234,
		9
	],
	"./services/payroll-person-onboard-access/payrollPersonOnboardAccess.service.ts": [
		234,
		9
	],
	"./services/payroll-record-of-employment-access/payrollRecordOfEmploymentAccess.contracts": [
		291,
		9
	],
	"./services/payroll-record-of-employment-access/payrollRecordOfEmploymentAccess.contracts.ts": [
		291,
		9
	],
	"./services/payroll-record-of-employment-access/payrollRecordOfEmploymentAccess.service": [
		1101,
		9,
		2712
	],
	"./services/payroll-record-of-employment-access/payrollRecordOfEmploymentAccess.service.ts": [
		1101,
		9,
		2712
	],
	"./services/payroll-report-access/payrollReport.contracts": [
		1065,
		9,
		2713
	],
	"./services/payroll-report-access/payrollReport.contracts.ts": [
		1065,
		9,
		2713
	],
	"./services/payroll-report-access/payrollReport.service": [
		1131,
		9,
		2715
	],
	"./services/payroll-report-access/payrollReport.service.ts": [
		1131,
		9,
		2715
	],
	"./services/payroll-wcbrate-access/wcbRateAccess.contracts": [
		3716,
		9,
		2716
	],
	"./services/payroll-wcbrate-access/wcbRateAccess.contracts.ts": [
		3716,
		9,
		2716
	],
	"./services/payroll-wcbrate-access/wcbRateAccess.service": [
		3165,
		9,
		2717
	],
	"./services/payroll-wcbrate-access/wcbRateAccess.service.ts": [
		3165,
		9,
		2717
	],
	"./services/payroll-xero-access/payrollXeroAccess.contracts": [
		3717,
		9,
		2718
	],
	"./services/payroll-xero-access/payrollXeroAccess.contracts.ts": [
		3717,
		9,
		2718
	],
	"./services/payroll-xero-access/payrollXeroAccess.services": [
		3718,
		9,
		2719
	],
	"./services/payroll-xero-access/payrollXeroAccess.services.ts": [
		3718,
		9,
		2719
	],
	"./services/payroll-year-end-access/payrollYearEndAccess.contracts": [
		386,
		9
	],
	"./services/payroll-year-end-access/payrollYearEndAccess.contracts.ts": [
		386,
		9
	],
	"./services/payroll-year-end-access/payrollYearEndAccess.service": [
		476,
		9
	],
	"./services/payroll-year-end-access/payrollYearEndAccess.service.ts": [
		476,
		9
	],
	"./services/payroll-year-end-access/yearEndAccess": [
		1712,
		9,
		2720
	],
	"./services/payroll-year-end-access/yearEndAccess.ts": [
		1712,
		9,
		2720
	],
	"./services/payroll/Functions/Functions": [
		1814,
		9,
		2721
	],
	"./services/payroll/Functions/Functions.ts": [
		1814,
		9,
		2721
	],
	"./services/payroll/models/access/accountingManagerAccess": [
		1409,
		9,
		2722
	],
	"./services/payroll/models/access/accountingManagerAccess.ts": [
		1409,
		9,
		2722
	],
	"./services/payroll/models/access/adjustmentAccess": [
		150,
		9
	],
	"./services/payroll/models/access/adjustmentAccess.ts": [
		150,
		9
	],
	"./services/payroll/models/access/billingAccess": [
		2050,
		9,
		2723
	],
	"./services/payroll/models/access/billingAccess.ts": [
		2050,
		9,
		2723
	],
	"./services/payroll/models/access/holidayPayAccess": [
		463,
		9
	],
	"./services/payroll/models/access/holidayPayAccess.ts": [
		463,
		9
	],
	"./services/payroll/models/access/nsfAccess": [
		2388,
		9,
		2724
	],
	"./services/payroll/models/access/nsfAccess.ts": [
		2388,
		9,
		2724
	],
	"./services/payroll/models/access/partnerAccess": [
		332,
		9
	],
	"./services/payroll/models/access/partnerAccess.ts": [
		332,
		9
	],
	"./services/payroll/models/access/payGroupAccess": [
		1082,
		9,
		2725
	],
	"./services/payroll/models/access/payGroupAccess.ts": [
		1082,
		9,
		2725
	],
	"./services/payroll/models/access/reportAccess": [
		1578,
		9,
		2726
	],
	"./services/payroll/models/access/reportAccess.ts": [
		1578,
		9,
		2726
	],
	"./services/payroll/models/schema/Schema": [
		2847,
		9,
		2727
	],
	"./services/payroll/models/schema/Schema.ts": [
		2847,
		9,
		2727
	],
	"./services/payroll/schema/Schema": [
		600,
		9
	],
	"./services/payroll/schema/Schema.ts": [
		600,
		9
	],
	"./services/payroll/utility/PayrollReportUtility": [
		3714,
		9,
		2728
	],
	"./services/payroll/utility/PayrollReportUtility.ts": [
		3714,
		9,
		2728
	],
	"./services/payrolladjustment-access/payrolladjustmentAccess.contracts": [
		2558,
		9,
		2729
	],
	"./services/payrolladjustment-access/payrolladjustmentAccess.contracts.ts": [
		2558,
		9,
		2729
	],
	"./services/payrolladjustment-access/payrolladjustmentAccess.service": [
		1457,
		9,
		2730
	],
	"./services/payrolladjustment-access/payrolladjustmentAccess.service.ts": [
		1457,
		9,
		2730
	],
	"./services/paystubmemo-access/paystubmemoAccess.contracts": [
		1421,
		9,
		2731
	],
	"./services/paystubmemo-access/paystubmemoAccess.contracts.ts": [
		1421,
		9,
		2731
	],
	"./services/paystubmemo-access/paystubmemoAccess.service": [
		1458,
		9,
		2732
	],
	"./services/paystubmemo-access/paystubmemoAccess.service.ts": [
		1458,
		9,
		2732
	],
	"./services/person-access/personAccess.contracts": [
		1074,
		9,
		2733
	],
	"./services/person-access/personAccess.contracts.ts": [
		1074,
		9,
		2733
	],
	"./services/person-access/personAccess.service": [
		84,
		9
	],
	"./services/person-access/personAccess.service.ts": [
		84,
		9
	],
	"./services/person-bank-access/personBankAccess.contracts": [
		333,
		9
	],
	"./services/person-bank-access/personBankAccess.contracts.ts": [
		333,
		9
	],
	"./services/person-bank-access/personBankAccess.service": [
		300,
		9
	],
	"./services/person-bank-access/personBankAccess.service.ts": [
		300,
		9
	],
	"./services/person-settings-access/personSettingsAccess.contracts": [
		1281,
		9,
		2734
	],
	"./services/person-settings-access/personSettingsAccess.contracts.ts": [
		1281,
		9,
		2734
	],
	"./services/person-settings-access/personSettingsAccess.service": [
		308,
		9
	],
	"./services/person-settings-access/personSettingsAccess.service.ts": [
		308,
		9
	],
	"./services/person-tax-access/personTaxAccess.contracts": [
		329,
		9
	],
	"./services/person-tax-access/personTaxAccess.contracts.ts": [
		329,
		9
	],
	"./services/person-tax-access/personTaxAccess.service": [
		192,
		9
	],
	"./services/person-tax-access/personTaxAccess.service.ts": [
		192,
		9
	],
	"./services/priorpayroll-access/priorpayrollAccess.contracts": [
		334,
		9
	],
	"./services/priorpayroll-access/priorpayrollAccess.contracts.ts": [
		334,
		9
	],
	"./services/priorpayroll-access/priorpayrollAccess.service": [
		133,
		9
	],
	"./services/priorpayroll-access/priorpayrollAccess.service.ts": [
		133,
		9
	],
	"./services/record-of-employment-access/record-of-employmentAccess.contracts": [
		1280,
		9,
		2735
	],
	"./services/record-of-employment-access/record-of-employmentAccess.contracts.ts": [
		1280,
		9,
		2735
	],
	"./services/record-of-employment-access/record-of-employmentAccess.service": [
		1342,
		9,
		2736
	],
	"./services/record-of-employment-access/record-of-employmentAccess.service.ts": [
		1342,
		9,
		2736
	],
	"./services/security-access/securityAccess.contracts": [
		46,
		9
	],
	"./services/security-access/securityAccess.contracts.ts": [
		46,
		9
	],
	"./services/security-access/securityAccess.service": [
		62,
		9
	],
	"./services/security-access/securityAccess.service.ts": [
		62,
		9
	],
	"./services/shared/optionList": [
		3719,
		9,
		2737
	],
	"./services/shared/optionList.ts": [
		3719,
		9,
		2737
	],
	"./services/shared/permission.contracts": [
		58,
		9
	],
	"./services/shared/permission.contracts.ts": [
		58,
		9
	],
	"./services/shared/query.contracts": [
		3720,
		9,
		2738
	],
	"./services/shared/query.contracts.ts": [
		3720,
		9,
		2738
	],
	"./services/shared/regexEnum.contracts": [
		93,
		9
	],
	"./services/shared/regexEnum.contracts.ts": [
		93,
		9
	],
	"./services/shared/securityRoleTypeEnum": [
		22,
		9
	],
	"./services/shared/securityRoleTypeEnum.ts": [
		22,
		9
	],
	"./services/shared/timeZoneTypeEnum": [
		390,
		9
	],
	"./services/shared/timeZoneTypeEnum.ts": [
		390,
		9
	],
	"./services/shared/validationResults.contracts": [
		410,
		9
	],
	"./services/shared/validationResults.contracts.ts": [
		410,
		9
	],
	"./services/tax-documents-access/taxDocumentsAccess.contracts": [
		2932,
		9,
		2739
	],
	"./services/tax-documents-access/taxDocumentsAccess.contracts.ts": [
		2932,
		9,
		2739
	],
	"./services/tax-documents-access/taxDocumentsAccess.service": [
		2933,
		9,
		2740
	],
	"./services/tax-documents-access/taxDocumentsAccess.service.ts": [
		2933,
		9,
		2740
	],
	"./services/tax-settings-access/taxSettingsAccess.contracts": [
		1088,
		9,
		2741
	],
	"./services/tax-settings-access/taxSettingsAccess.contracts.ts": [
		1088,
		9,
		2741
	],
	"./services/tax-settings-access/taxSettingsAccess.service": [
		259,
		9
	],
	"./services/tax-settings-access/taxSettingsAccess.service.ts": [
		259,
		9
	],
	"./services/trulioo-access/truliooAccess.contracts": [
		3721,
		9,
		2742
	],
	"./services/trulioo-access/truliooAccess.contracts.ts": [
		3721,
		9,
		2742
	],
	"./services/trulioo-access/truliooAccess.service": [
		2099,
		9,
		2743
	],
	"./services/trulioo-access/truliooAccess.service.ts": [
		2099,
		9,
		2743
	],
	"./services/ui-config-access/uiConfigAccess.contracts": [
		172,
		9
	],
	"./services/ui-config-access/uiConfigAccess.contracts.ts": [
		172,
		9
	],
	"./services/ui-config-access/uiConfigAccess.service": [
		554,
		9
	],
	"./services/ui-config-access/uiConfigAccess.service.ts": [
		554,
		9
	],
	"./services/workers-compensation-access/workersCompensationAccess.contracts": [
		1189,
		9,
		2744
	],
	"./services/workers-compensation-access/workersCompensationAccess.contracts.ts": [
		1189,
		9,
		2744
	],
	"./services/workers-compensation-access/workersCompensationAccess.service": [
		340,
		9
	],
	"./services/workers-compensation-access/workersCompensationAccess.service.ts": [
		340,
		9
	],
	"./services/yodlee-access/yodleeAccess.contracts": [
		3722,
		9,
		2745
	],
	"./services/yodlee-access/yodleeAccess.contracts.ts": [
		3722,
		9,
		2745
	],
	"./services/yodlee-access/yodleeAccess.service": [
		3723,
		9,
		2746
	],
	"./services/yodlee-access/yodleeAccess.service.ts": [
		3723,
		9,
		2746
	],
	"./services/zendesk/zendeskOperations/zendeskServices/zendesk.service": [
		2071,
		9,
		2747
	],
	"./services/zendesk/zendeskOperations/zendeskServices/zendesk.service.ts": [
		2071,
		9,
		2747
	],
	"./shared-components/AppContentWrapper": [
		336,
		9
	],
	"./shared-components/AppContentWrapper/": [
		336,
		9
	],
	"./shared-components/AppContentWrapper/index": [
		336,
		9
	],
	"./shared-components/AppContentWrapper/index.tsx": [
		336,
		9
	],
	"./shared-components/BeforeUnload/BeforeTabClosePrompt": [
		1780,
		9,
		1768
	],
	"./shared-components/BeforeUnload/BeforeTabClosePrompt.tsx": [
		1780,
		9,
		1768
	],
	"./shared-components/BeforeUnload/useBeforeTabClosePrompt": [
		1699,
		9,
		2748
	],
	"./shared-components/BeforeUnload/useBeforeTabClosePrompt.ts": [
		1699,
		9,
		2748
	],
	"./shared-components/EllipsisText/EllipsisText": [
		1402,
		9,
		2749
	],
	"./shared-components/EllipsisText/EllipsisText.tsx": [
		1402,
		9,
		2749
	],
	"./shared-components/Footer": [
		722,
		9,
		319
	],
	"./shared-components/Footer/": [
		722,
		9,
		319
	],
	"./shared-components/Footer/index": [
		722,
		9,
		319
	],
	"./shared-components/Footer/index.tsx": [
		722,
		9,
		319
	],
	"./shared-components/GroupedWpStatements": [
		758,
		9,
		320
	],
	"./shared-components/GroupedWpStatements/": [
		758,
		9,
		320
	],
	"./shared-components/GroupedWpStatements/index": [
		758,
		9,
		320
	],
	"./shared-components/GroupedWpStatements/index.tsx": [
		758,
		9,
		320
	],
	"./shared-components/GroupedWpStatements/styles": [
		3724,
		9,
		2750
	],
	"./shared-components/GroupedWpStatements/styles.ts": [
		3724,
		9,
		2750
	],
	"./shared-components/HiddenValue": [
		703,
		9,
		321
	],
	"./shared-components/HiddenValue/": [
		703,
		9,
		321
	],
	"./shared-components/HiddenValue/index": [
		703,
		9,
		321
	],
	"./shared-components/HiddenValue/index.tsx": [
		703,
		9,
		321
	],
	"./shared-components/TooltipInfoHelper": [
		711,
		9,
		322
	],
	"./shared-components/TooltipInfoHelper/": [
		711,
		9,
		322
	],
	"./shared-components/TooltipInfoHelper/index": [
		711,
		9,
		322
	],
	"./shared-components/TooltipInfoHelper/index.tsx": [
		711,
		9,
		322
	],
	"./shared-components/account-locked-page/accountLocked": [
		2667,
		9,
		1225
	],
	"./shared-components/account-locked-page/accountLocked.tsx": [
		2667,
		9,
		1225
	],
	"./shared-components/account-locked-page/styles": [
		2387,
		9,
		2751
	],
	"./shared-components/account-locked-page/styles.ts": [
		2387,
		9,
		2751
	],
	"./shared-components/account-verification/signature-warning/signatureWarning": [
		1597,
		9,
		1769
	],
	"./shared-components/account-verification/signature-warning/signatureWarning.tsx": [
		1597,
		9,
		1769
	],
	"./shared-components/account-verification/validation-request-card/validationRequestCard": [
		1557,
		9,
		1434
	],
	"./shared-components/account-verification/validation-request-card/validationRequestCard.tsx": [
		1557,
		9,
		1434
	],
	"./shared-components/account-verification/validation-request-card/validationRequestCardStyles": [
		1518,
		9,
		2752
	],
	"./shared-components/account-verification/validation-request-card/validationRequestCardStyles.ts": [
		1518,
		9,
		2752
	],
	"./shared-components/account-verification/validation-schema/accountVerificationValidationSchema": [
		1598,
		9,
		2753
	],
	"./shared-components/account-verification/validation-schema/accountVerificationValidationSchema.ts": [
		1598,
		9,
		2753
	],
	"./shared-components/account-verification/view-card/accountVerificationViewCard": [
		1596,
		9,
		1,
		835
	],
	"./shared-components/account-verification/view-card/accountVerificationViewCard.tsx": [
		1596,
		9,
		1,
		835
	],
	"./shared-components/account-verification/view-card/viewCardStyles": [
		1556,
		9,
		2754
	],
	"./shared-components/account-verification/view-card/viewCardStyles.ts": [
		1556,
		9,
		2754
	],
	"./shared-components/auth-provider/authProvider": [
		438,
		9
	],
	"./shared-components/auth-provider/authProvider.tsx": [
		438,
		9
	],
	"./shared-components/auth-provider/sucurePortalCheck": [
		586,
		9
	],
	"./shared-components/auth-provider/sucurePortalCheck.ts": [
		586,
		9
	],
	"./shared-components/auth-provider/useAuthProvider": [
		649,
		9
	],
	"./shared-components/auth-provider/useAuthProvider.ts": [
		649,
		9
	],
	"./shared-components/auth-provider/useAuthProviderDeprecated": [
		3725,
		9,
		2755
	],
	"./shared-components/auth-provider/useAuthProviderDeprecated.ts": [
		3725,
		9,
		2755
	],
	"./shared-components/backToButton/backToButton": [
		1111,
		9,
		1435
	],
	"./shared-components/backToButton/backToButton.tsx": [
		1111,
		9,
		1435
	],
	"./shared-components/backToButton/backToButtonStyles": [
		1108,
		9,
		2756
	],
	"./shared-components/backToButton/backToButtonStyles.ts": [
		1108,
		9,
		2756
	],
	"./shared-components/banking/create-signatory-form/createSignatoryForm": [
		1892,
		9,
		1080
	],
	"./shared-components/banking/create-signatory-form/createSignatoryForm.tsx": [
		1892,
		9,
		1080
	],
	"./shared-components/banking/create-signatory-form/employeeFields": [
		1815,
		9,
		1770
	],
	"./shared-components/banking/create-signatory-form/employeeFields.tsx": [
		1815,
		9,
		1770
	],
	"./shared-components/banking/create-signatory-form/nonEmployeeFields": [
		1816,
		9,
		1771
	],
	"./shared-components/banking/create-signatory-form/nonEmployeeFields.tsx": [
		1816,
		9,
		1771
	],
	"./shared-components/banking/create-signatory-form/types": [
		1287,
		9,
		2757
	],
	"./shared-components/banking/create-signatory-form/types.ts": [
		1287,
		9,
		2757
	],
	"./shared-components/banking/create-signatory-form/useValidationSchema": [
		1817,
		9,
		1772
	],
	"./shared-components/banking/create-signatory-form/useValidationSchema.ts": [
		1817,
		9,
		1772
	],
	"./shared-components/banking/form-fields/auth-signatory/authSignatoryAutoComplete": [
		1978,
		9,
		99,
		744
	],
	"./shared-components/banking/form-fields/auth-signatory/authSignatoryAutoComplete.tsx": [
		1978,
		9,
		99,
		744
	],
	"./shared-components/banking/form-fields/auth-signatory/authSignatoryBirthDate": [
		1979,
		9,
		2758
	],
	"./shared-components/banking/form-fields/auth-signatory/authSignatoryBirthDate.tsx": [
		1979,
		9,
		2758
	],
	"./shared-components/banking/form-fields/auth-signatory/authSignatorySin": [
		1980,
		9,
		842
	],
	"./shared-components/banking/form-fields/auth-signatory/authSignatorySin.tsx": [
		1980,
		9,
		842
	],
	"./shared-components/banking/form-fields/auth-signatory/authSignatoryStyles": [
		1323,
		9,
		2759
	],
	"./shared-components/banking/form-fields/auth-signatory/authSignatoryStyles.ts": [
		1323,
		9,
		2759
	],
	"./shared-components/banking/form-fields/auth-signatory/signedField": [
		1343,
		9,
		3,
		779
	],
	"./shared-components/banking/form-fields/auth-signatory/signedField.tsx": [
		1343,
		9,
		3,
		779
	],
	"./shared-components/banking/form-fields/auth-signatory/unsignedField": [
		1344,
		9,
		3,
		707
	],
	"./shared-components/banking/form-fields/auth-signatory/unsignedField.tsx": [
		1344,
		9,
		3,
		707
	],
	"./shared-components/banking/form-fields/bank-info/accountTypeRadioButton": [
		1975,
		9,
		1,
		1773
	],
	"./shared-components/banking/form-fields/bank-info/accountTypeRadioButton.tsx": [
		1975,
		9,
		1,
		1773
	],
	"./shared-components/banking/form-fields/bank-info/canadaBankDetailsFields": [
		1976,
		9,
		1226
	],
	"./shared-components/banking/form-fields/bank-info/canadaBankDetailsFields.tsx": [
		1976,
		9,
		1226
	],
	"./shared-components/banking/form-fields/bank-info/verificationDocument": [
		2054,
		9,
		3,
		255,
		1812
	],
	"./shared-components/banking/form-fields/bank-info/verificationDocument.tsx": [
		2054,
		9,
		3,
		255,
		1812
	],
	"./shared-components/banking/form-fields/common/docUploadField": [
		1095,
		9,
		3,
		918
	],
	"./shared-components/banking/form-fields/common/docUploadField.tsx": [
		1095,
		9,
		3,
		918
	],
	"./shared-components/banking/form-footer/formFooter": [
		1471,
		9,
		2760
	],
	"./shared-components/banking/form-footer/formFooter.tsx": [
		1471,
		9,
		2760
	],
	"./shared-components/banking/hooks/useDeleteBankAccountDocument": [
		1662,
		9,
		1436
	],
	"./shared-components/banking/hooks/useDeleteBankAccountDocument.ts": [
		1662,
		9,
		1436
	],
	"./shared-components/banking/hooks/useGeneratePadAgreement": [
		1324,
		9,
		2761
	],
	"./shared-components/banking/hooks/useGeneratePadAgreement.ts": [
		1324,
		9,
		2761
	],
	"./shared-components/banking/hooks/useGetAgreementDetails": [
		1179,
		9,
		2762
	],
	"./shared-components/banking/hooks/useGetAgreementDetails.ts": [
		1179,
		9,
		2762
	],
	"./shared-components/banking/init-banking-cards/authSignatoryEmptyCard": [
		1971,
		9,
		1227
	],
	"./shared-components/banking/init-banking-cards/authSignatoryEmptyCard.tsx": [
		1971,
		9,
		1227
	],
	"./shared-components/banking/init-banking-cards/authSignatoryInfoCard": [
		1972,
		9,
		1,
		780
	],
	"./shared-components/banking/init-banking-cards/authSignatoryInfoCard.tsx": [
		1972,
		9,
		1,
		780
	],
	"./shared-components/banking/init-banking-cards/bankingCard": [
		1260,
		9,
		2763
	],
	"./shared-components/banking/init-banking-cards/bankingCard.tsx": [
		1260,
		9,
		2763
	],
	"./shared-components/banking/init-banking-cards/bankingInfoCard": [
		1890,
		9,
		1,
		781
	],
	"./shared-components/banking/init-banking-cards/bankingInfoCard.tsx": [
		1890,
		9,
		1,
		781
	],
	"./shared-components/banking/init-banking-cards/bankingInfoEmptyCard": [
		1891,
		9,
		1228
	],
	"./shared-components/banking/init-banking-cards/bankingInfoEmptyCard.tsx": [
		1891,
		9,
		1228
	],
	"./shared-components/banking/init-banking-cards/initBankingCardsStyles": [
		1548,
		9,
		2764
	],
	"./shared-components/banking/init-banking-cards/initBankingCardsStyles.ts": [
		1548,
		9,
		2764
	],
	"./shared-components/banking/pad-agreement-card/padAgreementCard": [
		1663,
		9,
		1,
		3,
		28,
		556
	],
	"./shared-components/banking/pad-agreement-card/padAgreementCard.tsx": [
		1663,
		9,
		1,
		3,
		28,
		556
	],
	"./shared-components/banking/pad-agreement-card/padAgreementCardStyles": [
		1818,
		9,
		2765
	],
	"./shared-components/banking/pad-agreement-card/padAgreementCardStyles.ts": [
		1818,
		9,
		2765
	],
	"./shared-components/banking/validation-schema/authSignatoryValidationSchema": [
		1408,
		9,
		1,
		1081
	],
	"./shared-components/banking/validation-schema/authSignatoryValidationSchema.ts": [
		1408,
		9,
		1,
		1081
	],
	"./shared-components/banking/validation-schema/bankingValidationSchema": [
		1977,
		9,
		1,
		984
	],
	"./shared-components/banking/validation-schema/bankingValidationSchema.ts": [
		1977,
		9,
		1,
		984
	],
	"./shared-components/banking/validation-schema/commonYupSchemas": [
		1193,
		9,
		1,
		1229
	],
	"./shared-components/banking/validation-schema/commonYupSchemas.ts": [
		1193,
		9,
		1,
		1229
	],
	"./shared-components/banking/validation-schema/firmBankingValidationSchema": [
		1723,
		9,
		1,
		985
	],
	"./shared-components/banking/validation-schema/firmBankingValidationSchema.ts": [
		1723,
		9,
		1,
		985
	],
	"./shared-components/banking/view-fields/fieldWithAction": [
		1138,
		9,
		2766
	],
	"./shared-components/banking/view-fields/fieldWithAction.tsx": [
		1138,
		9,
		2766
	],
	"./shared-components/banking/view-fields/fieldWithIcon": [
		1239,
		9,
		2767
	],
	"./shared-components/banking/view-fields/fieldWithIcon.tsx": [
		1239,
		9,
		2767
	],
	"./shared-components/banks-autocomplete/banksAutocomplete": [
		1107,
		9,
		2768
	],
	"./shared-components/banks-autocomplete/banksAutocomplete.tsx": [
		1107,
		9,
		2768
	],
	"./shared-components/blockerScreensContainer/blockerScreensContainer": [
		2988,
		9,
		0,
		13,
		21,
		159,
		489
	],
	"./shared-components/blockerScreensContainer/blockerScreensContainer.tsx": [
		2988,
		9,
		0,
		13,
		21,
		159,
		489
	],
	"./shared-components/branch-transit-number/branchTransitNumber": [
		1161,
		9,
		2769
	],
	"./shared-components/branch-transit-number/branchTransitNumber.tsx": [
		1161,
		9,
		2769
	],
	"./shared-components/button/button": [
		1300,
		9,
		2770
	],
	"./shared-components/button/button.tsx": [
		1300,
		9,
		2770
	],
	"./shared-components/collapsible-card/collapsibleCard": [
		1356,
		9,
		1230
	],
	"./shared-components/collapsible-card/collapsibleCard.tsx": [
		1356,
		9,
		1230
	],
	"./shared-components/collapsible-card/collapsibleCardStyles": [
		1346,
		9,
		2771
	],
	"./shared-components/collapsible-card/collapsibleCardStyles.ts": [
		1346,
		9,
		2771
	],
	"./shared-components/collapsible-link/collapsibleLink": [
		2585,
		9,
		1774
	],
	"./shared-components/collapsible-link/collapsibleLink.tsx": [
		2585,
		9,
		1774
	],
	"./shared-components/collapsible-section/collapsibleSection": [
		1330,
		9,
		782
	],
	"./shared-components/collapsible-section/collapsibleSection.tsx": [
		1330,
		9,
		782
	],
	"./shared-components/collapsible-section/collapsibleSectionStyles": [
		1565,
		9,
		2772
	],
	"./shared-components/collapsible-section/collapsibleSectionStyles.ts": [
		1565,
		9,
		2772
	],
	"./shared-components/company-autocomplete-fields/addressAutocomplete": [
		1276,
		9,
		1748
	],
	"./shared-components/company-autocomplete-fields/addressAutocomplete.tsx": [
		1276,
		9,
		1748
	],
	"./shared-components/company-autocomplete-fields/statesAutocomplete": [
		2238,
		9,
		1775
	],
	"./shared-components/company-autocomplete-fields/statesAutocomplete.tsx": [
		2238,
		9,
		1775
	],
	"./shared-components/connectivity-handlers": [
		832,
		9,
		323
	],
	"./shared-components/connectivity-handlers/": [
		832,
		9,
		323
	],
	"./shared-components/connectivity-handlers/index": [
		832,
		9,
		323
	],
	"./shared-components/connectivity-handlers/index.tsx": [
		832,
		9,
		323
	],
	"./shared-components/content-container/accountingDashboardRedirect": [
		2934,
		9,
		2773
	],
	"./shared-components/content-container/accountingDashboardRedirect.tsx": [
		2934,
		9,
		2773
	],
	"./shared-components/content-container/accountingDashboardRouts": [
		3189,
		9,
		1776
	],
	"./shared-components/content-container/accountingDashboardRouts.tsx": [
		3189,
		9,
		1776
	],
	"./shared-components/content-container/contentContainer": [
		3529,
		9,
		562
	],
	"./shared-components/content-container/contentContainer.scss": [
		4069,
		7,
		2935
	],
	"./shared-components/content-container/contentContainer.tsx": [
		3529,
		9,
		562
	],
	"./shared-components/content-container/noPermissionModal": [
		1790,
		9,
		2774
	],
	"./shared-components/content-container/noPermissionModal.tsx": [
		1790,
		9,
		2774
	],
	"./shared-components/content-container/wagepointRedirect": [
		2935,
		9,
		2775
	],
	"./shared-components/content-container/wagepointRedirect.tsx": [
		2935,
		9,
		2775
	],
	"./shared-components/content-container/wagepointRoutes": [
		3190,
		9,
		1021
	],
	"./shared-components/content-container/wagepointRoutes.tsx": [
		3190,
		9,
		1021
	],
	"./shared-components/custom-prompt/customPrompt": [
		331,
		9
	],
	"./shared-components/custom-prompt/customPrompt.tsx": [
		331,
		9
	],
	"./shared-components/custom-prompt/hooks/use-callback-prompt": [
		524,
		9
	],
	"./shared-components/custom-prompt/hooks/use-callback-prompt.ts": [
		524,
		9
	],
	"./shared-components/custom-prompt/hooks/use-prompt": [
		643,
		9
	],
	"./shared-components/custom-prompt/hooks/use-prompt.ts": [
		643,
		9
	],
	"./shared-components/customize-hours": [
		723,
		9,
		324
	],
	"./shared-components/customize-hours/": [
		723,
		9,
		324
	],
	"./shared-components/customize-hours/index": [
		723,
		9,
		324
	],
	"./shared-components/customize-hours/index.tsx": [
		723,
		9,
		324
	],
	"./shared-components/details-list-item/detailsListItem": [
		1205,
		9,
		1777
	],
	"./shared-components/details-list-item/detailsListItem.tsx": [
		1205,
		9,
		1777
	],
	"./shared-components/details-list-item/detailsListItemStyles": [
		1270,
		9,
		2776
	],
	"./shared-components/details-list-item/detailsListItemStyles.ts": [
		1270,
		9,
		2776
	],
	"./shared-components/dividerWp/dividerWp": [
		1149,
		9,
		1778
	],
	"./shared-components/dividerWp/dividerWp.tsx": [
		1149,
		9,
		1778
	],
	"./shared-components/field-list-item-switch/fieldListItemSwitch": [
		2080,
		9,
		1079
	],
	"./shared-components/field-list-item-switch/fieldListItemSwitch.tsx": [
		2080,
		9,
		1079
	],
	"./shared-components/field-list-item-switch/fieldListItemSwitchStyles": [
		1957,
		9,
		2777
	],
	"./shared-components/field-list-item-switch/fieldListItemSwitchStyles.ts": [
		1957,
		9,
		2777
	],
	"./shared-components/field-radio/fieldRadio": [
		2477,
		9,
		1779
	],
	"./shared-components/field-radio/fieldRadio.tsx": [
		2477,
		9,
		1779
	],
	"./shared-components/field-radio/fieldRadioStyles": [
		2282,
		9,
		2778
	],
	"./shared-components/field-radio/fieldRadioStyles.ts": [
		2282,
		9,
		2778
	],
	"./shared-components/field-switch/fieldSwitch": [
		1958,
		9,
		2779
	],
	"./shared-components/field-switch/fieldSwitch.tsx": [
		1958,
		9,
		2779
	],
	"./shared-components/field-wrapper/fieldWrapper": [
		2589,
		9,
		1780
	],
	"./shared-components/field-wrapper/fieldWrapper.tsx": [
		2589,
		9,
		1780
	],
	"./shared-components/field-wrapper/fieldWrapperStyles": [
		2337,
		9,
		2780
	],
	"./shared-components/field-wrapper/fieldWrapperStyles.ts": [
		2337,
		9,
		2780
	],
	"./shared-components/fingerprintContainer/fingerprintContainer": [
		2989,
		9,
		21,
		1781
	],
	"./shared-components/fingerprintContainer/fingerprintContainer.tsx": [
		2989,
		9,
		21,
		1781
	],
	"./shared-components/fingerprintContainer/useGetFingerprintApiKey": [
		2676,
		9,
		2781
	],
	"./shared-components/fingerprintContainer/useGetFingerprintApiKey.ts": [
		2676,
		9,
		2781
	],
	"./shared-components/form-initial-values/formInitialValues": [
		1378,
		9,
		2782
	],
	"./shared-components/form-initial-values/formInitialValues.tsx": [
		1378,
		9,
		2782
	],
	"./shared-components/form-wrapper/formWrapper": [
		1301,
		9,
		2783
	],
	"./shared-components/form-wrapper/formWrapper.tsx": [
		1301,
		9,
		2783
	],
	"./shared-components/form-wrapper/formWrapperWithFooter": [
		2692,
		9,
		1783
	],
	"./shared-components/form-wrapper/formWrapperWithFooter.tsx": [
		2692,
		9,
		1783
	],
	"./shared-components/formPrevValues/formPrevValues": [
		1411,
		9,
		2784
	],
	"./shared-components/formPrevValues/formPrevValues.tsx": [
		1411,
		9,
		2784
	],
	"./shared-components/formSnackBar/formSnackbar": [
		1091,
		9,
		2785
	],
	"./shared-components/formSnackBar/formSnackbar.ts": [
		1091,
		9,
		2785
	],
	"./shared-components/fromAlfredProvider/fromAlfredProvider": [
		2983,
		9,
		2786
	],
	"./shared-components/fromAlfredProvider/fromAlfredProvider.tsx": [
		2983,
		9,
		2786
	],
	"./shared-components/header/addons-popover/addonsPopover": [
		3726,
		9,
		10,
		857
	],
	"./shared-components/header/addons-popover/addonsPopover.tsx": [
		3726,
		9,
		10,
		857
	],
	"./shared-components/header/addons-popover/integrations": [
		3506,
		9,
		10,
		1784
	],
	"./shared-components/header/addons-popover/integrations.tsx": [
		3506,
		9,
		10,
		1784
	],
	"./shared-components/header/addons-popover/noIntegrations": [
		3505,
		9,
		1785
	],
	"./shared-components/header/addons-popover/noIntegrations.tsx": [
		3505,
		9,
		1785
	],
	"./shared-components/header/addons-popover/styles": [
		2638,
		9,
		2787
	],
	"./shared-components/header/addons-popover/styles.ts": [
		2638,
		9,
		2787
	],
	"./shared-components/header/header": [
		3727,
		9,
		38,
		348,
		341,
		616
	],
	"./shared-components/header/header-dropdown/accounting-dashboard-section/accountingDashboardSection": [
		3191,
		9,
		986
	],
	"./shared-components/header/header-dropdown/accounting-dashboard-section/accountingDashboardSection.tsx": [
		3191,
		9,
		986
	],
	"./shared-components/header/header-dropdown/accounting-dashboard-section/accountingDashboardSectionStyles": [
		2937,
		9,
		2788
	],
	"./shared-components/header/header-dropdown/accounting-dashboard-section/accountingDashboardSectionStyles.ts": [
		2937,
		9,
		2788
	],
	"./shared-components/header/header-dropdown/headerDropdown": [
		3495,
		9,
		688
	],
	"./shared-components/header/header-dropdown/headerDropdown.tsx": [
		3495,
		9,
		688
	],
	"./shared-components/header/header-dropdown/headerDropdownStyles": [
		3192,
		9,
		2789
	],
	"./shared-components/header/header-dropdown/headerDropdownStyles.ts": [
		3192,
		9,
		2789
	],
	"./shared-components/header/header.tsx": [
		3727,
		9,
		38,
		348,
		341,
		616
	],
	"./shared-components/header/headerStyle": [
		3498,
		9,
		1786
	],
	"./shared-components/header/headerStyle.ts": [
		3498,
		9,
		1786
	],
	"./shared-components/header/info-icon": [
		866,
		9,
		186
	],
	"./shared-components/header/info-icon/": [
		866,
		9,
		186
	],
	"./shared-components/header/info-icon/index": [
		866,
		9,
		186
	],
	"./shared-components/header/info-icon/index.tsx": [
		866,
		9,
		186
	],
	"./shared-components/header/info-icon/styles": [
		3196,
		9,
		2790
	],
	"./shared-components/header/info-icon/styles.ts": [
		3196,
		9,
		2790
	],
	"./shared-components/header/notification-popover/hooks/useGetNotification": [
		1865,
		9,
		1747
	],
	"./shared-components/header/notification-popover/hooks/useGetNotification.ts": [
		1865,
		9,
		1747
	],
	"./shared-components/header/notification-popover/notification-popover": [
		3497,
		9,
		38,
		507
	],
	"./shared-components/header/notification-popover/notification-popover.tsx": [
		3497,
		9,
		38,
		507
	],
	"./shared-components/header/notification-popover/notification-utils": [
		2380,
		9,
		2791
	],
	"./shared-components/header/notification-popover/notification-utils.ts": [
		2380,
		9,
		2791
	],
	"./shared-components/header/notification-popover/notificationItemHtml/notificationItemHtml": [
		2453,
		9,
		38,
		658
	],
	"./shared-components/header/notification-popover/notificationItemHtml/notificationItemHtml.tsx": [
		2453,
		9,
		38,
		658
	],
	"./shared-components/header/notification-popover/notificationItemHtml/notificationStylesHtml": [
		1970,
		9,
		2792
	],
	"./shared-components/header/notification-popover/notificationItemHtml/notificationStylesHtml.ts": [
		1970,
		9,
		2792
	],
	"./shared-components/header/notification-popover/notificationItemNew/constants": [
		3195,
		9,
		2793
	],
	"./shared-components/header/notification-popover/notificationItemNew/constants.ts": [
		3195,
		9,
		2793
	],
	"./shared-components/header/notification-popover/notificationItemNew/notificationItemNew": [
		3193,
		9,
		38,
		743
	],
	"./shared-components/header/notification-popover/notificationItemNew/notificationItemNew.tsx": [
		3193,
		9,
		38,
		743
	],
	"./shared-components/header/notification-popover/notificationItemNew/notificationStylesNew": [
		3194,
		9,
		2794
	],
	"./shared-components/header/notification-popover/notificationItemNew/notificationStylesNew.ts": [
		3194,
		9,
		2794
	],
	"./shared-components/initialRedirect/InitialRedirect": [
		2981,
		9,
		1220
	],
	"./shared-components/initialRedirect/InitialRedirect.tsx": [
		2981,
		9,
		1220
	],
	"./shared-components/initialRedirect/InitialRedirectStyles": [
		2665,
		9,
		2795
	],
	"./shared-components/initialRedirect/InitialRedirectStyles.ts": [
		2665,
		9,
		2795
	],
	"./shared-components/layout-content/layoutContent": [
		3728,
		9,
		2796
	],
	"./shared-components/layout-content/layoutContent.tsx": [
		3728,
		9,
		2796
	],
	"./shared-components/layout-page/layoutPage": [
		3465,
		9,
		2797
	],
	"./shared-components/layout-page/layoutPage.tsx": [
		3465,
		9,
		2797
	],
	"./shared-components/link-with-confirmation/linkWithConfirmation": [
		1298,
		9,
		2798
	],
	"./shared-components/link-with-confirmation/linkWithConfirmation.tsx": [
		1298,
		9,
		2798
	],
	"./shared-components/link/link": [
		1339,
		9,
		2799
	],
	"./shared-components/link/link.tsx": [
		1339,
		9,
		2799
	],
	"./shared-components/list-container/listContainer": [
		2079,
		9,
		1787
	],
	"./shared-components/list-container/listContainer.tsx": [
		2079,
		9,
		1787
	],
	"./shared-components/list-container/listContainerStyles": [
		1956,
		9,
		2800
	],
	"./shared-components/list-container/listContainerStyles.ts": [
		1956,
		9,
		2800
	],
	"./shared-components/loadingBar/loadingBar": [
		3296,
		9,
		1231
	],
	"./shared-components/loadingBar/loadingBar.tsx": [
		3296,
		9,
		1231
	],
	"./shared-components/longNameWrapper/longNameWrapper": [
		2049,
		9,
		2801
	],
	"./shared-components/longNameWrapper/longNameWrapper.tsx": [
		2049,
		9,
		2801
	],
	"./shared-components/mobile-components/mobileBlockerScreens/mobileBlockerScreens": [
		2985,
		9,
		5,
		37,
		530
	],
	"./shared-components/mobile-components/mobileBlockerScreens/mobileBlockerScreens.tsx": [
		2985,
		9,
		5,
		37,
		530
	],
	"./shared-components/mobile-components/mobileBlockerScreens/useBlockedPagesConfig": [
		2669,
		9,
		2802
	],
	"./shared-components/mobile-components/mobileBlockerScreens/useBlockedPagesConfig.ts": [
		2669,
		9,
		2802
	],
	"./shared-components/mobile-components/mobileHeader/components/bottomNav": [
		3077,
		9,
		1232
	],
	"./shared-components/mobile-components/mobileHeader/components/bottomNav.tsx": [
		3077,
		9,
		1232
	],
	"./shared-components/mobile-components/mobileHeader/components/mobileMenu": [
		3078,
		9,
		48,
		944
	],
	"./shared-components/mobile-components/mobileHeader/components/mobileMenu.tsx": [
		3078,
		9,
		48,
		944
	],
	"./shared-components/mobile-components/mobileHeader/components/mobileNavItem": [
		2755,
		9,
		48,
		1788
	],
	"./shared-components/mobile-components/mobileHeader/components/mobileNavItem.tsx": [
		2755,
		9,
		48,
		1788
	],
	"./shared-components/mobile-components/mobileHeader/mobileHeader": [
		3388,
		9,
		48,
		623
	],
	"./shared-components/mobile-components/mobileHeader/mobileHeader.tsx": [
		3388,
		9,
		48,
		623
	],
	"./shared-components/mobile-components/mobileHeader/mobileStyles": [
		1997,
		9,
		2803
	],
	"./shared-components/mobile-components/mobileHeader/mobileStyles.ts": [
		1997,
		9,
		2803
	],
	"./shared-components/page-not-found/pageNotFound": [
		3744,
		9,
		2804
	],
	"./shared-components/page-not-found/pageNotFound.tsx": [
		3744,
		9,
		2804
	],
	"./shared-components/permission-tooltip/permissionTooltip": [
		1200,
		9,
		2805
	],
	"./shared-components/permission-tooltip/permissionTooltip.tsx": [
		1200,
		9,
		2805
	],
	"./shared-components/progress/progress": [
		1099,
		9,
		2806
	],
	"./shared-components/progress/progress.tsx": [
		1099,
		9,
		2806
	],
	"./shared-components/prompt/prompt": [
		1213,
		9,
		2807
	],
	"./shared-components/prompt/prompt.tsx": [
		1213,
		9,
		2807
	],
	"./shared-components/prompt/useCallbackPrompt": [
		1390,
		9,
		1789
	],
	"./shared-components/prompt/useCallbackPrompt.ts": [
		1390,
		9,
		1789
	],
	"./shared-components/prompt/usePrompt": [
		1310,
		9,
		2808
	],
	"./shared-components/prompt/usePrompt.ts": [
		1310,
		9,
		2808
	],
	"./shared-components/prompt/usePromptAction": [
		1290,
		9,
		1790
	],
	"./shared-components/prompt/usePromptAction.ts": [
		1290,
		9,
		1790
	],
	"./shared-components/prompt/usePromptRouter": [
		1618,
		9,
		1437
	],
	"./shared-components/prompt/usePromptRouter.ts": [
		1618,
		9,
		1437
	],
	"./shared-components/setup2FA/2FAStyles": [
		2072,
		9,
		1791
	],
	"./shared-components/setup2FA/2FAStyles.ts": [
		2072,
		9,
		1791
	],
	"./shared-components/setup2FA/form/components/googleAuthenticator/codeInput": [
		1879,
		9,
		21,
		914
	],
	"./shared-components/setup2FA/form/components/googleAuthenticator/codeInput.tsx": [
		1879,
		9,
		21,
		914
	],
	"./shared-components/setup2FA/form/components/googleAuthenticator/nextStepQr": [
		2213,
		9,
		1082
	],
	"./shared-components/setup2FA/form/components/googleAuthenticator/nextStepQr.tsx": [
		2213,
		9,
		1082
	],
	"./shared-components/setup2FA/form/components/googleAuthenticator/qrCodeGenerator": [
		2073,
		9,
		1792
	],
	"./shared-components/setup2FA/form/components/googleAuthenticator/qrCodeGenerator.tsx": [
		2073,
		9,
		1792
	],
	"./shared-components/setup2FA/form/components/googleAuthenticator/verificationBlock": [
		2371,
		9,
		0,
		13,
		21,
		177
	],
	"./shared-components/setup2FA/form/components/googleAuthenticator/verificationBlock.tsx": [
		2371,
		9,
		0,
		13,
		21,
		177
	],
	"./shared-components/setup2FA/form/components/textMessage/phoneNumber": [
		2214,
		9,
		0,
		13,
		991
	],
	"./shared-components/setup2FA/form/components/textMessage/phoneNumber.tsx": [
		2214,
		9,
		0,
		13,
		991
	],
	"./shared-components/setup2FA/form/components/textMessage/phoneNumberSent": [
		2390,
		9,
		21,
		741
	],
	"./shared-components/setup2FA/form/components/textMessage/phoneNumberSent.tsx": [
		2390,
		9,
		21,
		741
	],
	"./shared-components/setup2FA/form/components/twoFaOptionsForm": [
		2046,
		9,
		0,
		13,
		21,
		177
	],
	"./shared-components/setup2FA/form/components/twoFaOptionsForm.tsx": [
		2046,
		9,
		0,
		13,
		21,
		177
	],
	"./shared-components/setup2FA/form/components/twoFaOptionsFormStyles": [
		1645,
		9,
		2809
	],
	"./shared-components/setup2FA/form/components/twoFaOptionsFormStyles.ts": [
		1645,
		9,
		2809
	],
	"./shared-components/setup2FA/form/schema/validationSchema": [
		2389,
		9,
		2810
	],
	"./shared-components/setup2FA/form/schema/validationSchema.ts": [
		2389,
		9,
		2810
	],
	"./shared-components/setup2FA/form/setup2FAform": [
		2644,
		9,
		0,
		13,
		21,
		483
	],
	"./shared-components/setup2FA/form/setup2FAform.tsx": [
		2644,
		9,
		0,
		13,
		21,
		483
	],
	"./shared-components/setup2FA/setup2FA": [
		2672,
		9,
		0,
		13,
		21,
		159,
		1438
	],
	"./shared-components/setup2FA/setup2FA.tsx": [
		2672,
		9,
		0,
		13,
		21,
		159,
		1438
	],
	"./shared-components/sidebar/hook": [
		2120,
		9,
		2811
	],
	"./shared-components/sidebar/hook.tsx": [
		2120,
		9,
		2811
	],
	"./shared-components/sidebar/menuItem": [
		3741,
		9,
		1,
		48,
		614,
		34,
		479
	],
	"./shared-components/sidebar/menuItem.tsx": [
		3741,
		9,
		1,
		48,
		614,
		34,
		479
	],
	"./shared-components/sidebar/sidebar": [
		3499,
		9,
		1,
		48,
		34,
		359,
		472
	],
	"./shared-components/sidebar/sidebar.tsx": [
		3499,
		9,
		1,
		48,
		34,
		359,
		472
	],
	"./shared-components/sidebar/sidebarStyles": [
		2381,
		9,
		2812
	],
	"./shared-components/sidebar/sidebarStyles.ts": [
		2381,
		9,
		2812
	],
	"./shared-components/sidebar/useHideMenuOptions": [
		545,
		9
	],
	"./shared-components/sidebar/useHideMenuOptions.ts": [
		545,
		9
	],
	"./shared-components/skeleton-avatar/skeletonAvatar": [
		1807,
		9,
		1793
	],
	"./shared-components/skeleton-avatar/skeletonAvatar.tsx": [
		1807,
		9,
		1793
	],
	"./shared-components/skeleton-layout/skeletonLayout": [
		3729,
		9,
		1439
	],
	"./shared-components/skeleton-layout/skeletonLayout.tsx": [
		3729,
		9,
		1439
	],
	"./shared-components/skeleton-layout/skeletonLayoutStyles": [
		3500,
		9,
		2813
	],
	"./shared-components/skeleton-layout/skeletonLayoutStyles.ts": [
		3500,
		9,
		2813
	],
	"./shared-components/skeleton-text/skeletonText": [
		2592,
		9,
		1794
	],
	"./shared-components/skeleton-text/skeletonText.tsx": [
		2592,
		9,
		1794
	],
	"./shared-components/spacing/spacing": [
		1146,
		9,
		1795
	],
	"./shared-components/spacing/spacing.tsx": [
		1146,
		9,
		1795
	],
	"./shared-components/spacing/spacingStyles": [
		1172,
		9,
		2814
	],
	"./shared-components/spacing/spacingStyles.ts": [
		1172,
		9,
		2814
	],
	"./shared-components/status-text/statusText": [
		1948,
		9,
		1083
	],
	"./shared-components/status-text/statusText.tsx": [
		1948,
		9,
		1083
	],
	"./shared-components/status-text/statusTextStyles": [
		2043,
		9,
		2815
	],
	"./shared-components/status-text/statusTextStyles.ts": [
		2043,
		9,
		2815
	],
	"./shared-components/statusBar/statusBar": [
		2982,
		9,
		1796
	],
	"./shared-components/statusBar/statusBar.tsx": [
		2982,
		9,
		1796
	],
	"./shared-components/statusBar/statusBarStyles": [
		2666,
		9,
		2816
	],
	"./shared-components/statusBar/statusBarStyles.ts": [
		2666,
		9,
		2816
	],
	"./shared-components/subscription/badgeStatus/badgeStatus": [
		1646,
		9,
		1798
	],
	"./shared-components/subscription/badgeStatus/badgeStatus.tsx": [
		1646,
		9,
		1798
	],
	"./shared-components/subscription/badgeStatus/badgeStatusStyles": [
		1809,
		9,
		2817
	],
	"./shared-components/subscription/badgeStatus/badgeStatusStyles.ts": [
		1809,
		9,
		2817
	],
	"./shared-components/subscription/discount-card/discountCard": [
		3351,
		9,
		2818
	],
	"./shared-components/subscription/discount-card/discountCard.tsx": [
		3351,
		9,
		2818
	],
	"./shared-components/subscription/hooks/usePaymentStatusData": [
		2249,
		9,
		1799
	],
	"./shared-components/subscription/hooks/usePaymentStatusData.ts": [
		2249,
		9,
		1799
	],
	"./shared-components/subscription/payment-method-card/paymentMethodCard": [
		2429,
		9,
		919
	],
	"./shared-components/subscription/payment-method-card/paymentMethodCard.tsx": [
		2429,
		9,
		919
	],
	"./shared-components/subscription/payment-method-card/paymentMethodCardLink": [
		2248,
		9,
		2819
	],
	"./shared-components/subscription/payment-method-card/paymentMethodCardLink.tsx": [
		2248,
		9,
		2819
	],
	"./shared-components/subscription/types": [
		1705,
		9,
		2820
	],
	"./shared-components/subscription/types.ts": [
		1705,
		9,
		2820
	],
	"./shared-components/subscriptionPlanSetup/components/buttonWithTooltip/ButtonWithTooltip": [
		2391,
		9,
		1233
	],
	"./shared-components/subscriptionPlanSetup/components/buttonWithTooltip/ButtonWithTooltip.tsx": [
		2391,
		9,
		1233
	],
	"./shared-components/subscriptionPlanSetup/components/featureItem/featureItem": [
		1445,
		9,
		1234
	],
	"./shared-components/subscriptionPlanSetup/components/featureItem/featureItem.tsx": [
		1445,
		9,
		1234
	],
	"./shared-components/subscriptionPlanSetup/components/planCard": [
		1444,
		9,
		987
	],
	"./shared-components/subscriptionPlanSetup/components/planCard.tsx": [
		1444,
		9,
		987
	],
	"./shared-components/subscriptionPlanSetup/hooks/useIsShowPlanSetup": [
		2074,
		9,
		1521
	],
	"./shared-components/subscriptionPlanSetup/hooks/useIsShowPlanSetup.ts": [
		2074,
		9,
		1521
	],
	"./shared-components/subscriptionPlanSetup/hooks/useSafetyHooks": [
		1515,
		9,
		2821
	],
	"./shared-components/subscriptionPlanSetup/hooks/useSafetyHooks.ts": [
		1515,
		9,
		2821
	],
	"./shared-components/subscriptionPlanSetup/styles": [
		1245,
		9,
		1800
	],
	"./shared-components/subscriptionPlanSetup/styles.ts": [
		1245,
		9,
		1800
	],
	"./shared-components/subscriptionPlanSetup/subscriprionPlanSetup": [
		2673,
		9,
		671
	],
	"./shared-components/subscriptionPlanSetup/subscriprionPlanSetup.tsx": [
		2673,
		9,
		671
	],
	"./shared-components/table-skeleton/tableSkeleton": [
		2588,
		9,
		1801
	],
	"./shared-components/table-skeleton/tableSkeleton.tsx": [
		2588,
		9,
		1801
	],
	"./shared-components/text-item-icon/textIconStyles": [
		3501,
		9,
		2822
	],
	"./shared-components/text-item-icon/textIconStyles.ts": [
		3501,
		9,
		2822
	],
	"./shared-components/text-item-icon/textItemIcon": [
		3730,
		9,
		1433
	],
	"./shared-components/text-item-icon/textItemIcon.tsx": [
		3730,
		9,
		1433
	],
	"./shared-components/tooltipContainer/tooltipContainer": [
		2075,
		9,
		2823
	],
	"./shared-components/tooltipContainer/tooltipContainer.tsx": [
		2075,
		9,
		2823
	],
	"./shared-components/upload-sign-agreement-card/errorPAD": [
		1322,
		9,
		2824
	],
	"./shared-components/upload-sign-agreement-card/errorPAD.tsx": [
		1322,
		9,
		2824
	],
	"./shared-components/upload-sign-agreement-card/uploadSignAgreementCard": [
		1240,
		9,
		3,
		28,
		724
	],
	"./shared-components/upload-sign-agreement-card/uploadSignAgreementCard.tsx": [
		1240,
		9,
		3,
		28,
		724
	],
	"./shared-components/upload-sign-agreement-card/uploadSignAgreementCardStyles": [
		1321,
		9,
		2825
	],
	"./shared-components/upload-sign-agreement-card/uploadSignAgreementCardStyles.ts": [
		1321,
		9,
		2825
	],
	"./shared-components/useCheckExternalLayout/useCheckExternalLayout": [
		3297,
		9,
		2826
	],
	"./shared-components/useCheckExternalLayout/useCheckExternalLayout.ts": [
		3297,
		9,
		2826
	],
	"./shared-components/useFromAlfredUser/useFromAlfredUser": [
		301,
		9
	],
	"./shared-components/useFromAlfredUser/useFromAlfredUser.ts": [
		301,
		9
	],
	"./shared-components/useMenuAccessHook": [
		778,
		9,
		292
	],
	"./shared-components/useMenuAccessHook/": [
		778,
		9,
		292
	],
	"./shared-components/useMenuAccessHook/index": [
		778,
		9,
		292
	],
	"./shared-components/useMenuAccessHook/index.tsx": [
		778,
		9,
		292
	],
	"./shared-components/usePreviousHook": [
		714,
		9,
		325
	],
	"./shared-components/usePreviousHook/": [
		714,
		9,
		325
	],
	"./shared-components/usePreviousHook/index": [
		714,
		9,
		325
	],
	"./shared-components/usePreviousHook/index.tsx": [
		714,
		9,
		325
	],
	"./shared-components/usePreviousHook/usePreviousNew": [
		1677,
		9,
		2827
	],
	"./shared-components/usePreviousHook/usePreviousNew.ts": [
		1677,
		9,
		2827
	],
	"./shared-components/usePreviousHook/usePreviousPersistent": [
		1676,
		9,
		2828
	],
	"./shared-components/usePreviousHook/usePreviousPersistent.ts": [
		1676,
		9,
		2828
	],
	"./shared-components/user-profile/userProfile": [
		3496,
		9,
		513
	],
	"./shared-components/user-profile/userProfile.tsx": [
		3496,
		9,
		513
	],
	"./shared-components/validation-icon-text/check_circle_error.svg": [
		4216,
		9,
		3165
	],
	"./shared-components/validation-icon-text/check_circle_solid.svg": [
		4217,
		9,
		3166
	],
	"./shared-components/validation-icon-text/check_circle_success.svg": [
		4218,
		9,
		3167
	],
	"./shared-components/validation-icon-text/validationIconText": [
		2366,
		9,
		1802
	],
	"./shared-components/validation-icon-text/validationIconText.tsx": [
		2366,
		9,
		1802
	],
	"./shared-components/validation-icon-text/validationIconTextStyles": [
		2178,
		9,
		2829
	],
	"./shared-components/validation-icon-text/validationIconTextStyles.ts": [
		2178,
		9,
		2829
	],
	"./shared-components/wp-card-wrapper/wpCardWrapper": [
		1955,
		9,
		2830
	],
	"./shared-components/wp-card-wrapper/wpCardWrapper.tsx": [
		1955,
		9,
		2830
	],
	"./shared-lib/commonHooks": [
		338,
		9
	],
	"./shared-lib/commonHooks/": [
		338,
		9
	],
	"./shared-lib/commonHooks/index": [
		338,
		9
	],
	"./shared-lib/commonHooks/index.tsx": [
		338,
		9
	],
	"./shared-lib/provinces/provinceAutoComplete": [
		1328,
		9,
		1440
	],
	"./shared-lib/provinces/provinceAutoComplete.tsx": [
		1328,
		9,
		1440
	],
	"./shared-lib/provinces/returnLabelTooltip": [
		1528,
		9,
		2831
	],
	"./shared-lib/provinces/returnLabelTooltip.tsx": [
		1528,
		9,
		2831
	],
	"./shared-lib/provinces/useGetStateList": [
		1256,
		9,
		2832
	],
	"./shared-lib/provinces/useGetStateList.tsx": [
		1256,
		9,
		2832
	],
	"./shared-lib/serviceHook/useTimeoutAction": [
		650,
		9
	],
	"./shared-lib/serviceHook/useTimeoutAction.tsx": [
		650,
		9
	],
	"./shared/commonEnums": [
		704,
		9,
		326
	],
	"./shared/commonEnums/": [
		704,
		9,
		326
	],
	"./shared/commonEnums/index": [
		704,
		9,
		326
	],
	"./shared/commonEnums/index.tsx": [
		704,
		9,
		326
	],
	"./shared/heapUtil": [
		796,
		9,
		232
	],
	"./shared/heapUtil/": [
		796,
		9,
		232
	],
	"./shared/heapUtil/index": [
		796,
		9,
		232
	],
	"./shared/heapUtil/index.ts": [
		796,
		9,
		232
	],
	"./shared/launchDarkly": [
		349,
		9
	],
	"./shared/launchDarkly/": [
		349,
		9
	],
	"./shared/launchDarkly/index": [
		349,
		9
	],
	"./shared/launchDarkly/index.ts": [
		349,
		9
	],
	"./shared/markerIO": [
		879,
		9,
		301
	],
	"./shared/markerIO/": [
		879,
		9,
		301
	],
	"./shared/markerIO/index": [
		879,
		9,
		301
	],
	"./shared/markerIO/index.tsx": [
		879,
		9,
		301
	],
	"./shared/queries/useCompanyBankQueries": [
		1075,
		9,
		1077
	],
	"./shared/queries/useCompanyBankQueries.ts": [
		1075,
		9,
		1077
	],
	"./shared/services/appCore/schema": [
		109,
		9
	],
	"./shared/services/appCore/schema.tsx": [
		109,
		9
	],
	"./shared/services/documentManagement/documentAccess": [
		1352,
		9,
		1804
	],
	"./shared/services/documentManagement/documentAccess.ts": [
		1352,
		9,
		1804
	],
	"./shared/services/finance/billingAccess": [
		2245,
		9,
		1805
	],
	"./shared/services/finance/billingAccess.ts": [
		2245,
		9,
		1805
	],
	"./shared/services/finance/companyBankAccess": [
		427,
		9
	],
	"./shared/services/finance/companyBankAccess.ts": [
		427,
		9
	],
	"./shared/services/finance/schema": [
		1070,
		9,
		1,
		2834
	],
	"./shared/services/finance/schema.ts": [
		1070,
		9,
		1,
		2834
	],
	"./shared/services/payroll/migrationOneManager": [
		531,
		9
	],
	"./shared/services/payroll/migrationOneManager.ts": [
		531,
		9
	],
	"./shared/services/payroll/uiConfigAccess": [
		262,
		9
	],
	"./shared/services/payroll/uiConfigAccess.ts": [
		262,
		9
	],
	"./styles/config": [
		1109,
		9,
		2835
	],
	"./styles/config.ts": [
		1109,
		9,
		2835
	],
	"./styles/globalStyles": [
		104,
		9
	],
	"./styles/globalStyles.ts": [
		104,
		9
	],
	"./types/api-client/html2pdf/html2pdf.d": [
		3731,
		7,
		2836
	],
	"./types/api-client/html2pdf/html2pdf.d.ts": [
		3731,
		7,
		2836
	],
	"./types/api-client/index.d": [
		3732,
		9,
		2837
	],
	"./types/api-client/index.d.ts": [
		3732,
		9,
		2837
	],
	"./types/heap-analytics/heap-analytics.d": [
		3733,
		9,
		2838
	],
	"./types/heap-analytics/heap-analytics.d.ts": [
		3733,
		9,
		2838
	],
	"./util/analytics/hooks/useIdentify": [
		3734,
		9,
		2839
	],
	"./util/analytics/hooks/useIdentify.tsx": [
		3734,
		9,
		2839
	],
	"./util/analytics/serviceInstance": [
		880,
		9,
		327
	],
	"./util/analytics/serviceInstance/": [
		880,
		9,
		327
	],
	"./util/analytics/serviceInstance/analytics.contracts": [
		3735,
		9,
		2840
	],
	"./util/analytics/serviceInstance/analytics.contracts.ts": [
		3735,
		9,
		2840
	],
	"./util/analytics/serviceInstance/index": [
		880,
		9,
		327
	],
	"./util/analytics/serviceInstance/index.ts": [
		880,
		9,
		327
	],
	"./util/bankingHelper": [
		720,
		9,
		1,
		302
	],
	"./util/bankingHelper/": [
		720,
		9,
		1,
		302
	],
	"./util/bankingHelper/hooks": [
		1124,
		9,
		2841
	],
	"./util/bankingHelper/hooks.tsx": [
		1124,
		9,
		2841
	],
	"./util/bankingHelper/index": [
		720,
		9,
		1,
		302
	],
	"./util/bankingHelper/index.ts": [
		720,
		9,
		1,
		302
	],
	"./util/buildPath": [
		440,
		9
	],
	"./util/buildPath.ts": [
		440,
		9
	],
	"./util/customEvents": [
		121,
		9
	],
	"./util/customEvents/": [
		121,
		9
	],
	"./util/customEvents/eventContracts": [
		134,
		9
	],
	"./util/customEvents/eventContracts.ts": [
		134,
		9
	],
	"./util/customEvents/index": [
		121,
		9
	],
	"./util/customEvents/index.ts": [
		121,
		9
	],
	"./util/customHooks/useAutoRunFlag": [
		1177,
		9,
		2842
	],
	"./util/customHooks/useAutoRunFlag.ts": [
		1177,
		9,
		2842
	],
	"./util/customHooks/useAutoRunSupportingData": [
		2286,
		9,
		1764
	],
	"./util/customHooks/useAutoRunSupportingData.ts": [
		2286,
		9,
		1764
	],
	"./util/customHooks/useBeforeUnload": [
		1459,
		9,
		1235
	],
	"./util/customHooks/useBeforeUnload.ts": [
		1459,
		9,
		1235
	],
	"./util/customHooks/useCheckPartnerApplicationType": [
		1105,
		9,
		2843
	],
	"./util/customHooks/useCheckPartnerApplicationType.tsx": [
		1105,
		9,
		2843
	],
	"./util/customHooks/useClearRouterHistoryState": [
		2304,
		9,
		2844
	],
	"./util/customHooks/useClearRouterHistoryState.tsx": [
		2304,
		9,
		2844
	],
	"./util/customHooks/useDateValidations": [
		635,
		9
	],
	"./util/customHooks/useDateValidations.ts": [
		635,
		9
	],
	"./util/customHooks/useDateValidationsDeprecated": [
		541,
		9
	],
	"./util/customHooks/useDateValidationsDeprecated.ts": [
		541,
		9
	],
	"./util/customHooks/useDates": [
		3736,
		9,
		2845
	],
	"./util/customHooks/useDates.ts": [
		3736,
		9,
		2845
	],
	"./util/customHooks/useDoNotShowFlag": [
		1079,
		9,
		2846
	],
	"./util/customHooks/useDoNotShowFlag.ts": [
		1079,
		9,
		2846
	],
	"./util/customHooks/useEnumLocale": [
		1407,
		9,
		2847
	],
	"./util/customHooks/useEnumLocale.ts": [
		1407,
		9,
		2847
	],
	"./util/customHooks/useFastIsDirty": [
		1701,
		9,
		1782
	],
	"./util/customHooks/useFastIsDirty.ts": [
		1701,
		9,
		1782
	],
	"./util/customHooks/useFormatCraAccountNumber": [
		2703,
		9,
		2848
	],
	"./util/customHooks/useFormatCraAccountNumber.ts": [
		2703,
		9,
		2848
	],
	"./util/customHooks/useFormatCurrency": [
		1072,
		9,
		2849
	],
	"./util/customHooks/useFormatCurrency.ts": [
		1072,
		9,
		2849
	],
	"./util/customHooks/useFormatDate": [
		382,
		9
	],
	"./util/customHooks/useFormatDate.ts": [
		382,
		9
	],
	"./util/customHooks/useGeneratePDF": [
		3737,
		9,
		12,
		14,
		1754
	],
	"./util/customHooks/useGeneratePDF.ts": [
		3737,
		9,
		12,
		14,
		1754
	],
	"./util/customHooks/useGetDependentStepList": [
		1325,
		9,
		1749
	],
	"./util/customHooks/useGetDependentStepList.tsx": [
		1325,
		9,
		1749
	],
	"./util/customHooks/useGetFirmPreferences": [
		3429,
		9,
		2850
	],
	"./util/customHooks/useGetFirmPreferences.ts": [
		3429,
		9,
		2850
	],
	"./util/customHooks/useGetImages": [
		1888,
		9,
		2851
	],
	"./util/customHooks/useGetImages.ts": [
		1888,
		9,
		2851
	],
	"./util/customHooks/useGetLocationList": [
		1852,
		9,
		2852
	],
	"./util/customHooks/useGetLocationList.ts": [
		1852,
		9,
		2852
	],
	"./util/customHooks/useGetRestrictionByFeatureType": [
		1441,
		9,
		2853
	],
	"./util/customHooks/useGetRestrictionByFeatureType.ts": [
		1441,
		9,
		2853
	],
	"./util/customHooks/useGetSecurityPermissionQuery": [
		2578,
		9,
		1750
	],
	"./util/customHooks/useGetSecurityPermissionQuery.ts": [
		2578,
		9,
		1750
	],
	"./util/customHooks/useGetStateListQuery": [
		1129,
		9,
		2854
	],
	"./util/customHooks/useGetStateListQuery.ts": [
		1129,
		9,
		2854
	],
	"./util/customHooks/useGetUserPermissionQuery": [
		1066,
		9,
		1753
	],
	"./util/customHooks/useGetUserPermissionQuery.ts": [
		1066,
		9,
		1753
	],
	"./util/customHooks/useHandlerWithLoadingIndicator": [
		1243,
		9,
		2855
	],
	"./util/customHooks/useHandlerWithLoadingIndicator.tsx": [
		1243,
		9,
		2855
	],
	"./util/customHooks/useHideHeader": [
		3385,
		9,
		2856
	],
	"./util/customHooks/useHideHeader.ts": [
		3385,
		9,
		2856
	],
	"./util/customHooks/useHideSidebar": [
		1307,
		9,
		2857
	],
	"./util/customHooks/useHideSidebar.ts": [
		1307,
		9,
		2857
	],
	"./util/customHooks/useIsAlfred": [
		1123,
		9,
		2859
	],
	"./util/customHooks/useIsAlfred.ts": [
		1123,
		9,
		2859
	],
	"./util/customHooks/useIsCompanyOnboardingCompleted": [
		1085,
		9,
		2860
	],
	"./util/customHooks/useIsCompanyOnboardingCompleted.ts": [
		1085,
		9,
		2860
	],
	"./util/customHooks/useLanguage": [
		2336,
		9,
		2861
	],
	"./util/customHooks/useLanguage.ts": [
		2336,
		9,
		2861
	],
	"./util/customHooks/useLockedPayroll": [
		3126,
		9,
		1244
	],
	"./util/customHooks/useLockedPayroll.ts": [
		3126,
		9,
		1244
	],
	"./util/customHooks/useModalsState": [
		1568,
		9,
		2862
	],
	"./util/customHooks/useModalsState.ts": [
		1568,
		9,
		2862
	],
	"./util/customHooks/usePartherNewTable": [
		1320,
		9,
		2863
	],
	"./util/customHooks/usePartherNewTable.ts": [
		1320,
		9,
		2863
	],
	"./util/customHooks/usePasswordPolicies": [
		2339,
		9,
		1808
	],
	"./util/customHooks/usePasswordPolicies.ts": [
		2339,
		9,
		1808
	],
	"./util/customHooks/usePayrollNewTable": [
		1849,
		9,
		2864
	],
	"./util/customHooks/usePayrollNewTable.ts": [
		1849,
		9,
		2864
	],
	"./util/customHooks/usePossessiveString": [
		1493,
		9,
		2865
	],
	"./util/customHooks/usePossessiveString.ts": [
		1493,
		9,
		2865
	],
	"./util/customHooks/usePrintPDF": [
		3425,
		9,
		14,
		2866
	],
	"./util/customHooks/usePrintPDF.ts": [
		3425,
		9,
		14,
		2866
	],
	"./util/customHooks/useProfileImage": [
		2584,
		9,
		3,
		1224
	],
	"./util/customHooks/useProfileImage.ts": [
		2584,
		9,
		3,
		1224
	],
	"./util/customHooks/useQuarterList": [
		1396,
		9,
		2867
	],
	"./util/customHooks/useQuarterList.tsx": [
		1396,
		9,
		2867
	],
	"./util/customHooks/useQuery": [
		1136,
		9,
		2868
	],
	"./util/customHooks/useQuery.ts": [
		1136,
		9,
		2868
	],
	"./util/customHooks/useQueryFnWithLoader": [
		286,
		9
	],
	"./util/customHooks/useQueryFnWithLoader.ts": [
		286,
		9
	],
	"./util/customHooks/useROENewTable": [
		2037,
		9,
		2869
	],
	"./util/customHooks/useROENewTable.ts": [
		2037,
		9,
		2869
	],
	"./util/customHooks/useRedirectByPermission": [
		1791,
		9,
		1236
	],
	"./util/customHooks/useRedirectByPermission.tsx": [
		1791,
		9,
		1236
	],
	"./util/customHooks/useReloadConfig": [
		642,
		9
	],
	"./util/customHooks/useReloadConfig.ts": [
		642,
		9
	],
	"./util/customHooks/useRoeGetFieldList": [
		2567,
		9,
		1755
	],
	"./util/customHooks/useRoeGetFieldList.ts": [
		2567,
		9,
		1755
	],
	"./util/customHooks/useRoleName": [
		1998,
		9,
		2870
	],
	"./util/customHooks/useRoleName.ts": [
		1998,
		9,
		2870
	],
	"./util/customHooks/useSoloPlanRestrictions": [
		1440,
		9,
		1807
	],
	"./util/customHooks/useSoloPlanRestrictions.ts": [
		1440,
		9,
		1807
	],
	"./util/customHooks/useSwitchAssociatedCompany": [
		2210,
		9,
		2871
	],
	"./util/customHooks/useSwitchAssociatedCompany.tsx": [
		2210,
		9,
		2871
	],
	"./util/customHooks/useSwitchTenant": [
		1162,
		9,
		1441
	],
	"./util/customHooks/useSwitchTenant.tsx": [
		1162,
		9,
		1441
	],
	"./util/customHooks/useTimezones": [
		1702,
		9,
		1806
	],
	"./util/customHooks/useTimezones.ts": [
		1702,
		9,
		1806
	],
	"./util/customHooks/useToggle": [
		1167,
		9,
		2872
	],
	"./util/customHooks/useToggle.ts": [
		1167,
		9,
		2872
	],
	"./util/customHooks/useTransitNumberSchemaTest": [
		1110,
		9,
		1809
	],
	"./util/customHooks/useTransitNumberSchemaTest.ts": [
		1110,
		9,
		1809
	],
	"./util/customHooks/useUpdateErrorObject": [
		1223,
		9,
		2873
	],
	"./util/customHooks/useUpdateErrorObject.tsx": [
		1223,
		9,
		2873
	],
	"./util/customHooks/useValidatePassword": [
		2179,
		9,
		2874
	],
	"./util/customHooks/useValidatePassword.ts": [
		2179,
		9,
		2874
	],
	"./util/customHooks/useValidationMessage": [
		2068,
		9,
		2875
	],
	"./util/customHooks/useValidationMessage.ts": [
		2068,
		9,
		2875
	],
	"./util/customHooks/useViewPermission": [
		128,
		9
	],
	"./util/customHooks/useViewPermission.tsx": [
		128,
		9
	],
	"./util/deprecated-feature-toggle/useTemporaryFeatureToggle": [
		3738,
		9,
		2876
	],
	"./util/deprecated-feature-toggle/useTemporaryFeatureToggle.tsx": [
		3738,
		9,
		2876
	],
	"./util/documentManagementHelper": [
		749,
		9,
		274
	],
	"./util/documentManagementHelper/": [
		749,
		9,
		274
	],
	"./util/documentManagementHelper/index": [
		749,
		9,
		274
	],
	"./util/documentManagementHelper/index.ts": [
		749,
		9,
		274
	],
	"./util/financeUtil/sinValidationHelper": [
		3739,
		9,
		2877
	],
	"./util/financeUtil/sinValidationHelper.ts": [
		3739,
		9,
		2877
	],
	"./util/hideNumber": [
		1590,
		9,
		2878
	],
	"./util/hideNumber.ts": [
		1590,
		9,
		2878
	],
	"./util/manualErrorMessageTrigger": [
		1724,
		9,
		2879
	],
	"./util/manualErrorMessageTrigger.ts": [
		1724,
		9,
		2879
	],
	"./util/payPeriodHelpers": [
		747,
		9,
		328
	],
	"./util/payPeriodHelpers/": [
		747,
		9,
		328
	],
	"./util/payPeriodHelpers/index": [
		747,
		9,
		328
	],
	"./util/payPeriodHelpers/index.ts": [
		747,
		9,
		328
	],
	"./util/people/usePersonStatusText": [
		1210,
		9,
		1765
	],
	"./util/people/usePersonStatusText.ts": [
		1210,
		9,
		1765
	],
	"./util/queryKeyFactory": [
		146,
		9
	],
	"./util/queryKeyFactory.ts": [
		146,
		9
	],
	"./util/reportUtil/benifitReport/benifitReport": [
		1202,
		9,
		1757
	],
	"./util/reportUtil/benifitReport/benifitReport.ts": [
		1202,
		9,
		1757
	],
	"./util/reportUtil/deductionReport/deductionReport": [
		1201,
		9,
		1758
	],
	"./util/reportUtil/deductionReport/deductionReport.ts": [
		1201,
		9,
		1758
	],
	"./util/reportUtil/depositSummaryReport/depositSummaryReport": [
		1252,
		9,
		1759
	],
	"./util/reportUtil/depositSummaryReport/depositSummaryReport.ts": [
		1252,
		9,
		1759
	],
	"./util/reportUtil/incomeReport/incomeReport": [
		1203,
		9,
		1760
	],
	"./util/reportUtil/incomeReport/incomeReport.ts": [
		1203,
		9,
		1760
	],
	"./util/reportUtil/payStubReport/payStubReport": [
		1251,
		9,
		983
	],
	"./util/reportUtil/payStubReport/payStubReport.ts": [
		1251,
		9,
		983
	],
	"./util/reportUtil/payrollRegisterReport/payrollRegisterReport": [
		1430,
		9,
		7,
		2714
	],
	"./util/reportUtil/payrollRegisterReport/payrollRegisterReport.ts": [
		1430,
		9,
		7,
		2714
	],
	"./util/reportUtil/payrollReport.Util": [
		1208,
		9,
		7,
		23,
		1756
	],
	"./util/reportUtil/payrollReport.Util.ts": [
		1208,
		9,
		7,
		23,
		1756
	],
	"./util/reportUtil/postingJournalReport/postingJournalReport": [
		1254,
		9,
		1761
	],
	"./util/reportUtil/postingJournalReport/postingJournalReport.ts": [
		1254,
		9,
		1761
	],
	"./util/reportUtil/taxReport/taxReport": [
		1204,
		9,
		1762
	],
	"./util/reportUtil/taxReport/taxReport.ts": [
		1204,
		9,
		1762
	],
	"./util/reportUtil/workerCompensationReport/workerCompensationReport": [
		1253,
		9,
		1763
	],
	"./util/reportUtil/workerCompensationReport/workerCompensationReport.ts": [
		1253,
		9,
		1763
	],
	"./util/routeUtils": [
		2936,
		9,
		2880
	],
	"./util/routeUtils.tsx": [
		2936,
		9,
		2880
	],
	"./util/storage/buildSelector": [
		282,
		9
	],
	"./util/storage/buildSelector.ts": [
		282,
		9
	],
	"./util/storage/buildSlice": [
		3740,
		9,
		2881
	],
	"./util/storage/buildSlice.ts": [
		3740,
		9,
		2881
	],
	"./util/syncTabsProvider/syncTabsContext": [
		1175,
		9,
		2882
	],
	"./util/syncTabsProvider/syncTabsContext.ts": [
		1175,
		9,
		2882
	],
	"./util/syncTabsProvider/syncTabsProvider": [
		2986,
		9,
		1442
	],
	"./util/syncTabsProvider/syncTabsProvider.tsx": [
		2986,
		9,
		1442
	],
	"./util/syncTabsProvider/useSyncTabs": [
		1192,
		9,
		1810
	],
	"./util/syncTabsProvider/useSyncTabs.ts": [
		1192,
		9,
		1810
	],
	"./util/utility": [
		28,
		9
	],
	"./util/utility.ts": [
		28,
		9
	],
	"./util/viewByURLHandler": [
		1156,
		9,
		2883
	],
	"./util/viewByURLHandler.ts": [
		1156,
		9,
		2883
	],
	"./util/yupHelpers": [
		726,
		9,
		329
	],
	"./util/yupHelpers/": [
		726,
		9,
		329
	],
	"./util/yupHelpers/index": [
		726,
		9,
		329
	],
	"./util/yupHelpers/index.ts": [
		726,
		9,
		329
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 3929;
module.exports = webpackAsyncContext;